/* GBattle R46 — sharp, metre-calibrated building graffiti; R45 trains, R44 spray and R41 hoodie retained. */
function gbattle3DBetaInit(root) {
'use strict';
if (!root || root.dataset.gb3Initialized === '1') return;
root.dataset.gb3Initialized = '1';
// Disable browser right-click menus inside the entire game (desktop and mobile).
// Right-button drag still works for looking around. Never affect the Shopify page outside the game.
root.addEventListener('contextmenu',e=>e.preventDefault(),true);
root.addEventListener('dragstart',e=>{if(e.target.closest?.('img,button,canvas'))e.preventDefault()},true);
root.addEventListener('pointerdown', e => { if(e.target.closest?.('input,textarea,select,label[for],[contenteditable="true"],.gb3-beta-chat'))return; if(document.activeElement!==root)root.focus({preventScroll:true}); }, {capture:true});
const $ = id => root.querySelector('[data-gb3="'+id+'"]');
const gb3BetaMode=true;

// A touchscreen Windows laptop may report maxTouchPoints > 0 despite being
// operated with a mouse. Only switch to mobile HUD for a coarse primary pointer.
// A narrow handset with touch and no fine primary pointer is a fallback.
// Inject scoped UI overrides only; user's existing gbattle-3d.css stays untouched.
const gb3R4Styles=document.createElement('style');gb3R4Styles.dataset.gb3SprayMenuR4='';
gb3R4Styles.textContent='/* GBattle Spray Menu R4: scoped addition, never resize the paintbrush toolbar. */\n.gb3-game.gb3-unified .top-actions{gap:4px!important}\n.gb3-game.gb3-unified .top-actions button{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:35px!important;min-width:35px!important;height:35px!important;min-height:35px!important;padding:0!important;margin:0!important;border-radius:8px!important;background:#16232c!important;border:1px solid #4a5964!important;color:#f4f7fa!important;font-size:18px!important;font-weight:800!important;letter-spacing:0!important;line-height:1!important;white-space:nowrap!important;flex:0 0 35px!important;box-sizing:border-box!important}\n.gb3-game.gb3-unified .top-actions button[aria-pressed="true"],\n.gb3-game.gb3-unified .top-actions button[aria-expanded="true"]{background:#e7d24a!important;color:#101820!important;border-color:#e7d24a!important}\n.gb3-game.gb3-unified .top-actions [data-gb3="help"]::after{display:none!important;content:none!important}\n.gb3-game.gb3-unified .top-actions button:focus-visible{outline:2px solid #fff!important;outline-offset:2px!important}\n.gb3-game.gb3-unified.gb3-mobile .top-actions button{width:36px!important;height:36px!important;min-width:36px!important;min-height:36px!important;flex-basis:36px!important}\n/* Existing HUD content is reused rather than cloning controls or handlers. */\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > *{display:none!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-cap-title{display:flex!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-caps{display:grid!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-size,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-opacity,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-dust,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left > .gb3-setting-drips{display:flex!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-size,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-opacity,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-dust,\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-setting-drips{display:none!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left{max-height:min(68vh,515px)!important;overflow:auto!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .setting{margin:7px 0!important;gap:4px!important;font-size:11px!important}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .setting input[type="range"]{accent-color:#e7d24a;max-width:100%}\n.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .gb3-caps{margin-bottom:8px!important}\n@media(max-width:700px){.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left .gb3-caps{grid-template-columns:repeat(4,minmax(0,1fr))!important}}\n@media(max-height:550px){.gb3-game.gb3-unified.gb3-panel-tools.gb3-subpanel-spray .hud-left{max-height:calc(100% - 92px)!important}}\n';root.appendChild(gb3R4Styles);
// R5 presentation rules apply to this game instance only; do not edit CSS assets.
const gb3R5Styles=document.createElement('style');gb3R5Styles.dataset.gb3MenuR5='';
gb3R5Styles.textContent="/* GBattle R5: PC-only popover separation; mobile spray/color menus unchanged. */\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > *,\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-markers .hud-left > *{display:none!important}\n/* Only color choices, material finishes and the color picker belong to COLORS. */\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-heading-type,\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-heading-color{display:block!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .painttypes,\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .palette{display:grid!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-colors .hud-left > .gb3-color-picker{display:block!important}\n/* Only the four markers, all with the owner's same marker icon, belong to MARKERS. */\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-markers .hud-left > .gb3-markers-title{display:flex!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-panel-tools.gb3-subpanel-markers .hud-left > .gb3-marker-options{display:grid!important}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-subpanel-markers .gb3-markers-title{align-items:center;justify-content:space-between;gap:8px}\n.gb3-game.gb3-unified:not(.gb3-mobile).gb3-subpanel-markers .gb3-markers-title output{font-size:10px;color:var(--accent);font-weight:800}\n/* Non-invasive top tag suppression: Liquid markup need not be replaced. */\n.gb3-game.gb3-unified .top-actions > .tag{display:none!important}\n/* Mobile: preserve north/south arrows and show west/east arrows in movement stick. */\n.gb3-game.gb3-mobile .touchpad .gb3-stick-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:1;pointer-events:none;user-select:none;color:rgba(247,254,255,.72);font-size:12px;line-height:1;text-shadow:0 1px 3px #000}\n.gb3-game.gb3-mobile .touchpad .gb3-stick-arrow--left{left:7px}\n.gb3-game.gb3-mobile .touchpad .gb3-stick-arrow--right{right:7px}\n";root.appendChild(gb3R5Styles);
const gb3StoryTag=root.querySelector('.top-actions > .tag');
if(gb3StoryTag && gb3StoryTag.textContent.trim()==='WRITE YOUR OWN STORY')gb3StoryTag.remove();
const view=$('view');
// Public train choice is independent of server filenames and source/export format.
// C30 remains the default when the query string does not specify a train.
// R43: two rail lines and two matching tunnel portals, both on the original yard.
const GB3_SECOND_LINE_Z=-8.0;
const gb3RequestedTrain=(new URLSearchParams(location.search).get('gb3train')||'stockholm-c30').toLowerCase();
const gb3ModelChoice='stockholm-c30'; // Initial model until server returns authoritative room model.
// Stable public IDs: model filenames never carry temporary fix/version labels.
const gb3TrainRegistry=Object.freeze({
 'stockholm-c30':{key:'c30',name:'Stockholm-C30',save:'c30-exterior-v21',paint:'sl-c30-paint.glb',models:{desktop:'sl-c30.glb',mobile:'sl-c30.glb'},country:'Sweden'},
 'stockholm-c6':{key:'c6',name:'Stockholm-C6',save:'stockholm-c6-exterior-v01',paint:'sl-c6-paint.glb',model:'sl-c6.glb',country:'Sweden'},
 'santiago-ns74':{key:'santiago-ns74',name:'Santiago NS-74',save:'santiago-ns93-exterior-v01',combined:true,model:'santiago-ns74.glb',country:'Chile'},
 'paris-mp73':{key:'paris-mp73',name:'Paris MP-73',save:'paris-mp73-exterior-v01',combined:true,model:'paris-mp73.glb',country:'France'},
 'london-2009stock':{key:'london-2009stock',name:'London-2009 Stock',save:'london-2009stock-exterior-v01',paint:'london-2009stock-paint.glb',model:'london-2009stock.glb',country:'United Kingdom'}
});
const gb3KeyToPublic=Object.freeze(Object.fromEntries(Object.entries(gb3TrainRegistry).map(([id,entry])=>[entry.key,id])));
// Only missing URL defaults to C30. Known new train IDs never silently fall back.
const gb3StartChoice=gb3TrainRegistry[gb3ModelChoice]||gb3TrainRegistry['stockholm-c30'];
let gb3TrainSelection=gb3StartChoice.key;
let gb3TrainName=gb3StartChoice.name;
let gb3PaintSaveKey=gb3StartChoice.save;
root.dataset.gb3Train=gb3TrainSelection;

const mobilePlatform=/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
const coarseInput=window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
const isTouchDevice=coarseInput && (mobilePlatform ||
  (window.matchMedia('(max-width: 800px)').matches && !window.matchMedia('(pointer: fine)').matches));
let gb3MobileLongPress=null; // Supplied by toolbar after it is built.
if(isTouchDevice){
 root.classList.add('gb3-mobile');
 // Protect game controls from Android long-press selection, including events
 // dispatched on nested icon labels. Do not affect Shopify content outside root.
 const targetInsideGame=e=>{
   const n=e.target;
   const el=n && n.nodeType===1?n:n?.parentElement;
   return !!(el && root.contains(el) && !el.closest('input[type="text"],textarea,[contenteditable="true"]'));
 };
 const stopSelection=e=>{if(targetInsideGame(e))e.preventDefault();};
 document.addEventListener('selectstart',stopSelection,true);
 document.addEventListener('contextmenu',stopSelection,true);
 document.addEventListener('dragstart',stopSelection,true);
 document.addEventListener('selectionchange',()=>{
   const s=window.getSelection?.();
   if(s && s.rangeCount && s.anchorNode && root.contains(s.anchorNode) &&
     !s.anchorNode.parentElement?.closest('input[type="text"],textarea,[contenteditable="true"]')){
     s.removeAllRanges();
   }
 },true);

 root.addEventListener('contextmenu',e=>{e.preventDefault()},{capture:true});
 root.addEventListener('selectstart',e=>{if(!e.target.closest('input[type=text],textarea'))e.preventDefault()},{capture:true});
 root.addEventListener('dragstart',e=>e.preventDefault(),{capture:true});
 // Some Android browsers still select nested icon text after a prolonged press.
 // Suppress native touch selection for BUTTONS only, then deliver a single click.
 let touchButton=null,touchButtonId=null,touchOriginX=0,touchOriginY=0;
 let holdTimer=null,holdActivated=false;
 function resetHoldTimer(){if(holdTimer!==null){clearTimeout(holdTimer);holdTimer=null;}}
 root.addEventListener('touchstart',e=>{
   const button=e.target.closest?.('button');
   if(!button || button.closest('.gb3-beta-chat') || e.touches.length!==1)return;
   resetHoldTimer();touchButton=button;touchButtonId=e.changedTouches[0].identifier;
   touchOriginX=e.changedTouches[0].clientX;touchOriginY=e.changedTouches[0].clientY;
   holdActivated=false;
   // The browser cannot select text when pressing the toolbar, even for > 500ms.
   e.preventDefault();
   if(button.closest('.gb3-compact-toolbar')){
     holdTimer=setTimeout(()=>{
       holdTimer=null;
       if(touchButton===button&&root.contains(button)&&typeof gb3MobileLongPress==='function'){
         holdActivated=!!gb3MobileLongPress(button);
       }
     },520);
   }
 },{capture:true,passive:false});
 root.addEventListener('touchmove',e=>{
   if(!touchButton)return;
   const t=Array.from(e.touches).find(x=>x.identifier===touchButtonId);
   if(!t||Math.hypot(t.clientX-touchOriginX,t.clientY-touchOriginY)>12)resetHoldTimer();
 },{capture:true,passive:true});
 root.addEventListener('touchend',e=>{
   if(!touchButton)return;
   const t=Array.from(e.changedTouches).find(x=>x.identifier===touchButtonId);
   if(!t)return;
   e.preventDefault();resetHoldTimer();
   const button=touchButton,wasHold=holdActivated;touchButton=null;touchButtonId=null;holdActivated=false;
   if(!wasHold&&root.contains(button)&&!button.disabled)button.click();
 },{capture:true,passive:false});
 root.addEventListener('touchcancel',()=>{resetHoldTimer();touchButton=null;touchButtonId=null;holdActivated=false;},{capture:true});
}
else root.classList.remove('gb3-mobile','gb3-panel-tools','gb3-panel-session','gb3-immersive');
const gl=view.getContext('webgl',{alpha:false,antialias:true,preserveDrawingBuffer:true});
if(!gl){
 const message='WebGL is unavailable, so the multiplayer lobby cannot start. Try Chrome with graphics acceleration enabled.';
 $('hint').textContent=message;
 root.querySelectorAll('[data-gb3-beta-count]').forEach(el=>el.textContent='WEBGL ERROR');
 const notice=root.querySelector('[data-gb3-beta-notice]');if(notice)notice.textContent=message;
 return;
}
 // GBATTLE R48 — optional comparison presets; original R46/R47 gameplay is untouched.
 const gb3R37LightingSetting=(new URLSearchParams(location.search).get('gb3lighting')||'cinematic').toLowerCase();
 const gb3R37LightingEnabled=!['classic','off','0'].includes(gb3R37LightingSetting);
 const gb3R38MetalFX=!['0','off','false'].includes((new URLSearchParams(location.search).get('gb3metals')||'on').toLowerCase());
 // R55: live-scene cubemap, with a fast hybrid fallback. This is visual only.
 const gb3R55Requested=(new URLSearchParams(location.search).get('gb3reflections')||'dynamic').toLowerCase();
 let gb3R55ReflectMode=['dynamic','hybrid','off'].includes(gb3R55Requested)?gb3R55Requested:'dynamic';
 root.dataset.gb3LightingActive=gb3R37LightingEnabled?'cinematic':'classic';
 root.dataset.gb3MetalFX=gb3R38MetalFX?'on':'off';
 root.dataset.gb3ReflectMode=gb3R55ReflectMode;
const TAU=Math.PI*2, clamp=(v,a,b)=>Math.max(a,Math.min(b,v)), rnd=(a,b)=>a+Math.random()*(b-a), vec=(x,y,z)=>[x,y,z];
function unit(a){let m=Math.hypot(...a)||1;return a.map(v=>v/m)};
function cross(a,b){return [a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]]}
function dot(a,b){return a[0]*b[0]+a[1]*b[1]+a[2]*b[2]}
function perspective(fov,aspect,near,far){const f=1/Math.tan(fov/2),o=new Float32Array(16);o[0]=f/aspect;o[5]=f;o[10]=(far+near)/(near-far);o[11]=-1;o[14]=2*far*near/(near-far);return o}
function lookAt(e,tar){const f=unit([tar[0]-e[0],tar[1]-e[1],tar[2]-e[2]]),r=unit(cross(f,[0,1,0])),u=cross(r,f);return new Float32Array([r[0],u[0],-f[0],0,r[1],u[1],-f[1],0,r[2],u[2],-f[2],0,-dot(r,e),-dot(u,e),dot(f,e),1]);}
function model(pos,sca,rot=0){const c=Math.cos(rot),s=Math.sin(rot);return new Float32Array([c*sca[0],0,-s*sca[0],0,0,sca[1],0,0,s*sca[2],0,c*sca[2],0,pos[0],pos[1],pos[2],1])}
const vs=`attribute vec3 aP;attribute vec3 aN;attribute vec2 aUV;attribute vec3 aTint;varying vec3 vTint;uniform mat4 uProj,uView,uModel;varying vec3 vNormal,vWorld;varying vec2 vUV;void main(){vec4 w=uModel*vec4(aP,1.0);vWorld=w.xyz;vNormal=mat3(uModel)*aN;vUV=aUV;vTint=aTint;gl_Position=uProj*uView*w;}`;
const fs=`
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
varying vec3 vNormal,vWorld;varying vec3 vTint;
varying vec2 vUV;
uniform vec3 uColor,uCamera;
uniform sampler2D uTex;
uniform float uTexture,uMetal,uFog,uOpacity,uTrain,uBackdrop,uNight;
uniform vec3 uTorchOrigin,uTorchTarget;
uniform float uGB3R37Lighting,uGB3R37Art,uGB3R37Lamps;
uniform vec3 uGB3R37LampA,uGB3R37LampB;
// R38 per-pixel metal-type mask: R=chrome, G=gold, B=copper, A=coverage.
uniform sampler2D uGB3R38MetalMask;
uniform float uGB3R38HasMetal,uGB3R38MetalFX;
// R55: real game-scene dynamic reflection probe (not a static fake stripe).
uniform samplerCube uGB3R55Cube;
uniform float uGB3R55CubeReady;

// R37: fixed world-space fixtures, inexpensive single-pass highlights.
vec3 gb3R37PointLight(vec3 n,vec3 viewDir,vec3 p,vec3 tint,float specPower){
  vec3 delta=p-vWorld;
  float dist2=dot(delta,delta);
  vec3 dir=normalize(delta);
  float falloff=1.0/(1.0+0.035*dist2);
  float diffuse=max(dot(n,dir),0.0);
  vec3 halfDir=normalize(dir+viewDir);
  float specular=pow(max(dot(n,halfDir),0.0),specPower);
  return tint*falloff*(diffuse*2.3+specular*(0.35+uMetal*0.45));
}

vec3 gb3R54MetalEnv(vec3 r){
  float skyMix=clamp(r.y*0.5+0.5,0.0,1.0);
  vec3 sky=mix(vec3(0.33,0.40,0.52),vec3(0.82,0.90,0.98),pow(skyMix,0.80));
  vec3 ground=mix(vec3(0.12,0.12,0.13),vec3(0.30,0.28,0.24),clamp(-r.y,0.0,1.0));
  vec3 env=mix(ground,sky,smoothstep(-0.16,0.22,r.y));
  float horizon=pow(max(1.0-abs(r.y)*5.0,0.0),2.0);
  env+=vec3(0.40,0.42,0.45)*horizon*0.45;
  vec3 sunDir=normalize(vec3(-0.46,0.84,0.30));
  float sun=pow(max(dot(r,sunDir),0.0),82.0);
  env+=vec3(1.24,1.17,1.05)*sun*0.88;
  return env;
}

void main(){
 vec4 tex=uTexture>0.5?texture2D(uTex,vUV):vec4(1.0);
 if(tex.a<0.015)discard;
 vec3 n=normalize(vNormal);
 vec3 sun=normalize(vec3(-0.6,0.9,0.55));
 vec3 eye=normalize(uCamera-vWorld);
 vec3 halfSun=normalize(sun+eye);
 vec3 col;
 if(uGB3R37Lighting<0.5){
  // Exact R36 lighting preserved as reversible compatibility mode.
  float light=mix(0.52+max(dot(n,sun),0.0)*0.52,0.84+max(dot(n,sun),0.0)*0.17,uTrain);
  float spec=pow(max(dot(n,halfSun),0.0),uMetal>0.5?30.0:48.0)*(uMetal>0.5?0.48:0.13);
  col=uBackdrop>0.5?tex.rgb*uColor*vTint:tex.rgb*uColor*vTint*light+vec3(spec);
 }else{
  vec3 base=tex.rgb*uColor*vTint;
  float ndl=max(dot(n,sun),0.0);
  float fill=max(dot(n,normalize(vec3(0.46,0.25,-0.85))),0.0);
  // More form and contrast than the former nearly-flat train diffuse term.
  vec3 ambient=vec3(0.43,0.48,0.56);
  vec3 key=vec3(0.82,0.74,0.66)*ndl;
  vec3 skyFill=vec3(0.17,0.23,0.31)*fill;
  vec3 bounce=vec3(0.075,0.067,0.06)*max(-n.y,0.0);
  vec3 light=ambient+key+skyFill+bounce;
  if(uTrain>0.5)light+=vec3(0.07,0.06,0.045);
  // Keep the C30's white cab/body/roof neutral and visually consistent across
  // differently oriented repeated carriage panels. Its blue passenger-door
  // material remains distinct; this only softens directional color casts.
  float specPower=mix(56.0,85.0,clamp(uMetal,0.0,1.0));
  float glossy=pow(max(dot(n,halfSun),0.0),specPower);
  vec3 sheen=vec3(0.11,0.105,0.10)*glossy*(0.6+2.1*uMetal);
  vec3 lamp=vec3(0.0);
  if(uGB3R37Lamps>0.5){
   lamp=gb3R37PointLight(n,eye,uGB3R37LampA,vec3(1.18,0.93,0.71),specPower)
       +gb3R37PointLight(n,eye,uGB3R37LampB,vec3(0.72,0.85,1.03),specPower);
  }
  vec3 shaded=base*(light+lamp)+sheen;
  // Graffiti overlays keep recognizable paint colors and alpha; only a hint of environmental depth.
  float art=clamp(uGB3R37Art,0.0,1.0);
  vec3 paint=base*(0.95+0.06*ndl)+lamp*base*0.12;
  col=mix(shaded,paint,art*0.82);
  // Backdrop photos and panorama textures stay exactly as authored.
  if(uBackdrop>0.5)col=base;
  if(uBackdrop<0.5){
   col=mix(vec3(dot(col,vec3(0.2126,0.7152,0.0722))),col,1.055);
   col=(col-0.5)*1.04+0.5;
  }
 }
 // R38 reflective graffiti (layered over the R37 art-preserving shading).
 // Pixel mask prevents chrome-like shimmer affecting regular gray/yellow/brown paint.
 if(uGB3R38MetalFX>0.5&&uGB3R38HasMetal>0.5&&uBackdrop<0.5){
  vec4 m=texture2D(uGB3R38MetalMask,vUV);
  float cover=clamp(m.a*tex.a,0.0,1.0);
  if(cover>0.001){
   vec3 type=m.rgb/max(dot(m.rgb,vec3(1.0)),0.015);
   float chrome=clamp(type.r,0.0,1.0);
   float gold=clamp(type.g,0.0,1.0);
   float copper=clamp(type.b,0.0,1.0);
   vec3 tint=chrome*vec3(0.93,0.97,1.0)+gold*vec3(0.98,0.85,0.53)+copper*vec3(0.96,0.59,0.36);
   vec3 nMetal=normalize(vNormal);
   vec3 vMetal=normalize(uCamera-vWorld);
   vec3 rMetal=reflect(-vMetal,nMetal);
   vec3 env=gb3R54MetalEnv(rMetal);
   if(uGB3R55CubeReady>0.5){
    vec3 liveScene=textureCube(uGB3R55Cube,normalize(rMetal)).rgb;
    // Chrome should read like near-mirror metal; gold and copper tint the
    // reflected world rather than merely drawing yellow or brown brush marks.
    float liveWeight=0.95*chrome+0.95*gold+0.95*copper;
    env=mix(env,liveScene,clamp(liveWeight,0.0,0.96));
   }
   vec3 keyDir=normalize(vec3(-0.6,0.9,0.55));
   vec3 lampDir=normalize(uGB3R37LampA-vWorld);
   vec3 otherDir=normalize(uGB3R37LampB-vWorld);
   float sharp=120.0*chrome+110.0*gold+105.0*copper;
   float keySpec=pow(max(dot(reflect(-keyDir,nMetal),vMetal),0.0),sharp);
   float lampSpec=pow(max(dot(reflect(-lampDir,nMetal),vMetal),0.0),sharp*0.62);
   float otherSpec=pow(max(dot(reflect(-otherDir,nMetal),vMetal),0.0),sharp*0.62);
   float front=clamp(dot(nMetal,vMetal),0.0,1.0);
   float fresnel=pow(1.0-front,3.8);
   float skyline=pow(max(1.0-abs(rMetal.y)*6.0,0.0),2.0);
   float fixtures=step(0.5,uGB3R37Lamps);
   float sparkle=0.55*keySpec+fixtures*(1.15*lampSpec+0.82*otherSpec);
   float tintAmount=gold*0.44+copper*0.53+chrome*0.08;
   vec3 reflected=mix(env,env*tint,tintAmount);
   float mirror=chrome*0.88+gold*0.88+copper*0.88;
   vec3 coatBase=mix(tint*(0.52+0.14*front),reflected,clamp(0.57+mirror*0.37+fresnel*0.16,0.0,1.0));
   coatBase+=vec3(0.26,0.28,0.30)*skyline*(0.20+0.40*chrome);
   vec3 highlight=vec3(1.0)*(sparkle*(0.95+0.22*chrome));
   highlight+=tint*(0.10+0.24*fresnel+sparkle*(0.10+0.12*(gold+copper)));
   vec3 metallic=coatBase+highlight;
   col=mix(col,metallic,cover*0.96);
  }
 }
 if(uBackdrop<0.5&&uFog>0.5){
  float fog=clamp((length(uCamera-vWorld)-35.0)/105.0,0.0,1.0);
  col=mix(col,vec3(.065,.085,.112),fog);
 }
 if(uNight>0.5){
  vec3 axis=normalize(uTorchTarget-uTorchOrigin);
  vec3 toPix=vWorld-uTorchOrigin;
  float ray=length(toPix);
  float beam=smoothstep(.79,.95,dot(normalize(toPix),axis))*clamp(1.0-ray/27.0,0.0,1.0)*2.4;
  col*=.048+beam;
 }
 gl_FragColor=vec4(clamp(col,0.0,1.0),tex.a*uOpacity);
}`;
function shader(type,src){let s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error(gl.getShaderInfoLog(s));return s}
const program=gl.createProgram();gl.attachShader(program,shader(gl.VERTEX_SHADER,vs));gl.attachShader(program,shader(gl.FRAGMENT_SHADER,fs));gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error(gl.getProgramInfoLog(program));gl.useProgram(program);
const loc={tint:gl.getAttribLocation(program,'aTint'),p:gl.getAttribLocation(program,'aP'),n:gl.getAttribLocation(program,'aN'),uv:gl.getAttribLocation(program,'aUV'),projection:gl.getUniformLocation(program,'uProj'),view:gl.getUniformLocation(program,'uView'),model:gl.getUniformLocation(program,'uModel'),color:gl.getUniformLocation(program,'uColor'),camera:gl.getUniformLocation(program,'uCamera'),texture:gl.getUniformLocation(program,'uTex'),hasTex:gl.getUniformLocation(program,'uTexture'),metal:gl.getUniformLocation(program,'uMetal'),fog:gl.getUniformLocation(program,'uFog'),opacity:gl.getUniformLocation(program,'uOpacity'),train:gl.getUniformLocation(program,'uTrain'),backdrop:gl.getUniformLocation(program,'uBackdrop'),night:gl.getUniformLocation(program,'uNight'),torchOrigin:gl.getUniformLocation(program,'uTorchOrigin'),torchTarget:gl.getUniformLocation(program,'uTorchTarget'),r37Lighting:gl.getUniformLocation(program,'uGB3R37Lighting'),r37Art:gl.getUniformLocation(program,'uGB3R37Art'),r37Lamps:gl.getUniformLocation(program,'uGB3R37Lamps'),r37LampA:gl.getUniformLocation(program,'uGB3R37LampA'),r37LampB:gl.getUniformLocation(program,'uGB3R37LampB'),r38Mask:gl.getUniformLocation(program,'uGB3R38MetalMask'),r38HasMetal:gl.getUniformLocation(program,'uGB3R38HasMetal'),r38MetalFX:gl.getUniformLocation(program,'uGB3R38MetalFX'),r55Cube:gl.getUniformLocation(program,'uGB3R55Cube'),r55CubeReady:gl.getUniformLocation(program,'uGB3R55CubeReady')};
// R38: compact on-demand per-surface metal material layer. Hue channels identify
// CHROME (red), GOLD (green), COPPER (blue); alpha is paint coverage.
const gb3R38MetalColors=Object.freeze({chrome:'#ff0000',gold:'#00ff00',copper:'#0000ff'});
let gb3R55MetalSeen=false;
function gb3R38EnsureMetal(p){
 if(p.metalCanvas)return p;
 if(!p.canvas)return p;
 const c=document.createElement('canvas');
 c.width=Math.max(1,Math.min(isTouchDevice?384:768,Math.ceil(p.canvas.width*.5)));
 c.height=Math.max(1,Math.round(p.canvas.height*c.width/p.canvas.width));
 p.metalCanvas=c;p.metalCtx=c.getContext('2d',{willReadFrequently:true});
 p.metalTex=gl.createTexture();gl.activeTexture(gl.TEXTURE1);gl.bindTexture(gl.TEXTURE_2D,p.metalTex);
 gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,c);
 gl.activeTexture(gl.TEXTURE0);p.metalDirty=false;
 return p;
}
function gb3R38ClearMetal(p){
 if(!p?.metalCanvas)return;
 p.metalCtx.clearRect(0,0,p.metalCanvas.width,p.metalCanvas.height);
 p.metalDirty=true;
}
function gb3R38MarkMetal(p,x,y,r,finish,opacity,erase=false,elong=1,angle=0,spray=true){
 const metal=Object.prototype.hasOwnProperty.call(gb3R38MetalColors,finish);
 if(metal&&!erase)gb3R55MetalSeen=true;
 if(!metal&&!p.metalCanvas)return;
 gb3R38EnsureMetal(p);
 const c=p.metalCtx,ratio=p.metalCanvas.width/p.canvas.width;
 const rr=Math.max(.7,r*ratio*(spray?1.78:1.0));
 c.save();c.translate(x*ratio,y*ratio);c.rotate(angle);c.scale(Math.max(.5,Math.min(2.7,elong)),1);
 const gradient=c.createRadialGradient(0,0,0,0,0,rr);
 gradient.addColorStop(0,'rgba(255,255,255,1)');
 gradient.addColorStop(.53,'rgba(255,255,255,.92)');
 gradient.addColorStop(1,'rgba(255,255,255,0)');
 c.globalCompositeOperation='destination-out';
 c.globalAlpha=erase?Math.max(.2,opacity):Math.min(1,opacity*.65);
 c.fillStyle=gradient;c.fillRect(-rr,-rr,rr*2,rr*2);
 if(metal&&!erase){
  // Preserve the same diffuse stamp edge, but store the material category rather
  // than the metallic visual gradient. Not sent on the WebSocket wire.
  const rgb=finish==='chrome'?'255,0,0':finish==='gold'?'0,255,0':'0,0,255';
  const g=c.createRadialGradient(0,0,0,0,0,rr);
  g.addColorStop(0,'rgba('+rgb+',1)');g.addColorStop(.53,'rgba('+rgb+',.92)');
  g.addColorStop(1,'rgba('+rgb+',0)');
  c.globalCompositeOperation='source-over';c.globalAlpha=Math.min(1,opacity*.68);
  c.fillStyle=g;c.fillRect(-rr,-rr,rr*2,rr*2);
 }
 c.restore();p.metalDirty=true;
}
function gb3R38UploadMetal(p){
 if(!p?.metalTex||!p.metalDirty)return;
 gl.activeTexture(gl.TEXTURE1);gl.bindTexture(gl.TEXTURE_2D,p.metalTex);
 gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texSubImage2D(gl.TEXTURE_2D,0,0,0,gl.RGBA,gl.UNSIGNED_BYTE,p.metalCanvas);
 gl.activeTexture(gl.TEXTURE0);p.metalDirty=false;
}
function gb3R38DisposeMetal(p){if(p?.metalTex){gl.deleteTexture(p.metalTex);p.metalTex=null;}}
function faces(){const out=[];const face=(normal,p)=>{const uv=[[0,0],[1,0],[1,1],[0,0],[1,1],[0,1]];for(let i=0;i<6;i++)out.push(...p[i],...normal,...uv[i])};
 const a=-.5,b=.5;
 face([0,0,1],[[a,a,b],[b,a,b],[b,b,b],[a,a,b],[b,b,b],[a,b,b]]);
 face([0,0,-1],[[b,a,a],[a,a,a],[a,b,a],[b,a,a],[a,b,a],[b,b,a]]);
 face([1,0,0],[[b,a,b],[b,a,a],[b,b,a],[b,a,b],[b,b,a],[b,b,b]]);
 face([-1,0,0],[[a,a,a],[a,a,b],[a,b,b],[a,a,a],[a,b,b],[a,b,a]]);
 face([0,1,0],[[a,b,b],[b,b,b],[b,b,a],[a,b,b],[b,b,a],[a,b,a]]);
 face([0,-1,0],[[a,a,a],[b,a,a],[b,a,b],[a,a,a],[b,a,b],[a,a,b]]);return out;}
const quad=[-.5,-.5,0,0,0,1,0,0,.5,-.5,0,0,0,1,1,0,.5,.5,0,0,0,1,1,1,-.5,-.5,0,0,0,1,0,0,.5,.5,0,0,0,1,1,1,-.5,.5,0,0,0,1,0,1];
function mesh(arr,colors=null){let buf=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buf);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(arr),gl.STATIC_DRAW);let tintBuf=null;if(colors){tintBuf=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,tintBuf);gl.bufferData(gl.ARRAY_BUFFER,colors,gl.STATIC_DRAW);}return {buf,tintBuf,count:arr.length/8}}
function gb3DeleteMesh(shape){gl.deleteBuffer(shape.buf);if(shape.tintBuf)gl.deleteBuffer(shape.tintBuf);}
const cube=mesh(faces()),plane=mesh(quad);
function hex(s){let h=s.replace('#','');return [0,2,4].map(x=>parseInt(h.slice(x,x+2),16)/255)}
let scene=[],panels=[],dirty=new Set(),undo=[],strokes=0;
let addingPlaceholder=false;
function add(shape,x,y,z,w,h,d,color,metal=0,rot=0){const o={shape:shape||cube,pos:[x,y,z],size:[w,h,d],color:hex(color),metal,rot,placeholder:addingPlaceholder};scene.push(o);return o}
function box(x,y,z,w,h,d,c,metal=0){return add(cube,x,y,z,w,h,d,c,metal)}
function panel(name,cx,side,len,opt={}){const size=[len,opt.height??2.66,1], z=side*(opt.z??1.665);const o={shape:plane,pos:[cx,opt.y??2.18,z],size,color:[1,1,1],metal:0,rot:0,panel:true,side,len,cx,name,placeholder:addingPlaceholder};o.canvas=document.createElement('canvas');o.canvas.width=opt.width??1536;o.canvas.height=opt.pixelHeight??400;o.ctx=o.canvas.getContext('2d',{willReadFrequently:true});o.tex=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,o.tex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,o.canvas);panels.push(o);return o}

function makeYard(){
 box(0,-.36,0,230,.62,160,'#303b40');
 // Rails extend into BOTH tunnel openings, all the way to the map boundary.
 // A short continuation disappears inside the tunnel beyond the panoramic walls.
 const trackLength=260;
 for(const z of [-1.02,1.02]){
   box(0,.15,z,trackLength,.19,.17,'#adb5b3',1);
   box(0,.21,z+.21,trackLength,.04,.035,'#838d8d',1);
 }
 // Group sleepers into ONE mesh to avoid hundreds of draw calls on Android.
 const sleeperVerts=[];
 const template=faces();
 for(let x=-129.75;x<=129.75;x+=.75){
   for(let i=0;i<template.length;i+=8){
     sleeperVerts.push(x+template[i]*.28,-.05+template[i+1]*.18,template[i+2]*3.4,
       template[i+3],template[i+4],template[i+5],template[i+6],template[i+7]);
   }
 }
 scene.push({shape:mesh(sleeperVerts),pos:[0,0,0],size:[1,1,1],rot:0,color:hex('#473d34'),metal:0});
 // R42: second parallel train line in the SAME yard, connected to the SAME tunnels.
 // One batched sleeper geometry; the model and paint meshes share the source C30 buffers.
 const secondZ=GB3_SECOND_LINE_Z;
 for(const rail of [secondZ-1.02,secondZ+1.02]){
  box(0,.15,rail,trackLength,.19,.17,'#adb5b3',1).gb3Map='yard';
  box(0,.21,rail+.21,trackLength,.04,.035,'#838d8d',1).gb3Map='yard';
 }
 const secondSleepers=[];
 for(let x=-129.75;x<=129.75;x+=.75){
  for(let k=0;k<template.length;k+=8){
   secondSleepers.push(x+template[k]*.28,-.05+template[k+1]*.18,secondZ+template[k+2]*3.4,
    template[k+3],template[k+4],template[k+5],template[k+6],template[k+7]);
  }
 }
 scene.push({shape:mesh(secondSleepers),pos:[0,0,0],size:[1,1,1],rot:0,color:hex('#473d34'),metal:0,gb3Map:'yard'});
 // Scenic Stockholm panorama replaces the temporary industrial boxes and lamps.
 // Only the imported C30 is used; no test gray train is constructed.
 // No leftover depot sign geometry; the photographic perimeter is the entire backdrop.
}
makeYard();
// v2.3.6 — cover props: crates and a small maintenance shed on the spectator side.
// Each provides actual line-of-sight cover; the camera cannot pass through them.
const gb3Cover=[];
// R19: Street-front city on BOTH sides of the train yard. Buildings and paint
// layers stay outside the train's 50 UV regions, which can be reloaded on model swaps.
const GB3_CITY_SID_BASE=50;
const gb3CityPanels=[];
const gb3CityBodies=[];
const gb3CityImageCache=new Map();
function gb3CityImage(url){
 if(!url)return Promise.resolve(null);
 if(gb3CityImageCache.has(url))return gb3CityImageCache.get(url);
 const request=new Promise(resolve=>{const img=new Image();img.crossOrigin='anonymous';img.onload=()=>resolve(img);img.onerror=()=>resolve(null);img.src=url;});
 gb3CityImageCache.set(url,request);return request;
}
function gb3CityTexture(canvas){
 const tex=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,tex);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
 gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,canvas);
 return tex;
}
// Texture atlas of each wall: the supplied bricks/doors/windows become the BASE,
// with an independent transparent graffiti texture above, shared by the existing
// paint brush and WebSocket train_stroke protocol with stable SIDs 50..111.
async function gb3BakeCityFacade(p,cfg){
 const [brick,windowImg,door]=await Promise.all([
  gb3CityImage(root.dataset.gb3BuildingBricksUrl),gb3CityImage(root.dataset.gb3BuildingWindowUrl),
  gb3CityImage(root.getAttribute('data-gb3-building-door-'+cfg.door+'-url'))]);
 const c=p.baseCanvas,w=c.width,h=c.height,ctx=c.getContext('2d');
 ctx.fillStyle=cfg.color;ctx.fillRect(0,0,w,h);
 if(brick){
  const tile=document.createElement('canvas');tile.width=256;tile.height=192;
  const tc=tile.getContext('2d');tc.drawImage(brick,0,0,256,192);
  ctx.globalAlpha=.88;ctx.fillStyle=ctx.createPattern(tile,'repeat')||cfg.color;ctx.fillRect(0,0,w,h);ctx.globalAlpha=1;
 }
 ctx.fillStyle=cfg.color;ctx.globalAlpha=.18;ctx.fillRect(0,0,w,h);ctx.globalAlpha=1;
 const floor=h/cfg.storeys;
 for(let story=0;story<cfg.storeys;story++){
  const bottom=h-story*floor;
  const frameY=bottom-floor*.80,frameH=floor*.48,frameW=w*.18;
  for(const at of [.14,.68]){
   const x=w*at;
   if(windowImg)ctx.drawImage(windowImg,x,frameY,frameW,frameH);
   else{ctx.fillStyle='#b2bac0';ctx.fillRect(x,frameY,frameW,frameH)}
   ctx.strokeStyle='#55575a';ctx.lineWidth=5;ctx.strokeRect(x,frameY,frameW,frameH);
  }
  ctx.fillStyle='rgba(44,30,24,.37)';ctx.fillRect(0,bottom-8,w,8);
 }
 // Every building has a ground-floor entrance centered on its train-facing facade.
 // Use only the six user-provided JPG entrance photos, selected in a stable cycle.
 // Real-sized entrances: keep all six photographs at the same 2.5 m opening height,
 // regardless of whether the building has one or four storeys. Stretch the JPG to fit.
 const doorHeightMetres=2.50,doorWidthMetres=2.04;
 const dh=h*doorHeightMetres/(p.gb3BuildingHeight||4.25);
 const dw=w*doorWidthMetres/(p.gb3BuildingWidth||8.5);
 const dx=(w-dw)*.5,dy=h-dh;
 if(door)ctx.drawImage(door,dx,dy,dw,dh);
 else{
  // If an image is still unavailable, keep the entrance visible while reporting it.
  console.warn('GBattle: missing building entrance photo',cfg.door,root.getAttribute('data-gb3-building-door-'+cfg.door+'-url'));
  ctx.fillStyle='#73543d';ctx.fillRect(dx,dy,dw,dh);
  ctx.strokeStyle='#d1a87b';ctx.lineWidth=5;ctx.strokeRect(dx+3,dy+3,dw-6,dh-6);
  ctx.fillStyle='#d6b66c';ctx.beginPath();ctx.arc(dx+dw*.86,dy+dh*.52,4,0,Math.PI*2);ctx.fill();
 }
 ctx.fillStyle='#7d6252';ctx.fillRect(0,0,w,10);
 ctx.fillStyle='#a79b8a';ctx.fillRect(0,h-11,w,11);
 gl.bindTexture(gl.TEXTURE_2D,p.base.importTex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,c);
}
// R22: native UV-space graffiti planes on ALL four building walls plus the roof.
// WORLD coordinates are baked into each light 2-triangle mesh, so walls and roof
// share the same rendering and existing paint protocol without a new renderer.
const GB3_CITY_FACES=['front','rear','left','right','roof'];
const GB3_CITY_FRONT_COUNT=62;
const GB3_CITY_SURFACE_COUNT=GB3_CITY_FRONT_COUNT*GB3_CITY_FACES.length;
const gb3CityLadders=[];
const gb3CityRoofs=[]; // physical tops of ALL building roofs, including those without ladders
function gb3CityPaintQuad(origin,uVec,vVec){
 const add3=(a,b,c)=>[a[0]+b[0]+c[0],a[1]+b[1]+c[1],a[2]+b[2]+c[2]];
 const a=origin,b=add3(origin,uVec,[0,0,0]),c=add3(origin,uVec,vVec),d=add3(origin,[0,0,0],vVec);
 const n=unit(cross(uVec,vVec));
 const verts=[];
 for(const [p,uv] of [[a,[0,0]],[b,[1,0]],[c,[1,1]],[a,[0,0]],[c,[1,1]],[d,[0,1]]])verts.push(...p,...n,...uv);
 return mesh(verts);
}
function gb3CityPaintSurface(i,face,origin,uVec,vVec){
 const uLen=Math.hypot(...uVec),vLen=Math.hypot(...vVec);
 const high=face==='roof'?128:(vLen>8?224:144);
 const w=face==='roof'?160:face==='front'||face==='rear'?192:128;
 const c=document.createElement('canvas');c.width=w;c.height=high;
 const surfaceIndex=GB3_CITY_FACES.indexOf(face);
 // Preserve R21's 50..111 front SIDs: all new faces follow at 112..359.
 const sid=surfaceIndex===0?GB3_CITY_SID_BASE+i:
  GB3_CITY_SID_BASE+GB3_CITY_FRONT_COUNT+i*4+surfaceIndex-1;
 const p={shape:gb3CityPaintQuad(origin,uVec,vVec),pos:[0,0,0],size:[1,1,1],rot:0,
  color:[1,1,1],metal:0,panel:true,canvas:c,ctx:c.getContext('2d',{willReadFrequently:true}),
  tex:gb3CityTexture(c),name:'gb3:building:'+i+(face==='front'?'':':'+face),
  side:0,len:uLen,cx:0,gb3City:true,gb3CityFace:face,gb3CityBuilding:i,
  gb3BetaSID:sid,gb3Map:'yard',gb3HasPaint:false,
  // Real metres along each UV axis. Paint geometry is separate from the facade JPG.
  gb3WorldU:uLen,gb3WorldV:vLen,gb3PaintHiRes:false,
  gb3RayOrigin:origin,gb3RayU:uVec,gb3RayV:vVec,
  gb3RayNormal:unit(cross(uVec,vVec))};
 gb3CityPanels[sid-GB3_CITY_SID_BASE]=p;
 return p;
}
// R46: do NOT allocate 310 large paint canvases on load (slow on Android).
// Increase quality only when paint actually reaches a building face. Retain the
// stable R21/R22 surface IDs, normalized stroke coordinates and all five faces.
function gb3CityTargetResolution(p,mobile=isTouchDevice){
 const ppm=mobile?48:72;  // pixels per WORLD metre, not per CSS texture pixel
 const step=n=>Math.ceil(n/64)*64;
 return {width:Math.max(p.canvas.width,Math.min(1024,step(p.gb3WorldU*ppm))),
  height:Math.max(p.canvas.height,Math.min(1024,step(p.gb3WorldV*ppm)))};
}
function gb3CityPixelAspect(p){
 if(!p?.gb3City)return 1;
 return (p.canvas.height/p.gb3WorldV)/(p.canvas.width/p.gb3WorldU);
}
function gb3CityDripLengthPixels(p,seedValue,thickness){
 // 0.13–0.54 metres, not 20–200 pixels across a 4–13 metre facade.
 return (0.13+clamp(seedValue,0,1)*.22+clamp(thickness,0,1)*.19)*
  (p.canvas.height/p.gb3WorldV);
}
function gb3EnsureCityPaintResolution(p){
 if(!p?.gb3City||p.gb3PaintHiRes)return;
 const target=gb3CityTargetResolution(p);
 p.gb3PaintHiRes=true;
 if(p.canvas.width===target.width&&p.canvas.height===target.height)return;
 // Only done before the first paint event for this surface (including replay).
 // The small empty texture is replaced in-place. No new paint ID or 3D surface.
 p.canvas.width=target.width;p.canvas.height=target.height;
 p.ctx=p.canvas.getContext('2d',{willReadFrequently:true});
 gl.bindTexture(gl.TEXTURE_2D,p.tex);
 gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,p.canvas);
 dirty.add(p);
}
function gb3CityPaintRayHit(origin,dir,p,limit){
 const normal=p.gb3RayNormal,div=dot(normal,dir);
 if(Math.abs(div)<.00005)return null;
 const from=p.gb3RayOrigin;
 const t=dot(normal,[from[0]-origin[0],from[1]-origin[1],from[2]-origin[2]])/div;
 if(t<.07||t>=limit)return null;
 const world=[origin[0]+dir[0]*t,origin[1]+dir[1]*t,origin[2]+dir[2]*t];
 const diff=[world[0]-from[0],world[1]-from[1],world[2]-from[2]];
 const uu=dot(diff,p.gb3RayU)/dot(p.gb3RayU,p.gb3RayU);
 const vv=dot(diff,p.gb3RayV)/dot(p.gb3RayV,p.gb3RayV);
 if(uu<0||uu>1||vv<0||vv>1)return null;
 return {p,distance:t,u:uu,v:1-vv,world,normal,ray:dir,
  viewAngle:Math.atan2(-dir[1],dir[0])};
}
function gb3CreateCityLadder(cfg){
 // Ladder attaches to an exterior SIDE (or rear) wall, never across the entrance.
 // R22 climbing logic uses these coordinates and actual roof height.
 const side=(cfg.index%2===0)?'right':'rear';
 const h=cfg.height, faceDir=Math.sign(cfg.z)||1;
 let x,z,insideX,insideZ;
 if(side==='right'){
  x=cfg.x+cfg.width/2+.18;z=cfg.z;
  insideX=cfg.x+cfg.width/2-.88;insideZ=cfg.z;
  for(const dz of [-.33,.33])box(x,h/2,z+dz,.085,h,.085,'#a9b2b2',.5);
  for(let y=.55;y<h-.2;y+=.44)box(x,y,z,.12,.057,.75,'#959f9f',.4);
 }else{
  x=cfg.x;z=cfg.z+faceDir*(cfg.depth/2+.18);
  insideX=cfg.x;insideZ=cfg.z+faceDir*(cfg.depth/2-.88);
  for(const dx of [-.33,.33])box(x+dx,h/2,z,.085,h,.085,'#a9b2b2',.5);
  for(let y=.55;y<h-.2;y+=.44)box(x,y,z,.75,.057,.12,'#959f9f',.4);
 }
 gb3CityLadders.push({x,z,top:h+.34,insideX,insideZ,building:cfg.index,
  minX:cfg.x-cfg.width/2,maxX:cfg.x+cfg.width/2,
  minZ:cfg.z-cfg.depth/2,maxZ:cfg.z+cfg.depth/2});
}

function gb3CreateCity(){
 // Deterministic city layout around the train corridor: many small buildings around the yard,
 // with clear walkable lanes between the central train and the facades.
 const rows=[
  {z: 22.5, xs:[-98,-88,-78,-68,-57,-46,-35,-24,-13,-2,10,22,34,46,58,70,82,94], depthBase:5.8},
  {z: 31.0, xs:[-94,-80,-66,-50,-34,-18,-2,14,30,46,62,78,92], depthBase:6.3},
  {z:-22.5, xs:[-98,-88,-78,-68,-57,-46,-35,-24,-13,-2,10,22,34,46,58,70,82,94], depthBase:5.8},
  {z:-31.0, xs:[-94,-80,-66,-50,-34,-18,-2,14,30,46,62,78,92], depthBase:6.3}
 ];
 let i=0;
 for(const row of rows){
  for(const x of row.xs){
   const variation=(i%3), storeys=((i*7+3)%5<2)?4:1;
   const height=storeys===4?12.8:4.25;
   const width=(storeys===4?9.2:7.8)+(variation*.9);
   const depth=row.depthBase+((i%2)?.8:0);
   const plot={x,z:row.z,width,depth};
   const color=['#8c4d36','#9a563d','#a05a40','#a66a3f','#a07a39','#9a6d2f','#7f4a34','#8e5e34'][i%8];
   const frontZ=plot.z-Math.sign(plot.z)*plot.depth/2;
   // Roof heights exactly match the brick cap and the rooftop paint quad.
   gb3CityRoofs.push({building:i,x:plot.x,z:plot.z,hx:(plot.width+.28)/2,
    hz:(plot.depth+.30)/2,top:height+.34});
   const body=box(plot.x,height/2,plot.z,plot.width,height,plot.depth,color);
   gb3CityBodies.push(body);
   box(plot.x,height+.17,plot.z,plot.width+.28,.34,plot.depth+.3,'#665149');
   gb3Cover.push({x:plot.x,z:plot.z,hx:plot.width/2,hz:plot.depth/2,top:height+.34,kind:'building',map:'yard'});
   const faceNear=frontZ-Math.sign(plot.z)*.035;
   // A high-resolution textured base remains separate from the smaller paint layer.
   const w=384,h=storeys===4?528:352;
   const baseCanvas=document.createElement('canvas');baseCanvas.width=w;baseCanvas.height=h;
   const base={shape:plane,pos:[plot.x,height/2,frontZ-Math.sign(plot.z)*.020],
    size:[plot.width,height,1],rot:0,color:[1,1,1],metal:0,
    backdrop:true,importTex:gb3CityTexture(baseCanvas),gb3Map:'yard'};
   scene.push(base);
   // Front and rear walls are parallel to X; side walls are parallel to Z.
   // Roof paint is above the existing cap and remains raycastable from above.
   const front=gb3CityPaintSurface(i,'front',
    [plot.x-plot.width/2,0,faceNear],[plot.width,0,0],[0,height,0]);
   front.base=base;front.baseCanvas=baseCanvas;
   front.gb3BuildingHeight=height;front.gb3BuildingWidth=plot.width;
   gb3CityPaintSurface(i,'rear',
    [plot.x-plot.width/2,0,plot.z+Math.sign(plot.z)*(plot.depth/2+.045)],
    [plot.width,0,0],[0,height,0]);
   gb3CityPaintSurface(i,'left',
    [plot.x-plot.width/2-.045,0,plot.z-plot.depth/2],
    [0,0,plot.depth],[0,height,0]);
   gb3CityPaintSurface(i,'right',
    [plot.x+plot.width/2+.045,0,plot.z-plot.depth/2],
    [0,0,plot.depth],[0,height,0]);
   gb3CityPaintSurface(i,'roof',
    [plot.x-(plot.width+.28)/2,height+.36,plot.z-(plot.depth+.30)/2],
    [plot.width+.28,0,0],[0,0,plot.depth+.30]);
   void gb3BakeCityFacade(front,{color,storeys,door:(i%6)+1})
     .catch(err=>console.warn('GBattle facade '+i,err));
   if((i%5===0)||(storeys===4&&i%7===0))
    gb3CreateCityLadder({index:i,x:plot.x,z:plot.z,width:plot.width,
     depth:plot.depth,height,faceZ:frontZ});
   i++;
  }
 }
 // Brick-wrapped side and rear walls share ONE GPU texture; no per-building downloads.
 void gb3CityImage(root.dataset.gb3BuildingBricksUrl).then(brick=>{
  if(!brick)return;
  const tile=document.createElement('canvas');tile.width=512;tile.height=512;
  tile.getContext('2d').drawImage(brick,0,0,512,512);
  const tex=gb3CityTexture(tile);
  for(const body of gb3CityBodies){body.importTex=tex;body.color=[.95,.89,.83];}
 }).catch(err=>console.warn('GBattle brick wrapping',err));
}
gb3CreateCity();
if(gb3CityPanels.length!==GB3_CITY_SURFACE_COUNT||gb3CityPanels.some(x=>!x))
 throw Error('GBattle building faces/SID allocation incomplete');
const GB3_CITY_PAINT_BUILD='R46-building-world-metre-graffiti';
root.dataset.gb3CityPaintBuild=GB3_CITY_PAINT_BUILD;
window.GB3_CITY_PAINT_STATUS={build:GB3_CITY_PAINT_BUILD,
 get paintedFaces(){return gb3CityPanels.filter(p=>p.gb3HasPaint).length},
 get highResolutionFaces(){return gb3CityPanels.filter(p=>p.gb3PaintHiRes).length},
 surfaceCount:GB3_CITY_SURFACE_COUNT,realMetreScaling:true,dripLimitMetres:.54};

function gb3Crate(x,z,w=3.3){
 const obj=box(x,1.23,z,w,2.46,2.6,'#786246');
 const trim=box(x,2.53,z,w+.06,.14,2.72,'#4b3928');
 gb3Cover.push({x,z,hx:w/2+.14,hz:1.43,kind:'crate'});
 return [obj,trim];
}
gb3Crate(-41,13.6);gb3Crate(-15,13.4,3.8);gb3Crate(19,13.6,4.2);gb3Crate(42,14.2,3.3);
// Small shed on the yard side. Its walls are solid for shelter and guard sight.
box(61,2.6,17,9,5.2,7.5,'#3b4241');
box(61,5.43,17,10,.5,8.1,'#454946');
box(56.44,2.75,17,.18,5.5,7.9,'#2e3434');
box(61,2.85,13.18,9.05,4.9,.14,'#5d6662');
gb3Cover.push({x:61,z:17,hx:4.72,hz:3.85,kind:'shed'});
// Guard is drawn from inexpensive boxes, and hidden outside a patrol.
const gb3GuardMeshes=[];
function gb3GuardPart(dx,y,dz,w,h,d,color){
 const obj=box(-70, y,7.2,w,h,d,color);
 obj.guard=true;obj.guardOffset=[dx,y,dz];gb3GuardMeshes.push(obj);return obj;
}
gb3GuardPart(0,1.47,0,.7,.91,.42,'#152336'); // jacket
gb3GuardPart(0,2.19,0,.43,.43,.39,'#d8ae8c'); // head
gb3GuardPart(0,2.43,0,.60,.14,.57,'#101b25'); // hat
gb3GuardPart(-.44,1.38,0,.22,.83,.32,'#142337');
gb3GuardPart(.44,1.38,0,.22,.83,.32,'#142337');
gb3GuardPart(-.18,.57,0,.25,1.04,.32,'#20232b');
gb3GuardPart(.18,.57,0,.25,1.04,.32,'#20232b');
gb3GuardPart(0,1.54,.232,.23,.30,.038,'#ddd96c'); // reflective badge
// --- v1.9: photo stone yard below sleepers; configurable tiled texture.
// Upload a grass image in the Shopify section's Grass texture field. It is copied
// into a power-of-two WebGL texture so REPEAT works in WebGL1 on phones.
// Until then the single repeating texture is procedurally drawn and costs no HTTP request.
function grassGroundMesh(){
  const hw=115,hz=80,y=-.044;
  const tile=clamp(Number(root.dataset.floorTileSize)||4,2,20);
  const u=hw*2/tile,v=hz*2/tile;
  const verts=[
    -hw,y,-hz, 0,1,0, 0,0,   hw,y,-hz, 0,1,0, u,0,   hw,y,hz, 0,1,0,u,v,
    -hw,y,-hz, 0,1,0, 0,0,   hw,y,hz, 0,1,0,u,v,     -hw,y,hz, 0,1,0,0,v
  ];
  return mesh(verts);
}
function fallbackGrassCanvas(){
  const c=document.createElement('canvas');c.width=c.height=256;
  const ctx=c.getContext('2d');ctx.fillStyle='#45563a';ctx.fillRect(0,0,256,256);
  let seed=82641;const random=()=>{seed=(1664525*seed+1013904223)>>>0;return seed/4294967296};
  // Dense tiny grass blades; stable, not continuously regenerated.
  for(let i=0;i<10800;i++){
    const x=random()*256,y=random()*256;
    const green=46+Math.floor(random()*46),red=27+Math.floor(random()*39),blue=22+Math.floor(random()*24);
    ctx.strokeStyle=`rgba(${red},${green},${blue},${(.13+random()*.52).toFixed(2)})`;
    ctx.lineWidth=.4+random()*1.4;
    ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(x+(random()-.5)*3,y-1-random()*5);ctx.stroke();
  }
  // Repeat marks across opposite edges so the raster doesn't have bright seams.
  for(let i=0;i<260;i++){
    const x=random()*256,y=random()*256;
    const col=random()>.5?'rgba(145,154,91,.18)':'rgba(20,43,20,.25)';
    ctx.fillStyle=col;
    for(const dx of [-256,0,256])for(const dy of [-256,0,256]){
      ctx.beginPath();ctx.ellipse(x+dx,y+dy,1+random()*2,1+random()*2,0,0,TAU);ctx.fill();
    }
  }
  return c;
}
const yardGrass={shape:grassGroundMesh(),pos:[0,0,0],size:[1,1,1],rot:0,color:[1,1,1],metal:0,ground:true,tex:gl.createTexture()};
function uploadGrass(canvas){
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,yardGrass.tex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.REPEAT);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.REPEAT);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR_MIPMAP_LINEAR);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,canvas);
  gl.generateMipmap(gl.TEXTURE_2D);
}
uploadGrass(fallbackGrassCanvas());
scene.push(yardGrass);
if(root.dataset.floorUrl){
  const img=new Image();img.crossOrigin='anonymous';
  img.onload=()=>{
    const c=document.createElement('canvas');c.width=c.height=512;
    const ctx=c.getContext('2d');ctx.drawImage(img,0,0,512,512);
    uploadGrass(c);
  };
  img.onerror=()=>console.warn('GBattle yard texture could not load: keeping procedural tile');
  img.src=root.dataset.floorUrl;
}
// v2.2 — single-image panorama per wall: 1 opposite 3, 2 opposite 4.
// Normals face into the playable yard; walls are NOT spray targets.
const gb3Backdrop=[];
function gb3BackdropPlane(x,y,z,w,h,rotation,name){
 const o={shape:plane,pos:[x,y,z],size:[w,h,1],rot:rotation,color:[1,1,1],metal:0,backdrop:true,importTex:gl.createTexture(),name};
 gb3Backdrop.push(o);scene.push(o);
 gl.bindTexture(gl.TEXTURE_2D,o.importTex);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,new Uint8Array([92,159,213,255]));
 return o;
}
function gb3BackdropImage(o,url){
 if(!url)return;const image=new Image();image.crossOrigin='anonymous';
 image.onload=()=>{const cv=document.createElement('canvas');const scale=Math.min(1,1024/image.width);
 cv.width=Math.round(image.width*scale);cv.height=Math.round(image.height*scale);
 cv.getContext('2d').drawImage(image,0,0,cv.width,cv.height);
 gl.bindTexture(gl.TEXTURE_2D,o.importTex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,cv);
 };
 image.onerror=()=>console.warn('GBattle wall image failed:',o.name,url,'— confirm the jpg is uploaded to Shopify Assets.');image.src=url;
}
const gb3W1=gb3BackdropPlane(0,37.5,-79,226,75,0,'Wall 1 — north');
const gb3W3=gb3BackdropPlane(0,37.5,79,226,75,Math.PI,'Wall 3 — south');
const gb3W2=gb3BackdropPlane(113,37.5,0,158,75,-Math.PI/2,'Wall 2 — east');
const gb3W4=gb3BackdropPlane(-113,37.5,0,158,75,Math.PI/2,'Wall 4 — west');
// R43: the two full-size train lines each get their own tunnel portal.
// Track A is centred at z=0 and track B at z=-8. Both cut real holes in the
// original panorama, keeping the original photo UVs rather than overlaying
// dark geometry in front of a solid wall.
function gb3WallPatch(master,u0,v0,u1,v1){
 if(u1<=u0||v1<=v0)return;
 const quadPart=[
   u0-.5,v0-.5,0,0,0,1,u0,v0,  u1-.5,v0-.5,0,0,0,1,u1,v0,
   u1-.5,v1-.5,0,0,0,1,u1,v1,  u0-.5,v0-.5,0,0,0,1,u0,v0,
   u1-.5,v1-.5,0,0,0,1,u1,v1,  u0-.5,v1-.5,0,0,0,1,u0,v1
 ];
 scene.push({shape:mesh(quadPart),pos:master.pos,size:master.size,rot:master.rot,
   color:[1,1,1],metal:0,backdrop:true,importTex:master.importTex});
}
const GB3_PORTAL_HALF_WIDTH=3.55;
const GB3_PORTAL_HEIGHT=7.8;
for(const master of [gb3W2,gb3W4]){
 const i=scene.indexOf(master);if(i>=0)scene.splice(i,1);
 // East and west face opposite directions, so their local horizontal UV axes
 // run in opposite world-Z directions. Never use the same U for the B tunnel.
 const zDirection=master===gb3W2?1:-1;
 const windows=[0,GB3_SECOND_LINE_Z].map(z=>{
  const mid=.5+z*zDirection/158;
  return {a:mid-GB3_PORTAL_HALF_WIDTH/158,b:mid+GB3_PORTAL_HALF_WIDTH/158};
 }).sort((a,b)=>a.a-b.a);
 let cursor=0;
 for(const w of windows){
  gb3WallPatch(master,cursor,0,w.a,1);
  gb3WallPatch(master,w.a,GB3_PORTAL_HEIGHT/75,w.b,1);
  cursor=w.b;
 }
 gb3WallPatch(master,cursor,0,1,1);
}
// Concrete portal frames stand beside (not in front of) each rail opening.
for(const sign of [-1,1])for(const z of [0,GB3_SECOND_LINE_Z]){
 const mouth=sign*112.45,edge=GB3_PORTAL_HALF_WIDTH+.12;
 box(mouth,GB3_PORTAL_HEIGHT/2,z-edge,1.0,GB3_PORTAL_HEIGHT,.65,'#252b31');
 box(mouth,GB3_PORTAL_HEIGHT/2,z+edge,1.0,GB3_PORTAL_HEIGHT,.65,'#252b31');
 box(mouth,GB3_PORTAL_HEIGHT+.25,z,1.15,.5,2*GB3_PORTAL_HALF_WIDTH+1.1,'#1d2329');
 // Dark tunnel interior is further along the track, beyond the facade.
 box(sign*133,GB3_PORTAL_HEIGHT/2,z,.55,GB3_PORTAL_HEIGHT,2*GB3_PORTAL_HALF_WIDTH-.3,'#10141b');
}

// Shopify data-gb3-wall-1-url maps to dataset["gb3Wall-1Url"], NOT
// dataset.gb3Wall1Url: the hyphen before a digit is retained by DOMStringMap.
// Read the literal attribute so numbered walls always resolve reliably.
for(const [n,o] of [[1,gb3W1],[2,gb3W2],[3,gb3W3],[4,gb3W4]]){
 const url=root.getAttribute('data-gb3-wall-'+n+'-url');
 if(url && !/^(?:\s*|undefined|null)$/i.test(url)) gb3BackdropImage(o,url);
 else console.warn('GBattle: missing Wall '+n+' Shopify URL. Update sections/3D-graffiti.liquid.');
}
// Sky ceiling uses the tiny user-provided BLUE TILE with repeating UVs.
const gb3SkyShape=mesh([
 -113,75,-79,0,-1,0,0,0,113,75,-79,0,-1,0,24,0,113,75,79,0,-1,0,24,17,
 -113,75,-79,0,-1,0,0,0,113,75,79,0,-1,0,24,17,-113,75,79,0,-1,0,0,17]);
const gb3Sky={shape:gb3SkyShape,pos:[0,0,0],size:[1,1,1],rot:0,color:[1,1,1],metal:0,backdrop:true,importTex:gl.createTexture(),name:'Tiled Sky'};
scene.push(gb3Sky);
function gb3SkyTile(image){
 const cv=document.createElement('canvas');cv.width=cv.height=256;const ctx=cv.getContext('2d');
 // Make a power-of-two repeating texture, preserving the tile image.
 ctx.drawImage(image,0,0,256,256);
 gl.bindTexture(gl.TEXTURE_2D,gb3Sky.importTex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.REPEAT);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.REPEAT);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,cv);
}
{const fallback=document.createElement('canvas');fallback.width=fallback.height=256;fallback.getContext('2d').fillStyle='#58a7ef';fallback.getContext('2d').fillRect(0,0,256,256);gb3SkyTile(fallback)}
if(root.dataset.gb3SkyUrl){const skyImg=new Image();skyImg.crossOrigin='anonymous';skyImg.onload=()=>gb3SkyTile(skyImg);skyImg.src=root.dataset.gb3SkyUrl;}


// GB3_WORLD_YARD_V1: Alternate playable environments use procedural meshes; no train GLBs modified.
// Save the existing yard/guard scene as drawn. Each environment has its own cover objects.
for(const o of scene)if(!o.guard)o.gb3Map='yard';
let gb3ActiveMap='yard';
if(!['yard','depot','tunnel'].includes(gb3ActiveMap))gb3ActiveMap='yard';
const gb3TrafficCars=[];
function gb3Track(z,span=224){
 for(const r of [-1.02,1.02]){
  box(0,.13,z+r,span,.16,.17,'#adb5b3',1);
  box(0,.24,z+r+.19,span,.027,.045,'#75878a',1);
 }
 // Sleepers grouped into a single GPU buffer, preserving Android performance.
 const a=[],template=faces();
 for(let x=-span/2;x<span/2;x+=1.2){
  for(let i=0;i<template.length;i+=8)a.push(x+template[i]*.27,-.02+template[i+1]*.16,z+template[i+2]*3.2,template[i+3],template[i+4],template[i+5],template[i+6],template[i+7]);
 }
 scene.push({shape:mesh(a),pos:[0,0,0],size:[1,1,1],rot:0,color:hex('#51463d'),metal:0});
}
function gb3MapBounds(){
 if(gb3ActiveMap==='tunnel')return {minX:-90,maxX:90,minZ:-12.8,maxZ:5.8};
 if(gb3ActiveMap==='depot')return {minX:-81,maxX:81,minZ:-24.5,maxZ:24.5};
 return {minX:-82,maxX:82,minZ:-51,maxZ:51};
}
function gb3DepotScene(){
 const st=scene.length;
 // White repair depot with four rail lines and red structural beams.
 box(0,-.34,0,168,.65,66,'#f0f2f1');
 box(0,6.7,-25.5,168,13,.7,'#fbfbfb');
 box(0,6.7,25.5,168,13,.7,'#fbfbfb');
 box(0,13.5,0,168,.4,52.5,'#fbfbfb');
 // Red roof/column structure running front to back.
 for(let x=-78;x<=78;x+=13.5){
  box(x,6.6,-23.85,.58,13.1,.66,'#d94b49');
  box(x,6.6,23.85,.58,13.1,.66,'#d94b49');
 }
 for(const z of [-21,-12,-3,6,15,24]){
  box(0,12.25,z,168,.22,.55,'#d94b49');
 }
 for(const z of [-21,24])box(0,9.5,z,168,.18,.34,'#d94b49');
 // Ceiling light strips.
 for(let x=-72;x<=72;x+=13.5){
  for(const z of [-19.5,-10.5,-1.5,7.5,16.5]){
   box(x,12.95,z,6.8,.11,.85,'#ece9dd');
   box(x,12.86,z,5.9,.05,.42,'#fffff2');
  }
 }
 // Four rail lines: 3 static trains, 1 active center rail.
 const railZ=[-18,0,9,18];
 for(const z of railZ)gb3Track(z,164);
 // Main playable rail service pit.
 box(0,-.025,0,157,.07,1.38,'#272c30');
 for(const z of [-1.55,1.55])box(0,.07,z,155,.10,.09,'#d7b349');
 // Yellow lifting pillars only over line 1 and line 4.
 for(const z of [-18,18]){
  for(let x=-68;x<=68;x+=24){
   box(x,2.7,z-3.1,.92,5.4,.92,'#b18b02');
   box(x,2.7,z+3.1,.92,5.4,.92,'#b18b02');
   box(x,5.42,z,9.2,.42,8.4,'#b18b02');
  }
 }
 // Static trains for lines 1, 3 and 4. They are scenery only and never use the player's paint layer.
 // Actual selected GLB is instanced on the three rails after gb3LoadTrain; no placeholder geometry.
 // Minimal equipment cover kept clear of the new walking corridors.
 for(const [x,z,w,d] of [[-52,23,3.5,2.5],[-24,-23,3.5,2.5],[52,-23,3.5,2.5]]){
  box(x,1.15,z,w,2.3,d,'#d7b349');
  box(x,2.37,z,w+.1,.12,d+.1,'#6d7277');
  gb3Cover.push({x,z,hx:w/2+.1,hz:d/2+.1,kind:'equipment',map:'depot'});
 }
 // Entry frames / hall edges.
 for(const x of [-84,84]){
  box(x,7.7,-12.75,.6,10,22.5,'#d94b49');
  box(x,7.7,12.75,.6,10,22.5,'#d94b49');
  box(x,12.8,0,.6,.55,49.5,'#d94b49');
 }
 for(const o of scene.slice(st))o.gb3Map='depot';
}
// GB3_CAVE_TILED_TEXTURES_V1: only Tunnel Yard; Shopify theme asset URLs, not guessed paths.
// Resample uploaded 627px JPGs into 512x512 power-of-two textures for WebGL1 REPEAT.
function gb3CaveTexture(assetUrl,background,name){
 const tex=gl.createTexture();
 gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tex);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.REPEAT);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.REPEAT);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR_MIPMAP_LINEAR);
 gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
 const rgb=hex(background).map(v=>Math.round(v*255));
 gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,1,1,0,gl.RGBA,gl.UNSIGNED_BYTE,
   new Uint8Array([rgb[0],rgb[1],rgb[2],255]));
 gl.generateMipmap(gl.TEXTURE_2D);
 if(!assetUrl||/^(?:\s*|undefined|null)$/i.test(assetUrl)){
  console.warn('GBattle: missing '+name+' Shopify Asset URL; keeping tunnel base material');
  return tex;
 }
 const img=new Image();img.crossOrigin='anonymous';
 img.onload=()=>{
  const cv=document.createElement('canvas');cv.width=cv.height=512;
  cv.getContext('2d').drawImage(img,0,0,512,512);
  gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,tex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
  gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,cv);
  gl.generateMipmap(gl.TEXTURE_2D);
 };
 img.onerror=()=>console.warn('GBattle: '+name+' image failed; check Shopify Assets: '+assetUrl);
 img.src=assetUrl;
 return tex;
}

function gb3TunnelScene(){
 const st=scene.length;
 // Narrower tunnel footprint so movement stays inside the tunnel envelope.
 box(0,-.34,-3.2,224,.65,22,'#4a4b46');
 // Tiled cave gravel over cave ground only (tracks/walkways remain visible).
 // Real-world 4 m repeats; do not stretch the source image once over 224 m.
 const caveFloorTex=gb3CaveTexture(root.getAttribute('data-gb3-cave-floor-url'),'#4a4b46','cave-floor.jpg');
 const caveFloorY=-.012,caveX=112,caveZa=-14.2,caveZb=7.8;
 const caveFloorUVX=224/4,caveFloorUVZ=22/4;
 const caveFloorVerts=[
  -caveX,caveFloorY,caveZa,0,1,0,0,0,
  caveX,caveFloorY,caveZa,0,1,0,caveFloorUVX,0,
  caveX,caveFloorY,caveZb,0,1,0,caveFloorUVX,caveFloorUVZ,
  -caveX,caveFloorY,caveZa,0,1,0,0,0,
  caveX,caveFloorY,caveZb,0,1,0,caveFloorUVX,caveFloorUVZ,
  -caveX,caveFloorY,caveZb,0,1,0,0,caveFloorUVZ
 ];
 scene.push({shape:mesh(caveFloorVerts),pos:[0,0,0],size:[1,1,1],rot:0,
  color:[1,1,1],metal:0,importTex:caveFloorTex,name:'GB3_CAVE_FLOOR'});
 const shell=[];const cols=20,steps=32;
 for(let k=0;k<steps;k++){
  const x0=-112+k*7,x1=x0+7;
  for(let j=0;j<cols;j++){
   const u=j*Math.PI/cols,v=(j+1)*Math.PI/cols;
   const vertex=(x,t)=>[x,1.1+7.6*Math.sin(t),-3.0+12.6*Math.cos(t)];
   const a=vertex(x0,u),b=vertex(x1,u),c=vertex(x1,v),d=vertex(x0,v);
   const n=[0,-.78,-.24];
   // UV follows tunnel arc length and train direction, for dense seamless tiling.
   const uv0=[x0/4,(u*12.6)/4],uv1=[x1/4,(u*12.6)/4];
   const uv2=[x1/4,(v*12.6)/4],uv3=[x0/4,(v*12.6)/4];
   for(const [p,uv] of [[a,uv0],[b,uv1],[c,uv2],[a,uv0],[c,uv2],[d,uv3]])
    shell.push(...p,...n,...uv);
  }
 }
 const caveWallTex=gb3CaveTexture(root.getAttribute('data-gb3-cave-wall-url'),'#656660','cave-wall.jpg');
 scene.push({shape:mesh(shell),pos:[0,0,0],size:[1,1,1],rot:0,
  color:[1,1,1],metal:0,importTex:caveWallTex,name:'GB3_CAVE_WALL'});
 for(let x=-108;x<=108;x+=12){
  for(const z of [-12.4,4.9]){
   box(x,2.9,z,.22,4.6,.25,'#343638');
   box(x,4.62,z,.35,.22,.4,'#969c93');
  }
  for(const z of [-9.8,-7.3,-4.9])box(x,8.12,z,.32,.11,2.2,'#d0d4c3');
 }
 gb3Track(0);gb3Track(-7.2);
 // Walkways and cable trays brought 50% closer to the train.
 for(const z of [-10.4,2.8]){
  box(0,.16,z,221,.28,1.65,'#6c6e67');
  for(let y=1.9;y<=3.5;y+=.55)box(0,y,z>0?z+.86:z-.86,221,.085,.10,'#818981',1);
  box(0,4.05,z>0?z+.36:z-.36,221,.25,.54,'#43474a',1);
 }
 // Remove the large gap/box clutter; keep only slim shelter columns.
 for(const x of [-60,-18,24,66]){
  box(x,2.25,2.2,1.6,4.5,1.2,'#4e5659');
  box(x,4.56,2.2,1.9,.16,1.5,'#252e32');
  gb3Cover.push({x,z:2.2,hx:.95,hz:.78,kind:'pillar',map:'tunnel'});
 }
 // Tunnel train is drawn as a clean GPU instance of the selected model, never procedural boxes.
 for(const o of scene.slice(st))o.gb3Map='tunnel';
}
gb3DepotScene();gb3TunnelScene();
// Map switch is native and does not reload or clear spray textures.
const gb3MapSelect=document.createElement('select');gb3MapSelect.className='gb3-map-select';
gb3MapSelect.setAttribute('aria-label','Choose train yard map');gb3MapSelect.title='Switch between yards';
for(const [v,label] of [['yard','OUTDOOR YARD'],['depot','REPAIR DEPOT'],['tunnel','TUNNEL YARD']]){
 const option=document.createElement('option');option.value=v;option.textContent=label;gb3MapSelect.appendChild(option);
}
gb3MapSelect.value=gb3ActiveMap;
const gb3MapCSS=document.createElement('style');gb3MapCSS.textContent=`
.gb3-game .gb3-map-select{position:absolute;top:60px;right:10px;z-index:110;max-width:min(48vw,180px);padding:8px;border-radius:7px;background:#142027;color:#fff;border:1px solid #e8c84e;font-size:11px;font-weight:800;letter-spacing:.02em;pointer-events:auto}
.gb3-game.gb3-mobile .gb3-map-select{top:54px;max-width:130px;font-size:10px;padding:6px}`;
root.appendChild(gb3MapCSS);root.appendChild(gb3MapSelect);
// Isolated city route: no map/metro JS runs in the existing multiplayer yard.
// Stop the legacy map-change listener from selecting an unsupported map in place.
if(root.getAttribute('data-gb3-city-manifest-url')){
 const opt=document.createElement('option');opt.value='sodermalm';opt.textContent='SÖDERMALM · STOCKHOLM';gb3MapSelect.appendChild(opt);
 gb3MapSelect.addEventListener('change',event=>{
  if(gb3MapSelect.value!=='sodermalm')return;
  event.stopImmediatePropagation();
  const dest=new URL(location.href);dest.searchParams.set('gb3map','sodermalm');dest.searchParams.delete('gb3room');
  location.assign(dest.toString());
 },true);
}

gb3MapSelect.addEventListener('change',()=>{
 gb3ActiveMap=gb3MapSelect.value;
 root.dataset.gb3Map=gb3ActiveMap;
 cam.x=3;cam.z=gb3ActiveMap==='tunnel'?5.5:gb3ActiveMap==='depot'?21.8:16.5;
 gb3TunnelTraffic.elapsed=0;gb3TunnelTraffic.state='waiting';gb3TunnelTraffic.next=gb3ActiveMap==='tunnel'?20:90;
 // Current art, train model, WebGL context and cover/patrol system remain intact.
 try{const url=new URL(location.href);url.searchParams.set('gb3map',gb3ActiveMap);history.replaceState(history.state,'',url.toString())}catch(_){}
 toast(gb3ActiveMap==='depot'?'REPAIR DEPOT':gb3ActiveMap==='tunnel'?'TUNNEL YARD':'OUTDOOR YARD');
});
root.dataset.gb3Map=gb3ActiveMap;
const gb3TunnelTraffic={elapsed:0,state:'waiting',next:gb3ActiveMap==='tunnel'?22:90,dir:1,x:-155,horned:false};
function gb3StepTunnelTraffic(dt){
 if(gb3ActiveMap!=='tunnel'||!dt)return;
 const t=gb3TunnelTraffic;
 t.elapsed+=dt;
 if(t.state==='waiting'&&t.elapsed>=t.next){
  t.elapsed=0;t.state='warning';t.dir=Math.random()<.5?1:-1;t.horned=false;
  toast('APPROACHING TRAIN · SECOND TRACK');
 }
 if(t.state==='warning'){
  if(!t.horned){t.horned=true;gb3PlayTrainHorn()}
  if(t.elapsed>3.5){t.elapsed=0;t.state='passing';t.x=-155*t.dir;}
 }
 if(t.state==='passing'){
  t.x+=t.dir*dt*(Math.random()<.002?22:18);
  if(Math.abs(t.x)>165){t.state='waiting';t.elapsed=0;t.next=80+Math.random()*50;}
 }
 // Passing train position is used by gb3DrawSecondaryModels; no duplicate model meshes.
}
// Visible flashlight sweep used by the guard in every playable environment.
const gb3Flashlight={origin:[0,2.2,0],target:[0,1.0,-10]};
const gb3BeamShape=mesh([
  0,2.14,0, 0,1,0, .5,0,  -5.6,.06,-15.5, 0,1,0, 0,1,  5.6,.06,-15.5,0,1,0,1,1,
  0,2.14,0, 0,1,0,.5,0,  5.6,.06,-15.5,0,1,0,1,1, -5.6,.06,-15.5,0,1,0,0,1]);
const gb3Beam={shape:gb3BeamShape,pos:[0,0,0],size:[1,1,1],rot:0,color:hex('#d9e6b5'),metal:0,alpha:.12,beam:true};
function gb3StepFlashlight(){
 if(!gb3Security.active)return;
 const t=gb3Security.elapsed;
 gb3Flashlight.origin=[gb3Security.x,2.2,gb3Security.z];
 gb3Flashlight.target=[gb3Security.x+Math.sin(t*1.8)*8,1,gb3Security.z+9*Math.cos(t*.52)];
 const dx=gb3Flashlight.target[0]-gb3Security.x,dz=gb3Flashlight.target[2]-gb3Security.z;
 gb3Beam.pos[0]=gb3Security.x;gb3Beam.pos[2]=gb3Security.z;
 gb3Beam.rot=-Math.atan2(dx,-dz);
}

// Draw base geometry first, then texture layers using depth-tested alpha blending.
const opaque=scene.filter(x=>!x.panel);
const transparentTrain=[];
// Separate depot/tunnel instances share the exact loaded train geometry (zero extra model downloads).
const gb3Secondary={models:[],shells:[],slots:[-18,9,18],surfaces:[],epoch:0};
// SL C30 source: user-provided SketchUp Collada export, converted to two glTF 2.0 GLBs.
// Public train model assets are loaded from the game asset endpoint.
// Full source geometry and independent UV graffiti overlay, including curved/sloped exterior surfaces.
const C30_BASE='https://gbattle.sweink.com/3d/models/';
const c30LoadStatus={state:'loading',name:''};
// Train A: same imported C30 meshes + fitted graffiti shell, translated
// together. Only its world-space X changes: materials/UVs/paint are untouched.
const TRAIN_END_WALL_X=113,TRAIN_HALF_LENGTH=70.2,TRAIN_TUNNEL_MARGIN=6;
const TRAIN_OFFSCREEN=TRAIN_END_WALL_X+TRAIN_HALF_LENGTH+TRAIN_TUNNEL_MARGIN;
const TRAIN_DWELL_SECONDS=180,TRAIN_TUNNEL_SECONDS=10;
const TRAIN_ENTRY_SECONDS=18,TRAIN_EXIT_SECONDS=18;
const trainMotion={phase:'loading',elapsed:0,x:0};
// R42: independent opposite-direction train with its own 240-second dwell.
// The existing train uses 180 seconds. Both spend 10 s beyond the end wall.
const TRAIN2_DWELL_SECONDS=240;
const trainMotion2={phase:'loading',elapsed:0,x:0,synced:false};
const gb3TwinPanels=[];
const gb3TwinModels=[];
// R45: both trains travel in ONE direction while visible. After leaving their
// departure tunnel, they re-enter from the OPPOSITE end following a 10 s pause.
// This changes only the placement/clock state: train textures and paint SIDs stay separate.
function gb3TrainLoopAt(age,dwell,direction){
 const cycle=dwell+TRAIN_EXIT_SECONDS+TRAIN_TUNNEL_SECONDS+TRAIN_ENTRY_SECONDS;
 const t=((age%cycle)+cycle)%cycle;
 if(t<dwell)return {phase:'parked',elapsed:t,x:0};
 if(t<dwell+TRAIN_EXIT_SECONDS){const e=t-dwell;
  return {phase:'exiting',elapsed:e,x:direction*TRAIN_OFFSCREEN*trainSmooth(e/TRAIN_EXIT_SECONDS)};}
 if(t<dwell+TRAIN_EXIT_SECONDS+TRAIN_TUNNEL_SECONDS){
  return {phase:'tunnel',elapsed:t-dwell-TRAIN_EXIT_SECONDS,x:direction*TRAIN_OFFSCREEN};}
 const e=t-dwell-TRAIN_EXIT_SECONDS-TRAIN_TUNNEL_SECONDS;
 // Crucial: start beyond the OPPOSITE tunnel and come toward the center.
 return {phase:'entering',elapsed:e,x:-direction*TRAIN_OFFSCREEN*(1-trainSmooth(e/TRAIN_ENTRY_SECONDS))};
}
function gb3TwinCycle(age){return gb3TrainLoopAt(age,TRAIN2_DWELL_SECONDS,-1);}
function gb3SecondsToDeparture(age,dwell){
 const t=((age%(dwell+TRAIN_EXIT_SECONDS+TRAIN_TUNNEL_SECONDS+TRAIN_ENTRY_SECONDS))+
  dwell+TRAIN_EXIT_SECONDS+TRAIN_TUNNEL_SECONDS+TRAIN_ENTRY_SECONDS)%
  (dwell+TRAIN_EXIT_SECONDS+TRAIN_TUNNEL_SECONDS+TRAIN_ENTRY_SECONDS);
 return t<dwell?Math.max(0,Math.ceil(dwell-t)):0;
}
function gb3StepSecondTrain(dt,now){
 if(c30LoadStatus.state!=='ready')return;
 const prev=trainMotion2.phase;
 let age;
 if(gb3BetaMode){if(!gb3BetaJoinedRoom||!gb3BetaTrainClock)return;
  age=gb3BetaTrainClock.ageSeconds+(now-gb3BetaTrainClock.receivedAt)/1000;
 }else{gb3TwinLocalAge+=dt;age=gb3TwinLocalAge;}
 Object.assign(trainMotion2,gb3TwinCycle(age));
 const wasSynchronized=trainMotion2.synced;trainMotion2.synced=true;
 if(wasSynchronized&&prev!==trainMotion2.phase){
  if(prev==='parked'&&trainMotion2.phase==='exiting'){gb3PlayTrainHorn();gb3PlayTwinCue('journey');}
  if(trainMotion2.phase==='entering')gb3PlayTwinCue('arrival');
 }
}
let gb3TwinLocalAge=0;
function gb3PlayTwinCue(key){
 if(!gb3Sound.enabled||document.hidden||!gb3AudioContext||gb3AudioContext.state!=='running')return;
 const buffer=gb3AudioBuffers[key];
 if(!buffer){void gb3DecodeAudio(key);return;}
 try{const source=gb3AudioContext.createBufferSource();source.buffer=buffer;
  const gain=gb3AudioContext.createGain();gain.gain.value=.25;
  source.connect(gain);gain.connect(gb3AudioVolume);gb3HornSources.add(source);
  source.onended=()=>gb3HornSources.delete(source);source.start();
 }catch(e){console.warn('GBattle second train audio',e)}
}
// Shared beta train clock: a join response supplies server epoch and time.
// Avoid Date.now() client clock skew; performance.now() advances from server sync.
let gb3BetaTrainClock=null;
const GB3_TRAIN_CYCLE_SECONDS=TRAIN_DWELL_SECONDS+TRAIN_EXIT_SECONDS+TRAIN_TUNNEL_SECONDS+TRAIN_ENTRY_SECONDS;
// Console diagnostics: window.GB3_TRAIN_STATUS (read-only; no network changes).
Object.defineProperty(window,'GB3_TRAIN_STATUS',{configurable:true,get(){
 const clock=gb3BetaTrainClock;
 const now=performance.now();
 const age=clock?clock.ageSeconds+(now-clock.receivedAt)/1000:gb3TwinLocalAge;
 return {build:'R45-opposite-tunnel-return-two-trains',room:gb3BetaJoinedRoom||null,
  clockSource:clock?.source||(gb3BetaMode?'waiting-for-room':'local'),
  trainA:{phase:trainMotion.phase,x:Math.round(trainMotion.x*100)/100,
   elapsed:Math.round(trainMotion.elapsed),dwellSeconds:180,cycleSeconds:226,
   departure:'RIGHT',returnFrom:'LEFT',secondsUntilDeparture:gb3SecondsToDeparture(age,TRAIN_DWELL_SECONDS)},
  trainB:{phase:trainMotion2.phase,x:Math.round(trainMotion2.x*100)/100,
   elapsed:Math.round(trainMotion2.elapsed),dwellSeconds:240,cycleSeconds:286,
   departure:'LEFT',returnFrom:'RIGHT',secondsUntilDeparture:gb3SecondsToDeparture(age,TRAIN2_DWELL_SECONDS)},
  model:c30LoadStatus.state};
}});
// Default sound ON. Browser audio starts on the first permitted real gesture.
// User may switch SOUND OFF at any time; we NEVER automatically unmute it.
const gb3Sound={enabled:true,userChoice:false,unlocked:false,playedLoop:false,failed:false};
const gb3SoundButton=document.createElement('button');
gb3SoundButton.type='button';gb3SoundButton.className='gb3-sound-btn';
gb3SoundButton.title='Sound is on by default; playback starts after your first interaction. Click to mute.';
gb3SoundButton.setAttribute('aria-label','Mute train and spray sounds');
(root.querySelector('.top-actions')||root).prepend(gb3SoundButton);
// Models, brushes and audio all use the existing public server HTTPS host.
const gb3AudioBase=(root.dataset.gb3AudioBase||'https://gbattle.sweink.com/3d/audio/').replace(/\/?$/,'/');
// Verified historic server URL contract. Never request uninstalled Shopify audio assets.
// Original working horn is trainhorn.mp3; no old filename is referenced.
const gb3AudioURLs={
 arrival:[gb3AudioBase+'gb3-train-arrival.mp3'],
 journey:[gb3AudioBase+'gb3-train-departure.mp3'],
 spray:[gb3AudioBase+'gb3-spray-loop.mp3'],
 shake:[gb3AudioBase+'gb3-can-shake.mp3'],
 horn:[gb3AudioBase+'trainhorn.mp3']
};
const gb3AudioCtor=window.AudioContext||window.webkitAudioContext;
let gb3AudioContext=null,gb3AudioVolume=null,gb3CurrentSource=null;
let gb3CurrentKey=null,gb3SourceStartedAt=0;
const gb3AudioBuffers={},gb3AudioLoads={},gb3AudioFailedKeys=new Set();
let gb3SprayPainting=false,gb3SpraySource=null,gb3SprayGain=null,gb3NextShakeAt=0;
const gb3ShakeSources=new Set();
function gb3SetSoundLabel(message){
 gb3SoundButton.textContent=message&&message.includes('⚠')?'⚠':(gb3Sound.enabled?'🔊':'🔇');
  if(message)gb3SoundButton.title=message;
  else gb3SoundButton.title=gb3Sound.enabled?'Mute train and spray sounds':'Enable train and spray sounds';
 gb3SoundButton.setAttribute('aria-label',gb3Sound.enabled?'Mute train and spray sounds':'Enable train and spray sounds');
 gb3SoundButton.setAttribute('aria-pressed',String(gb3Sound.enabled));
}
gb3SetSoundLabel();
function gb3ActiveAudio(){
 if(c30LoadStatus.state!=='ready')return null;
 // The train's original arrival audio plays when it RETURNS from the far end.
 if(trainMotion.phase==='entering')return ['arrival',trainMotion.elapsed];
 if(trainMotion.phase==='exiting'||trainMotion.phase==='tunnel'){
  const seconds=trainMotion.phase==='exiting'?trainMotion.elapsed:TRAIN_EXIT_SECONDS+trainMotion.elapsed;
  return ['journey',seconds];
 }
 return null;
}
function gb3StopAudio(){
 if(gb3CurrentSource){try{gb3CurrentSource.stop()}catch(_){}try{gb3CurrentSource.disconnect()}catch(_){}}
 gb3CurrentSource=null;gb3CurrentKey=null;
}
function gb3StopSprayAudio(){
 gb3NextShakeAt=0;
 if(gb3SpraySource){
  const source=gb3SpraySource,gain=gb3SprayGain;
  gb3SpraySource=null;gb3SprayGain=null;
  try{
   const now=gb3AudioContext.currentTime;
   gain.gain.cancelScheduledValues(now);
   gain.gain.setValueAtTime(gain.gain.value,now);
   gain.gain.linearRampToValueAtTime(0,now+.075);
   source.stop(now+.085);
  }catch(_){try{source.stop()}catch(_){}}
 }
 // If a shake is in progress when spraying stops, cut it off too.
 for(const node of gb3ShakeSources){
  try{node.stop()}catch(_){}
  try{node.disconnect()}catch(_){}
 }
 gb3ShakeSources.clear();
}
function gb3StopAllAudio(){gb3StopAudio();gb3StopSprayAudio();for(const s of gb3HornSources){try{s.stop()}catch(_){} }gb3HornSources.clear();}
async function gb3DecodeAudio(key){
 if(gb3AudioBuffers[key])return gb3AudioBuffers[key];
 if(gb3AudioLoads[key])return gb3AudioLoads[key];
 if(!gb3AudioContext)return null;
 const order=[...new Set((gb3AudioURLs[key]||[]).filter(Boolean))];
 gb3AudioLoads[key]=(async()=>{
  const problems=[];
  for(const url of order){
   try{
    const resp=await fetch(url,{mode:'cors',credentials:'omit'});
    if(!resp.ok)throw Error('HTTP '+resp.status);
    if((resp.headers.get('content-type')||'').includes('text/html'))throw Error('HTML returned instead of audio');
    const buffer=await resp.arrayBuffer();
    const decoded=await gb3AudioContext.decodeAudioData(buffer);
    if(decoded.duration<(key==='shake'?.15:key==='spray'?1:key==='horn'?1:3))throw Error('Audio track too short');
    gb3AudioBuffers[key]=decoded;
    gb3AudioFailedKeys.delete(key);
    if(gb3Sound.enabled&&gb3AudioFailedKeys.size===0)gb3SetSoundLabel();
    gb3SyncAudio();gb3SyncSprayAudio();return decoded;
   }catch(err){
    problems.push({url,error:String(err?.message||err)});
    console.warn('GBattle: audio URL failed:',key,url,err);
   }
  }
  gb3AudioFailedKeys.add(key);
  if(gb3Sound.enabled)gb3SetSoundLabel('⚠ '+key.toUpperCase()+' AUDIO');
  gb3SoundButton.title='Could not load '+key+' from: '+order.join(' | ')+'; details in browser console';
  console.error('GBattle: no playable '+key+' audio found.',problems);
  return null;
 })();
 const result=await gb3AudioLoads[key];
 if(!result)delete gb3AudioLoads[key]; // permit retry after a network error
 return result;
}
function gb3SyncAudio(){
 const active=gb3ActiveAudio();
 if(!gb3Sound.enabled||document.hidden||!gb3AudioContext||gb3AudioContext.state!=='running'||!active){gb3StopAudio();return;}
 const [key,time]=active;
 const buffer=gb3AudioBuffers[key];
 if(!buffer){gb3StopAudio();if(!gb3AudioLoads[key])void gb3DecodeAudio(key);return;}
 const offset=Math.max(0,time);
 if(offset>=buffer.duration-.035){gb3StopAudio();return;}
 if(gb3CurrentSource&&gb3CurrentKey===key&&Math.abs((gb3AudioContext.currentTime-gb3SourceStartedAt)-offset)<1.0)return;
 gb3StopAudio();
 try{
  const source=gb3AudioContext.createBufferSource();source.buffer=buffer;
  source.connect(gb3AudioVolume);source.start(0,offset);
  gb3CurrentSource=source;gb3CurrentKey=key;gb3SourceStartedAt=gb3AudioContext.currentTime-offset;
  source.onended=()=>{if(gb3CurrentSource===source){gb3CurrentSource=null;gb3CurrentKey=null}};
 }catch(err){gb3Sound.failed=true;gb3SetSoundLabel('⚠ SOUND ERROR');console.warn('GBattle: train audio could not start',err)}
}
const gb3HornSources=new Set();
function gb3PlayTrainHorn(){
 if(!gb3Sound.enabled||!gb3AudioContext||gb3AudioContext.state!=='running')return;
 const buffer=gb3AudioBuffers.horn;
 if(!buffer){
  // The train horn can be triggered before CDN audio finishes decoding.
  // Await the existing in-flight load instead of permanently skipping this pass.
  void gb3DecodeAudio('horn').then(decoded=>{
   if(decoded&&gb3ActiveMap==='tunnel'&&
      (gb3TunnelTraffic.state==='warning'||gb3TunnelTraffic.state==='passing')&&
      gb3Sound.enabled&&!document.hidden){gb3PlayTrainHorn();}
  });
  return;
 }
 try{const src=gb3AudioContext.createBufferSource();src.buffer=buffer;
  const gain=gb3AudioContext.createGain();gain.gain.value=.62;
  src.connect(gain);gain.connect(gb3AudioVolume);gb3HornSources.add(src);src.onended=()=>gb3HornSources.delete(src);src.start();
 }catch(err){console.warn('GBattle train horn playback',err)}
}
function gb3PlayShake(){
 const ctx=gb3AudioContext,buffer=gb3AudioBuffers.shake;
 if(!ctx||!buffer||!gb3Sound.enabled||!gb3SprayPainting)return;
 try{
  const source=ctx.createBufferSource();source.buffer=buffer;
  const gain=ctx.createGain();gain.gain.value=.18+Math.random()*.18;
  source.playbackRate.value=.88+Math.random()*.25;
  source.connect(gain);gain.connect(gb3AudioVolume);
  gb3ShakeSources.add(source);
  source.onended=()=>{gb3ShakeSources.delete(source);try{source.disconnect()}catch(_){}};
  source.start();
 }catch(err){console.warn('GBattle: shake effect failed',err)}
}
function gb3SyncSprayAudio(){
 const canPlay=gb3Sound.enabled&&!document.hidden&&gb3AudioContext?.state==='running'&&gb3SprayPainting;
 if(!canPlay){gb3StopSprayAudio();return;}
 if(!gb3AudioBuffers.spray){if(!gb3AudioLoads.spray)void gb3DecodeAudio('spray');return;}
 if(!gb3AudioBuffers.shake&&!gb3AudioLoads.shake)void gb3DecodeAudio('shake');
 if(!gb3SpraySource){
  try{
   const ctx=gb3AudioContext,source=ctx.createBufferSource(),gain=ctx.createGain();
   source.buffer=gb3AudioBuffers.spray;source.loop=true;
   // Fade in/out to avoid clicks when the user releases the spray can.
   gain.gain.setValueAtTime(0,ctx.currentTime);
   gain.gain.linearRampToValueAtTime(.31,ctx.currentTime+.07);
   source.connect(gain);gain.connect(gb3AudioVolume);source.start();
   gb3SpraySource=source;gb3SprayGain=gain;
   gb3NextShakeAt=performance.now()+650+Math.random()*1800;
  }catch(err){console.warn('GBattle: spray effect could not start',err);return;}
 }
 if(performance.now()>=gb3NextShakeAt){
  gb3NextShakeAt=performance.now()+2200+Math.random()*3300;
  if(Math.random()<.8)gb3PlayShake();
 }
}
function gb3SetSprayPainting(active){
 const next=!!active;
 if(gb3SprayPainting===next)return;
 gb3SprayPainting=next;gb3SyncSprayAudio();
}
function gb3EnableAudio(){
 gb3Sound.enabled=true;gb3Sound.failed=false;
 if(!gb3AudioCtor){gb3Sound.failed=true;gb3SetSoundLabel('⚠ AUDIO UNSUPPORTED');return;}
 try{
  if(!gb3AudioContext){
   gb3AudioContext=new gb3AudioCtor();
   gb3AudioVolume=gb3AudioContext.createGain();gb3AudioVolume.gain.value=.65;
   gb3AudioVolume.connect(gb3AudioContext.destination);
  }
  // Called synchronously within a real click, pointerdown or keydown.
  const p=gb3AudioContext.resume();
  gb3Sound.unlocked=true;gb3SetSoundLabel();
  if(p?.then)p.then(()=>{gb3SyncAudio();gb3SyncSprayAudio()}).catch(e=>{gb3Sound.unlocked=false;if(gb3Sound.enabled)gb3SetSoundLabel('🔊 SOUND ON · TAP TO START');console.warn('GBattle: audio unlock failed',e)});
  for(const k of ['arrival','journey','spray','shake','horn'])void gb3DecodeAudio(k);
  gb3SyncAudio();gb3SyncSprayAudio();
 }catch(err){gb3Sound.failed=true;gb3SetSoundLabel('⚠ AUDIO ERROR');console.error('GBattle: audio device error',err)}
}
function gb3DisableAudio(){gb3Sound.enabled=false;gb3StopAllAudio();gb3SetSoundLabel();}
gb3SoundButton.addEventListener('click',e=>{
 e.stopPropagation();gb3Sound.userChoice=true;
 if(gb3Sound.enabled)gb3DisableAudio();else gb3EnableAudio();
});
// Sound starts ON; no extra ENABLE click needed. Browser autoplay policy still
// requires one real interaction to unlock Web Audio on many devices.
root.addEventListener('pointerdown',e=>{
 if(e.target.closest?.('.gb3-sound-btn'))return;
 if(gb3Sound.enabled&&(!gb3AudioContext||gb3AudioContext.state!=='running'))gb3EnableAudio();
},{capture:true});
root.addEventListener('keydown',e=>{
 if(e.repeat)return;
 if(gb3Sound.enabled&&(!gb3AudioContext||gb3AudioContext.state!=='running'))gb3EnableAudio();
},{capture:true});
document.addEventListener('visibilitychange',()=>{
 if(document.hidden){gb3StopAllAudio();gb3SprayPainting=false;}
 else if(gb3Sound.enabled&&gb3AudioContext){
  gb3AudioContext.resume().then(()=>{gb3SyncAudio();gb3SyncSprayAudio()}).catch(()=>gb3SetSoundLabel('🔊 SOUND ON · TAP TO START'));
 }
});
function trainSmooth(t){t=clamp(t,0,1);return t*t*(3-2*t)}
function changeTrainPhase(phase){
 trainMotion.phase=phase;trainMotion.elapsed=0;
 if(phase==='exiting'){gb3Sound.playedLoop=true;gb3PlayTrainHorn();}
 if(phase==='parked')gb3Sound.playedLoop=false;
 gb3SyncAudio();
 if(phase==='entering')trainMotion.x=-TRAIN_OFFSCREEN;
 if(phase==='parked')trainMotion.x=0;
 if(phase==='tunnel')trainMotion.x=TRAIN_OFFSCREEN;
 if(phase!=='parked')stopStroke();
 const hint=$('hint');
 if(phase==='entering')hint.textContent='TRAIN ARRIVING FROM THE TUNNEL';
 if(phase==='parked')hint.textContent='TRAIN PARKED · 3 MINUTES TO PAINT';
 if(phase==='exiting')hint.textContent='TRAIN DEPARTING · WATCH THE TUNNEL';
 if(phase==='tunnel')hint.textContent='TRAIN BEYOND TUNNEL · ENTERING OPPOSITE END IN 10 SECONDS';
}
function gb3SyncSharedTrainCycle(now){
 if(!gb3BetaJoinedRoom||!gb3BetaTrainClock||c30LoadStatus.state!=='ready')return;
 const age=gb3BetaTrainClock.ageSeconds+(now-gb3BetaTrainClock.receivedAt)/1000;
 const {phase,elapsed,x}=gb3TrainLoopAt(age,TRAIN_DWELL_SECONDS,1);
 const previous=trainMotion.phase;
 const first= !gb3BetaTrainClock.initialized;
 trainMotion.phase=phase;trainMotion.elapsed=elapsed;trainMotion.x=x;
 gb3BetaTrainClock.initialized=true;
 if(phase!==previous){
  // Do not honk for a player who joined while a train was already moving.
  if(!first&&previous==='parked'&&phase==='exiting')gb3PlayTrainHorn();
  if(phase!=='parked')stopStroke();
  const hint=$('hint');if(hint)hint.textContent=phase==='parked'?'TRAIN PARKED · 3 MINUTES TO PAINT':
   phase==='exiting'?'TRAIN DEPARTING · WATCH THE TUNNEL':
   phase==='tunnel'?'TRAIN BEYOND TUNNEL · ENTERING OPPOSITE END IN 10 SECONDS':'TRAIN ARRIVING FROM THE FAR END';
  gb3SyncAudio();
 }
}
function stepTrainMotion(dt){if(gb3BetaMode)return;
 if(c30LoadStatus.state!=='ready')return;
 if(!['entering','parked','exiting','tunnel'].includes(trainMotion.phase))return;
 trainMotion.elapsed+=dt;
 if(trainMotion.phase==='entering'){
  const t=trainSmooth(trainMotion.elapsed/TRAIN_ENTRY_SECONDS);
  trainMotion.x=-TRAIN_OFFSCREEN*(1-t);
  if(trainMotion.elapsed>=TRAIN_ENTRY_SECONDS)changeTrainPhase('parked');
 }else if(trainMotion.phase==='parked'){
  // Patrol takes precedence; do not dispatch the train while a guard is outside.
  if(gb3Security.active)return;
  if(trainMotion.elapsed>=TRAIN_DWELL_SECONDS)changeTrainPhase('exiting');
 }else if(trainMotion.phase==='exiting'){
  const t=trainSmooth(trainMotion.elapsed/TRAIN_EXIT_SECONDS);
  trainMotion.x=TRAIN_OFFSCREEN*t;
  if(trainMotion.elapsed>=TRAIN_EXIT_SECONDS)changeTrainPhase('tunnel');
 }else if(trainMotion.phase==='tunnel'){
  if(trainMotion.elapsed>=TRAIN_TUNNEL_SECONDS)changeTrainPhase('entering');
 }
}

async function readGLB(arrayBuffer){
 const dv=new DataView(arrayBuffer);if(arrayBuffer.byteLength<20||dv.getUint32(0,true)!==0x46546c67||dv.getUint32(4,true)!==2)throw Error('Invalid GLB version');
 let p=12,desc=null,bin=null;
 while(p+8<=arrayBuffer.byteLength){const len=dv.getUint32(p,true),kind=dv.getUint32(p+4,true);p+=8;
   if(p+len>arrayBuffer.byteLength)throw Error('Corrupt GLB chunk');
   if(kind===0x4e4f534a)desc=JSON.parse(new TextDecoder().decode(new Uint8Array(arrayBuffer,p,len)));
   if(kind===0x004e4942)bin=new Uint8Array(arrayBuffer,p,len);
   p+=len;
 }
 if(!desc||!bin||desc.asset?.version!=='2.0')throw Error('GLB missing glTF JSON or binary');
 function numbers(accessorId){
   const a=desc.accessors[accessorId],v=desc.bufferViews[a.bufferView];
   if(a.sparse)throw Error('Sparse GLB accessors are unsupported');
   const types={5126:[Float32Array,4],5125:[Uint32Array,4],5123:[Uint16Array,2],5122:[Int16Array,2],5121:[Uint8Array,1],5120:[Int8Array,1]};
   const t=types[a.componentType];if(!t)throw Error('Unsupported GLB component '+a.componentType);
   const fields={SCALAR:1,VEC2:2,VEC3:3,VEC4:4};const count=a.count*fields[a.type];
   const offset=bin.byteOffset+(v.byteOffset||0)+(a.byteOffset||0),width=fields[a.type];
   const stride=v.byteStride||width*t[1],span=a.count?(a.count-1)*stride+width*t[1]:0;
   if(!width||stride<width*t[1]||offset+span>bin.byteOffset+bin.byteLength||(a.byteOffset||0)+span>v.byteLength)throw Error('Out of bounds GLB accessor');
   let raw;
   if(stride===width*t[1])raw=new t[0](bin.buffer.slice(offset,offset+t[1]*count));
   else{
    raw=new t[0](count);const view=new DataView(bin.buffer);
    const getter=({5120:'getInt8',5121:'getUint8',5122:'getInt16',5123:'getUint16',5125:'getUint32',5126:'getFloat32'})[a.componentType];
    for(let row=0;row<a.count;row++)for(let col=0;col<width;col++)raw[row*width+col]=view[getter](offset+row*stride+col*t[1],true);
   }
   if(a.normalized&&a.componentType!==5126){
    const signed=a.componentType===5120||a.componentType===5122;
    const divisor=({5120:127,5121:255,5122:32767,5123:65535,5125:4294967295})[a.componentType];
    if(!divisor)throw Error('Unsupported normalized GLB component');
    return Float64Array.from(raw,v=>signed?Math.max(-1,v/divisor):v/divisor);
   }
   return raw;
 }

 // Preserve the original glTF material textures. Embedded images are loaded from
 // GLB bufferViews; no external model-related requests or hand-drawn decals.
 const gltfTextures=[];
 await Promise.all((desc.images||[]).map((im,index)=>new Promise((resolve,reject)=>{
   if(im.bufferView===undefined){reject(Error('GLB image is not embedded'));return;}
   const view=desc.bufferViews[im.bufferView];
   const blob=new Blob([bin.slice(view.byteOffset||0,(view.byteOffset||0)+view.byteLength)],{type:im.mimeType||'image/png'});
   const url=URL.createObjectURL(blob),image=new Image();
   image.onload=()=>{
     const t=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,t);
     gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,false);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
     gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
     gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,image);
     gltfTextures[index]=t;URL.revokeObjectURL(url);resolve();
   };
   image.onerror=()=>{URL.revokeObjectURL(url);reject(Error('Could not decode embedded glTF image '+index));};
   image.src=url;
 })));

 // C6 uses KHR_mesh_quantization with a standard per-mesh node transform;
 // the legacy C30 format remains float32 and is decoded exactly as before.
 const quantized=!!desc.extensionsUsed?.includes('KHR_mesh_quantization');
 const nodeByMesh=new Map();
 {
   for(const node of desc.nodes||[]){
     if(node.mesh!==undefined){
       if(nodeByMesh.has(node.mesh))throw Error('C6 quantized mesh has multiple instances');
       nodeByMesh.set(node.mesh,node);
     }
   }
 }

 const parts=[];
 for(const [meshId,meshDef] of (desc.meshes||[]).entries()){
  for(const prim of meshDef.primitives||[]){
    if(prim.mode!==undefined&&prim.mode!==4)continue;
    const positions=numbers(prim.attributes.POSITION),normals=prim.attributes.NORMAL!==undefined?numbers(prim.attributes.NORMAL):null,uvs=prim.attributes.TEXCOORD_0!==undefined?numbers(prim.attributes.TEXCOORD_0):null;
    const vertexTint=prim.attributes.COLOR_0!==undefined?numbers(prim.attributes.COLOR_0):null;
    const tintFields=vertexTint?(desc.accessors[prim.attributes.COLOR_0].type==='VEC4'?4:3):0;
    const quantNode=nodeByMesh.get(meshId);
    if(quantNode?.matrix||quantNode?.rotation||quantNode?.children)throw Error('Train loader requires baked node rotations and hierarchy');
    const qscale=quantNode?.scale||[1,1,1],qoffset=quantNode?.translation||[0,0,0];
    if(qscale.some(v=>!Number.isFinite(v)||v===0))throw Error('Invalid train node scale');
    const idx=prim.indices!==undefined?numbers(prim.indices):Uint32Array.from({length:positions.length/3},(_,i)=>i);
    // Safeguard mobile devices against unexpectedly huge external GLBs.
    if(idx.length>1800000)throw Error('Train model exceeds safety limit');
    const raw=new Float32Array(idx.length*8),colors=vertexTint?new Float32Array(idx.length*3):null;
    const positionDenominator=quantized&&desc.accessors[prim.attributes.POSITION].componentType===5123&&!desc.accessors[prim.attributes.POSITION].normalized?65535:1;
    const tintToSrgb=c=>c<=.0031308?12.92*c:1.055*Math.pow(c,1/2.4)-.055;
    for(let i=0;i<idx.length;i++){
      const k=idx[i],b=i*8,h=k*3;
      if(h+2>=positions.length)throw Error('Invalid model index');
      raw[b]=qoffset[0]+qscale[0]*positions[h]/positionDenominator;
      raw[b+1]=qoffset[1]+qscale[1]*positions[h+1]/positionDenominator;
      raw[b+2]=qoffset[2]+qscale[2]*positions[h+2]/positionDenominator;
      const nx=normals?normals[h]/qscale[0]:0,ny=normals?normals[h+1]/qscale[1]:1,nz=normals?normals[h+2]/qscale[2]:0;
      const invN=1/(Math.hypot(nx,ny,nz)||1);
      raw[b+3]=nx*invN;raw[b+4]=ny*invN;raw[b+5]=nz*invN;
      raw[b+6]=uvs?uvs[k*2]:0;raw[b+7]=uvs?uvs[k*2+1]:0;
      if(colors)for(let channel=0;channel<3;channel++)colors[i*3+channel]=tintToSrgb(vertexTint[k*tintFields+channel]);
    }
    // A few retained legacy train faces have zero normals. Use their actual
    // triangle normal instead of sending normalize(vec3(0)) into the shader.
    for(let i=0;i<raw.length;i+=24){
     if(Math.hypot(raw[i+3],raw[i+4],raw[i+5])<1e-8||Math.hypot(raw[i+11],raw[i+12],raw[i+13])<1e-8||Math.hypot(raw[i+19],raw[i+20],raw[i+21])<1e-8){
      const ax=raw[i+8]-raw[i],ay=raw[i+9]-raw[i+1],az=raw[i+10]-raw[i+2];
      const bx=raw[i+16]-raw[i],by=raw[i+17]-raw[i+1],bz=raw[i+18]-raw[i+2];
      let nx=ay*bz-az*by,ny=az*bx-ax*bz,nz=ax*by-ay*bx;const length=Math.hypot(nx,ny,nz);
      if(length>1e-12){nx/=length;ny/=length;nz/=length;}else{nx=0;ny=1;nz=0;}
      for(let j=0;j<24;j+=8)if(Math.hypot(raw[i+j+3],raw[i+j+4],raw[i+j+5])<1e-8){raw[i+j+3]=nx;raw[i+j+4]=ny;raw[i+j+5]=nz;}
     }
    }
    const mat=desc.materials?.[prim.material]||{};
    const tint=mat.pbrMetallicRoughness?.baseColorFactor||[.72,.72,.72,1];
    const tid=mat.pbrMetallicRoughness?.baseColorTexture?.index;
    const source=tid===undefined?undefined:desc.textures?.[tid]?.source;
    parts.push({vertices:raw,colors,color:tint.slice(0,3),metal:mat.pbrMetallicRoughness?.metallicFactor||0,alpha:mat.alphaMode==='BLEND'?tint[3]:1,tex:source===undefined?null:gltfTextures[source],name:meshDef.name||''});
  }
 }
 if(!parts.length)throw Error('Model has no supported triangle meshes');
 return parts;
}
// A lightweight spatial AABB check followed by triangle raycasting lets paint follow
// the actual C30 exterior (including doors, glazing, upper panels, ends and roof).
// The train is never recolored/rebuilt when spraying: a separate alpha texture overlay
// is depth-tested against the original train mesh.
// Multiplayer artwork is saved by surface ID in the room journal. Keep each
// train model in its own SID range so matching faces on other train types never
// replay the same strokes. C30 keeps its established live IDs for compatibility.
const GB3_MODEL_SURFACE_BASES=Object.freeze({
 c6:{main:520,twin:620},'paris-mp73':{main:670,twin:720},
 'santiago-ns74':{main:770,twin:820},'london-2009stock':{main:870,twin:920}
});
function gb3TrainSurfaceSID(trainKey,index,twin=false){
 if(trainKey==='c30')return twin?(index<50?360+index:460+index-50):(index<50?index:410+index-50);
 const base=GB3_MODEL_SURFACE_BASES[trainKey];
 if(!base)return -1;
 return base[twin?'twin':'main']+index;
}
function createSurfacePanel(part,idx,trainKey,twin=false){
 const name=part.name||('PAINT_surface_'+idx);
 const region=name.includes('roof')?'roof':name.includes('end')?'end':'side';
 const isPhone=isTouchDevice;
 const overflow=name.startsWith('PAINT_extra_');
 const w=overflow?(isPhone?384:512):region==='end'?(isPhone?384:512):(isPhone?768:1024);
 const h=overflow?(isPhone?128:160):region==='end'?w:(isPhone?240:320);
 const p=panel(name,0,1,region==='end'?3.04:8.767,{width:w,pixelHeight:h});
 p.shape=mesh(part.vertices);p.pos=[0,0,0];p.size=[1,1,1];p.rot=0;
 p.surface=true;p.region=region;p.raw=part.vertices;
 p.gb3BetaSID=gb3TrainSurfaceSID(trainKey,idx,twin);
 let mi=[Infinity,Infinity,Infinity],ma=[-Infinity,-Infinity,-Infinity];
 for(let i=0;i<p.raw.length;i+=8){for(let k=0;k<3;k++){const v=p.raw[i+k];if(v<mi[k])mi[k]=v;if(v>ma[k])ma[k]=v}}
 p.bounds=[mi,ma];return p;
}
// GB3_SECONDARY_INSTANCE_V2: three independently paintable copies of exactly the selected train.
// Their graphics buffers are shared with the original; their paint textures and save keys are not.
function gb3SecondaryKey(slot){return 'gb3-depot-static-v2:'+gb3PaintSaveKey+':rail-'+slot;}
function gb3SecondaryClear(){
 for(const p of gb3Secondary.surfaces){try{gl.deleteTexture(p.tex)}catch(_){}}
 gb3Secondary.models=[];gb3Secondary.shells=[];gb3Secondary.surfaces=[];
 gb3Secondary.epoch++;
}
function gb3SecondaryInit(models,shells){if(gb3BetaMode)return;
 gb3SecondaryClear();gb3Secondary.models=models;gb3Secondary.shells=shells;
 // Use the exact source paint geometry/UV but independent low-resolution canvas textures.
 // Same saved artwork stays specific to model identity AND depot rail number.
 for(let slot=0;slot<3;slot++){
  const row=[];
  for(const original of shells){
   const canvas=document.createElement('canvas');
   canvas.width=Math.min(original.canvas.width,isTouchDevice?256:384);
   canvas.height=Math.min(original.canvas.height,isTouchDevice?96:128);
   const ctx=canvas.getContext('2d',{willReadFrequently:true});
   const tex=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,tex);
   gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
   gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
   gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,canvas);
   row.push({...original,canvas,ctx,tex,gb3Slot:slot,gb3StaticOffset:gb3Secondary.slots[slot]});
  }
  gb3Secondary.surfaces.push(row);
 }
 if(db)gb3SecondaryRestore();
}
function gb3SecondarySave(){if(gb3BetaMode)return;
 if(!db||!['ready','switching'].includes(c30LoadStatus.state)||gb3PaintRestoring)return;
 try{
  const tx=db.transaction('paint','readwrite');const store=tx.objectStore('paint');
  gb3Secondary.surfaces.forEach((row,slot)=>{
   store.put({version:1,created:Date.now(),layers:Object.fromEntries(row.map(p=>[p.name,p.canvas.toDataURL('image/png')]))},gb3SecondaryKey(slot));
  });
 }catch(e){console.warn('GBattle: independent depot paint save failed',e)}
}
function gb3SecondaryRestore(){
 if(!db||!gb3Secondary.surfaces.length)return;
 const epoch=gb3Secondary.epoch,key=gb3PaintSaveKey;
 try{
  for(let slot=0;slot<3;slot++){
   const request=db.transaction('paint','readonly').objectStore('paint').get(gb3SecondaryKey(slot));
   request.onsuccess=()=>{
    if(epoch!==gb3Secondary.epoch||key!==gb3PaintSaveKey)return;
    const saved=request.result;if(saved?.version!==1||!saved.layers)return;
    for(const p of gb3Secondary.surfaces[slot]){
     const url=saved.layers[p.name];if(!url?.startsWith('data:image/png;base64,'))continue;
     const im=new Image();im.onload=()=>{
      if(epoch!==gb3Secondary.epoch||key!==gb3PaintSaveKey)return;
      p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);
      p.ctx.drawImage(im,0,0,p.canvas.width,p.canvas.height);dirty.add(p);
     };im.src=url;
    }
   };
  }
 }catch(e){console.warn('GBattle: independent depot paint restore failed',e)}
}
function gb3SecondaryPaintHit(x,y,dir,best,reach,rayOrigin){
 if(gb3ActiveMap!=='depot'||!gb3Secondary.surfaces.length)return best;
 for(const row of gb3Secondary.surfaces){
  for(const p of row){
   const origin=[rayOrigin[0],rayOrigin[1],rayOrigin[2]-p.gb3StaticOffset];
   const hit=surfaceHit(origin,dir,p,best?Math.min(best.distance,reach):reach);
   if(hit&&(!best||hit.distance<best.distance)){
    hit.world[2]+=p.gb3StaticOffset;
    best=hit;
   }
  }
 }
 return best;
}
function gb3DrawSecondaryModels(transparent=false){
 if(c30LoadStatus.state!=='ready'||!gb3Secondary.models.length)return;
 if(gb3ActiveMap==='depot'){
  for(const z of gb3Secondary.slots){
   for(const part of gb3Secondary.models){
    if(!!part.translucent!==transparent)continue;
    renderPart({...part,imported:false,gb3SecondaryInstance:true,pos:[0,0,z]});
   }
  }
  if(transparent){
   for(const row of gb3Secondary.surfaces)for(const p of row){
    renderPart({...p,panel:true,surface:false,gb3SecondaryInstance:true,pos:[0,0,p.gb3StaticOffset]});
   }
  }
 }else if(gb3ActiveMap==='tunnel'&&gb3TunnelTraffic.state==='passing'){
  for(const part of gb3Secondary.models){
   if(!!part.translucent!==transparent)continue;
   renderPart({...part,imported:false,gb3SecondaryInstance:true,pos:[gb3TunnelTraffic.x,0,-7.2]});
  }
 }
}
function rayBox(o,d,p,maxDistance){
 let low=.08,high=maxDistance;const b=p.bounds;
 for(let k=0;k<3;k++){
  if(Math.abs(d[k])<1e-9){if(o[k]<b[0][k]-.02||o[k]>b[1][k]+.02)return false;continue}
  let a=(b[0][k]-.02-o[k])/d[k],c=(b[1][k]+.02-o[k])/d[k];
  if(a>c){const x=a;a=c;c=x}low=Math.max(low,a);high=Math.min(high,c);
  if(low>high)return false;
 }return true;
}
function surfaceHit(origin,dir,p,maxDist){
 if(!rayBox(origin,dir,p,maxDist))return null;
 const a=p.raw;let best=maxDist,uu=0,vv=0,wx=0,wy=0,wz=0,hitNormal=null,viewAngle=0;
 for(let i=0;i<a.length;i+=24){
   const x0=a[i],y0=a[i+1],z0=a[i+2];
   const e1x=a[i+8]-x0,e1y=a[i+9]-y0,e1z=a[i+10]-z0;
   const e2x=a[i+16]-x0,e2y=a[i+17]-y0,e2z=a[i+18]-z0;
   const px=dir[1]*e2z-dir[2]*e2y,py=dir[2]*e2x-dir[0]*e2z,pz=dir[0]*e2y-dir[1]*e2x;
   const det=e1x*px+e1y*py+e1z*pz;if(Math.abs(det)<1e-8)continue;
   const inv=1/det,tx=origin[0]-x0,ty=origin[1]-y0,tz=origin[2]-z0;
   const u=(tx*px+ty*py+tz*pz)*inv;if(u<-.0001||u>1.0001)continue;
   const qx=ty*e1z-tz*e1y,qy=tz*e1x-tx*e1z,qz=tx*e1y-ty*e1x;
   const v=(dir[0]*qx+dir[1]*qy+dir[2]*qz)*inv;if(v<-.0001||u+v>1.0001)continue;
   const t=(e2x*qx+e2y*qy+e2z*qz)*inv;
   if(t>.08&&t<best){best=t;const b=1-u-v;
     uu=a[i+6]*b+a[i+14]*u+a[i+22]*v;
     vv=a[i+7]*b+a[i+15]*u+a[i+23]*v;
     wx=origin[0]+dir[0]*t;wy=origin[1]+dir[1]*t;wz=origin[2]+dir[2]*t;
      const nx=e1y*e2z-e1z*e2y,ny=e1z*e2x-e1x*e2z,nz=e1x*e2y-e1y*e2x;
      const invN=1/(Math.hypot(nx,ny,nz)||1),facing=nx*dir[0]+ny*dir[1]+nz*dir[2]>0?-1:1;
      hitNormal=[nx*invN*facing,ny*invN*facing,nz*invN*facing];
      // Projection of the camera's spray ray onto the 3D face. Convert its
      // surface-tangent direction to the paint shell's pixel UV axes so grazing
      // marks smear along the VIEWING direction rather than mouse travel.
      const nDot=dir[0]*hitNormal[0]+dir[1]*hitNormal[1]+dir[2]*hitNormal[2];
      const sx=dir[0]-nDot*hitNormal[0],sy=dir[1]-nDot*hitNormal[1],sz=dir[2]-nDot*hitNormal[2];
      const aa=e1x*e1x+e1y*e1y+e1z*e1z,bb=e1x*e2x+e1y*e2y+e1z*e2z,cc=e2x*e2x+e2y*e2y+e2z*e2z;
      const dd=sx*e1x+sy*e1y+sz*e1z,ee=sx*e2x+sy*e2y+sz*e2z,detUV=aa*cc-bb*bb;
      if(detUV>1e-12){
       const ta=(dd*cc-ee*bb)/detUV,tb=(ee*aa-dd*bb)/detUV;
       const du=(ta*(a[i+14]-a[i+6])+tb*(a[i+22]-a[i+6]))*p.canvas.width;
       const dv=-(ta*(a[i+15]-a[i+7])+tb*(a[i+23]-a[i+7]))*p.canvas.height;
       viewAngle=du*du+dv*dv>1e-8?Math.atan2(dv,du):0;
      }else viewAngle=0;
   }
 }
 return best<maxDist?{p,distance:best,u:clamp(uu,0,1),v:clamp(1-vv,0,1),world:[wx,wy,wz],normal:hitNormal,ray:dir,viewAngle}:null;
}
// Change trains without navigating away from the yard or resetting WebGL.
// The old train stays on screen while both assets are downloaded and decoded.
// C6 always requests fresh bytes on both desktop and Android (same stable filenames).
let gb3ModelEpoch=0;
let gb3TrainWalkBounds=null;
function gb3TrainOccupies(x,z){
 if(!gb3TrainWalkBounds||c30LoadStatus.state!=='ready')return false;
 const b=gb3TrainWalkBounds;
 const inside=(shift,side)=>x>shift+b.minX-.62&&x<shift+b.maxX+.62&&
        z>side+b.minZ-.55&&z<side+b.maxZ+.55;
 if(gb3ActiveMap==='depot'&&gb3Secondary.slots.some(rail=>inside(0,rail)))return true;
 return (trainMotion.phase!=='tunnel'&&inside(trainMotion.x,0))||(trainMotion2.phase!=='tunnel'&&
  x>trainMotion2.x-b.maxX-.62&&x<trainMotion2.x-b.minX+.62&&
  z>GB3_SECOND_LINE_Z-b.maxZ-.55&&z<GB3_SECOND_LINE_Z-b.minZ+.55);
}

async function gb3LoadTrain(target=gb3TrainSelection,swapping=false){
 const id=gb3KeyToPublic[target]||target;
 const train=gb3TrainRegistry[id];
 if(!train)throw Error('Unknown requested train: '+String(target));
 const trainKey=train.key,trainName=train.name,saveKey=train.save;
 const previousState=c30LoadStatus.state;
 const size=isTouchDevice?'mobile':'desktop';
 const modelFile=train.models?train.models[size]:train.model;
 const paintFile=train.paint;
 c30LoadStatus.state=swapping?'switching':'loading';
 try{
  const fresh=String(Date.now());
  async function fetchModel(file){
   // C30 existing cache policy stays unchanged; newer stable filenames refresh.
   const refresh=trainKey!=='c30';
   const url=C30_BASE+file+(refresh?'?fresh='+fresh:'');
   let response;
   try{response=await fetch(url,{mode:'cors',credentials:'omit',cache:refresh?'no-store':'default'});}catch(err){
    // Some Android browser caches retain failed previous map/model fetches.
    console.warn('GBattle model fetch retry:',file,err);
   }
   if(!response?.ok){
    // Only a failed model fetch is retried; the normal train cache is unchanged.
    const retryURL=C30_BASE+file+'?gb3-model-retry='+encodeURIComponent(Date.now());
    response=await fetch(retryURL,{mode:'cors',credentials:'omit',cache:'no-store'});
   }
   if(!response.ok)throw Error('Unable to load '+file+' (HTTP '+response.status+')');
   return response.arrayBuffer();
  }
  // Original C6/C30/London keep their existing two-file loader unchanged.
  // Paris MP-73 and Santiago NS-74 carry base mesh, embedded materials and PAINT_ geometry in one GLB.
  const [shellBuffer,modelBuffer]=train.combined?[null,await fetchModel(modelFile)]:await Promise.all([fetchModel(paintFile),fetchModel(modelFile)]);
  const combinedParts=train.combined?await readGLB(modelBuffer):null;
  const shells=train.combined?combinedParts.filter(p=>p.name.startsWith('PAINT_')):await readGLB(shellBuffer);
  if((trainKey==='c30'||trainKey==='c6')?(shells.length<50||shells.length>100):(shells.length!==50))throw Error(trainName+' paint surface is incomplete');
  if(shells.length<30)throw Error(trainName+' paint surface is incomplete');
  const parts=train.combined?combinedParts.filter(p=>!p.name.startsWith('PAINT_')):await readGLB(modelBuffer);
  if(!parts.length)throw Error('Empty train model: '+modelFile);
  // Compute the actual occupied footprint of THIS train (not C30's former fixed 144m barrier).
  const nextWalkBounds={minX:Infinity,maxX:-Infinity,minZ:Infinity,maxZ:-Infinity};
  for(const p of parts){const v=p.vertices;for(let i=0;i<v.length;i+=8){
   nextWalkBounds.minX=Math.min(nextWalkBounds.minX,v[i]);
   nextWalkBounds.maxX=Math.max(nextWalkBounds.maxX,v[i]);
   nextWalkBounds.minZ=Math.min(nextWalkBounds.minZ,v[i+2]);
   nextWalkBounds.maxZ=Math.max(nextWalkBounds.maxZ,v[i+2]);
  }}
  if(!Number.isFinite(nextWalkBounds.minX)||nextWalkBounds.maxX-nextWalkBounds.minX<1)throw Error('Invalid train collision bounds');
  const linearToSrgb=c=>c<=.0031308?12.92*c:1.055*Math.pow(c,1/2.4)-.055;
  const modelParts=parts.map(part=>({shape:mesh(part.vertices,part.colors),pos:[0,0,0],size:[1,1,1],
   color:part.color.map(linearToSrgb),metal:part.metal,rot:0,imported:true,
   importTex:part.tex||null,alpha:part.alpha,translucent:part.alpha<.999,c30ColorLock:trainKey==='c30'}));
  // Prepare the matching graffiti layers without altering the currently visible train.
  const previousPanels=panels;
  let preparedPanels;
  panels=[];
  try{
   shells.forEach((part,i)=>createSurfacePanel(part,i,trainKey,false));
   preparedPanels=panels;
  }catch(err){
   for(const p of panels){gl.deleteTexture(p.tex);gb3DeleteMesh(p.shape);}
   for(const o of modelParts)gb3DeleteMesh(o.shape);
   panels=previousPanels;
   throw err;
  }
  panels=previousPanels;
  // R42: independent graffiti canvases for train B, with original UV and model mesh.
  // The train body's GPU buffers are shared; B's paint textures are NOT shared.
  const preparedTwin=[];
  const originalList=panels;
  panels=[];
  try{
   shells.forEach((part,i)=>{
    const p=createSurfacePanel(part,i,trainKey,true);
    p.name+=':line-b';p.gb3Twin=true;p.gb3Map='yard';p.pos[2]=GB3_SECOND_LINE_Z;p.rot=Math.PI;
   });
   preparedTwin.push(...panels);
  }catch(err){
   for(const p of panels){gl.deleteTexture(p.tex);gb3DeleteMesh(p.shape);}
   panels=originalList;throw err;
  }
  panels=originalList;
  // Atomic model swap: the WebGL context, camera, UI and yard stay alive.
  const oldTrain=opaque.filter(o=>o.imported).concat(transparentTrain);
  const oldTextures=new Set(oldTrain.map(o=>o.importTex).filter(Boolean));
  const oldYard=opaque.filter(o=>!o.imported);
  stopStroke();gb3SecondarySave();clearTimeout(saveTimer);
  dirty.clear();wetPools.length=0;activeDrips.length=0;undo=[];
  panels=preparedPanels;
  for(const p of gb3TwinPanels){gl.deleteTexture(p.tex);gb3DeleteMesh(p.shape);}
  gb3TwinPanels.splice(0,gb3TwinPanels.length,...preparedTwin);
  gb3TwinModels.splice(0,gb3TwinModels.length,...modelParts.map(o=>({...o,gb3Twin:true,gb3Map:'yard',pos:[0,0,GB3_SECOND_LINE_Z],rot:Math.PI})));
  gb3TrainWalkBounds=nextWalkBounds;
  opaque.splice(0,opaque.length,...oldYard,...modelParts.filter(o=>!o.translucent),...gb3TwinModels.filter(o=>!o.translucent));
  transparentTrain.splice(0,transparentTrain.length,...modelParts.filter(o=>o.translucent),...gb3TwinModels.filter(o=>o.translucent));
  for(const p of previousPanels){gl.deleteTexture(p.tex);gb3DeleteMesh(p.shape);}
  for(const shape of new Set(oldTrain.map(o=>o.shape)))gb3DeleteMesh(shape);
  for(const t of oldTextures)gl.deleteTexture(t);
  gb3TrainSelection=trainKey;
  gb3TrainName=trainName;
  gb3PaintSaveKey=saveKey;
  gb3SecondaryInit(modelParts,preparedPanels);
  root.dataset.gb3Train=trainKey;
  c30LoadStatus.state='ready';c30LoadStatus.name=modelFile;
  gb3ModelEpoch++;
  strokes=0;
  $('paintedCount').textContent='0 strokes';
  $('undoCount').textContent='0 / 7';
  $('saveState').textContent=gb3BetaMode?'ROOM SYNC':'LOCAL ONLY';
  // In-game changes park the replacement train immediately, with no fade to black.
  changeTrainPhase(gb3BetaMode?'parked':(swapping?'parked':'entering'));gb3TwinLocalAge=0;Object.assign(trainMotion2,{phase:'parked',elapsed:0,x:0,synced:false});
  const caughtText=gb3Caught.querySelector('.gb3-caught-card span');
  if(caughtText)caughtText.textContent='Your graffiti was cleared. The '+trainName+' stays parked.';
  if(!gb3BetaMode)gb3RestoreTrainPaint(saveKey,gb3ModelEpoch);
  if(gb3BetaMode)gb3BetaModelReady();
  toast(trainName+' ready'); // Never expose file types or source formats to players.
  console.info('GBattle 3D: active train',trainName,'model fetched',modelFile,'bytes',modelBuffer.byteLength,
   'cache mode',trainKey!=='c30'?'no-store':'default');
  return true;
 }catch(err){
  c30LoadStatus.state=swapping&&previousState==='ready'?'ready':'error';
  if(c30LoadStatus.state==='error')c30LoadStatus.name=String(err.message||err);
  console.error('GBattle '+trainName+' failed to load:',err);
  if(c30LoadStatus.state==='error')$('hint').textContent=trainName+' UNAVAILABLE · CHECK TRAIN CONNECTION';
  toast(trainName+' could not load. '+(swapping?'Current train kept.':'Please try again.'));
  return false;
 }
}
// Initial train loads once. Later selection uses this same function in-place.
setTimeout(()=>{void gb3LoadTrain(gb3TrainSelection,false)},0);
function bindShape(m){gl.bindBuffer(gl.ARRAY_BUFFER,m.buf);gl.enableVertexAttribArray(loc.p);gl.vertexAttribPointer(loc.p,3,gl.FLOAT,false,32,0);gl.enableVertexAttribArray(loc.n);gl.vertexAttribPointer(loc.n,3,gl.FLOAT,false,32,12);gl.enableVertexAttribArray(loc.uv);gl.vertexAttribPointer(loc.uv,2,gl.FLOAT,false,32,24);if(m.tintBuf){gl.bindBuffer(gl.ARRAY_BUFFER,m.tintBuf);gl.enableVertexAttribArray(loc.tint);gl.vertexAttribPointer(loc.tint,3,gl.FLOAT,false,12,0);}else{gl.disableVertexAttribArray(loc.tint);gl.vertexAttrib3f(loc.tint,1,1,1);}}
// R55 -- dynamic scene reflections. An actual world render into a small cubemap,
// updating one face at a time; no external textures, maps, or network requests.
// Low stays .75 render scale with the same metallic shader as High.
const gb3R55Probe={tex:null,fbo:null,depth:null,size:0,ready:false,face:0,last:0,disabled:false,frames:0,slowFrom:0,jank:0};
const gb3R55CubeDirections=[
 [[1,0,0],[0,-1,0]],[[-1,0,0],[0,-1,0]],
 [[0,1,0],[0,0,1]],[[0,-1,0],[0,0,-1]],
 [[0,0,1],[0,-1,0]],[[0,0,-1],[0,-1,0]]
];
function gb3R55LookAt(eye,target,up){
 const f=unit(target.map((v,i)=>v-eye[i]));
 const r=unit(cross(f,up)),u=cross(r,f);
 return new Float32Array([r[0],u[0],-f[0],0,r[1],u[1],-f[1],0,r[2],u[2],-f[2],0,-dot(r,eye),-dot(u,eye),dot(f,eye),1]);
}
function gb3R55DestroyProbe(){
 const p=gb3R55Probe;
 if(p.tex)gl.deleteTexture(p.tex);
 if(p.depth)gl.deleteRenderbuffer(p.depth);
 if(p.fbo)gl.deleteFramebuffer(p.fbo);
 Object.assign(p,{tex:null,depth:null,fbo:null,size:0,ready:false,face:0});
}
function gb3R55CreateProbe(){
 const p=gb3R55Probe;
 if(p.disabled||gb3R55ReflectMode!=='dynamic')return false;
 // Fixed probe dimensions minimize memory and fill rate on old phones.
 const size=quality<=0.76?64:quality<=1.01?96:128;
 if(p.tex&&p.size===size)return true;
 gb3R55DestroyProbe();
 try{
  p.size=size;p.tex=gl.createTexture();
  gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_CUBE_MAP,p.tex);
  gl.texParameteri(gl.TEXTURE_CUBE_MAP,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_CUBE_MAP,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_CUBE_MAP,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_CUBE_MAP,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
  for(let face=0;face<6;face++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X+face,0,gl.RGBA,size,size,0,gl.RGBA,gl.UNSIGNED_BYTE,null);
  gl.bindTexture(gl.TEXTURE_CUBE_MAP,null);gl.activeTexture(gl.TEXTURE0);
  p.fbo=gl.createFramebuffer();p.depth=gl.createRenderbuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER,p.fbo);
  gl.bindRenderbuffer(gl.RENDERBUFFER,p.depth);
  gl.renderbufferStorage(gl.RENDERBUFFER,gl.DEPTH_COMPONENT16,size,size);
  gl.framebufferRenderbuffer(gl.FRAMEBUFFER,gl.DEPTH_ATTACHMENT,gl.RENDERBUFFER,p.depth);
  gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_CUBE_MAP,p.tex);
  gl.framebufferTexture2D(gl.FRAMEBUFFER,gl.COLOR_ATTACHMENT0,gl.TEXTURE_CUBE_MAP_POSITIVE_X,p.tex,0);
  const ok=gl.checkFramebufferStatus(gl.FRAMEBUFFER)===gl.FRAMEBUFFER_COMPLETE;
  gl.bindFramebuffer(gl.FRAMEBUFFER,null);
  gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_CUBE_MAP,null);gl.activeTexture(gl.TEXTURE0);
  if(!ok)throw Error('Reflection framebuffer unsupported');
  return true;
 }catch(err){
  console.warn('GBATTLE R55 dynamic probe unavailable:',err);
  gl.bindFramebuffer(gl.FRAMEBUFFER,null);gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_CUBE_MAP,null);gl.activeTexture(gl.TEXTURE0);
  gb3R55DestroyProbe();p.disabled=true;gb3R55ReflectMode='hybrid';root.dataset.gb3ReflectMode='hybrid';
  return false;
 }
}
function gb3R55UpdateProbe(now,frame){
 const p=gb3R55Probe;
 if(!gb3R55MetalSeen||gb3R55ReflectMode!=='dynamic'||!gb3R38MetalFX||!gb3R37LightingEnabled)return;
 // Deliberately spread cubemap draws: average FPS can look high even with GPU stalls.
 const baseInterval=quality<=0.76?145:quality<=1.01?100:65;
 const interval=baseInterval*(1+Math.min(2.5,p.jank*0.30));
 if(now-p.last<interval)return;
 if(!gb3R55CreateProbe())return;
 p.last=now;
 const f=p.face;
 const direction=gb3R55CubeDirections[f][0],up=gb3R55CubeDirections[f][1];
 const eye=frame.eye;const target=eye.map((v,i)=>v+direction[i]);
 try{
  // Never read the cube while writing to one of its faces (GL feedback loop).
  gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_CUBE_MAP,null);gl.activeTexture(gl.TEXTURE0);
  gl.uniform1f(loc.r55CubeReady,0);gl.uniform1f(loc.r38MetalFX,0);
  gl.bindFramebuffer(gl.FRAMEBUFFER,p.fbo);
  gl.framebufferTexture2D(gl.FRAMEBUFFER,gl.COLOR_ATTACHMENT0,gl.TEXTURE_CUBE_MAP_POSITIVE_X+f,p.tex,0);
  gl.viewport(0,0,p.size,p.size);gl.clearColor(.054,.08,.109,1);
  gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
  gl.uniformMatrix4fv(loc.projection,false,perspective(Math.PI/2,1,.1,180));
  gl.uniformMatrix4fv(loc.view,false,gb3R55LookAt(eye,target,up));
  gl.uniform3fv(loc.camera,eye);
  gl.disable(gl.CULL_FACE);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);
  gl.disable(gl.BLEND);gl.depthMask(true);
  for(const o of opaque)renderPart(o);
  gb3DrawSecondaryModels(false);
  // Reflect transparent train windows too, without re-rendering ink overlays.
  gl.enable(gl.BLEND);gl.blendFunc(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA);gl.depthMask(false);
  for(const o of transparentTrain)renderPart(o);
  gb3DrawSecondaryModels(true);
  p.face=(f+1)%6;
  if(p.face===0)p.ready=true;
 }catch(err){
  console.warn('GBATTLE R55 disabled dynamic reflections:',err);
  p.disabled=true;gb3R55ReflectMode='hybrid';root.dataset.gb3ReflectMode='hybrid';
 }finally{
  gl.bindFramebuffer(gl.FRAMEBUFFER,null);
  gl.viewport(0,0,view.width,view.height);
  gl.depthMask(true);gl.disable(gl.BLEND);
  gl.activeTexture(gl.TEXTURE2);
  gl.bindTexture(gl.TEXTURE_CUBE_MAP,p.disabled?null:p.tex);
  gl.uniform1i(loc.r55Cube,2);
  gl.activeTexture(gl.TEXTURE0);
 }
}
function gb3R55ConfigureCube(){
 const p=gb3R55Probe;
 gl.activeTexture(gl.TEXTURE2);gl.bindTexture(gl.TEXTURE_CUBE_MAP,p.tex&&!p.disabled?p.tex:null);
 gl.uniform1i(loc.r55Cube,2);
 gl.activeTexture(gl.TEXTURE0);
 gl.uniform1f(loc.r55CubeReady,gb3R55ReflectMode==='dynamic'&&p.ready&&!p.disabled?1:0);
}

function renderPart(o){if(o.gb3Map&&o.gb3Map!==gb3ActiveMap)return;if(o.gb3MovingTunnel&&gb3TunnelTraffic.state!=='passing')return;if(o.guard&&!gb3Security.active)return;if((o.imported||o.surface)&&(o.gb3Twin?trainMotion2.phase:trainMotion.phase)==='tunnel')return;bindShape(o.shape);const drawPos=(o.imported||o.surface)?[o.pos[0]+(o.gb3Twin?trainMotion2.x:trainMotion.x),o.pos[1],o.pos[2]]:o.pos;gl.uniformMatrix4fv(loc.model,false,model(drawPos,o.size,o.rot));gl.uniform3fv(loc.color,o.color);gl.uniform1f(loc.metal,o.metal);gl.uniform1f(loc.hasTex,(o.panel||o.ground||o.decal||o.importTex)?1:0);gl.uniform1f(loc.opacity,o.alpha??1);gl.uniform1f(loc.train,o.imported||o.surface||o.gb3SecondaryInstance?1:0);gl.uniform1f(loc.c30ColorLock,o.c30ColorLock?1:0);gl.uniform1f(loc.backdrop,o.backdrop?1:0);gl.uniform1f(loc.r37Art,(o.panel||o.decal||o.gb3HasPaint)?1:0);if(o.metalDirty)gb3R38UploadMetal(o);gl.uniform1f(loc.r38HasMetal,gb3R37LightingEnabled&&gb3R38MetalFX&&o.metalTex?1:0);if(o.metalTex){gl.activeTexture(gl.TEXTURE1);gl.bindTexture(gl.TEXTURE_2D,o.metalTex);gl.uniform1i(loc.r38Mask,1);gl.activeTexture(gl.TEXTURE0);}if(o.panel||o.ground||o.decal||o.importTex){gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,o.importTex||o.tex);gl.uniform1i(loc.texture,0)}/* Respect original double-sided SketchUp face materials. Do not enable
 backface culling for C6: it can remove source roof and front faces. */
if(o.surface||o.gb3SecondaryInstance&&o.panel){gl.enable(gl.POLYGON_OFFSET_FILL);gl.polygonOffset(-1,-1);} gl.drawArrays(gl.TRIANGLES,0,o.shape.count);
 if(o.surface||o.gb3SecondaryInstance&&o.panel)gl.disable(gl.POLYGON_OFFSET_FILL);
}
// Spray Engine R3 configuration. Values in METRES for reach/stand-off;
// texture pixels/second for speed response. Adjust only these numbers when tuning.
const gb3SprayConfig=Object.freeze({
 sprayReach:3.2,        // Max distance from player's eye to the paint surface
 markerReach:1.45,     // Marker requires touching/standing close
 washerReach:2.2,     // Washer requires physical proximity
 spreadStart:0.9,      // Spray begins to broaden after 0.9m
 spreadFull:3.2,       // Spray reaches its widest usable footprint at 3.2m
 spreadNear:0.85,      // Close spray width relative to cap size
 spreadFar:1.55,       // Farthest spray width relative to cap size (old: 2.47)
 offAxisWiden:0.68,    // Extra 0%-68% widen at the edge of the camera view
 offAxisPower:1.45,   // Stronger widening toward screen edges (higher = later onset)
 maxViewSpread:2.15,  // Safety clamp for combined stand-off and edge widening
 speedSoftStart:260,   // Below this, motion never thins the line
 speedFull:1900,       // Requires a genuine fast flick to reach maximum speed effect
 speedPinch:0.58,      // At full speed + FLARE 100%, width shrinks by up to 58%
 speedDensityDrop:0.42,// At full speed, paint flux lightens by up to 42%
 cameraHeight:1.09,    // Original 2.18m: now half-height
 minCameraHeight:0.65, // Lower movement/ducking limit
 maxCameraHeight:6.5
});
function gb3ReachForTool(){return state.tool==='marker'?gb3SprayConfig.markerReach:state.tool==='wash'?gb3SprayConfig.washerReach:gb3SprayConfig.sprayReach;}
let cam={x:1.7,y:gb3SprayConfig.cameraHeight,z:gb3ActiveMap==='tunnel'?5.5:gb3ActiveMap==='depot'?21.8:16.5,yaw:0,pitch:-.025}, speed=3.2, quality=.75, fog=1;
// R12 yard-prototype movement: one 5m climbable test ladder and a top platform.
// Coordinates use the current map's spawn, not a second renderer or server.
const gb3TestLadder={x:cam.x+2.0,z:cam.z-3.2,top:5.0,platformZ:cam.z-4.1};
for(const dx of [-.44,.44]){
 const rail=box(gb3TestLadder.x+dx,2.5,gb3TestLadder.z,.10,5,.12,'#c6cbd0',.55);
 rail.gb3Map=gb3ActiveMap;opaque.push(rail);
}
for(let i=0;i<=14;i++){
 const rung=box(gb3TestLadder.x,.34+i*.32,gb3TestLadder.z,.92,.075,.10,'#f4ca4e',.5);
 rung.gb3Map=gb3ActiveMap;opaque.push(rung);
}
const ladderTop=box(gb3TestLadder.x,4.94,gb3TestLadder.platformZ,3,.22,2.3,'#48585d',.45);
ladderTop.gb3Map=gb3ActiveMap;opaque.push(ladderTop);
function gb3RoofAt(x,z,pad=0){
 if(gb3ActiveMap!=='yard')return null;
 let chosen=null;
 for(const r of gb3CityRoofs){
  if(Math.abs(x-r.x)<=r.hx-pad && Math.abs(z-r.z)<=r.hz-pad && (!chosen||r.top>chosen.top))chosen=r;
 }
 return chosen;
}
const gb3Mobility={height:0,vy:0,mode:'ground',crouch:false,jumpHeld:false,touchCrouch:false,jumpQueued:false,appliedCameraOffset:0,activeLadder:null,supportRoof:null};
function gb3TestOnPlatform(){
 const r=gb3Mobility.supportRoof;
 if(r)return gb3RoofAt(cam.x,cam.z,.04)===r;
 const b=gb3Mobility.activeLadder;
 if(b&&b.insideX!==undefined)return cam.x>b.minX+.04&&cam.x<b.maxX-.04&&cam.z>b.minZ+.04&&cam.z<b.maxZ-.04;
 return Math.abs(cam.x-gb3TestLadder.x)<1.36&&Math.abs(cam.z-gb3TestLadder.platformZ)<1.08;
}
function gb3MovementStep(dt,forwards){
 const m=gb3Mobility;
 if(gb3AdminAuthenticated&&gb3AdminFlyEnabled){
  const rise=(key.has(' ')||key.has('r')||gb3AdminTouchAscend?1:0)-(key.has('control')||key.has('f')||gb3AdminTouchDescend?1:0);
  const old=m.height;
  m.height=clamp(m.height+rise*dt*5,0,28);
  m.mode='fly';m.vy=0;m.crouch=false;m.jumpQueued=false;
  cam.y+=m.height-old;
  m.appliedCameraOffset=m.height;
  return;
 }
 if(m.mode==='fly'){m.mode='air';m.vy=0;}

 const jumpPressed=key.has(' ')||m.jumpQueued;
 const jumpEdge=jumpPressed&&!m.jumpHeld;
 m.jumpHeld=jumpPressed;
 m.jumpQueued=false;
 m.crouch=(key.has('control')||m.touchCrouch)&&(m.mode==='ground'||m.mode==='platform');
 // Attach to existing yard building ladders or the original test ladder.
 let closest=null,dist=.90;
 if(gb3ActiveMap==='yard')for(const b of gb3CityLadders){
  const d=Math.hypot(cam.x-b.x,cam.z-b.z);
  if(d<dist){closest=b;dist=d;}
 }
 const active=m.activeLadder||closest||gb3TestLadder;
 const dx=cam.x-active.x,dz=cam.z-active.z;
 const ladderNear=Math.hypot(dx,dz)<.98;
 // Enter from the base by pressing forward, with the ladder directly in front.
 if(m.mode==='ground'&&ladderNear&&forwards>.25&&!jumpPressed){m.mode='ladder';m.vy=0;m.activeLadder=closest;}
 if(jumpEdge){
  if(m.mode==='ladder'||m.mode==='hang'){m.mode='air';m.vy=1.3;}
  else if(m.mode==='ground'||m.mode==='platform'){m.mode='air';m.vy=5.4;}
 }
 if(m.mode==='ladder'){
  cam.x+=(active.x-cam.x)*Math.min(1,dt*8);
  cam.z+=(active.z-cam.z)*Math.min(1,dt*8);
  m.height=Math.max(0,Math.min(active.top,m.height+forwards*2.1*dt));
  if(m.height>=active.top-.03&&forwards>.15){
   m.height=active.top;m.mode='platform';
   if(active.insideX!==undefined){cam.x=active.insideX;cam.z=active.insideZ;}
   else cam.z=gb3TestLadder.platformZ+.35;
   m.supportRoof=gb3RoofAt(cam.x,cam.z,.015);
  }else if(m.height<=0&&forwards<-.15)m.mode='ground';
 }else if(m.mode==='hang'){
  m.height=Math.max(0,active.top-.88);m.vy=0;
  if(forwards>.2){m.height=active.top;m.mode='platform';
   if(active.insideX!==undefined){cam.x=active.insideX;cam.z=active.insideZ;}
   else cam.z=gb3TestLadder.platformZ+.32;
   m.supportRoof=gb3RoofAt(cam.x,cam.z,.015);}
  if(forwards<-.2){m.mode='air';m.vy=-.5;}
 }else if(m.mode==='air'){
  const beforeY=m.height;
  m.height+=m.vy*dt;m.vy-=13.5*dt;
  // A descending body lands on the *highest occupied building roof* it crosses.
  // Crossing from BELOW does not teleport a character upward through a roof.
  const landing=gb3RoofAt(cam.x,cam.z,.015);
  if(m.vy<=0&&landing&&beforeY>=landing.top-.01&&m.height<=landing.top){
   m.height=landing.top;m.vy=0;m.mode='platform';m.supportRoof=landing;
  }else if(m.vy<0&&m.height<active.top&&m.height>active.top-1.1&&ladderNear&&forwards>.2){
   m.mode='hang';m.vy=0;m.height=active.top-.88;m.supportRoof=null;
  }else if(m.height<=0){m.height=0;m.vy=0;m.mode='ground';m.supportRoof=null;}
 }else if(m.mode==='platform'){
  // Stay firmly on the roof while inside its bounds; stepping off triggers a fall.
  // This also works for roofs without a ladder.
  if(m.supportRoof){
   const still=gb3RoofAt(cam.x,cam.z,.015);
   if(still===m.supportRoof){m.height=still.top;m.vy=0;}
   else{m.mode='air';m.vy=-.5;m.supportRoof=null;}
  }else{
   const standingRoof=gb3RoofAt(cam.x,cam.z,.015);
   if(standingRoof&&Math.abs(m.height-standingRoof.top)<.48){
    m.supportRoof=standingRoof;m.height=standingRoof.top;m.vy=0;
   }else if(!gb3TestOnPlatform()){
    if(Math.hypot(cam.x-active.x,cam.z-active.z)<1.45){m.mode='hang';m.height=active.top-.88;}
    else {m.mode='air';m.vy=-.5;}
   }
  }
 }
 if(m.mode==='ground')m.activeLadder=null;
 m.visualCrouch=(m.visualCrouch||0)+(Number(m.crouch)-(m.visualCrouch||0))*(1-Math.exp(-Math.max(0,dt)*12));
 const elevation=m.height-m.visualCrouch*.42;
 // Apply the offset additively, preserving the existing R/F and camera-height controls.
 cam.y+=elevation-m.appliedCameraOffset;
 m.appliedCameraOffset=elevation;
}
// Mobile symbolic counterparts to Ctrl and Space. Scoped to the game only.
const gb3MobilityButtons=document.createElement('div');
gb3MobilityButtons.className='gb3-mobility-actions';
gb3MobilityButtons.innerHTML='<button type="button" data-gb3-crouch title="Crouch (Ctrl)" aria-label="Crouch">⇣ CROUCH</button><button type="button" data-gb3-jump title="Jump / release ladder (Space)" aria-label="Jump or release ladder">⇧ JUMP</button>';
root.appendChild(gb3MobilityButtons);
const crouchButton=gb3MobilityButtons.querySelector('[data-gb3-crouch]');
const jumpButton=gb3MobilityButtons.querySelector('[data-gb3-jump]');
crouchButton.addEventListener('pointerdown',e=>{e.preventDefault();e.stopPropagation();gb3Mobility.touchCrouch=true;crouchButton.setAttribute('aria-pressed','true');});
function gb3ReleaseCrouch(){gb3Mobility.touchCrouch=false;crouchButton.setAttribute('aria-pressed','false');}
for(const ev of ['pointerup','pointercancel','pointerleave'])crouchButton.addEventListener(ev,gb3ReleaseCrouch);
jumpButton.addEventListener('pointerdown',e=>{e.preventDefault();e.stopPropagation();gb3Mobility.jumpQueued=true;});
for(const [btn,which] of [[jumpButton,'up'],[crouchButton,'down']]){
 btn.addEventListener('pointerdown',()=>{if(gb3AdminFlyEnabled){if(which==='up')gb3AdminTouchAscend=true;else gb3AdminTouchDescend=true;}});
 for(const evt of ['pointerup','pointerleave','pointercancel'])btn.addEventListener(evt,()=>{if(which==='up')gb3AdminTouchAscend=false;else gb3AdminTouchDescend=false;});
}


// Timed security gameplay: one patrol every eight minutes of play, starting
// with the first parked train. Patrol only runs with a stationary train.
const gb3LocalQAMode=(location.hostname==='localhost'||location.hostname==='127.0.0.1'||window.Shopify?.designMode===true)&&new URLSearchParams(location.search).has('gb3_patrol_test');
const GB3_SECURITY_INTERVAL=gb3LocalQAMode?12:480,GB3_PATROL_SECONDS=gb3LocalQAMode?18:48;
const gb3Security={active:false,started:false,cooldown:GB3_SECURITY_INTERVAL,
  elapsed:0,x:-67,z:7.7,dir:1,detectedFor:0,noticeElapsed:0,patrolDuration:GB3_PATROL_SECONDS};
const gb3Status=document.createElement('div');gb3Status.className='gb3-security-status';
gb3Status.setAttribute('role','status');gb3Status.setAttribute('aria-live','polite');
gb3Status.textContent=gb3LocalQAMode?'SECURITY · QA PATROL IN 0:12':'SECURITY · PATROL IN 8:00';root.appendChild(gb3Status);
const gb3Caught=document.createElement('div');gb3Caught.className='gb3-caught-overlay';gb3Caught.hidden=true;
gb3Caught.innerHTML='<div class="gb3-caught-card"><strong>SECURITY CAUGHT YOU</strong><span>Your graffiti was cleared. The '+gb3TrainName+' stays parked.</span><button type="button">TRY AGAIN</button></div>';
root.appendChild(gb3Caught);gb3Caught.querySelector('button').addEventListener('click',()=>gb3Caught.hidden=true);
function gb3CircleBoxHit(cx,cz,cover,pad){return Math.abs(cx-cover.x)<cover.hx+pad&&Math.abs(cz-cover.z)<cover.hz+pad;}
function gb3InCoverBox(cx,cz){return gb3Cover.some(c=>(!c.map&&gb3ActiveMap==='yard'||c.map===gb3ActiveMap)&&gb3CircleBoxHit(cx,cz,c,c.kind==='building'?.16:.55))}
function gb3Occluded(ax,az,bx,bz){
 // Segment vs expanded AABB: a shed/crate blocks the guard's direct view.
 return gb3Cover.some(c=>{
  if(!(!c.map&&gb3ActiveMap==='yard'||c.map===gb3ActiveMap))return false;
  let lo=0,hi=1;
  for(const [a,b,min,max] of [[ax,bx,c.x-c.hx,c.x+c.hx],[az,bz,c.z-c.hz,c.z+c.hz]]){
   const d=b-a;if(Math.abs(d)<1e-8){if(a<min||a>max)return false;continue;}
   let t0=(min-a)/d,t1=(max-a)/d;if(t0>t1){let s=t0;t0=t1;t1=s;}
   lo=Math.max(lo,t0);hi=Math.min(hi,t1);if(lo>hi)return false;
  }
  return hi>0.02&&lo<.98;
 });
}
function gb3GuardSeePlayer(){
 if(gb3AdminAuthenticated&&gb3AdminGodEnabled)return false;
 const dx=cam.x-gb3Security.x,dz=cam.z-gb3Security.z;
 const range=Math.hypot(dx,dz);
 if(range>17||range<.01)return false;
 const lookX=gb3Flashlight.target[0]-gb3Flashlight.origin[0],lookZ=gb3Flashlight.target[2]-gb3Flashlight.origin[2];
 const inv=1/(Math.hypot(lookX,lookZ)||1);
 if((dx*lookX+dz*lookZ)*inv/range<.45)return false;
 return !gb3Occluded(gb3Security.x,gb3Security.z,cam.x,cam.z);
}
function gb3SetGuardPositions(){
 const step=Math.sin(gb3Security.elapsed*10)*.13;
 gb3GuardMeshes.forEach((o,i)=>{
  o.pos[0]=gb3Security.x+o.guardOffset[0];
  o.pos[1]=o.guardOffset[1]+(i===5?step:i===6?-step:0);
  o.pos[2]=gb3Security.z+o.guardOffset[2];
 });
}
function gb3ClearPaintingOnCatch(){
 // Do not ask for confirmation: this is the loss condition. Do not restart
 // the train or change its model, and invalidate locally saved paint.
 stopStroke();gb3SecondarySave();clearTimeout(saveTimer);wetPools.length=0;activeDrips.length=0;
 for(const p of [...panels,...gb3TwinPanels]){p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);dirty.add(p)}
 undo=[];strokes=0;$('paintedCount').textContent='0 strokes';$('undoCount').textContent='0 / 7';
 if(db){try{const tx=db.transaction('paint','readwrite');tx.objectStore('paint').delete(gb3PaintSaveKey);tx.objectStore('paint').delete('session')}catch(_){}}
 // Deleting the save must NOT immediately write a blank saved session again.
 $('saveState').textContent='ARTWORK LOST';
 gb3Security.active=false;gb3Security.started=true;gb3Security.cooldown=GB3_SECURITY_INTERVAL;gb3Security.detectedFor=0;
 // Freeze at present station; caught does not cause a new moving train cycle.
 trainMotion.phase='parked';trainMotion.x=0;trainMotion.elapsed=0;
 gb3SyncAudio();
 cam={x:1.7,y:gb3SprayConfig.cameraHeight,z:16.5,yaw:0,pitch:-.025};
 gb3Caught.hidden=false;gb3Status.textContent='SECURITY · CAUGHT · ARTWORK LOST';
 toast('Caught! Graffiti cleared. Train remains parked.');
}
function gb3StepSecurity(dt){if(gb3BetaMode)return;
 if(c30LoadStatus.state!=='ready'||gb3Caught.hidden===false)return;
 if(!gb3Security.started){if(trainMotion.phase!=='parked')return;gb3Security.started=true;}
 if(!gb3Security.active){
  gb3Security.cooldown=Math.max(0,gb3Security.cooldown-dt);
  if(gb3Security.cooldown===0&&trainMotion.phase==='parked'){
   gb3Security.active=true;gb3Security.elapsed=0;gb3Security.detectedFor=0;
   gb3Security.dir=1;gb3Security.x=-67;gb3Security.z=7.7;
   gb3Security.patrolDuration=GB3_PATROL_SECONDS*(Math.random()<.4?.65:1.0);
   stopStroke();toast('SECURITY PATROL! Hide behind the crates or shed.');
  }
 }else{
  gb3Security.elapsed+=dt;
  const t=Math.min(1,gb3Security.elapsed/gb3Security.patrolDuration);
  gb3Security.x=-67+134*t;
  gb3SetGuardPositions();gb3StepFlashlight();
  if(gb3GuardSeePlayer()){
   gb3Security.detectedFor+=dt;
   if(gb3Security.detectedFor>=1.15){gb3ClearPaintingOnCatch();return;}
  }else gb3Security.detectedFor=Math.max(0,gb3Security.detectedFor-dt*1.5);
  if(t>=1){gb3Security.active=false;gb3Security.cooldown=GB3_SECURITY_INTERVAL;
   gb3Security.detectedFor=0;toast('Security patrol has left the yard.');}
 }
 gb3Security.noticeElapsed+=dt;
 if(gb3Security.noticeElapsed>.5){
  gb3Security.noticeElapsed=0;
  if(gb3Security.active)gb3Status.textContent='⚠ SECURITY PATROLLING · HIDE BEHIND COVER';
  else {const whole=Math.ceil(gb3Security.cooldown),m=Math.floor(whole/60),s=whole%60;gb3Status.textContent=`SECURITY · PATROL IN ${m}:${String(s).padStart(2,'0')}`;}
 }
}

let fov=Math.PI/3.1;const defaultFov=fov;let width=1,height=1;
function resize(){let b=view.getBoundingClientRect(),d=Math.min(window.devicePixelRatio||1,1.5)*quality;let w=Math.max(1,Math.round(b.width*d)),h=Math.max(1,Math.round(b.height*d));if(view.width!==w||view.height!==h){view.width=w;view.height=h}width=b.width;height=b.height;gl.viewport(0,0,w,h)}
// Avoid a synchronous DOM layout read on every game frame.
window.addEventListener('resize',resize);
if(typeof ResizeObserver!=='undefined'){const gb3CanvasSizeObserver=new ResizeObserver(()=>resize());gb3CanvasSizeObserver.observe(view);}
resize();
let past=performance.now(),frames=0,fpsLast=past;
const key=new Set();
root.addEventListener('keydown',e=>{if(['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName))return;key.add(e.key.toLowerCase());if(['w','a','s','d','q','e','r','f',' ','control'].includes(e.key.toLowerCase()))e.preventDefault();if(['1','2','3','4'].includes(e.key))selectTool(['spray','marker','wash','look'][Number(e.key)-1]);/* Shared painting has no Ctrl+Z or undo action. */if(e.key==='Escape')root.querySelectorAll('.modal').forEach(x=>x.hidden=true)});
root.addEventListener('keyup',e=>key.delete(e.key.toLowerCase()));root.addEventListener('blur',()=>key.clear());
function forward(){let c=Math.cos(cam.pitch);return [Math.sin(cam.yaw)*c,Math.sin(cam.pitch),-Math.cos(cam.yaw)*c]}
// R17: the SAME full original hoodie is visible in both camera modes.
// The GLB head is at roughly 1.63m after its 1.26x model scale, while cam.y's
// standing baseline is 1.09m. Lift the FIRST-PERSON lens to eye height and put
// it in front of the face to avoid looking through the hood/head. These are
// camera-only tuning parameters: NO character mesh, wrist or spray-can changes.
const GB3_FIRST_PERSON_EYE_RAISE=0.56;      // Eye-level lens above the existing 1.09m baseline
const GB3_FIRST_PERSON_FACE_FORWARD=0.20;  // Small forward shift avoids clipping through the face
const GB3_FIRST_PERSON_SIDE_OFFSET=-0.02;  // Slight left offset so the right hand/can can enter frame naturally
// GB3 CAMERA CORRIDOR COLLISION: world-space cover boxes were already used to
// stop the player's body, but the trailing camera ignored them and entered
// neighboring buildings. Keep ONE implementation for touch and keyboard/mouse.
const GB3_CHASE_NORMAL_DISTANCE=3.1;
const GB3_CHASE_CLEARANCE=.17; // Leave room for the WebGL near clipping plane.
const GB3_CHASE_RADIUS=.16;    // Small sphere against walls, not a point camera.
let gb3ChaseDistance=GB3_CHASE_NORMAL_DISTANCE;
let gb3ChasePreviousTime=0;
let gb3CorridorAutoFirstPerson=false;
// Deterministic swept segment/AABB collision. Returns the distance along the
// chase line that is safe for the camera lens (never changes avatar position).
function gb3CameraWallLimit(dir){
 const dx=-dir[0]*GB3_CHASE_NORMAL_DISTANCE;
 const dz=-dir[2]*GB3_CHASE_NORMAL_DISTANCE;
 const y=cam.y+.85;
 let earliest=1;
 for(const c of gb3Cover){
  if(c.map ? c.map!==gb3ActiveMap : gb3ActiveMap!=='yard')continue;
  // Camera above a roof should not collide with walls below it.
  const top=c.top??(c.kind==='crate'?2.7:c.kind==='shed'?5.7:8);
  if(y>top+.08)continue;
  let enter=0,exit=1;
  const slabs=[[cam.x,dx,c.x-c.hx-GB3_CHASE_RADIUS,c.x+c.hx+GB3_CHASE_RADIUS],
               [cam.z,dz,c.z-c.hz-GB3_CHASE_RADIUS,c.z+c.hz+GB3_CHASE_RADIUS]];
  let hit=true;
  for(const [start,delta,min,max] of slabs){
   if(Math.abs(delta)<1e-8){if(start<min||start>max){hit=false;break;}continue;}
   let t0=(min-start)/delta,t1=(max-start)/delta;
   if(t0>t1){const swap=t0;t0=t1;t1=swap;}
   enter=Math.max(enter,t0);exit=Math.min(exit,t1);
   if(enter>exit){hit=false;break;}
  }
  if(hit&&exit>=0&&enter<=1)earliest=Math.min(earliest,enter);
 }
 if(earliest>=1)return GB3_CHASE_NORMAL_DISTANCE;
 return Math.max(0,earliest*GB3_CHASE_NORMAL_DISTANCE-GB3_CHASE_CLEARANCE);
}
function gb3ViewFrame(){
 const dir=forward();
 if(gb3ThirdPerson){
  const limit=gb3CameraWallLimit(dir);
  const now=performance.now();
  const dt=gb3ChasePreviousTime?Math.min(.05,Math.max(0,(now-gb3ChasePreviousTime)/1000)):0;
  gb3ChasePreviousTime=now;
  // Retreat immediately when a wall approaches; extend gradually after exit.
  // Delaying the retreat would put the lens inside the brick geometry.
  if(limit<gb3ChaseDistance)gb3ChaseDistance=limit;
  else gb3ChaseDistance+=(limit-gb3ChaseDistance)*(1-Math.exp(-dt*5));
  // In an extremely narrow passage, move to an unobstructed lens at the
  // character's eyes rather than looking through the hoodie from 20cm away.
  // Hysteresis avoids rapidly switching perspectives at a wall edge.
  if(gb3CorridorAutoFirstPerson){
   if(gb3ChaseDistance>1.15)gb3CorridorAutoFirstPerson=false;
  }else if(gb3ChaseDistance<.80)gb3CorridorAutoFirstPerson=true;
  if(gb3CorridorAutoFirstPerson){
   const eye=[cam.x,cam.y+GB3_FIRST_PERSON_EYE_RAISE,cam.z];
   return {dir,eye,target:[eye[0]+dir[0],eye[1]+dir[1],eye[2]+dir[2]]};
  }
  return {dir,
   eye:[cam.x-dir[0]*gb3ChaseDistance,cam.y+.85,cam.z-dir[2]*gb3ChaseDistance],
   target:[cam.x+dir[0]*2,cam.y+dir[1]*2,cam.z+dir[2]*2]};
 }
 gb3CorridorAutoFirstPerson=false;
 // Explicit first person: retain the original lens and aiming behavior.
 const sideX=Math.cos(cam.yaw)*GB3_FIRST_PERSON_SIDE_OFFSET;
 const sideZ=Math.sin(cam.yaw)*GB3_FIRST_PERSON_SIDE_OFFSET;
 const ex=cam.x+Math.sin(cam.yaw)*GB3_FIRST_PERSON_FACE_FORWARD+sideX;
 const ey=cam.y+GB3_FIRST_PERSON_EYE_RAISE;
 const ez=cam.z-Math.cos(cam.yaw)*GB3_FIRST_PERSON_FACE_FORWARD+sideZ;
 return {dir,eye:[ex,ey,ez],target:[ex+dir[0],ey+dir[1],ez+dir[2]]};
}
function tick(now){if(!root.isConnected)return;const realDt=Math.max(0,(now-past)/1000);let dt=clamp(realDt,0,.06);past=now;
 // Adapt cubemap capture cadence to frame-time spikes, not just average FPS.
 if(realDt>0.037&&realDt<0.30)gb3R55Probe.jank=Math.min(9,gb3R55Probe.jank+1.2);
 else gb3R55Probe.jank=Math.max(0,gb3R55Probe.jank-Math.min(realDt,0.05)*1.2);const gameDt=!document.hidden&&realDt<=5?realDt:0;if(gb3Caught.hidden){if(gb3BetaMode)gb3SyncSharedTrainCycle(now);else stepTrainMotion(gameDt);gb3StepSecondTrain(gameDt,now);}gb3StepSecurity(gameDt);let movement=(key.has('shift')?2.15:1)*speed*dt;
 let forwards=(key.has('w')?1:0)-(key.has('s')?1:0),side=(key.has('d')?1:0)-(key.has('a')?1:0);
 forwards+=touchVec.y;side+=touchVec.x;
 // Record REAL movement after wall/train collision resolution; pressing a blocked key is not walking.
 const gb3AvatarOriginX=cam.x,gb3AvatarOriginZ=cam.z;
 if(forwards||side){const ox=cam.x,oz=cam.z;let norm=1/Math.max(1,Math.hypot(forwards,side));cam.x+=movement*norm*(Math.sin(cam.yaw)*forwards+Math.cos(cam.yaw)*side);cam.z+=movement*norm*(-Math.cos(cam.yaw)*forwards+Math.sin(cam.yaw)*side);const bounds=gb3MapBounds();cam.x=clamp(cam.x,bounds.minX,bounds.maxX);cam.z=clamp(cam.z,bounds.minZ,bounds.maxZ);
 // Resolve each axis against the actual selected train's bounds, including while it moves.
 // Once past either END of a short train, the player can cross the tracks freely.
 if(!gb3AdminGodEnabled&&gb3TrainOccupies(cam.x,cam.z)){
  if(!gb3TrainOccupies(ox,cam.z))cam.x=ox;
  if(gb3TrainOccupies(cam.x,cam.z))cam.z=oz;
 }
 if(!gb3AdminGodEnabled&&gb3Mobility.height<2&&gb3InCoverBox(cam.x,cam.z)){if(!gb3InCoverBox(ox,cam.z))cam.x=ox;if(gb3InCoverBox(cam.x,cam.z))cam.z=oz;}}
 gb3MovementStep(dt,forwards);
 const gb3DistanceMoved=Math.hypot(cam.x-gb3AvatarOriginX,cam.z-gb3AvatarOriginZ);
 gb3AvatarTravel+=gb3DistanceMoved;
 const gb3InstantSpeed=dt>0.0001?gb3DistanceMoved/dt:0;
 // Smooth the gait's start/stop without changing the existing movement speed or camera controls.
 gb3AvatarVelocity+=(gb3InstantSpeed-gb3AvatarVelocity)*(1-Math.exp(-dt*11));
 gb3MotionNow=gb3AvatarVelocity;
 gb3AvatarTransmit(now);
 if(key.has('q'))cam.yaw-=dt*1.0;if(key.has('e'))cam.yaw+=dt*1.0;
 if(root.gb3StepOptionalLook)root.gb3StepOptionalLook(dt);
 if(key.has('r'))cam.y=clamp(cam.y+movement,gb3SprayConfig.minCameraHeight,gb3SprayConfig.maxCameraHeight);if(key.has('f'))cam.y=clamp(cam.y-movement,gb3SprayConfig.minCameraHeight,gb3SprayConfig.maxCameraHeight);
 if(gb3Sound.enabled&&gb3AudioContext){gb3SyncAudio();gb3SyncSprayAudio();}
 gb3StepTunnelTraffic(gameDt);
 gl.clearColor(gb3Security.active?.004:.054,gb3Security.active?.006:.08,gb3Security.active?.009:.109,1);
 gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.useProgram(program);
 // R37: existing game scene uses custom WebGL (not Three.js), so fixture light uniforms
 // are passed directly to its shader. Positions snap to FIXED ceiling fixtures, not the camera.
 gl.uniform1f(loc.r37Lighting,gb3R37LightingEnabled?1:0);gl.uniform1f(loc.r38MetalFX,gb3R37LightingEnabled&&gb3R38MetalFX?1:0);
 if(gb3R37LightingEnabled&&gb3ActiveMap==='depot'){
  const fixtureX=-72+clamp(Math.round((cam.x+72)/13.5),0,11)*13.5;
  const rowZ=[-19.5,-10.5,-1.5,7.5,16.5].reduce((best,z)=>Math.abs(z-cam.z)<Math.abs(best-cam.z)?z:best,-19.5);
  const otherX=fixtureX+((cam.x>=fixtureX&&fixtureX<72)?13.5:-13.5);
  gl.uniform1f(loc.r37Lamps,1);gl.uniform3fv(loc.r37LampA,[fixtureX,12.86,rowZ]);gl.uniform3fv(loc.r37LampB,[clamp(otherX,-72,72),12.86,rowZ]);
 }else if(gb3R37LightingEnabled&&gb3ActiveMap==='tunnel'){
  const fixtureX=clamp(Math.round(cam.x/12)*12,-108,108);
  gl.uniform1f(loc.r37Lamps,1);gl.uniform3fv(loc.r37LampA,[fixtureX,8.12,-7.3]);gl.uniform3fv(loc.r37LampB,[clamp(fixtureX+(cam.x>fixtureX?12:-12),-108,108),8.12,-7.3]);
 }else{gl.uniform1f(loc.r37Lamps,0);}
 gl.uniform1f(loc.night,gb3Security.active?1:0);
 gl.uniform3fv(loc.torchOrigin,gb3Flashlight.origin);gl.uniform3fv(loc.torchTarget,gb3Flashlight.target);
 const viewFrame=gb3ViewFrame();
 gb3R55UpdateProbe(now,viewFrame);
 gb3R55ConfigureCube();
 gl.uniform1f(loc.r38MetalFX,gb3R37LightingEnabled&&gb3R38MetalFX&&gb3R55ReflectMode!=='off'?1:0);
 gl.uniformMatrix4fv(loc.projection,false,perspective(fov,view.width/view.height,.07,240));
 gl.uniformMatrix4fv(loc.view,false,lookAt(viewFrame.eye,viewFrame.target));gl.uniform3fv(loc.camera,viewFrame.eye);gl.uniform1f(loc.fog,fog);
 gl.disable(gl.CULL_FACE);gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.disable(gl.BLEND);for(let o of opaque)renderPart(o);gb3DrawSecondaryModels(false);
 gl.enable(gl.BLEND);gl.blendFunc(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA);gl.depthMask(false);for(let o of transparentTrain)renderPart(o);for(let o of panels)renderPart(o);if(gb3ActiveMap==='yard')for(const p of gb3TwinPanels)renderPart(p);if(gb3ActiveMap==='yard')for(const p of gb3CityPanels)if(p.gb3HasPaint)renderPart(p);gb3DrawSecondaryModels(true);if(gb3Security.active){gl.uniform1f(loc.night,0);renderPart(gb3Beam);gl.uniform1f(loc.night,1);}gl.depthMask(true);gl.disable(gl.BLEND);
 gb3AvatarDraw(now,dt);
 for(const p of dirty){gl.bindTexture(gl.TEXTURE_2D,p.tex);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);gl.texSubImage2D(gl.TEXTURE_2D,0,0,0,gl.RGBA,gl.UNSIGNED_BYTE,p.canvas)}dirty.clear();
 frames++;if(now-fpsLast>1300){
  const observedFps=frames*1000/(now-fpsLast);
  $('fps').textContent=Math.round(observedFps)+' FPS';frames=0;fpsLast=now;
  if(gb3R55ReflectMode==='dynamic'&&gb3R55MetalSeen&&isTouchDevice&&!document.hidden){
   if(observedFps<19){
    if(!gb3R55Probe.slowFrom)gb3R55Probe.slowFrom=now;
    if(now-gb3R55Probe.slowFrom>9000&&gb3R55Requested!=='dynamic-force'){
     gb3R55ReflectMode='hybrid';root.dataset.gb3ReflectMode='hybrid';
     if(gb3R55Setting)gb3R55Setting.value='hybrid';
     gb3R55DestroyProbe();toast('Reflections switched to Hybrid for smoother FPS');
    }
   }else{gb3R55Probe.slowFrom=0;}
  }
 }
 requestAnimationFrame(tick);
}
gl.enable(gl.DEPTH_TEST);requestAnimationFrame(tick);
// Select the surface using the actual VIEWING ray. In third-person that ray
// starts behind the character, so it must NEVER be used to enforce spray reach.
function gb3PickRay(x,y){
 const frame=gb3ViewFrame(),looking=unit(frame.target.map((v,i)=>v-frame.eye[i]));
 const right=unit(cross(looking,[0,1,0])),up=cross(right,looking);
 const nx=x/Math.max(1,width)*2-1,ny=1-y/Math.max(1,height)*2,t=Math.tan(fov/2);
 return {origin:frame.eye,dir:unit([0,1,2].map(i=>looking[i]+right[i]*nx*t*width/Math.max(1,height)+up[i]*ny*t))};
}
function gb3PaintHand(){
 // Right-hand spray anchor: inside the physical character, not the chase camera.
 // Arm elevation is model/world based; raising a free camera cannot lengthen reach.
 const right=[Math.cos(cam.yaw),Math.sin(cam.yaw)];
 return [cam.x+right[0]*.20+Math.sin(cam.yaw)*.22,1.16,cam.z+right[1]*.20-Math.cos(cam.yaw)*.22];
}
function hitTest(x,y){
 if(gb3BetaMode&&!gb3BetaDrawingReady)return null;
 if(c30LoadStatus.state!=='ready'||gb3PaintRestoring)return null;
 const picked=gb3PickRay(x,y),d=picked.dir,rayOrigin=picked.origin,reach=gb3ReachForTool();
 // Cast far enough to FIND a surface from the trailing camera. Tool range is
 // checked against the real character afterward, never against camera distance.
 const castLimit=gb3ThirdPerson?30:reach;
 const origin=[rayOrigin[0]-trainMotion.x,rayOrigin[1],rayOrigin[2]];
 let best=null;
 // Real-time ray hits of street walls are independent from the parked train.
 if(gb3ActiveMap==='yard')for(const p of gb3CityPanels){
  const hit=gb3CityPaintRayHit(rayOrigin,d,p,Math.min(castLimit,best?best.distance:castLimit));
  if(hit&&(!best||hit.distance<best.distance))best=hit;
 }
 if(trainMotion.phase==='parked')for(const p of panels){
  if(p.surface){const h=surfaceHit(origin,d,p,best?best.distance:castLimit);if(h&&(!best||h.distance<best.distance))best=h;continue;}
  if(Math.abs(d[2])<.001)continue;
  const dist=(p.pos[2]-rayOrigin[2])/d[2];
  if(dist<.1||dist>=castLimit)continue;
  const xx=rayOrigin[0]+d[0]*dist,yy=rayOrigin[1]+d[1]*dist;
  if(Math.abs(xx-p.cx)>p.len/2||Math.abs(yy-p.pos[1])>p.size[1]/2)continue;
  if(!best||dist<best.distance)best={p,distance:dist,u:(xx-(p.cx-p.len/2))/p.len,v:1-(yy-(p.pos[1]-p.size[1]/2))/p.size[1],world:[xx,yy,p.pos[2]],normal:[0,0,Math.sign(d[2])*-1],ray:d,viewAngle:Math.atan2(-d[1],d[0])};
 }
 // R42 independent train B: ray in its own model-local coordinate system.
 if(gb3ActiveMap==='yard'&&trainMotion2.phase==='parked'){
  const bOrigin=[trainMotion2.x-rayOrigin[0],rayOrigin[1],GB3_SECOND_LINE_Z-rayOrigin[2]];
  const bDir=[-d[0],d[1],-d[2]];
  for(const p of gb3TwinPanels){
   const h=surfaceHit(bOrigin,bDir,p,best?best.distance:castLimit);
   if(h&&(!best||h.distance<best.distance)){
    h.world=[trainMotion2.x-h.world[0],h.world[1],GB3_SECOND_LINE_Z-h.world[2]];
    if(h.normal)h.normal=[-h.normal[0],h.normal[1],-h.normal[2]];
    h.ray=d;best=h;
   }
  }
 }
 if(trainMotion.phase==='parked')best=gb3SecondaryPaintHit(x,y,d,best,castLimit,rayOrigin);
 if(!best||!gb3ThirdPerson)return best;
 const hand=gb3PaintHand(),delta=best.world.map((v,i)=>v-hand[i]);
 const physicalDistance=Math.hypot(...delta);
 if(!Number.isFinite(physicalDistance)||physicalDistance<.08||physicalDistance>=reach)return null;
 // Spray physics now sees the true stand-off and spray angle of the hand.
 // Preserve surface UV/viewAngle from the screen-accurate camera intersection.
 return {...best,distance:physicalDistance,ray:delta.map(v=>v/physicalDistance)};
}
const palette=['#f2eee1','#000000','#f03d42','#ec8740','#ffc90e','#54d66b','#3bb7c8','#4177eb','#8d4fe6','#ed62b5','#a9b6bd','#816145'];
const state={tool:'spray',mat:'solid',color:palette[1],size:18,opacity:.68,dust:.35,drips:true,markerVariant:1,flare:.50,sprayThickness:.35};
root.dataset.gb3Build='R48-R46R47-metal-lighting';root.dataset.gb3PaintDefault='#000000';
for(const c of palette){let b=document.createElement('button');b.className='swatch';b.style.background=c;b.title=c;b.type='button';b.setAttribute('aria-label','Choose color '+c);if(c===state.color)b.classList.add('active');b.onclick=()=>gb3SetPickerHex(c,true);$('colors').append(b)}
// Photoshop-inspired HSV picker: saturation/value square + hue strip + editable HEX.
// Solid colors use picker, metallics remain independent and unmodified.
const gb3PickSquare=$('pickSquare'),gb3PickHue=$('pickHue'),gb3PickCross=$('pickCross'),gb3PickHueMark=$('pickHueMark');
const gb3PickPreview=$('pickPreview'),gb3PickHex=$('pickHex');
let gb3HSV={h:0,s:0,v:0},gb3PickerActive=false;
function gb3HsvRgb(h,s,v){
 const c=v*s,x=c*(1-Math.abs((h/60)%2-1)),m=v-c;let a;
 if(h<60)a=[c,x,0];else if(h<120)a=[x,c,0];else if(h<180)a=[0,c,x];
 else if(h<240)a=[0,x,c];else if(h<300)a=[x,0,c];else a=[c,0,x];
 return a.map(n=>Math.round((n+m)*255));
}
function gb3HexRgb(rgb){return '#'+rgb.map(v=>Math.max(0,Math.min(255,v)).toString(16).padStart(2,'0')).join('');}
function gb3RgbHsv(rgb){
 const [r,g,b]=rgb.map(x=>x/255),max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min;
 let h=0;if(d){if(max===r)h=((g-b)/d)%6;else if(max===g)h=(b-r)/d+2;else h=(r-g)/d+4;h=(h*60+360)%360;}
 return {h,s:max===0?0:d/max,v:max};
}
function gb3PickerRender(){
 const {h,s,v}=gb3HSV,hexColor=gb3HexRgb(gb3HsvRgb(h,s,v));
 if(gb3PickSquare){gb3PickSquare.style.background='linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,hsl('+h+' 100% 50%))';}
 if(gb3PickCross){gb3PickCross.style.left=s*100+'%';gb3PickCross.style.top=(1-v)*100+'%';}
 if(gb3PickHueMark)gb3PickHueMark.style.top=h/360*100+'%';
 if(gb3PickPreview)gb3PickPreview.style.background=hexColor;
 if(gb3PickHex&&document.activeElement!==gb3PickHex)gb3PickHex.value=hexColor.toUpperCase();
 state.color=hexColor;
 const mobileColorDot=root.querySelector('[data-gb3-mobile-color-dot]');
 if(mobileColorDot)mobileColorDot.style.backgroundColor=hexColor;
 root.querySelectorAll('.swatch').forEach(b=>b.classList.toggle('active',b.title.toLowerCase()===hexColor.toLowerCase()));
}
function gb3SetPickerHex(hex,activateSolid=false){
 if(!/^#[0-9a-f]{6}$/i.test(hex))return;
 gb3HSV=gb3RgbHsv([1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)));
 gb3PickerRender();if(activateSolid){setMaterial('solid');if(state.tool==='wash'||state.tool==='look')selectTool('spray');}
}
if(gb3PickSquare&&gb3PickHue){
 function gb3PickAt(e,which){
  const b=which.getBoundingClientRect();if(!b.width||!b.height)return;
  const x=Math.max(0,Math.min(1,(e.clientX-b.left)/b.width));
  const y=Math.max(0,Math.min(1,(e.clientY-b.top)/b.height));
  if(which===gb3PickSquare){gb3HSV.s=x;gb3HSV.v=1-y}else gb3HSV.h=y*359.999;
  gb3PickerRender();setMaterial('solid');
  if(state.tool==='wash'||state.tool==='look')selectTool('spray');
 }
 for(const el of [gb3PickSquare,gb3PickHue]){
  el.addEventListener('pointerdown',e=>{e.preventDefault();el.setPointerCapture(e.pointerId);gb3PickAt(e,el)});
  el.addEventListener('pointermove',e=>{if(e.buttons||e.pressure>0)gb3PickAt(e,el)});
  el.addEventListener('keydown',e=>{
   const delta=(e.key==='ArrowUp'||e.key==='ArrowRight')?1:(e.key==='ArrowDown'||e.key==='ArrowLeft')?-1:0;
   if(!delta)return;e.preventDefault();if(el===gb3PickHue)gb3HSV.h=(gb3HSV.h+360+delta*3)%360;
   else if(e.shiftKey)gb3HSV.v=Math.max(0,Math.min(1,gb3HSV.v+delta*.025));
   else gb3HSV.s=Math.max(0,Math.min(1,gb3HSV.s+delta*.025));
   gb3PickerRender();setMaterial('solid');
  });
 }
 if(gb3PickHex){gb3PickHex.addEventListener('change',e=>{
   let val=e.target.value.trim();if(!val.startsWith('#'))val='#'+val;
   if(/^#[0-9a-f]{6}$/i.test(val))gb3SetPickerHex(val,true);else gb3PickerRender();
  });}
}
gb3SetPickerHex(state.color);

let gb3DualOn=false; // Set to the saved/default preference when creating mobile controls.
let mobileTouchMode='look';
function renderTouchModes(){root.querySelectorAll('[data-touch-mode]').forEach(b=>{const active=b.dataset.touchMode===mobileTouchMode;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active))})}
function setTouchMode(mode){mobileTouchMode=gb3DualOn?'paint':(mode==='paint'?'paint':'look');if(!isTouchDevice){selectTool(mode==='look'?'look':'spray');}if(mobileTouchMode==='paint'&&state.tool==='look')selectTool('spray');renderTouchModes();$('hint').textContent=mobileTouchMode==='look'?'ONE FINGER: LOOK · TWO: ZOOM':'ONE FINGER: PAINT · TWO: ZOOM'}
function selectTool(v){if(v!=='spray')gb3SetSprayPainting(false);state.tool=v;root.querySelectorAll('[data-tool]').forEach(b=>b.classList.toggle('active',b.dataset.tool===v));root.querySelectorAll('[data-mobile-tool]').forEach(b=>b.classList.toggle('is-active',b.dataset.mobileTool===v));$('hint').textContent=v==='look'?'DRAG TO LOOK · WASD TO WALK':'DRAG TO PAINT · WASD TO WALK · RIGHT DRAG TO LOOK';if(isTouchDevice){mobileTouchMode=gb3DualOn?'paint':(v==='look'?'look':'paint');renderTouchModes()}}
root.querySelectorAll('[data-tool]').forEach(b=>b.addEventListener('click',()=>selectTool(b.dataset.tool)));
{
  root.classList.add('gb3-unified');
  const ui=document.createElement('div');ui.className='gb3-mobile-ui';
  ui.innerHTML=`<nav class="gb3-compact-toolbar" aria-label="Graffiti painting toolbar"><button type="button" data-mobile-tool="spray" title="Spray pattern, size, flare, dust, opacity and thickness" aria-label="Spray settings" data-tooltip="Spray settings" class="is-active"><img class="gb3-tool-icon" src="${root.dataset.gb3SprayIcon}" alt=""><small>SPRAY</small></button><button type="button" data-mobile-tool="marker" title="Choose Markers — hold for settings" aria-label="Choose Markers — hold for settings" data-tooltip="Choose Markers"><img class="gb3-tool-icon" src="${root.dataset.gb3MarkerIcon}" alt=""><small>MARKERS</small></button><button type="button" data-mobile-tool="wash" title="Choose Eraser" aria-label="Choose Eraser — hold for options" data-tooltip="Choose Eraser">⌁<small>ERASE</small></button><button type="button" data-mobile-panel="tools" aria-expanded="false" title="Choose Colors — tap to open picker and sliders" aria-label="Choose Colors — tap to open picker and sliders" data-tooltip="Choose Colors" aria-pressed="true" class="is-active gb3-solid-selected"><span class="gb3-mobile-color-dot" data-gb3-mobile-color-dot aria-hidden="true"></span><small>COLORS</small></button></nav><div class="gb3-mobile-erase-menu" data-gb3-erase-menu hidden role="group" aria-label="Eraser actions"><button type="button" data-gb3-erase-action="clear" title="Clear the train">✕ CLEAR TRAIN</button><button type="button" data-gb3-erase-action="wash" title="Choose eraser">⌁ ERASER</button></div><div class="gb3-touch-mode-buttons" role="group" aria-label="Touch interaction mode"><button type="button" data-gb3-roof-toggle title="Switch between ground and roof height" aria-label="Switch between ground and roof height">↑</button><button type="button" data-touch-mode="look" aria-pressed="true"><span aria-hidden="true">👁</span> LOOK</button><button type="button" data-touch-mode="paint" aria-pressed="false"><span aria-hidden="true">🎨</span> PAINT</button></div><div class="gb3-mobile-zoom-indicator" data-gb3-touch-zoom>PINCH TO ZOOM</div>`;
  root.appendChild(ui);
  // Keep the joystick inside the same overlay/stacking context in inline and fullscreen views.
  if(isTouchDevice){
    const movePad=$('touchpad');
    ui.appendChild(movePad);
    for(const [direction,glyph] of [['left','◀'],['right','▶']]){
      const arrow=document.createElement('span');
      arrow.className='gb3-stick-arrow gb3-stick-arrow--'+direction;
      arrow.textContent=glyph;arrow.setAttribute('aria-hidden','true');
      movePad.appendChild(arrow);
    }
  }
  // Marker presets use exactly the same squeezer icon for all four options.
  // Keep their selection distinct from the color/paint-type picker.
  const markerTitle=document.createElement('div');
  markerTitle.className='gb3-markers-title';
  markerTitle.innerHTML='<span class="eyebrow">CHOOSE MARKERS</span><output data-gb3-marker-name>MARKER 1</output>';
  const markerOptions=document.createElement('div');
  markerOptions.className='gb3-marker-options';
  markerOptions.setAttribute('role','group');
  markerOptions.setAttribute('aria-label','Choose marker type');
  for(let markerNo=1;markerNo<=4;markerNo++){
    const b=document.createElement('button');b.type='button';b.className='gb3-marker-option';
    b.dataset.markerVariant=String(markerNo);b.setAttribute('aria-pressed',String(markerNo===state.markerVariant));
    b.title='Choose Marker '+markerNo;
    const img=document.createElement('img');img.src=root.dataset.gb3MarkerIcon||'';
    img.alt='';img.setAttribute('aria-hidden','true');
    const caption=document.createElement('small');caption.textContent='MARKER '+markerNo;
    b.append(img,caption);markerOptions.append(b);
  }
  const capHeading=root.querySelector('.hud-left > .gb3-cap-title');
  if(capHeading)capHeading.before(markerTitle,markerOptions);
  const eraseMenu=ui.querySelector('[data-gb3-erase-menu]');
  const mobileSubpanels=['gb3-subpanel-caps','gb3-subpanel-spray','gb3-subpanel-colors','gb3-subpanel-markers'];
  function closeMobileMenus(){
    root.classList.remove('gb3-panel-tools','gb3-panel-session',...mobileSubpanels);
    eraseMenu.hidden=true;
    ui.querySelectorAll('[data-mobile-panel]').forEach(b=>b.setAttribute('aria-expanded','false'));
  }
  function openMobileTools(which){
    const name='gb3-subpanel-'+which;
    const already=root.classList.contains('gb3-panel-tools')&&root.classList.contains(name);
    closeMobileMenus();
    if(!already){root.classList.add('gb3-panel-tools',name);}
  }
  function openEraseMenu(){
    const wasOpen=!eraseMenu.hidden;
    closeMobileMenus();eraseMenu.hidden=wasOpen;
  }
  function selectMarkerVariant(v){
    state.markerVariant=v;
    markerOptions.querySelectorAll('[data-marker-variant]').forEach(b=>{
      const picked=Number(b.dataset.markerVariant)===v;
      b.classList.toggle('selected',picked);b.setAttribute('aria-pressed',String(picked));
    });
    const name=markerTitle.querySelector('[data-gb3-marker-name]');
    if(name)name.textContent='MARKER '+v;
    selectTool('marker');closeMobileMenus();
  }
  markerOptions.querySelectorAll('[data-marker-variant]').forEach(b=>{
    b.classList.toggle('selected',Number(b.dataset.markerVariant)===state.markerVariant);
    b.addEventListener('click',()=>selectMarkerVariant(Number(b.dataset.markerVariant)));
  });
  // A short tap selects the tool; holding opens its dedicated chooser.
  gb3MobileLongPress=button=>{
    if(button.dataset.mobileTool==='spray'){selectTool('spray');openMobileTools('spray');return true;}
    if(button.dataset.mobileTool==='marker'){selectTool('marker');openMobileTools('markers');return true;}
    if(button.dataset.mobileTool==='wash'){openEraseMenu();return true;}
    if(button.dataset.mobilePanel==='tools'){openMobileTools('colors');return true;}
    return false;
  };
  // Desktop mouse or pen long-hold opens the very same toolbar submenus as mobile.
  // A capture listener suppresses the synthetic release-click after an activated hold.
  if(!isTouchDevice){
   let holdTimer=null,holdButton=null,held=false,startX=0,startY=0;
   const toolbar=ui.querySelector('.gb3-compact-toolbar');
   toolbar.addEventListener('pointerdown',e=>{
    if(e.button!==0||!e.target.closest('button'))return;
    holdButton=e.target.closest('button');held=false;startX=e.clientX;startY=e.clientY;
    clearTimeout(holdTimer);
    holdTimer=setTimeout(()=>{holdTimer=null;if(holdButton){held=gb3MobileLongPress(holdButton);}},520);
   });
   toolbar.addEventListener('pointermove',e=>{
    if(holdButton&&Math.hypot(e.clientX-startX,e.clientY-startY)>10){clearTimeout(holdTimer);holdTimer=null;}
   });
   const end=()=>{clearTimeout(holdTimer);holdTimer=null;holdButton=null;};
   toolbar.addEventListener('pointerup',end);toolbar.addEventListener('pointercancel',end);
   toolbar.addEventListener('click',e=>{
    if(held){e.preventDefault();e.stopImmediatePropagation();held=false;}
   },true);
   // Right-click on tools offers quick access without affecting the 3D canvas.
   toolbar.addEventListener('contextmenu',e=>{
    const b=e.target.closest('button');if(!b)return;
    if(gb3MobileLongPress(b)){e.preventDefault();e.stopPropagation();}
   });
  }
  ui.querySelectorAll('[data-touch-mode]').forEach(b=>b.addEventListener('click',()=>{setTouchMode(b.dataset.touchMode);closeMobileMenus()}));
  ui.querySelectorAll('[data-mobile-tool]').forEach(b=>b.addEventListener('click',()=>{
    const tool=b.dataset.mobileTool;
    if(!isTouchDevice && tool==='marker'){
      // PC: choose a preset BEFORE switching tool; never open the color picker.
      openMobileTools('markers');return;
    }
    if(!isTouchDevice && tool==='wash'){
      // PC: ERASE has the same Undo / Clear Train / Eraser menu as mobile.
      openEraseMenu();return;
    }
    selectTool(tool);
    if(tool==='spray')openMobileTools('spray');else closeMobileMenus();
  }));
  ui.querySelectorAll('[data-mobile-panel]').forEach(b=>b.addEventListener('click',()=>{
    if(b.dataset.mobilePanel==='tools'){
      // One tap both selects solid paint and TOGGLES the color picker.
      // No long press is required; a second tap closes the panel.
      setMaterial('solid');
      if(state.tool==='wash'||state.tool==='look')selectTool('spray');
      openMobileTools('colors');
    }else{
      const active=root.classList.contains('gb3-panel-session');
      closeMobileMenus();if(!active){root.classList.add('gb3-panel-session');b.setAttribute('aria-expanded','true');}
    }
  }));
  ui.querySelectorAll('[data-gb3-erase-action]').forEach(b=>b.addEventListener('click',()=>{
    const action=b.dataset.gb3EraseAction;
    closeMobileMenus();
    if(action==='undo')return;
    else if(action==='clear')$('clear').click();
    else selectTool('wash');
  }));
  // Dismiss popovers when clicking outside their controls, without breaking painting.
  view.addEventListener('pointerdown',()=>{if(root.classList.contains('gb3-panel-tools')||!eraseMenu.hidden)closeMobileMenus()});
  ui.querySelector('[data-gb3-roof-toggle]').addEventListener('click',e=>{const goUp=cam.y<4.1;cam.y=goUp?5.1:gb3SprayConfig.cameraHeight;cam.pitch=goUp?-.22:-.025;e.currentTarget.textContent=goUp?'↓':'↑';e.currentTarget.setAttribute('aria-label',goUp?'Return to ground height':'Switch to roof height');toast(goUp?'Roof view: pinch and spray':'Ground view')});
  renderTouchModes();
  const helpGrid=$('helpModal').querySelector('.help-grid');
  if(isTouchDevice&&helpGrid)helpGrid.innerHTML='<div><b>🕹 MOVE</b><small>Hold and drag to walk</small></div><div><b>👁 LOOK</b><small>One finger rotates camera</small></div><div><b>🎨 PAINT</b><small>One finger sprays train</small></div><div><b>🤏 TWO FINGERS</b><small>Pinch out to zoom in</small></div>';
  const para=$('helpModal').querySelector('.modal-panel>p');if(isTouchDevice&&para)para.textContent='Every wall has a story. GBattle 3D gives writers a virtual yard to explore, experiment with color and build their own style. Use MOVE to walk, LOOK to explore, PAINT to spray, and pinch to zoom.';
}
// Remove TAR even if a Shopify section from an older theme still lists it.
 root.querySelectorAll('[data-material="tar"]').forEach(b=>b.remove());
 function setMaterial(v){
  if(!['solid','chrome','gold','copper'].includes(v))v='solid';
  state.mat=v;
 root.querySelectorAll('[data-material]').forEach(b=>b.classList.toggle('selected',b.dataset.material===v));
 const colorBtn=root.querySelector('[data-mobile-panel="tools"]');
 if(colorBtn){
   const solid=v==='solid';
   colorBtn.classList.toggle('is-active',solid);
   colorBtn.classList.toggle('gb3-solid-selected',solid);
   colorBtn.setAttribute('aria-pressed',String(solid));
   const dot=colorBtn.querySelector('[data-gb3-mobile-color-dot]');
   if(dot)dot.style.backgroundColor=state.color;
 }
}
root.querySelectorAll('[data-material]').forEach(b=>b.addEventListener('click',()=>setMaterial(b.dataset.material)));
setMaterial(state.mat);gb3PickerRender();
for(const [name,key,suffix,convert] of [['size','size',' cm',Number],['opacity','opacity','%',v=>Number(v)/100],['dust','dust','%',v=>Number(v)/100]]){$(name).addEventListener('input',e=>{state[key]=convert(e.target.value);$(name+'Value').textContent=e.target.value+suffix})}
// Flare is a real user-adjustable spray control; reuse existing setting styling.
{
 const dustSetting=$('dust')?.closest('label');
 if(dustSetting&&!root.querySelector('[data-gb3="flare"]')){
   const label=document.createElement('label');label.className='setting gb3-setting-dust gb3-setting-flare';
   label.append(document.createTextNode('FLARE '));
   const value=document.createElement('output');value.textContent=Math.round(state.flare*100)+'%';
   const slider=document.createElement('input');slider.type='range';slider.min='0';slider.max='100';slider.step='5';slider.value=String(Math.round(state.flare*100));
   slider.dataset.gb3='flare';slider.setAttribute('aria-label','Spray speed flare strength');
   slider.addEventListener('input',()=>{state.flare=Number(slider.value)/100;value.textContent=slider.value+'%';});
   label.append(value,slider);dustSetting.insertAdjacentElement('afterend',label);
 }
 // Separate spray DROPLET SIZE from cap SIZE, DUST amount, and FLARE.
 // The default is finer than the old spray. The right end recreates coarse droplets.
 if(dustSetting&&!root.querySelector('[data-gb3="sprayThickness"]')){
   const label=document.createElement('label');label.className='setting gb3-setting-dust gb3-setting-spray-thickness';
   label.title='0% = very fine mist; 100% = thick original droplets. Does not change cap diameter.';
   label.append(document.createTextNode('SPRAY THICKNESS '));
   const value=document.createElement('output');value.textContent=Math.round(state.sprayThickness*100)+'%';
   const slider=document.createElement('input');slider.type='range';slider.min='0';slider.max='100';slider.step='5';
   slider.value=String(Math.round(state.sprayThickness*100));slider.dataset.gb3='sprayThickness';
   slider.setAttribute('aria-label','Spray droplet thickness. Zero is very fine, one hundred is coarse');
   slider.title='FINE mist ← 0%   ·   100% → COARSE droplets';
   slider.addEventListener('input',()=>{state.sprayThickness=Number(slider.value)/100;value.textContent=slider.value+'%';});
   label.append(value,slider);dustSetting.insertAdjacentElement('afterend',label);
 }
}
{
 const capList=$('caps');
 const selectors=['.gb3-setting-size','.gb3-setting-flare',
   '.gb3-setting-dust:not(.gb3-setting-flare):not(.gb3-setting-spray-thickness)',
   '.gb3-setting-opacity','.gb3-setting-spray-thickness','.gb3-setting-drips'];
 let anchor=capList;
 if(anchor)for(const sel of selectors){
  const element=root.querySelector('.hud-left > '+sel);
  if(!element)continue;anchor.insertAdjacentElement('afterend',element);anchor=element;
 }
}
$('drips').onchange=e=>{state.drips=e.target.checked;if(!state.drips){wetPools.length=0;activeDrips.length=0;}};
// v2.3 — Brush masks and previews come from the owner's server server.
// Important: browser-delivered PNGs remain inspectable; they are NOT secret.
let sprayStamp=null,stampKey='';
const gb3CapNames=["ap-micro", "astro-f3", "fbs", "la-outline", "lego-10", "ny-fat", "ny-outline-10", "pink-dot", "rd-cali", "red-b-fat", "rusto-fat", "sky-dot-fat"];
state.cap='ny-fat';
const gb3CapImages=new Map();
const gb3CapBase=(root.dataset.gb3CapBase||'https://gbattle.sweink.com/3d/caps/').replace(/\/?$/,'/');
const gb3CapAsset=name=>root.getAttribute('data-gb3-cap-'+name)||'';
const gb3CapThumbAsset=name=>root.getAttribute('data-gb3-cap-thumb-'+name)||'';
function gb3CapURL(name,thumb=false){
 const v=thumb?gb3CapThumbAsset(name):gb3CapAsset(name);
 return v&&/^(https?:)?\/\//.test(v)?v:gb3CapBase+(thumb?'thumb-':'')+name+'.png';
}

const gb3CapChooser=$('caps');
const gb3CapTitle=root.querySelector('.gb3-cap-title .eyebrow');if(gb3CapTitle)gb3CapTitle.textContent='SPRAY PATTERN';
function gb3RefreshCapStatus(){
 const label=$('capName');if(!label)return;
 label.textContent=state.cap.replace(/-/g,' ').toUpperCase()+(gb3CapImages.has(state.cap)?'':' · DEFAULT');
 label.title=gb3CapImages.has(state.cap)?'Original server spray mask loaded':'Using default spray while server brush loads or is unavailable';
}
function gb3SelectCap(name){
 if(!gb3CapNames.includes(name))return;state.cap=name;sprayStamp=null;stampKey='';
 if(gb3CapChooser)gb3CapChooser.querySelectorAll('[data-cap]').forEach(b=>{const active=b.dataset.cap===name;b.classList.toggle('selected',active);b.setAttribute('aria-pressed',String(active))});
 gb3RefreshCapStatus();
}
if(gb3CapChooser){
 for(const name of gb3CapNames){
  const btn=document.createElement('button');btn.type='button';btn.className='gb3-cap-option';btn.dataset.cap=name;btn.title=name.replace(/-/g,' ').toUpperCase();btn.setAttribute('aria-label','Spray cap '+btn.title);btn.setAttribute('aria-pressed','false');
  const img=document.createElement('img');img.alt='';img.loading='lazy';img.crossOrigin='anonymous';
  img.onerror=()=>{img.hidden=true;img.style.display='none';btn.classList.add('gb3-cap-unavailable');};
  img.src=gb3CapURL(name,true);
  const small=document.createElement('small');small.textContent=name.replace(/-/g,' ');btn.append(img,small);btn.onclick=()=>gb3SelectCap(name);gb3CapChooser.append(btn);
  const url=gb3CapURL(name);
  const brush=new Image();brush.crossOrigin='anonymous';
  brush.onload=()=>{gb3CapImages.set(name,brush);btn.classList.remove('gb3-cap-unavailable');if(state.cap===name){sprayStamp=null;stampKey='';gb3RefreshCapStatus()}};
  brush.onerror=()=>{console.warn('GBattle cap unavailable, using default stamp:',name);if(state.cap===name)gb3RefreshCapStatus()};
  brush.src=url;
 }
 gb3SelectCap(state.cap);
}
const swatches={chrome:['#212a33','#939ca4','#f4f8fa','#5a656e','#eff5f8','#2b343e'],gold:['#392004','#a86e09','#fff4ac','#9a5c05','#f9d44d','#543209'],copper:['#481f17','#b55f32','#f8c697','#a24a27','#f0a16b','#5c291c'],tar:['#06080a','#111417','#373b3d','#0d1115','#202426','#050708']};
// R53-M1: metallic pigment is spatially uniform; lighting adds reflection.
// Avoid one dark-to-light gradient per spray stamp, which creates giant bands.
const gb3MetalCoatColors=Object.freeze({chrome:'#9ba6af',gold:'#c6a65b',copper:'#b66f47'});
function gb3MetalCoatColor(finish,fallback){return gb3MetalCoatColors[finish]||fallback;}
function gb3MetalCoatAlpha(seg,opacity){
 const f=gb3BetaR47Profile(seg,opacity);
 return clamp(Math.pow(f.opacity,1.20)*(.23+.62*f.thickness)*(.55+.45*f.density),.01,.86);
}
// Spray Engine R2: visible accumulated wetness + bounded gravity rivers.
// Keep the original canvas paint system, drip toggle, save snapshots and washer.
// LONG strokes have strongly varied lengths, not width-dependent short tails.
const wetPools=[],activeDrips=[],MAX_WET_POOLS=isTouchDevice?125:170,MAX_ACTIVE_DRIPS=isTouchDevice?54:86;
let currentPaintActionId=0,lastWetSample=null,dripLastTick=0,dripTimer=null;
function paintInk(){return state.mat==='gold'?'#c6a65b':state.mat==='chrome'?'#9ba6af':state.mat==='copper'?'#b66f47':state.mat==='tar'?'#14191d':state.color}
function gb3SurfaceResponse(hit){
 const p=hit.p,name=(p.name||'').toLowerCase(),uvx=hit.u*p.canvas.width,uvy=hit.v*p.canvas.height;
 const roof=p.region==='roof'||name.includes('roof');
 const end=p.region==='end';
 const door=name.includes('door');
 const ribbed=name.includes('rib')||name.includes('side')||name.includes('body')||name.includes('wall');
 const rough=name.includes('concrete')||name.includes('brick')||name.includes('stone');
 // Stable microstructure tied to surface UVs; no frame-to-frame random jitter.
 const rib= ribbed?Math.abs(Math.sin(uvx*.077+Math.sin(uvy*.018)*.3)):0;
 const grain=Math.sin(uvx*1.41+uvy*.38)*Math.cos(uvy*1.23-uvx*.29);
 let adhesion=1,spread=1,scatter=1;
 if(roof){adhesion=.68;spread=1.10;scatter=.88;}
 else if(rough){adhesion=1.16;spread=1.07;scatter=1.72;}
 else if(door){adhesion=.93;spread=.99;scatter=1.02;}
 else if(end){adhesion=.97;scatter=.97;}
 if(ribbed){adhesion*=.77+.23*rib;scatter*=1.08;}
 adhesion*=1+grain*(rough?.21:.06);
 return {adhesion:clamp(adhesion,.42,1.5),spread,scatter,roughness:rough?1:ribbed?.43:.16,roof,door,ribbed,grain};
}
function dropWetness(hit,r,held=false,intensity=1){
 if(!state.drips||state.tool!=='spray'||!hit||!hit.p||hit.p.region==='roof')return;
 const p=hit.p,x=clamp(hit.u*p.canvas.width,0,p.canvas.width),y=clamp(hit.v*p.canvas.height,0,p.canvas.height);
 const now=performance.now(),movement=lastWetSample&&lastWetSample.p===p?Math.hypot(lastWetSample.x-x,lastWetSample.y-y):r*2;
 const slow=held?2.45:1+clamp(1-movement/Math.max(4,r*.85),0,1)*.85;
 const surface=gb3SurfaceResponse(hit),finishWet=state.mat==='tar'?1.30:state.mat==='chrome'?.78:1;
 const amount=(held?.27:.105)*state.opacity*slow*clamp(intensity,.25,1.65)*surface.adhesion*finishWet;
 lastWetSample={p,x,y};
 const near=Math.max(6,Math.min(28,r*.92)),near2=near*near;
 let pool=null;
 for(let i=wetPools.length-1;i>=0;i--){const w=wetPools[i];if(w.p!==p||w.actionId!==currentPaintActionId)continue;
   if((w.x-x)**2+(w.y-y)**2<near2){pool=w;break;}}
 if(pool){const mix=Math.min(.22,amount/(pool.wet+amount));pool.x+=(x-pool.x)*mix;pool.y+=(y-pool.y)*mix;
   pool.wet=Math.min(7,pool.wet+amount);pool.width=Math.max(pool.width,r);pool.touched=now;}
 else if(wetPools.length<MAX_WET_POOLS){wetPools.push({p,x,y,wet:amount,width:r,color:paintInk(),opacity:state.opacity,actionId:currentPaintActionId,touched:now,
   charge:rnd(.0,.35),threshold:rnd(.44,.92),emitted:0,adhesion:surface.adhesion});}
 if(wetPools.length||activeDrips.length)ensureDripTimer();
}
function spawnGravityDrip(w){
 if(activeDrips.length>=MAX_ACTIVE_DRIPS||w.y>=w.p.canvas.height-4)return;
 const r=Math.max(3,w.width),wet=clamp(w.wet/2.7,.13,1.5),room=w.p.canvas.height-w.y-2;
 const thin=Math.random();
 const width=clamp(r*(thin<.54?rnd(.018,.057):thin<.91?rnd(.058,.135):rnd(.14,.25))*(.8+wet*.34),.65,9.3);
 // 15% short, 48% medium, 37% LONG, independent of cap diameter.
 const draw=Math.random();
 const length=draw<.15?rnd(18,62):draw<.63?rnd(66,158):rnd(155,365);
 const lengthBoost=clamp(.74+wet*.36,.76,1.38);
 const y=clamp(w.y+rnd(-r*.13,r*.18),1,w.p.canvas.height-3);
 const x=clamp(w.x+rnd(-r*.44,r*.44),2,w.p.canvas.width-2);
 const maxLength=Math.min(room,length*lengthBoost);
 if(maxLength<9)return;
 // Random 0..4 split events, biased upward by length and fresh wet volume.
 const probability=clamp(.06+wet*.24+maxLength/420,.08,.95);
 const forkRoll=Math.random();
 const forkBudget=forkRoll>probability?0:forkRoll<probability*.25?3+(Math.random()<.4?1:0):forkRoll<probability*.60?2:1;
 const d={p:w.p,x,y,startY:y,width,length:maxLength,speed:rnd(33,100),phase:rnd(0,TAU),bend:rnd(-.45,.45),
   color:w.color,opacity:clamp(w.opacity*.8,.12,1),actionId:w.actionId,volume:wet,depth:0,
   forkBudget,splitAt:forkBudget?rnd(.16,.48):0,splitDone:false,fade:rnd(.78,1.23)};
 activeDrips.push(d);
}
function ensureDripTimer(){if(!dripTimer){dripLastTick=performance.now();dripTimer=setTimeout(stepWetDrips,65);}}
function splitWetDrip(d,progress){
 if(!d.splitAt||d.splitDone||progress<d.splitAt||d.depth>=3||activeDrips.length>=MAX_ACTIVE_DRIPS)return;
 d.splitDone=true;
 const room=Math.min(d.p.canvas.height-2-d.y,d.length*(1-progress));
 if(room<14||d.width<.85||d.volume<.105||d.forkBudget<=0)return;
 const originalVolume=d.volume,originalWidth=d.width,sign=Math.random()<.5?-1:1;
 // Usually Y; occasionally two daughter branches. Wet parent retains paint.
 const available=Math.min(MAX_ACTIVE_DRIPS-activeDrips.length,d.volume>.52&&d.width>2.2&&Math.random()<.22?2:1);
 const childShares=[];
 let shareLeft=.70;
 for(let i=0;i<available;i++){
   const fraction=Math.min(shareLeft*.76,rnd(.19,.38));shareLeft-=fraction;childShares.push(fraction);
 }
 const sum=childShares.reduce((a,b)=>a+b,0);
 d.volume=originalVolume*(1-sum);d.width=Math.max(.45,originalWidth*Math.sqrt(1-sum));
 d.bend-=sign*rnd(.18,.55);
 d.forkBudget=Math.max(0,d.forkBudget-1-available);
 d.splitAt=d.forkBudget>0?rnd(Math.min(.96,progress+.10),Math.min(.99,progress+.28)):0;
 d.splitDone=!d.splitAt;
 for(let i=0;i<childShares.length;i++){
   const share=childShares[i],volume=originalVolume*share,depth=d.depth+1;
   const childLen=Math.min(d.p.canvas.height-d.y-2,Math.max(12,room*rnd(.46,1.45)));
   const forkChance=clamp(.03+volume*.42+childLen/560,0,.74);
   const forkBudget=depth<3&&Math.random()<forkChance?(Math.random()<.24?2:1):0;
   activeDrips.push({...d,x:d.x,y:d.y,startY:d.y,volume,width:Math.max(.55,originalWidth*Math.sqrt(share)),
     length:childLen,speed:d.speed*rnd(.74,1.10),bend:d.bend+sign*(i===0?1:-1)*rnd(1.25,2.65),
     phase:rnd(0,TAU),depth,forkBudget,splitDone:!forkBudget,splitAt:forkBudget?rnd(.19,.62):0,
     fade:rnd(.7,1.10)});
 }
}
function stepWetDrips(){
 dripTimer=null;
 if(!state.drips){wetPools.length=0;activeDrips.length=0;return;}
 const now=performance.now(),dt=clamp((now-dripLastTick)/1000,.01,.13);dripLastTick=now;
 for(let i=wetPools.length-1;i>=0;i--){const w=wetPools[i],age=(now-w.touched)/1000;
   w.wet=Math.max(0,w.wet-dt*(.075+age*.052));
   w.charge+=dt*(.36+w.wet*.74);
   // Wide wet lines can emit MANY independent streams at distinct x positions.
   if(w.wet>.27&&w.charge>=w.threshold&&activeDrips.length<MAX_ACTIVE_DRIPS){
     w.charge=0;const available=w.wet;
     w.wet=Math.max(0,w.wet-rnd(.22,.46));w.emitted++;
     spawnGravityDrip({...w,wet:available});w.threshold=rnd(.38,.98);
   }
   if(w.wet<.045||age>12)wetPools.splice(i,1);
 }
 // Snapshot count prevents new forks from being stepped until the next tick.
 for(let i=activeDrips.length-1;i>=0;i--){
   const d=activeDrips[i],p=d.p,remaining=d.length-(d.y-d.startY);
   const dy=Math.min(remaining,(d.speed+=47*dt)*dt);
   if(!(dy>0)||d.volume<.035){activeDrips.splice(i,1);continue;}
   const oldX=d.x,oldY=d.y,progress=clamp((oldY-d.startY)/Math.max(1,d.length),0,1);
   const wobble=Math.sin(progress*13+d.phase)*Math.min(.24,d.width*.11)*dt*14+d.bend*dt*7.0;
   // Branches open into a Y, then gravity gradually straightens the tails.
   d.bend*=Math.max(.65,1-dt*(d.depth?1.05:.36));
   d.x=clamp(d.x+wobble,1,p.canvas.width-1);d.y=Math.min(p.canvas.height-1,d.y+dy);
   const tapered=clamp(d.width*Math.pow(Math.max(.02,1-progress),.44)*d.fade,.42,10.2);
   const ctx=p.ctx;ctx.save();ctx.globalAlpha=d.opacity;ctx.strokeStyle=d.color;ctx.lineCap='round';ctx.lineJoin='round';ctx.lineWidth=tapered;
   ctx.beginPath();ctx.moveTo(oldX,oldY);ctx.quadraticCurveTo((oldX+d.x)/2,(oldY+d.y)/2,d.x,d.y);ctx.stroke();
   if(progress>.80||remaining<=dy+1){ctx.beginPath();ctx.ellipse(d.x,d.y,Math.max(.45,tapered*.53),Math.max(.5,tapered*.66),0,0,TAU);ctx.fillStyle=d.color;ctx.fill();}
   ctx.restore();dirty.add(p);
   splitWetDrip(d,progress);
   if(d.y>=d.startY+d.length-1||d.y>=p.canvas.height-2)activeDrips.splice(i,1);
 }
 if(wetPools.length||activeDrips.length)dripTimer=setTimeout(stepWetDrips,65);
 else if(!dragging)saveLater();
}
function removeWetAt(p,x,y,r){
 for(let i=wetPools.length-1;i>=0;i--){const w=wetPools[i];if(w.p===p&&Math.hypot(w.x-x,w.y-y)<r*1.65)wetPools.splice(i,1);}
 for(let i=activeDrips.length-1;i>=0;i--){const d=activeDrips[i];if(d.p===p&&Math.hypot(d.x-x,d.y-y)<r*1.65)activeDrips.splice(i,1);}
}
function makeStamp(){let id=[state.mat,state.color,state.tool,state.cap,gb3CapImages.has(state.cap)].join('|');if(id===stampKey&&sprayStamp)return sprayStamp;stampKey=id;let c=document.createElement('canvas');c.width=c.height=128;let ctx=c.getContext('2d');
 if(state.mat==='solid'||gb3MetalCoatColors[state.mat]){ctx.fillStyle=gb3MetalCoatColor(state.mat,state.color);ctx.fillRect(0,0,128,128)}else{let g=ctx.createLinearGradient(0,0,128,0);let stops=swatches[state.mat];stops.forEach((color,i)=>g.addColorStop(i/(stops.length-1),color));ctx.fillStyle=g;ctx.fillRect(0,0,128,128)}
 ctx.globalCompositeOperation='destination-in';const brush=state.tool==='spray'&&!gb3MetalCoatColors[state.mat]?gb3CapImages.get(state.cap):null;if(brush){ctx.drawImage(brush,0,0,128,128)}else{let r=ctx.createRadialGradient(64,64,1,64,64,64);r.addColorStop(0,'rgba(255,255,255,1)');r.addColorStop(.67,'rgba(255,255,255,1)');r.addColorStop(.86,'rgba(255,255,255,.62)');r.addColorStop(1,'rgba(255,255,255,0)');ctx.fillStyle=r;ctx.fillRect(0,0,128,128)}sprayStamp=c;return c}
// Full spray deposition: physical stand-off, incidence, speed/flare, and texture.
function gb3SprayPhysics(hit,speed=0){
 const cfg=gb3SprayConfig;
 const distance=Number.isFinite(hit.distance)?hit.distance:1.2;
 // Physical cone: close spray remains close to the selected cap diameter.
 // Widen only over the final 2.3m of the deliberately SHORT 3.2m reach.
 const linearStandOff=clamp((distance-cfg.spreadStart)/(cfg.spreadFull-cfg.spreadStart),0,1);
 const standOff=linearStandOff*linearStandOff*(3-2*linearStandOff);
 // A centred ray and an edge ray do NOT paint the same projected footprint.
 // Use real ray/eye divergence, surface incidence and the current camera FOV;
 // never use arbitrary pointer jitter or force widening on markers/erasers.
 const centralRay=forward();
 const divergence=Math.acos(clamp(dot(unit(hit.ray||centralRay),centralRay),-1,1));
 const edgeAngle=Math.atan(Math.tan(fov/2)*Math.hypot(1,(width/Math.max(1,height))));
 const edge=clamp(divergence/Math.max(.001,edgeAngle),0,1);
 const viewWiden=1+cfg.offAxisWiden*Math.pow(edge,cfg.offAxisPower);
 const distanceSpread=clamp((cfg.spreadNear+(cfg.spreadFar-cfg.spreadNear)*standOff)*viewWiden,
   cfg.spreadNear,cfg.maxViewSpread);
 const ray=hit.ray||unit([hit.world[0]+trainMotion.x-cam.x,hit.world[1]-cam.y,hit.world[2]-cam.z]);
 const normal=hit.normal||[0,0,1];
 const incidence=clamp(Math.abs(dot(unit(normal),unit(ray))),.03,1);
 const graze=clamp((1-incidence)*1.12,0,.97);
 const surface=gb3SurfaceResponse(hit);
 const p=hit.p,nominal=Math.max(1.6,state.size/100/p.len*p.canvas.width/2);
 // Dead zone + smooth ramp. Small drag events no longer crush the line.
 // R47: dragStroke speed is measured in pixels/second on each surface's
 // OWN canvas (train vs high-resolution city facade). Normalize to the same
 // 3600px reference as the original speed thresholds, so flare responds
 // equally to the exact same physical pointer motion on trains/buildings.
 const normalizedSpeed=Math.max(0,Number(speed)||0)*3600/Math.max(64,p.canvas.width);
 const moving=clamp((normalizedSpeed-cfg.speedSoftStart)/(cfg.speedFull-cfg.speedSoftStart),0,1);
 const fast=moving*moving*(3-2*moving);
 const flare=clamp(state.flare,0,1);
 const pinch=1-fast*cfg.speedPinch*flare;
 const radius=clamp(nominal*distanceSpread*pinch*surface.spread*.25,.30,nominal*cfg.maxViewSpread*1.14*.25);
 const density=clamp((1-fast*cfg.speedDensityDrop)*Math.pow(1/distanceSpread,.68)*(1-graze*.55)*surface.adhesion,.12,1.20);
 const elongate=1+graze*1.65;
 const finish=state.mat==='tar'?1.12:state.mat==='chrome'?.84:1;
 // The footprint elongates along the ray projected onto the actual surface.
 // Mouse-stroke movement determines speed only; it must not rotate the spray cone.
 const viewAngle=Number.isFinite(hit.viewAngle)?hit.viewAngle:0;
 return {radius,density:density*finish,graze,fast,elongate,standOff,incidence,surface,viewAngle};
}
function gb3SprayParticles(c,px,py,r,phys,angle){
 // SPRAY THICKNESS: 0 = atomized mist; 1 = the original coarse paint drops.
 // This does NOT resize the cap footprint and does not alter the wet-drip system.
 const thickness=clamp(state.sprayThickness??1,0,1),fine=1-thickness;
 const dust=clamp(state.dust,0,1),spread=r*(1.75+phys.standOff*.72+phys.graze);
 const scatter=phys.surface.scatter,atomSize=.27+.73*thickness;
 const mobileBudget=isTouchDevice?72:104;
 // Core atomization is present even with zero overspray. More (smaller) grains
 // for a fine mist; the coarsest setting matches the old outer-droplet pattern.
 const coreN=clamp(Math.round(fine*(9+18*scatter)),0,isTouchDevice?22:32);
 const edgeN=dust>0?clamp(Math.round((9+dust*32)*scatter*(.62+phys.standOff*.5)*(1+fine*.60)),0,mobileBudget-coreN):0;
 const ink=paintInk();c.fillStyle=ink;
 for(let i=0;i<coreN;i++){
   const theta=rnd(0,TAU),dist=r*Math.sqrt(Math.random())*.90;
   const along=Math.cos(theta)*dist,across=Math.sin(theta)*dist;
   const sz=clamp(rnd(.48,1.10)*atomSize,.16,1.2);
   c.globalAlpha=clamp(state.opacity*rnd(.09,.22)*phys.density,.018,.23);
   c.fillRect(px+along*phys.elongate,py+across,sz,sz);
 }
 for(let i=0;i<edgeN;i++){
   const t=rnd(0,TAU),dist=r*Math.sqrt(rnd(.4,2.5+phys.standOff)),jitter=rnd(.7,1.32);
   const dx=Math.cos(t)*dist*jitter,dy=Math.sin(t)*dist*jitter;
   const along=dx*Math.cos(angle)-dy*Math.sin(angle),across=dx*Math.sin(angle)+dy*Math.cos(angle);
   c.globalAlpha=clamp(state.opacity*(.09+.21*Math.random())*phys.density*dust,.009,.37);
   const sz=clamp(rnd(.45,1.65)*atomSize*(1+phys.surface.roughness*.34),.15,2.35);
   c.fillRect(px+along*phys.elongate,py+across,sz,sz);
 }
 // Heavy wet splatter is a separate physical behavior: it still appears on
 // slow passes, but droplets are finer when the thickness slider is low.
 if(phys.fast<.46&&phys.standOff<.64&&dust>.18&&Math.random()<.58){
   const count=clamp(2+Math.floor(Math.random()*5)+Math.floor(fine*2),0,8);
   for(let i=0;i<count;i++){
     const t=rnd(0,TAU),d=rnd(r*.90,spread);
     c.globalAlpha=state.opacity*rnd(.14,.36)*phys.density;
     c.beginPath();c.arc(px+Math.cos(t)*d,py+Math.sin(t)*d,rnd(.45,2.1)*atomSize,0,TAU);c.fill();
   }
 }
}
function gb3WasherStreak(c,px,py,r){
 // Preserve the original washer but pull random erased rivulets down the surface.
 const count=3+Math.floor(Math.random()*3);
 c.strokeStyle='#000';c.lineCap='round';
 for(let i=0;i<count;i++){
   const offset=rnd(-.74,.74)*r,len=r*rnd(.75,2.55);
   c.globalAlpha=clamp(state.opacity*rnd(.32,.74),.15,.95);
   c.lineWidth=Math.max(.5,r*rnd(.035,.15));
   c.beginPath();c.moveTo(px+offset,py+rnd(-.24,.15)*r);
   c.quadraticCurveTo(px+offset+rnd(-.35,.35)*r,py+len*.48,px+offset+rnd(-.45,.45)*r,py+len);c.stroke();
 }
}
function paint(hit,dynamics=null){
 if(!hit)return;
 if(hit.p?.gb3City)hit.p.gb3HasPaint=true;
 if(gb3BetaMode){gb3BetaPaint(hit,dynamics);return;}
 const p=hit.p,c=p.ctx,px=hit.u*p.canvas.width,py=hit.v*p.canvas.height;
 const markerScale=[.65,.9,1.2,1.55][state.markerVariant-1];
 const spray=state.tool==='spray',wash=state.tool==='wash';
 const phys=spray?gb3SprayPhysics(hit,dynamics?.speed||0):null;
 const diam=state.size/100/p.len*p.canvas.width*(state.tool==='marker'?markerScale:1);
 const r=spray?phys.radius:Math.max(2,diam/2);
 const held=!!dynamics?.held,angle=spray?phys.viewAngle:(dynamics?.angle||0);
 const alpha=state.tool==='marker'?state.opacity:Math.max(.014,state.opacity*(.28+(held?.08:0))*(phys?.density||1));
 c.save();
 if(wash){
   removeWetAt(p,px,py,r);c.globalCompositeOperation='destination-out';
   c.globalAlpha=Math.min(1,state.opacity*.78);c.fillStyle='#000';
   c.beginPath();c.arc(px,py,r*1.18,0,TAU);c.fill();
   gb3WasherStreak(c,px,py,r);
 }else{
   const stamp=makeStamp();c.globalAlpha=alpha;
   if(spray){
     c.save();c.translate(px,py);c.rotate(angle);c.scale(phys.elongate,1-phys.graze*.30);
     // Broad diffuse halo behind the denser cap. More stand-off gives dusty edges.
     if(phys.standOff>.05&&state.dust>.02){
       c.globalAlpha=alpha*state.dust*.21;
       c.drawImage(stamp,-r*2.24,-r*2.24,r*4.48,r*4.48);
     }
     c.globalAlpha=alpha;
     c.drawImage(stamp,-r*1.78,-r*1.78,r*3.56,r*3.56);c.restore();
   }else c.drawImage(stamp,px-r*1.85,py-r*1.85,r*3.7,r*3.7);
   if(spray){
     gb3SprayParticles(c,px,py,r,phys,angle);
     dropWetness(hit,r,held,phys.density);
     if(held){
       // Fresh paint settles into a darker saturated pool with irregular wet rims.
       c.globalAlpha=state.opacity*.095*phys.surface.adhesion;c.strokeStyle=paintInk();
       for(let i=0;i<2;i++){
         c.lineWidth=Math.max(.5,r*rnd(.045,.115));
         c.beginPath();c.ellipse(px+rnd(-.1,.1)*r,py+rnd(-.1,.1)*r,
           r*rnd(.31,.56),r*rnd(.30,.48),rnd(-.15,.15),0,TAU);c.stroke();
       }
     }
     // Metallic finishes have fine glints that use the EXISTING swatch colors.
     if(state.mat==='tar'&&phys.fast<.85){
       const colors=swatches[state.mat];
       if(colors){for(let i=0;i<3;i++){
         c.globalAlpha=state.opacity*rnd(.14,.32)*phys.density;c.fillStyle=colors[(i+2)%colors.length];
         c.fillRect(px+rnd(-r,r),py+rnd(-r,r),rnd(.5,1.5),rnd(.45,1.4));
       }}
     }
   }
 }
 c.restore();dirty.add(p);
}
// R5: a separate, render-only painting gesture. The multiplayer paint/UV data
// and Go protocol are unchanged; the skeletal avatar receives only world-space
// targets that have already passed the existing 3.2m hand-to-surface test.
const gb3PaintGesture={active:false,ready:false,world:null,tool:'spray'};
let dragging=false,turning=false,gb3StrokeStarted=false,lastHit=null,lastX=0,lastY=0,lastPaintMotionAt=0,lastDragSampleAt=0,gb3SmoothedStrokeSpeed=0;
// Stationary spraying builds visible pigment and wets the underlying pool.
setInterval(()=>{
 if(dragging&&state.tool==='spray'&&lastHit&&performance.now()-lastPaintMotionAt>100){
   const hit=hitTest(lastX,lastY);
   if(hit){lastHit=hit;paint(hit,{held:true,speed:0,angle:0});}
   else {lastHit=null;gb3SetSprayPainting(false);}
 }
},83);
const activeTouches=new Map();let activeMousePointer=null,pinchDistance=0,pinchStartFov=fov,ignoreUntilTouchRelease=false;
function touchGap(){const points=[...activeTouches.values()];return points.length<2?0:Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y)}
function displayZoom(){const value=root.querySelector('[data-gb3-touch-zoom]');if(value)value.textContent='ZOOM '+Math.round(defaultFov/fov*100)+'%'}
function stopStroke(){
 gb3PaintGesture.active=false;gb3PaintGesture.ready=false;gb3PaintGesture.world=null;
 gb3SetSprayPainting(false);gb3SmoothedStrokeSpeed=0;gb3BetaWetSpot=null;
 if(dragging){dragging=false;gb3StrokeStarted=false;lastHit=null;lastWetSample=null;saveLater()}
 turning=false;
}
function beginStroke(h){if(!h)return;gb3EnsureCityPaintResolution(h.p);gb3StrokeStarted=true;gb3SetSprayPainting(state.tool==='spray');const snap=null;currentPaintActionId++;lastWetSample=null;gb3SmoothedStrokeSpeed=0;gb3BetaWetSpot=null;lastPaintMotionAt=lastDragSampleAt=performance.now();/* No client undo snapshots: durable shared painting only. */$('undoCount').textContent=undo.length+' / 7';strokes++;$('paintedCount').textContent=strokes+' strokes';$('saveState').textContent='UNSAVED'}
function dragStroke(hit){
 // Animate the hand toward the SAME accepted surface point used by paint().
 // If reach fails, the hand settles back instead of inventing a distant hit.
 gb3PaintGesture.active=dragging&&state.tool==='spray';
 gb3PaintGesture.ready=gb3PaintGesture.active;
 if(gb3PaintGesture.active&&hit.world?.every(Number.isFinite)){
  gb3PaintGesture.world=hit.world.slice(0,3);
  gb3PaintGesture.tool=state.tool;
 }
 gb3SetSprayPainting(!!hit&&state.tool==='spray'&&dragging);
 if(!hit){gb3PaintGesture.world=null;lastHit=null;return;}
 if(!gb3StrokeStarted)beginStroke(hit);
 const now=performance.now(),elapsed=clamp((now-lastDragSampleAt)/1000,.016,.20);
 lastDragSampleAt=now;lastPaintMotionAt=now;
 if(!lastHit||lastHit.p!==hit.p){paint(hit,{speed:0,angle:0});lastHit=hit;return}
 const dx=(hit.u-lastHit.u)*hit.p.canvas.width,dy=(hit.v-lastHit.v)*hit.p.canvas.height;
 const dist=Math.hypot(dx,dy),instantSpeed=dist/elapsed,angle=Math.atan2(dy,dx);
 // Low-pass speed: small event jitter cannot trigger instant full-flare strokes.
 // A sustained fast movement still responds promptly (0.11 second time constant).
 const mix=1-Math.exp(-elapsed/.11);
 gb3SmoothedStrokeSpeed+=mix*(instantSpeed-gb3SmoothedStrokeSpeed);
 const speed=gb3SmoothedStrokeSpeed;
 const step=Math.max(2,state.size/100/hit.p.len*hit.p.canvas.width*.30);
 // Particle flux is time-based, not fixed per dragged pixel. Fast flicks thin out.
 const timeBudget=Math.max(1,Math.ceil(elapsed*(isTouchDevice?100:125)));
 const count=state.tool==='spray'?clamp(Math.min(Math.ceil(dist/step),timeBudget),1,56):clamp(Math.ceil(dist/step),1,70);
 for(let i=1;i<=count;i++){
   const a=i/count;
   paint({...hit,u:lastHit.u+(hit.u-lastHit.u)*a,v:lastHit.v+(hit.v-lastHit.v)*a},{speed,angle});
 }
 lastHit=hit;
}
function pointerCoord(e){let r=view.getBoundingClientRect();return [e.clientX-r.left,e.clientY-r.top]}
// Touch controls: one finger follows an explicit LOOK/PAINT mode;
// two fingers always pinch to zoom and never leave stray paint strokes.
view.addEventListener('pointerdown',e=>{
  if(e.pointerType==='touch'){
    e.preventDefault();const [x,y]=pointerCoord(e);activeTouches.set(e.pointerId,{x,y});view.setPointerCapture(e.pointerId);
    if(activeTouches.size>=2){stopStroke();ignoreUntilTouchRelease=true;pinchDistance=touchGap();pinchStartFov=fov;displayZoom();return}
    if(ignoreUntilTouchRelease)return;
    lastX=x;lastY=y;
    if(!gb3DualOn&&mobileTouchMode==='look'){turning=true;return}
    const h=hitTest(x,y);dragging=true;lastHit=null;gb3PaintGesture.active=state.tool==='spray';gb3PaintGesture.ready=gb3PaintGesture.active;gb3PaintGesture.world=null;
    if(!h){toast('Ready to spray · move closer to train');return}
    beginStroke(h);dragStroke(h);return;
  }
  if(e.button!==0&&e.button!==2)return;
  const [x,y]=pointerCoord(e);lastX=x;lastY=y;activeMousePointer=e.pointerId;view.setPointerCapture(e.pointerId);
  if(e.button===2||state.tool==='look'||e.altKey){turning=true;return}
  const h=hitTest(x,y);dragging=true;lastHit=null;gb3PaintGesture.active=state.tool==='spray';gb3PaintGesture.ready=gb3PaintGesture.active;gb3PaintGesture.world=null;
  if(!h){toast('Ready to spray · move closer to train');return}
  beginStroke(h);dragStroke(h);
});
view.addEventListener('pointermove',e=>{
  const [x,y]=pointerCoord(e);
  if(e.pointerType==='touch'){
    if(!activeTouches.has(e.pointerId))return;
    activeTouches.set(e.pointerId,{x,y});
    if(activeTouches.size>=2){const gap=touchGap();if(pinchDistance>0&&gap>0){fov=clamp(pinchStartFov*pinchDistance/gap,Math.PI/5.5,Math.PI/2.5);displayZoom()}return}
    if(ignoreUntilTouchRelease)return;
    if(turning){cam.yaw+=(x-lastX)*.003;cam.pitch=clamp(cam.pitch-(y-lastY)*.003,-1.15,1.15)}
    else if(dragging)dragStroke(hitTest(x,y));
    lastX=x;lastY=y;return;
  }
  if(activeMousePointer!==null&&e.pointerId!==activeMousePointer)return;
  if(turning){cam.yaw+=(x-lastX)*.003;cam.pitch=clamp(cam.pitch-(y-lastY)*.003,-1.15,1.15)}
  else if(dragging)dragStroke(hitTest(x,y));
  lastX=x;lastY=y;let h=hitTest(x,y);view.style.cursor=turning?'grabbing':state.tool==='look'?'grab':h?'crosshair':'default';
});
function endPointer(e){
  if(e.pointerType==='touch'){
    activeTouches.delete(e.pointerId);
    if(activeTouches.size===0){ignoreUntilTouchRelease=false;pinchDistance=0;stopStroke()}
    else if(activeTouches.size===1){ignoreUntilTouchRelease=true;stopStroke()}
    return;
  }
  if(activeMousePointer!==null&&e.pointerId!==activeMousePointer)return;
  activeMousePointer=null;stopStroke();
}
view.addEventListener('pointerup',endPointer);view.addEventListener('pointercancel',endPointer);
view.addEventListener('lostpointercapture',e=>{if(e.pointerType==='touch'){activeTouches.delete(e.pointerId);if(activeTouches.size===0){ignoreUntilTouchRelease=false;pinchDistance=0;stopStroke()}}});
view.addEventListener('contextmenu',e=>e.preventDefault());
view.addEventListener('wheel',e=>{speed=clamp(speed+(e.deltaY>0?-.7:.7),2,15);toast('Move speed: '+speed.toFixed(1))},{passive:true});
function doUndo(){if(gb3BetaMode){toast('Shared-room undo is unavailable');return}let u=undo.pop();if(!u){toast('No more strokes to undo');return}for(let i=activeDrips.length-1;i>=0;i--)if(activeDrips[i].actionId===u.id)activeDrips.splice(i,1);for(let i=wetPools.length-1;i>=0;i--)if(wetPools[i].actionId===u.id)wetPools.splice(i,1);u.p.ctx.putImageData(u.snap,0,0);dirty.add(u.p);$('undoCount').textContent=undo.length+' / 7';strokes=Math.max(0,strokes-1);$('paintedCount').textContent=strokes+' strokes';saveLater()}
/* Undo control removed from shared multiplayer UI. */$('clear').onclick=()=>{if(gb3BetaMode){toast('Shared artwork can only be cleared by room moderation');return}if(!confirm('Erase all paint from every train side? This cannot be undone.'))return;wetPools.length=0;activeDrips.length=0;panels.forEach(p=>{p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);dirty.add(p)});undo=[];strokes=0;$('paintedCount').textContent='0 strokes';$('undoCount').textContent='0 / 7';saveLater();toast('All paint cleared')};
$('resetCamera').onclick=()=>{cam={x:1.7,y:gb3SprayConfig.cameraHeight,z:16.5,yaw:0,pitch:-.025};toast('Camera reset')};
// True element fullscreen where supported. Some mobile browsers do not support
// requestFullscreen() for arbitrary divs, so use a portal-to-body fallback.
// Both modes keep the joystick/UI attached to the actual game viewport.
let immersivePlaceholder=null, immersive=false;
function viewportChanged(){
  resetJoystick();
  requestAnimationFrame(()=>{resize();updateVisibleGameArea()});
}
function enterImmersive(){
  if(immersive)return;
  immersivePlaceholder=document.createComment('GBattle 3D restore position');
  root.parentNode.insertBefore(immersivePlaceholder,root);
  document.body.appendChild(root);
  root.classList.add('gb3-immersive');
  document.documentElement.classList.add('gb3-immersive-open');
  immersive=true;viewportChanged();
}
function leaveImmersive(){
  if(!immersive)return;
  root.classList.remove('gb3-immersive');
  document.documentElement.classList.remove('gb3-immersive-open');
  if(immersivePlaceholder&&immersivePlaceholder.parentNode){
    immersivePlaceholder.parentNode.replaceChild(root,immersivePlaceholder);
  }
  immersivePlaceholder=null;immersive=false;viewportChanged();
}
$('fullscreen').onclick=async()=>{
  // Preserve the original desktop fullscreen path. Only phones use the
  // immersive portal fallback required for mobile browser compatibility.
  if(!isTouchDevice){
    try{
      if(document.fullscreenElement===root)await document.exitFullscreen();
      else await root.requestFullscreen?.();
    }catch(err){console.warn('Desktop fullscreen unavailable',err)}
    return;
  }
  if(document.fullscreenElement===root){await document.exitFullscreen();return}
  if(immersive){leaveImmersive();return}
  try{
    if(typeof root.requestFullscreen!=='function')throw Error('Element fullscreen unsupported');
    await root.requestFullscreen({navigationUI:'hide'});
  }catch(err){enterImmersive()}
};
document.addEventListener('fullscreenchange',()=>{
  if(isTouchDevice){
    root.classList.toggle('gb3-native-fullscreen',document.fullscreenElement===root);
    viewportChanged();
  }else{
    root.classList.remove('gb3-native-fullscreen');
    requestAnimationFrame(resize);
  }
});
// When the Shopify header/browser bars occupy part of the phone screen,
// anchor the controls to the visible part of the game, not a clipped bottom.
let visibleAreaQueued=false;
function updateVisibleGameArea(){
  if(!isTouchDevice)return;
  const rect=root.getBoundingClientRect();
  const vv=window.visualViewport;
  const top=vv?vv.offsetTop:0;
  const bottom=top+(vv?vv.height:window.innerHeight);
  const cutoff=Math.max(0,Math.ceil(rect.bottom-bottom));
  const visible=Math.max(0,Math.min(rect.bottom,bottom)-Math.max(rect.top,top));
  root.style.setProperty('--gb3-visible-bottom-offset',cutoff+'px');
  root.classList.toggle('gb3-short-visible',visible>0&&visible<390);
}
function scheduleVisibleGameArea(){
  if(visibleAreaQueued)return;
  visibleAreaQueued=true;
  requestAnimationFrame(()=>{visibleAreaQueued=false;updateVisibleGameArea()});
}
if(isTouchDevice){
  window.addEventListener('scroll',scheduleVisibleGameArea,{passive:true});
  window.addEventListener('resize',scheduleVisibleGameArea,{passive:true});
  window.addEventListener('orientationchange',()=>setTimeout(viewportChanged,160),{passive:true});
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',scheduleVisibleGameArea,{passive:true});
    window.visualViewport.addEventListener('scroll',scheduleVisibleGameArea,{passive:true});
  }
  const observer=new ResizeObserver(scheduleVisibleGameArea);
  observer.observe(root);
  updateVisibleGameArea();
}

$('photo').onclick=()=>{let a=document.createElement('a');a.href=view.toDataURL('image/png');a.download='gbattle-3d-yard-'+Date.now()+'.png';a.click();toast('Screenshot downloaded')};
const addEvents=(sel,fn)=>root.querySelectorAll(sel).forEach(n=>n.onclick=fn);
$('help').onclick=()=>{$('helpModal').hidden=false};$('settings').onclick=()=>{$('settingsModal').hidden=false};root.querySelectorAll('[data-close]').forEach(n=>n.onclick=()=>n.closest('.modal').hidden=true);
// Display preference stays local to this browser; no extra server traffic.
const gb3NameTagStorageKey='gbattle-mp3d-player-names-v1';
let gb3ShowPlayerNames=true;
try{gb3ShowPlayerNames=localStorage.getItem(gb3NameTagStorageKey)!=='off';}catch(_){}
root.dataset.gb3PlayerNames=gb3ShowPlayerNames?'on':'off';
const gb3NameTagSetting=$('playerNames');
if(gb3NameTagSetting){
 gb3NameTagSetting.checked=gb3ShowPlayerNames;
 gb3NameTagSetting.onchange=e=>{
  gb3ShowPlayerNames=!!e.target.checked;
  root.dataset.gb3PlayerNames=gb3ShowPlayerNames?'on':'off';
  try{localStorage.setItem(gb3NameTagStorageKey,gb3ShowPlayerNames?'on':'off');}catch(_){}
 };
}
$('quality').value='0.75';root.dataset.gb3GraphicsDefault='low';
$('quality').onchange=e=>{quality=Number(e.target.value);gb3R55DestroyProbe();resize();toast('Graphics quality updated')};
$('fog').onchange=e=>fog=e.target.checked?1:0;
const gb3R55Setting=$('reflectionMode');
if(gb3R55Setting){
 gb3R55Setting.value=gb3R55ReflectMode;
 gb3R55Setting.onchange=e=>{
  gb3R55ReflectMode=e.target.value;gb3R55Probe.disabled=false;
  if(gb3R55ReflectMode!=='dynamic')gb3R55DestroyProbe();
  root.dataset.gb3ReflectMode=gb3R55ReflectMode;
  toast('Metal reflections: '+gb3R55ReflectMode);
 };
} 
let toastTimer;function toast(msg){let n=$('toast');n.textContent=msg;n.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>n.classList.remove('show'),2600)}
// IndexedDB stores complete paint-layer images. No need to upload artwork or send private data.
let db=null;
// Pause paint input/autosave while saved layers are being restored to the new train.
let gb3PaintRestoring=false;
if(!gb3BetaMode)try{
  const req=indexedDB.open('gbattle3d-beta-unused-v1',1);
  req.onupgradeneeded=()=>req.result.createObjectStore('paint');
  req.onsuccess=()=>{db=req.result;if(c30LoadStatus.state==='ready')gb3RestoreTrainPaint(gb3PaintSaveKey,gb3ModelEpoch);gb3SecondaryRestore()};
  req.onerror=()=>toast('Browser storage unavailable; local autosave may not work');
}catch(err){
  // Private browsing / storage restrictions must not disable the game controls.
  console.warn('GBattle 3D: local storage unavailable',err);
  toast('Local autosave unavailable on this browser');
}
function snapshot(){return {version:1,strokes,created:Date.now(),layers:Object.fromEntries([...panels,...gb3TwinPanels].map(p=>[p.name,p.canvas.toDataURL('image/png')]))}}
let saveTimer;function saveLater(){if(gb3BetaMode)return;clearTimeout(saveTimer);if(gb3PaintRestoring)return;saveTimer=setTimeout(()=>{if(!db||gb3PaintRestoring)return;try{let tx=db.transaction('paint','readwrite');tx.objectStore('paint').put(snapshot(),c30LoadStatus.state==='ready'?gb3PaintSaveKey:'session');tx.oncomplete=()=>{$('saveState').textContent='SAVED ON DEVICE'};gb3SecondarySave();tx.onerror=()=>{$('saveState').textContent='SAVE FAILED'}}catch(e){$('saveState').textContent='SAVE FAILED'}},1300)}
function restoreState(record,notify=true,epoch=gb3ModelEpoch){
 if(epoch!==gb3ModelEpoch){return;}
 if(record?.version!==1||!record.layers||Object.keys(record.layers).length>120){gb3PaintRestoring=false;return;}
 wetPools.length=0;activeDrips.length=0;
 let pending=0;
 const finished=()=>{pending--;if(pending===0&&epoch===gb3ModelEpoch)gb3PaintRestoring=false;};
 for(const p of [...panels,...gb3TwinPanels]){
  const data=record.layers[p.name];
  if(!data||typeof data!=='string'||!data.startsWith('data:image/png;base64,'))continue;
  pending++;
  const im=new Image();
  im.onload=()=>{
   if(epoch===gb3ModelEpoch&&(panels.includes(p)||gb3TwinPanels.includes(p))){
    p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);
    p.ctx.drawImage(im,0,0,p.canvas.width,p.canvas.height);
    dirty.add(p);if(notify)saveLater();
   }
   finished();
  };
  im.onerror=finished;
  im.src=data;
 }
 strokes=Number(record.strokes)||0;
 $('paintedCount').textContent=strokes+' strokes';
 $('saveState').textContent='LOADED LOCAL';
 if(!pending)gb3PaintRestoring=false;
 if(notify)toast('Painting loaded');
}
function gb3RestoreTrainPaint(key,epoch){
 if(epoch!==gb3ModelEpoch)return;
 clearTimeout(saveTimer);
 if(!db){gb3PaintRestoring=false;return;}
 gb3PaintRestoring=true;
 try{
  const tx=db.transaction('paint','readonly');
  const req=tx.objectStore('paint').get(key);
  req.onsuccess=()=>{
   if(epoch!==gb3ModelEpoch||key!==gb3PaintSaveKey)return;
   if(req.result)restoreState(req.result,false,epoch);
   else gb3PaintRestoring=false;
  };
  req.onerror=()=>{if(epoch===gb3ModelEpoch)gb3PaintRestoring=false;
   console.warn('GBattle: saved painting could not be read for the selected train');};
 }catch(err){gb3PaintRestoring=false;console.warn('GBattle: local paint restore unavailable',err)}
}
// Train chooser swaps GPU models inside the running game on desktop and mobile.
// URLs only record the selected train for bookmarks and refreshes.
// C30 remains default; C6 is the only alternative. C8 has been retired.
function gb3SetupTrainChooser(){
 const topActions=root.querySelector('.top-actions');
 if(!topActions||topActions.querySelector('[data-gb3-train-open]'))return;
 const open=document.createElement('button');open.type='button';open.className='gb3-train-open';
 open.setAttribute('data-gb3-train-open','');open.setAttribute('aria-haspopup','dialog');
 open.textContent='🚆';open.title='Choose train · '+gb3TrainName;open.setAttribute('aria-label','Choose train · '+gb3TrainName);
 const helpButton=$('help');topActions.insertBefore(open,helpButton);
 const dialog=document.createElement('div');dialog.className='modal gb3-train-modal';
 dialog.setAttribute('data-gb3-train-modal','');dialog.setAttribute('role','dialog');
 dialog.setAttribute('aria-modal','true');dialog.setAttribute('aria-labelledby','gb3-train-title');
 dialog.hidden=true;
 dialog.innerHTML=`<div class="modal-panel gb3-train-panel">
  <button type="button" class="close" data-gb3-train-close aria-label="Close train chooser">×</button>
  <span class="eyebrow">THE YARD · TRAIN SELECTION</span>
  <h2 id="gb3-train-title">CHOOSE TRAIN</h2>
  <p class="muted">Choose a train to paint. Your graffiti is saved separately for each train on this device.</p>
  <div class="gb3-train-options" role="group" aria-label="Available trains">
   <p class="gb3-train-country">SWEDEN · STOCKHOLM</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="stockholm-c30"><strong>Stockholm-C30</strong><small>Modern Stockholm subway</small><span class="gb3-train-indicator"></span></button>
   <button type="button" class="gb3-train-option" data-gb3-train-target="stockholm-c6"><strong>Stockholm-C6</strong><small>Classic green Stockholm subway</small><span class="gb3-train-indicator"></span></button>
   <p class="gb3-train-country">CHILE · SANTIAGO</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="santiago-ns74"><strong>Santiago NS-74</strong><small>Santiago Metro</small><span class="gb3-train-indicator"></span></button>
   <p class="gb3-train-country">FRANCE · PARIS</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="paris-mp73"><strong>Paris MP-73</strong><small>Paris Métro</small><span class="gb3-train-indicator"></span></button>
   <p class="gb3-train-country">UNITED KINGDOM · LONDON</p>
   <button type="button" class="gb3-train-option" data-gb3-train-target="london-2009stock"><strong>London-2009 Stock</strong><small>London Underground</small><span class="gb3-train-indicator"></span></button>
  </div>
  <p class="muted">Trains change inside the yard. Your camera and controls stay in place.</p>
  <div class="gb3-train-status" role="status" aria-live="polite"></div>
  <button class="wide" type="button" data-gb3-train-close>BACK TO YARD</button>
 </div>`;
 root.appendChild(dialog);
 const status=dialog.querySelector('.gb3-train-status');
 let busy=false;
 const close=()=>{if(busy)return;dialog.hidden=true;open.setAttribute('aria-expanded','false');open.focus({preventScroll:true})};
 const show=()=>{root.querySelectorAll('.modal').forEach(m=>m.hidden=true);
  dialog.hidden=false;open.setAttribute('aria-expanded','true');
  dialog.querySelector('[data-gb3-train-target]:not([disabled])')?.focus({preventScroll:true});};
 open.setAttribute('aria-expanded','false');open.addEventListener('click',()=>dialog.hidden?show():close());
 dialog.querySelectorAll('[data-gb3-train-close]').forEach(b=>b.addEventListener('click',close));
 dialog.addEventListener('click',e=>{if(e.target===dialog)close()});
 dialog.addEventListener('keydown',e=>{if(e.key==='Escape'){e.stopPropagation();close()}});
 dialog.querySelectorAll('[data-gb3-train-target]').forEach(b=>{
  const target=b.getAttribute('data-gb3-train-target');
  const isSelected=()=>target===gb3KeyToPublic[gb3TrainSelection];
  const refresh=()=>{const selected=isSelected();b.setAttribute('aria-current',String(selected));
   b.disabled=selected;b.querySelector('.gb3-train-indicator').textContent=selected?'✓ CURRENT TRAIN':'SELECT TRAIN →';};
  refresh();
  b.addEventListener('click',async()=>{
   if(busy||isSelected())return;
   if(gb3BetaMode){
     if(!gb3BetaJoinedRoom){status.textContent='Join a multiplayer room first.';return;}
     status.textContent='This server keeps the current shared train. Train changes are disabled to protect existing room artwork.';
     return;
   }
   if(gb3PaintRestoring){status.textContent='Finishing saved painting. Please try again in a moment.';return;}
   busy=true;status.textContent='Saving your painting…';
   stopStroke();gb3SecondarySave();clearTimeout(saveTimer);
   const previousKey=gb3PaintSaveKey;
   try{
    if(c30LoadStatus.state==='ready'){
     if(!db){
      if(strokes>0&&!confirm('Local saving is unavailable. Changing train may lose your painting. Continue?')){
       status.textContent='Train change cancelled';return;
      }
     }else{
      try{
       await new Promise((resolve,reject)=>{
        const tx=db.transaction('paint','readwrite');
        tx.objectStore('paint').put(snapshot(),previousKey);
        tx.oncomplete=resolve;
        tx.onerror=()=>reject(tx.error||Error('Save failed'));
        tx.onabort=()=>reject(tx.error||Error('Save cancelled'));
       });
      }catch(err){
       console.warn('GBattle: could not save paint before train change',err);
       if(!confirm('Painting could not be saved. Switch train anyway?')){
        status.textContent='Train change cancelled';return;
       }
      }
     }
    }
    const next=gb3TrainRegistry[target].key;
    status.textContent='Preparing '+gb3TrainRegistry[target].name+'… your yard remains open.';
    const ok=await gb3LoadTrain(next,true);
    if(ok){
     // URL reflects the active train without a navigation, page reload or history entry.
     try{const url=new URL(window.location.href);url.searchParams.set('gb3train',target);
      url.searchParams.delete('gb3c8model');window.history.replaceState(window.history.state,'',url.toString());}
     catch(err){console.warn('GBattle: could not update train link',err)}
     status.textContent='Ready to paint '+gb3TrainName;
     for(const other of dialog.querySelectorAll('[data-gb3-train-target]')){
      const current=other.getAttribute('data-gb3-train-target')===gb3KeyToPublic[gb3TrainSelection];
      other.setAttribute('aria-current',String(current));other.disabled=current;
      other.querySelector('.gb3-train-indicator').textContent=current?'✓ CURRENT TRAIN':'SELECT TRAIN →';
     }
     dialog.hidden=true;open.setAttribute('aria-expanded','false');
     open.title='Choose train · '+gb3TrainName;
     open.setAttribute('aria-label','Choose train · '+gb3TrainName);
     open.focus({preventScroll:true});
    }else status.textContent='Could not load train. Your previous train is still available.';
   }finally{busy=false;}
  });
 });
}
// Multiplayer train is selected by the room authority. No train chooser is exposed.
const gb3WorldChooserStyle=document.createElement('style');
gb3WorldChooserStyle.textContent=`.gb3-game .gb3-train-options{max-height:min(45vh,380px);overflow-y:auto;overscroll-behavior:contain;padding:2px 4px 8px 0;scrollbar-width:thin}.gb3-game .gb3-train-options .gb3-train-country{font-size:11px;font-weight:900;letter-spacing:.16em;color:#ffc90e;border-bottom:1px solid rgba(255,201,14,.28);margin:13px 0 7px;padding-bottom:5px}.gb3-game .gb3-train-option{margin-bottom:7px}`;
root.appendChild(gb3WorldChooserStyle);
// Compact icon-only upper controls; titles and aria-labels remain descriptive.
// No asset filename changes or dependency on external icon fonts.
for(const [name,glyph,label] of [['help','?','Help and controls'],['fullscreen','⛶','Toggle fullscreen'],['settings','⚙','Display settings']]){
 const b=$(name);if(!b)continue;b.textContent=glyph;b.setAttribute('aria-label',label);b.title=label;
 b.setAttribute('aria-pressed','false');
}
// Reflect actual modal/fullscreen state, including Escape and outside close.
function gb3RefreshTopActions(){
 const on={'help':!$('helpModal')?.hidden,'settings':!$('settingsModal')?.hidden,
   'fullscreen':document.fullscreenElement===root||!!immersive};
 for(const [key,v] of Object.entries(on)){const b=$(key);if(b)b.setAttribute('aria-pressed',String(!!v));}
}
root.addEventListener('click',()=>queueMicrotask(gb3RefreshTopActions));
document.addEventListener('fullscreenchange',gb3RefreshTopActions);
gb3RefreshTopActions();
// Two-stick mobile gameplay. Default is DUAL ON on new devices.
// TILT requests Android landscape fullscreen; it does not control the camera.
let gb3TiltOn=false,gb3RightTouchId=null,gb3TiltOwnsFullscreen=false,gb3TiltOwnsImmersive=false;
const gb3ReadDualSetting=()=>{try{const v=localStorage.getItem('gb3-dual-v250');return v===null?true:v!=='0';}catch(_){return true;}};
const gb3WriteDualSetting=v=>{try{localStorage.setItem('gb3-dual-v250',v?'1':'0');}catch(_){}};
if(isTouchDevice){
 const trainButton=root.querySelector('[data-gb3-train-open]');
 const makeToggle=(label,description)=>{
  const b=document.createElement('button');b.type='button';b.className='gb3-feature-toggle';b.textContent=label;
  b.title=description;b.setAttribute('aria-pressed','false');
  const target=trainButton?.parentElement||root.querySelector('.top-actions');if(target)target.appendChild(b);return b;
 };
 const tiltButton=makeToggle('↔','Landscape fullscreen (Android orientation)');
 tiltButton.innerHTML='<svg aria-hidden="true" viewBox="0 0 32 32" width="23" height="23" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><rect x="10" y="10" width="12" height="12" rx="1.2" transform="rotate(-43 16 16)"/><path d="M22 4h6v6M28 4c-3-2-7-3-10-2M10 28H4v-6M4 28c3 2 7 3 10 2"/></svg>';
 const dualButton=makeToggle('🕹️','Toggle dual joystick: move and look');
 dualButton.setAttribute('aria-label','Toggle dual joystick');tiltButton.setAttribute('aria-label','Toggle landscape fullscreen');
 const rightPad=document.createElement('div');rightPad.className='gb3-rightpad';
 rightPad.setAttribute('role','group');rightPad.setAttribute('aria-label','Look joystick');
 rightPad.innerHTML='<div class="gb3-rightknob" aria-hidden="true">✥</div>';
 root.querySelector('.gb3-mobile-ui').appendChild(rightPad);
 const rightKnob=rightPad.querySelector('.gb3-rightknob');
 let gb3RightLook={x:0,y:0};
 function resetRight(){gb3RightTouchId=null;rightKnob.style.transform='translate(0,0)';rightPad.classList.remove('is-active');gb3RightLook={x:0,y:0}}
 function lookInput(e){
  const r=rightPad.getBoundingClientRect(),radius=Math.max(1,(r.width-rightKnob.offsetWidth)/2);
  let dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2);
  const distance=Math.hypot(dx,dy),scale=Math.max(1,distance/radius);dx/=scale;dy/=scale;
  rightKnob.style.transform=`translate(${dx}px,${dy}px)`;
  gb3RightLook={x:dx/radius,y:dy/radius};
 }
 rightPad.addEventListener('pointerdown',e=>{if(!gb3DualOn||gb3RightTouchId!==null)return;e.preventDefault();gb3RightTouchId=e.pointerId;rightPad.setPointerCapture(e.pointerId);rightPad.classList.add('is-active');lookInput(e)});
 rightPad.addEventListener('pointermove',e=>{if(e.pointerId!==gb3RightTouchId)return;e.preventDefault();lookInput(e)});
 for(const ev of ['pointerup','pointercancel','lostpointercapture'])rightPad.addEventListener(ev,e=>{if(e.pointerId===gb3RightTouchId)resetRight()});
 function setDual(v){
  gb3DualOn=!!v;dualButton.textContent='🕹️';dualButton.title=gb3DualOn?'Dual joystick ON':'Dual joystick OFF';
  dualButton.setAttribute('aria-pressed',String(gb3DualOn));root.classList.toggle('gb3-dual-on',gb3DualOn);
  resetRight();gb3WriteDualSetting(gb3DualOn);
  if(gb3DualOn){if(state.tool==='look')selectTool('spray');mobileTouchMode='paint';}
  else{mobileTouchMode='look';stopStroke();}
  renderTouchModes();
  $('hint').textContent=gb3DualOn?'DUAL: MOVE + LOOK JOYSTICKS · TOUCH TRAIN TO PAINT':'SELECT LOOK OR PAINT TO USE TOUCH';
 }
 dualButton.addEventListener('click',()=>setDual(!gb3DualOn));setDual(gb3ReadDualSetting());
 async function setTilt(v){
  if(!v){
   gb3TiltOn=false;tiltButton.innerHTML='<svg aria-hidden="true" viewBox="0 0 32 32" width="23" height="23" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><rect x="10" y="10" width="12" height="12" rx="1.2" transform="rotate(-43 16 16)"/><path d="M22 4h6v6M28 4c-3-2-7-3-10-2M10 28H4v-6M4 28c3 2 7 3 10 2"/></svg>';tiltButton.title='Landscape fullscreen OFF';tiltButton.setAttribute('aria-pressed','false');
   root.classList.remove('gb3-tilt-on');
   try{screen.orientation?.unlock?.()}catch(_){}
   if(gb3TiltOwnsFullscreen&&document.fullscreenElement===root){try{await document.exitFullscreen()}catch(_){}}
   if(gb3TiltOwnsImmersive&&immersive)leaveImmersive();
   gb3TiltOwnsFullscreen=false;gb3TiltOwnsImmersive=false;
   viewportChanged();return;
  }
  try{
   if(document.fullscreenElement!==root&&!immersive){
    if(typeof root.requestFullscreen==='function'){
     try{await root.requestFullscreen({navigationUI:'hide'});gb3TiltOwnsFullscreen=true;}
     catch(_){enterImmersive();gb3TiltOwnsImmersive=true;}
    }else{enterImmersive();gb3TiltOwnsImmersive=true;}
   }
   let locked=false;
   try{if(screen.orientation?.lock){await screen.orientation.lock('landscape');locked=true;}}catch(err){console.info('Landscape orientation lock unavailable:',err)}
   gb3TiltOn=true;root.classList.add('gb3-tilt-on');
   tiltButton.innerHTML='<svg aria-hidden="true" viewBox="0 0 32 32" width="23" height="23" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><rect x="10" y="10" width="12" height="12" rx="1.2" transform="rotate(-43 16 16)"/><path d="M22 4h6v6M28 4c-3-2-7-3-10-2M10 28H4v-6M4 28c3 2 7 3 10 2"/></svg>';tiltButton.title='Landscape fullscreen ON';tiltButton.setAttribute('aria-pressed','true');
   if(!locked)toast('Fullscreen enabled · rotate phone sideways / enable Auto-rotate');
   else toast('Landscape fullscreen enabled');
   viewportChanged();
  }catch(err){console.warn('Landscape fullscreen unavailable',err);toast('Fullscreen unavailable on this browser')}
 }
 tiltButton.addEventListener('click',()=>{void setTilt(!gb3TiltOn)});
 document.addEventListener('fullscreenchange',()=>{
  if(gb3TiltOn&&gb3TiltOwnsFullscreen&&document.fullscreenElement!==root){
   gb3TiltOn=false;gb3TiltOwnsFullscreen=false;tiltButton.innerHTML='<svg aria-hidden="true" viewBox="0 0 32 32" width="23" height="23" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><rect x="10" y="10" width="12" height="12" rx="1.2" transform="rotate(-43 16 16)"/><path d="M22 4h6v6M28 4c-3-2-7-3-10-2M10 28H4v-6M4 28c3 2 7 3 10 2"/></svg>';tiltButton.title='Landscape fullscreen OFF';
   tiltButton.setAttribute('aria-pressed','false');root.classList.remove('gb3-tilt-on');
   try{screen.orientation?.unlock?.()}catch(_){}
  }
 });
 root.gb3StepOptionalLook=dt=>{
  if(gb3DualOn){cam.yaw+=gb3RightLook.x*dt*1.9;cam.pitch=clamp(cam.pitch-gb3RightLook.y*dt*1.3,-1.15,1.15);}
 };
}
$('online').textContent='THE YARD';$('online').style.color='#e4c56e';
// Highly visible joystick; relative thumb position gives normalized movement.
let touchVec={x:0,y:0},touchId=null;const pad=$('touchpad'),knob=$('touchKnob');
function resetJoystick(){touchId=null;touchVec={x:0,y:0};knob.style.transform='translate(0,0)';pad.classList.remove('is-active')}
pad.addEventListener('pointerdown',e=>{if(touchId!==null)return;e.preventDefault();touchId=e.pointerId;pad.setPointerCapture(touchId);pad.classList.add('is-active');touchUpdate(e)});
pad.addEventListener('pointermove',e=>{if(e.pointerId===touchId){e.preventDefault();touchUpdate(e)}});
pad.addEventListener('pointerup',e=>{if(e.pointerId===touchId)resetJoystick()});
pad.addEventListener('pointercancel',e=>{if(e.pointerId===touchId)resetJoystick()});
pad.addEventListener('lostpointercapture',e=>{if(e.pointerId===touchId)resetJoystick()});
function touchUpdate(e){let r=pad.getBoundingClientRect(),radius=(r.width-knob.offsetWidth)/2,dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2),scale=Math.max(1,Math.hypot(dx,dy)/radius);dx/=scale;dy/=scale;touchVec={x:dx/radius,y:-dy/radius};knob.style.transform=`translate(${dx}px,${dy}px)`}
function firstVisit(key){
  try{
    if(sessionStorage.getItem(key))return false;
    sessionStorage.setItem(key,'yes');return true;
  }catch(err){return true}
}
if(!gb3BetaMode&&isTouchDevice){
  if(firstVisit('gbattle3d-mobile-controls-v3'))$('helpModal').hidden=false;
}else if(!gb3BetaMode&&firstVisit('gbattle3d-help-seen'))$('helpModal').hidden=false;

// GB3D_BETA_V711 connection. Shares existing WSS API; no 2D wall or single-player saves.
const gb3BetaRooms=[1,2,3,4].map(i=>'train:gb3d-beta:room-'+i);
let gb3BetaDrawingReady=false,gb3BetaModelLoaded=false,gb3BetaSocket=null,gb3BetaJoinedRoom='',gb3BetaAwaitingRoom='',gb3BetaPendingState=null;
// R16: Generate one lobby identity before the existing websocket hello is sent.
// Five numeric digits, no roster, no server protocol changes.
function gb3GenerateGuestName(){
 let number;
 if(globalThis.crypto?.getRandomValues){
  const u=new Uint32Array(1);globalThis.crypto.getRandomValues(u);
  number=10000+(u[0]%90000);
 }else number=10000+Math.floor(Math.random()*90000);
 return 'Guest'+number;
}
// R62: Names belong to players, not their shared IP address.
const gb3SessionGuest=gb3GenerateGuestName();
const gb3GuestField=root.querySelector('[data-gb3-beta-name]');
const gb3NameStorageKey='gb3-multiplayer-chosen-name-v1';
function gb3NormalizeChosenName(raw){return String(raw||'').replace(/[^a-zA-Z0-9 _-]/g,'').replace(/\s+/g,' ').trim().slice(0,20).trim();}
let gb3SavedName='';
try{gb3SavedName=gb3NormalizeChosenName(localStorage.getItem(gb3NameStorageKey));}catch(_){}
if(gb3SavedName.toUpperCase()==='ADMIN')gb3SavedName='';
if(gb3GuestField){
 gb3GuestField.value=gb3SavedName; gb3GuestField.readOnly=false;
 gb3GuestField.setAttribute('autocomplete','nickname');
 gb3GuestField.placeholder='Your graffiti name (blank = '+gb3SessionGuest+')';
 gb3GuestField.setAttribute('aria-label','Choose your multiplayer username');
}
function gb3ChosenPlayerName(){
 const requested=gb3NormalizeChosenName(gb3GuestField?.value);
 if(requested.toUpperCase()==='ADMIN')return '';
 try{if(requested)localStorage.setItem(gb3NameStorageKey,requested);else localStorage.removeItem(gb3NameStorageKey);}catch(_){}
 const chosen=requested||gb3SessionGuest;
 if(gb3GuestField)gb3GuestField.value=chosen; // Gallery credits use the same visible room name.
 return chosen;
}
let gb3BetaNick=gb3SavedName||gb3SessionGuest,gb3BetaClientID='gb3db-'+Math.random().toString(36).slice(2)+Date.now().toString(36);
let gb3BetaQueue=[],gb3BetaSeq=0,gb3BetaReconnect=null,gb3BetaSocketOpen=false,gb3BetaRetry=0;
let gb3ChatSocket=null,gb3ChatReady=false,gb3ChatTransportSupported=false;
let gb3ChatReconnect=null,gb3ChatRetry=0,gb3ChatProbeConfirmed=false;
let gb3ChatLinkToken='';
// ADMIN password is transient in memory only and is passed to the verified Go
// admin_auth command. No password is saved to Shopify, localStorage or URLs.
let gb3AdminPasswordPending='',gb3AdminAwaitingAuth=false,gb3AdminAuthenticated=false;
let gb3AdminFlyEnabled=false,gb3AdminGodEnabled=false;
let gb3StaffRole='user';
const gb3HasStaffAccess=()=>gb3AdminAuthenticated||gb3StaffRole==='moderator';
const gb3StaffTokenKey=()=> 'gbattle-mp3d-staff-token:'+gb3BetaClientID;
function gb3ReadStaffToken(){try{const token=localStorage.getItem(gb3StaffTokenKey())||'';return /^[0-9a-f]{64}$/.test(token)?token:'';}catch(_){return '';}}

let gb3AdminTouchAscend=false,gb3AdminTouchDescend=false;
let gb3AdminAuthMode='',gb3AdminRequestedRoom=0;

// R62: no global chat connection is opened until JOIN; room presence alone is the in-room roster.
const gb3BetaPendingSaves=new Map();
let gb3BetaChunkPending=null;
let gb3BetaTargetModel='';
root.querySelectorAll('[data-gb3-beta-count]').forEach(el=>el.textContent='JOIN ROOM');
const gb3BetaUI=root.querySelector('[data-gb3-beta-overlay]');
const gb3BetaChat=root.querySelector('[data-gb3-beta-chat]');
const gb3GlobalInput=root.querySelector('[data-gb3-beta-message]');
if(gb3GlobalInput){gb3GlobalInput.placeholder='Global chat…';gb3GlobalInput.setAttribute('aria-label','Write to global GBattle chat');}
const gb3BetaNotice=root.querySelector('[data-gb3-beta-notice]');
const gb3BetaRoomStatus=root.querySelector('[data-gb3-beta-room-status]');
const gb3BetaPeople=root.querySelector('[data-gb3-beta-users]');
const gb3BetaMessages=root.querySelector('[data-gb3-beta-messages]');
const gb3ChatLinkStatus=root.querySelector('[data-gb3-chat-link-status]');
function gb3ChatStatus(message){if(gb3ChatLinkStatus)gb3ChatLinkStatus.textContent=message;}
// Global V7.11 chat (the unchanged production server has no room-only chat).
const gb3BetaChatButton=document.createElement('button');
gb3BetaChatButton.type='button';gb3BetaChatButton.className='gb3-chat-tool';
gb3BetaChatButton.setAttribute('aria-label','Open global GBattle chat');
gb3BetaChatButton.setAttribute('aria-expanded','false');
gb3BetaChatButton.title='Global GBattle chat';
gb3BetaChatButton.innerHTML='<span class="gb3-chat-symbol" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M20 11.5a7 7 0 0 1-7 7H7l-4 3v-6a7 7 0 1 1 17-4Z"/><path d="M7.5 11h9M7.5 14h6"/></svg></span><span class="gb3-chat-unread" hidden>0</span><small>CHAT</small>';
(root.querySelector('.gb3-compact-toolbar')||root.querySelector('.top-actions')||root).appendChild(gb3BetaChatButton);
let gb3ChatVisible=false,gb3ChatUnread=0;
function gb3SetChatVisible(visible){
 gb3ChatVisible=!!visible&&!!gb3BetaJoinedRoom;
 if(gb3BetaChat)gb3BetaChat.hidden=!gb3ChatVisible;
 gb3BetaChatButton.setAttribute('aria-expanded',String(gb3ChatVisible));
 gb3BetaChatButton.classList.toggle('is-open',gb3ChatVisible);
 if(gb3ChatVisible){gb3ChatUnread=0;gb3BetaChatButton.querySelector('.gb3-chat-unread').hidden=true;gb3BetaChatButton.querySelector('.gb3-chat-unread').textContent='0';
  root.querySelector('[data-gb3-beta-message]')?.focus({preventScroll:true});}
}
gb3BetaChatButton.addEventListener('click',()=>{
 if(!gb3BetaJoinedRoom&&!gb3BetaAwaitingRoom){gb3BetaStatus('Choose a room to chat');return;}
 gb3SetChatVisible(!gb3ChatVisible);
});
root.querySelector('[data-gb3-beta-chat-close]')?.addEventListener('click',()=>gb3SetChatVisible(false));
const gb3PendingChat=[];
const gb3GlobalChatRows=new Map();
let gb3GlobalChatCounter=0;
const gb3GlobalSeenIds=new Set();
if(gb3BetaChat){gb3BetaChat.setAttribute('aria-label','Global GBattle chat (messages may be from other games and earlier sessions)');gb3BetaChat.querySelector('header > span')?.setAttribute('data-gb3-global-chat-label','');} 
// R12 beta skeletal avatars and room-scoped server position packets; GLB stays on server.
const gb3Avatars=new Map();let gb3AvatarParts=[];let gb3ThirdPerson=true;let gb3AvatarRig=null;
// Single authoritative server model path; no obsolete character URL or Shopify model fallback.
const gb3AvatarURL=(root.getAttribute('data-gb3-avatar-url')||'https://gbattle.sweink.com/3d/models/hood.glb').trim();

// R26: room selection stays on the original page; character roulette opens OVER
// the already-rendering yard, keeping the paint/train camera loading in parallel.
const gb3CharacterRoster=[
 {id:'hood',name:'Original',kind:'Original hoodie',model:gb3AvatarURL,portrait:''},
 {id:'man1_test',name:'Man 1 Test',kind:'Male base · 175 cm',model:'https://gbattle.sweink.com/3d/models/basemale1.glb',portrait:root.getAttribute('data-gb3-portrait-man1-test')||''},
 {id:'kid1_test',name:'Kid 1 Test',kind:'Kid base · 116 cm',model:'https://gbattle.sweink.com/3d/models/basekid1.glb',portrait:root.getAttribute('data-gb3-portrait-kid1-test')||''}
];
let gb3SelectedCharacter='hood',gb3RouletteOffset=0,gb3RouletteRoomReady=false,gb3RouletteModelReady=true,gb3RouletteBusy=false,gb3RouletteError='';
// Actual join-resource counter: 1 room-state header, 1 model, N WebP files,
// and 1 final sync boundary. Never claim 20 resources when a room has 500.
let gb3ResourcesStep=0;
let gb3ResourcesHeader=false,gb3ResourcesModel=false,gb3ResourcesSync=false;
let gb3ResourcesFilesDone=0,gb3ResourcesFilesTotal=0;
let gb3ResourceHideTimer=null;
let gb3GameplayActive=false;
function gb3JoinScreenVisible(){
 return !gb3GameplayActive&&(root.querySelector('[data-gb3-beta-overlay]')?.hidden===false||root.querySelector('[data-gb3-character-roulette]')?.hidden===false);
}
function gb3HideResourceProgress(){
 clearTimeout(gb3ResourceHideTimer);
 const hud=root.querySelector('[data-gb3-resource-progress]');if(hud)hud.hidden=true;
}
function gb3JoinStatus(message){if(gb3JoinScreenVisible())gb3BetaStatus(message);}

function gb3ResourceLabel(){
 const total=3+gb3ResourcesFilesTotal;
 const done=Number(gb3ResourcesHeader)+Number(gb3ResourcesModel)+
   Math.min(gb3ResourcesFilesDone,gb3ResourcesFilesTotal)+Number(gb3ResourcesSync);
 const percent=Math.max(0,Math.min(100,Math.round(done/Math.max(1,total)*100)));
 return (done===total?'Resources loaded':'Loading resources')+' '+done+'/'+total+' ('+percent+'%)';
}
function gb3ResourceUpdate(step){
 const n=Number(step)||0;
 if(n===1){gb3ResourcesHeader=false;gb3ResourcesModel=false;gb3ResourcesSync=false;gb3ResourcesFilesDone=0;gb3ResourcesFilesTotal=0;}
 else if(n===2)gb3ResourcesHeader=true;
 else if(n===3)gb3ResourcesModel=true;
 else if(n===20)gb3ResourcesSync=true;
 gb3ResourcesStep=n;
 const hud=root.querySelector('[data-gb3-resource-progress]');
 const label=gb3ResourceLabel();
 if(hud&&!gb3JoinScreenVisible()){gb3HideResourceProgress();}
 if(hud&&gb3JoinScreenVisible()){clearTimeout(gb3ResourceHideTimer);hud.hidden=false;
   const labelNode=hud.querySelector('[data-gb3-resource-label]');
   if(labelNode)labelNode.textContent=label;else hud.textContent=label;
   const bar=hud.querySelector('[data-gb3-resource-bar]');if(bar)bar.value=Math.min(100,Math.round((Number(gb3ResourcesHeader)+Number(gb3ResourcesModel)+Math.min(gb3ResourcesFilesDone,gb3ResourcesFilesTotal)+Number(gb3ResourcesSync))/Math.max(1,3+gb3ResourcesFilesTotal)*100));
   if(gb3ResourcesSync)gb3ResourceHideTimer=setTimeout(()=>{hud.hidden=true;},1600);}
 const status=root.querySelector('[data-gb3-character-status]');
 if(status&&root.querySelector('[data-gb3-character-roulette]')?.hidden===false)status.textContent=label;
}
function gb3ResourcePictures(done,total){
 gb3ResourcesFilesTotal=Math.max(0,Number(total)||0);
 gb3ResourcesFilesDone=Math.min(gb3ResourcesFilesTotal,Math.max(0,Number(done)||0));
 gb3ResourceUpdate(0);
}

const gb3Roulette=root.querySelector('[data-gb3-character-roulette]');
const gb3RouletteCards=root.querySelector('[data-gb3-character-cards]');
const gb3RouletteEnter=root.querySelector('[data-gb3-character-enter]');
const gb3RouletteStatus=root.querySelector('[data-gb3-character-status]');
function gb3RouletteCount(){return window.matchMedia('(max-width:700px)').matches?3:6;}
function gb3RouletteUpdate(){
 if(!gb3Roulette)return;
 const ready=gb3RouletteRoomReady&&gb3RouletteModelReady&&!gb3RouletteBusy;
 gb3RouletteEnter.disabled=!ready;
 const chosen=gb3CharacterRoster.find(x=>x.id===gb3SelectedCharacter);
 gb3RouletteEnter.textContent=ready?'ENTER AS '+chosen.name.toUpperCase():'PREPARING PLAYER…';
 gb3RouletteStatus.textContent=gb3RouletteError||(ready?'Ready · '+gb3BetaNick:gb3ResourceLabel());
}
function gb3RouletteRender(){
 if(!gb3RouletteCards)return;
 gb3RouletteCards.replaceChildren();
 const visible=Math.min(gb3RouletteCount(),gb3CharacterRoster.length);
 for(let n=0;n<visible;n++){
  const c=gb3CharacterRoster[(gb3RouletteOffset+n)%gb3CharacterRoster.length];
  const el=document.createElement('button');el.type='button';el.className='gb3-character-card'+(c.id===gb3SelectedCharacter?' is-selected':'');
  el.setAttribute('aria-pressed',String(c.id===gb3SelectedCharacter));
  if(c.portrait){const img=document.createElement('img');img.src=c.portrait;img.alt=c.name+' face portrait';img.loading='lazy';el.appendChild(img);}
  else{const icon=document.createElement('div');icon.textContent='G';icon.style.cssText='display:grid;place-items:center;background:#283039;color:#ffe000;font-weight:950;font-size:42px;border-radius:7px;aspect-ratio:3/4;max-height:158px';el.appendChild(icon);}
  const name=document.createElement('strong');name.textContent=c.name;el.appendChild(name);
  const kind=document.createElement('small');kind.textContent=c.kind;el.appendChild(kind);
  el.addEventListener('click',()=>gb3RouletteSelect(c.id));gb3RouletteCards.appendChild(el);
 }
 gb3RouletteUpdate();
}
async function gb3RouletteSelect(id){
 if(!gb3CharacterRoster.some(c=>c.id===id))return;
 gb3SelectedCharacter=id;gb3RouletteError='';gb3RouletteModelReady=id==='hood';gb3RouletteRender();
 const expected=id;
 if(id!=='hood'){
  try{
   // Loads ONLY the chosen R29 base GLB plus the shared MTN can grip; remote selections load on demand.
   for(let i=0;i<200&&!gb3AvatarRig&&root.isConnected&&gb3SelectedCharacter===expected;i++){
    if(root.dataset.gb3SkeletalAvatar==='fallback')throw Error('Skeletal renderer unavailable');
    await new Promise(resolve=>setTimeout(resolve,100));
   }
   if(!gb3AvatarRig)throw Error('Avatar engine not ready; use the original hoodie or refresh');
   if(gb3SelectedCharacter!==expected)return;
   await gb3AvatarRig.ensureCharacter(id);
   if(gb3SelectedCharacter===expected)gb3RouletteModelReady=true;
  }catch(err){if(gb3SelectedCharacter===expected){gb3RouletteModelReady=false;gb3RouletteError='Character could not load: '+String(err.message||err);}}
 }
 gb3RouletteUpdate();
}
function gb3RouletteShow(){gb3GameplayActive=false;gb3ResourcesStep=1;gb3ResourceUpdate(1);gb3RouletteRoomReady=false;gb3RouletteBusy=false;gb3RouletteError='';if(gb3Roulette)gb3Roulette.hidden=false;gb3RouletteRender();}
function gb3RouletteHide(){if(gb3Roulette)gb3Roulette.hidden=true;}
root.querySelector('[data-gb3-character-prev]')?.addEventListener('click',()=>{gb3RouletteOffset=(gb3RouletteOffset-1+gb3CharacterRoster.length)%gb3CharacterRoster.length;gb3RouletteRender();});
root.querySelector('[data-gb3-character-next]')?.addEventListener('click',()=>{gb3RouletteOffset=(gb3RouletteOffset+1)%gb3CharacterRoster.length;gb3RouletteRender();});
window.addEventListener('resize',()=>{if(gb3Roulette&&!gb3Roulette.hidden)gb3RouletteRender();});
gb3RouletteEnter?.addEventListener('click',()=>{
 if(!gb3RouletteRoomReady||!gb3RouletteModelReady||gb3RouletteBusy)return;
 gb3RouletteBusy=true;gb3GameplayActive=true;gb3HideResourceProgress();gb3RouletteHide();gb3AvatarLastTX=0;
 gb3BetaStatus('Playing as '+(gb3CharacterRoster.find(x=>x.id===gb3SelectedCharacter)?.name||'Original'));
});
root.querySelector('[data-gb3-character-cancel]')?.addEventListener('click',()=>{
 gb3RouletteHide();
 if(gb3BetaJoinedRoom||gb3BetaAwaitingRoom)gb3BetaSend({type:'train_leave'});
 gb3BetaJoinedRoom='';gb3BetaAwaitingRoom='';gb3BetaDrawingReady=false;
 if(gb3BetaUI)gb3BetaUI.hidden=false;
});

let gb3AvatarFailure='';
const gb3AvatarBtn=document.createElement('button');gb3AvatarBtn.type='button';gb3AvatarBtn.title='Third-person view enabled; tap to switch to first-person';
gb3AvatarBtn.className='gb3-avatar-toggle';
const gb3TopActions=root.querySelector('.top-actions');
if(gb3TopActions)gb3TopActions.insertBefore(gb3AvatarBtn,gb3SoundButton);
else root.appendChild(gb3AvatarBtn);
const gb3ModOpenButton=document.createElement('button');
gb3ModOpenButton.type='button';gb3ModOpenButton.textContent='ADMIN';gb3ModOpenButton.hidden=true;
gb3ModOpenButton.setAttribute('aria-label','Open authenticated owner moderation panel');
gb3ModOpenButton.className='gb3-admin-toolbar-button';gb3ModOpenButton.innerHTML='<span aria-hidden="true">A</span><small>ADMIN</small>';gb3ModOpenButton.title='ADMIN tools';
(root.querySelector('.gb3-compact-toolbar')||root).appendChild(gb3ModOpenButton);

function gb3AvatarButtonRefresh(){
 gb3AvatarBtn.innerHTML=gb3ThirdPerson?'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="7" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/></svg>':'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg>';
 gb3AvatarBtn.setAttribute('aria-label',gb3ThirdPerson?'Third-person view; switch to first-person':'First-person view; switch to third-person');
 gb3AvatarBtn.title=gb3ThirdPerson?'Third-person view enabled; tap for first person':'First-person view enabled; tap for third person';
 gb3AvatarBtn.setAttribute('aria-pressed',String(gb3ThirdPerson));
}
gb3AvatarBtn.onclick=()=>{gb3ThirdPerson=!gb3ThirdPerson;gb3AvatarButtonRefresh();
 if(gb3ThirdPerson&&root.dataset.gb3AvatarFallback==='failed'&&root.dataset.gb3SkeletalAvatar!=='ready')gb3BetaStatus('Character GLB could not load: '+gb3AvatarFailure);
};
gb3AvatarButtonRefresh();gb3AvatarBtn.style.cssText='';
async function gb3AvatarLoad(){
 try{
  const response=await fetch(gb3AvatarURL,{mode:'cors',credentials:'omit'});
  if(!response.ok)throw Error('server character HTTP '+response.status);
  const parts=await readGLB(await response.arrayBuffer());
  const toRGB=c=>c<=.0031308?12.92*c:1.055*Math.pow(c,1/2.4)-.055;
  gb3AvatarParts=parts.map(p=>({shape:mesh(p.vertices),pos:[0,0,0],size:[1,1,1],rot:0,color:p.color.map(toRGB),metal:p.metal||0,alpha:p.alpha||1,importTex:p.tex,gb3Avatar:true}));
  root.dataset.gb3AvatarFallback='ready';
 }catch(error){gb3AvatarFailure=String(error?.message||error);root.dataset.gb3AvatarFallback='failed';console.warn('GBattle multiplayer character cannot load',error);
  if(root.dataset.gb3SkeletalAvatar!=='ready'&&gb3ThirdPerson)gb3BetaStatus('Character GLB failed to load: '+gb3AvatarFailure);
 }
}
function gb3AvatarRemoteUpdate(msg){
 const id=String(msg.client||'');if(!id||id===gb3BetaClientID)return;
 const x=Number(msg.x),z=Number(msg.z),yaw=Number(msg.yaw),alt=Number(msg.y??0);
 if(![x,z,yaw].every(Number.isFinite)||Math.abs(x)>120||Math.abs(z)>65)return;
 const o=gb3Avatars.get(id)||{x,z,yaw,tx:x,tz:z,tyaw:yaw,moving:false};
 const stamp=performance.now();
 const ds=Math.hypot(x-(o.tx??x),z-(o.tz??z));const seconds=Math.max(.07,(stamp-(o.last||stamp))/1000);
 o.speed=ds/seconds;o.tx=x;o.tz=z;o.tyaw=yaw;o.ty=Number.isFinite(alt)?Math.max(0,Math.min(50,alt)):0;o.y??=o.ty;o.mode=String(msg.mode||'ground');o.avatarId=gb3CharacterRoster.some(c=>c.id===msg.avatar_id)?msg.avatar_id:'hood';o.moving=!!msg.moving;
 o.name=String(msg.name||o.name||'Guest').replace(/[\u0000-\u001f\u007f]/g,'').slice(0,32);
 o.running=msg.running===true;
 o.crouching=msg.crouching===true||o.mode==='crouch';
 o.verticalVelocity=Number.isFinite(msg.vy)?msg.vy:undefined;
 o.grounded=typeof msg.grounded==='boolean'?msg.grounded:undefined;
 o.painting=msg.painting===true;
 o.sprayTool=msg.spray_tool!==false;
 o.paintTarget=Array.isArray(msg.paint_target)&&msg.paint_target.length===3&&msg.paint_target.every(v=>Number.isFinite(Number(v))&&Math.abs(Number(v))<200)?msg.paint_target.map(Number):null;
 o.last=stamp;gb3Avatars.set(id,o);
}
function gb3AvatarSyncUsers(users){
 if(!Array.isArray(users))return;
 const active=new Set();for(const user of users){if(!user?.id||user.id===gb3BetaClientID)continue;
  active.add(user.id);if(Number.isFinite(Number(user.x))&&Number.isFinite(Number(user.z)))gb3AvatarRemoteUpdate({...user,client:user.id});
 }
 for(const id of gb3Avatars.keys())if(!active.has(id))gb3Avatars.delete(id);
}
function gb3AvatarDraw(now,dt){
 // Frame-time-independent interpolation prevents remote avatars from stuttering on variable-refresh mobile displays.
 const moveBlend=1-Math.exp(-Math.max(0,Math.min(dt,0.08))*14);
 const turnBlend=1-Math.exp(-Math.max(0,Math.min(dt,0.08))*10);
 if(gb3AvatarRig){
  for(const [id,a] of gb3Avatars){
   if(a.last&&now-a.last>30000){gb3Avatars.delete(id);continue;}
   a.x+=(a.tx-a.x)*moveBlend;a.z+=(a.tz-a.z)*moveBlend;a.y+=(a.ty-a.y)*moveBlend;a.yaw+=Math.atan2(Math.sin(a.tyaw-a.yaw),Math.cos(a.tyaw-a.yaw))*turnBlend;
  }
  const {eye,target}=gb3ViewFrame();
  try{
   gb3AvatarRig.draw({now,eye,target,fov,remote:gb3Avatars,joined:!!gb3BetaJoinedRoom,
    own:{name:gb3BetaNick,x:cam.x,z:cam.z,yaw:cam.yaw,moving:gb3AvatarVelocity>.12,
     y:gb3Mobility.height,crouching:gb3Mobility.crouch,mode:gb3Mobility.mode,verticalVelocity:gb3Mobility.vy,grounded:gb3Mobility.mode==='ground'||gb3Mobility.mode==='platform',
     speed:gb3AvatarVelocity,distance:gb3AvatarTravel,running:(key.has('shift')&&gb3AvatarVelocity>1)||gb3AvatarVelocity>5.65,
     painting:gb3PaintGesture.active,paintTarget:gb3PaintGesture.world,
     paintTool:gb3PaintGesture.tool,sprayTool:state.tool==='spray',avatarId:gb3SelectedCharacter,
     firstPerson:!gb3ThirdPerson||gb3CorridorAutoFirstPerson,eye,viewTarget:target}});
   return;
  }catch(err){
   console.warn('GBattle multiplayer character renderer failed: using fallback',err);
   try{gb3AvatarRig.cleanup()}catch(_){}
   gb3AvatarRig=null;root.dataset.gb3SkeletalAvatar='fallback';
   if(!gb3AvatarParts.length)void gb3AvatarLoad();
  }
 }
 if(!gb3AvatarParts.length||!gb3BetaJoinedRoom)return;
 const draw=(x,z,yaw,moving,own,elev=0)=>{
  const bob=moving?Math.sin(now*.014)*.04:0;
  const stance=moving?Math.sin(now*.007)*.035:0;
  // GLB faces +Z at bind pose. GBattle's camera forward is (sin(yaw),0,-cos(yaw)).
  // Facing angle PI - camera yaw keeps the character's BACK toward the trailing camera.
  for(const part of gb3AvatarParts)renderPart({...part,pos:[x,bob+elev,z],size:[1.32,1.32,1.32],rot:Math.PI-yaw+stance});
 };
 for(const [id,a] of gb3Avatars){
  if(a.last&&now-a.last>30000){gb3Avatars.delete(id);continue;}
  a.x+=(a.tx-a.x)*moveBlend;a.z+=(a.tz-a.z)*moveBlend;a.y+=(a.ty-a.y)*moveBlend;a.yaw+=Math.atan2(Math.sin(a.tyaw-a.yaw),Math.cos(a.tyaw-a.yaw))*turnBlend;
  draw(a.x,a.z,a.yaw,a.moving,false,a.y||0);
 }
 if(gb3ThirdPerson&&!gb3CorridorAutoFirstPerson)draw(cam.x,cam.z,cam.yaw,Math.abs(gb3MotionNow)>0.01,true,gb3Mobility.height);
}
let gb3MotionNow=0;
let gb3AvatarTravel=0,gb3AvatarVelocity=0;
let gb3AvatarLastTX=0;
// GBATTLE-R61-LIVE-1: Read-only transport counters to verify both live movement and live paint.
const gb3LiveMeters={avatarsIn:0, avatarsOut:0, paintIn:0, paintSegmentsIn:0, paintBuffered:0, paintOut:0,
  saved:0, errors:0, lastPaintAt:0, lastAvatarAt:0, lastError:''};
let gb3LastPoseSignature='';
window.GB3_LIVE_STATUS={build:'GBATTLE-R61-LIVE-1',get snapshot(){
 return {...gb3LiveMeters,room:gb3BetaJoinedRoom,connected:gb3BetaSocket?.readyState===WebSocket.OPEN,
   pendingPaint:gb3BetaPendingSaves.size, drawingReady:gb3BetaDrawingReady,others:gb3Avatars.size};
}};
if(new URLSearchParams(location.search).has('gb3live')){
 const hud=document.createElement('div');hud.setAttribute('data-gb3-live-hud','');
 hud.style.cssText='position:fixed;bottom:8px;left:8px;z-index:2147483000;background:#111d;color:#ffc90e;padding:9px 11px;max-width:92vw;border:1px solid #ffc90e;border-radius:6px;pointer-events:none;font:11px/1.5 monospace;white-space:pre-wrap';
 document.body.appendChild(hud);
 setInterval(()=>{const m=window.GB3_LIVE_STATUS.snapshot;
  hud.textContent='GBATTLE LIVE / '+(m.room||'NO ROOM')+' / '+(m.connected?'ONLINE':'OFFLINE')+'\n'+
   'Remote avatars '+m.others+' | pose RX '+m.avatarsIn+' | pose TX '+m.avatarsOut+'\n'+
   'Paint RX '+m.paintIn+' ('+m.paintSegmentsIn+' segments) | paint TX '+m.paintOut+' | saved '+m.saved+'\n'+
   'Paint pending '+m.pendingPaint+' | room ready '+m.drawingReady+(m.lastError?'\nERROR: '+m.lastError:'');
 },1000);
}

function gb3AvatarTransmit(now){
 if(!gb3BetaJoinedRoom||!gb3BetaSocket||gb3BetaSocket.readyState!==WebSocket.OPEN)return;
 // Send the first spray/stop/motion transition without waiting for the normal 110 ms heartbeat.
 // R53 allows no more than one avatar packet each 70 ms; never exceed that rate.
 const signature=(gb3PaintGesture.active?'spray':'idle')+'|'+(gb3AvatarVelocity>.12?'move':'still')+'|'+
   (gb3Mobility.crouch?'crouch':gb3Mobility.mode);
 const urgent=signature!==gb3LastPoseSignature;
 if(now-gb3AvatarLastTX<(urgent?76:110))return;
 gb3LastPoseSignature=signature;gb3AvatarLastTX=now;
 gb3LiveMeters.avatarsOut++;
 gb3BetaSend({type:'beta_avatar',room:gb3BetaJoinedRoom,
  x:Math.round(cam.x*100)/100,z:Math.round(cam.z*100)/100,y:Math.round(gb3Mobility.height*100)/100,
  vy:Math.round(gb3Mobility.vy*100)/100,grounded:gb3Mobility.mode==='ground'||gb3Mobility.mode==='platform',crouching:!!gb3Mobility.crouch,running:(key.has('shift')&&gb3AvatarVelocity>1)||gb3AvatarVelocity>5.65,
  yaw:Math.round(cam.yaw*1000)/1000,moving:gb3AvatarVelocity>.12,mode:gb3Mobility.crouch?'crouch':gb3Mobility.mode,
  avatar_id:gb3SelectedCharacter,painting:!!gb3PaintGesture.active,
  paint_target:gb3PaintGesture.active&&gb3PaintGesture.world?.length===3?gb3PaintGesture.world.map(v=>Math.round(v*100)/100):null,
  spray_tool:state.tool==='spray'});
}
// Skeletal renderer is separate from the train/spray WebGL pipeline.
// It loads only in this beta; the legacy character stays available if module loading fails.
const gb3AvatarEngineURL=root.getAttribute('data-gb3-avatar-engine-url');
// Load the visible static avatar immediately; the optional articulated renderer upgrades it if available.
const gb3AvatarFallbackPromise=gb3AvatarLoad();
if(gb3AvatarEngineURL){
 import(gb3AvatarEngineURL).then(async m=>{
  await gb3AvatarFallbackPromise;
  return m.createGB3AvatarStage({root,view,modelURL:gb3AvatarURL});
 }).then(rig=>{
  gb3AvatarRig=rig;
  root.dataset.gb3SkeletalAvatar='ready';
  gb3AvatarButtonRefresh();
  root.dataset.gb3AvatarModel='loaded';
 }).catch(e=>{
  console.warn('GBattle skeletal animation module unavailable; retaining original GLB fallback',e);
  root.dataset.gb3SkeletalAvatar='fallback';
  if(!gb3AvatarParts.length){gb3AvatarFailure=String(e?.message||e);root.dataset.gb3AvatarModel='failed';if(gb3ThirdPerson)gb3BetaStatus('Character renderer unavailable: '+gb3AvatarFailure);}
 });
}
function gb3BetaStatus(s){if(gb3BetaNotice)gb3BetaNotice.textContent=s;}
const gb3V711AllowedMessages=new Set(['hello','presence','train_join','train_leave','train_stroke','train_history_ack','train_picture_ready','train_picture_begin','train_picture_part','train_picture_finish','train_picture_sync','chat','ping','beta_avatar','admin_auth','admin_action','admin_log','moderation_roster','moderation_audit','moderation_mode','moderation_block','moderation_rooms','moderation_staff']);
function gb3BetaSend(msg){
 if(!gb3V711AllowedMessages.has(msg?.type)){console.warn('GBattle blocked unsupported V7.11 command:',msg?.type);return false;}
 if(gb3BetaSocket?.readyState===WebSocket.OPEN){gb3BetaSocket.send(JSON.stringify(msg));return true;}return false;
}
function gb3BetaRenderCounts(counts){if(!Array.isArray(counts))return;counts.slice(0,4).forEach((n,i)=>{const el=root.querySelector('[data-gb3-beta-count="'+(i+1)+'"]');if(el)el.textContent='JOIN ROOM';});}
function gb3BetaNewName(s){return String(s||'Guest').trim().slice(0,20).replace(/[^a-zA-Z0-9 _-]/g,'')||'Guest';}
const gb3PicturePainted=new Set();
// Transient live overlay only, not old journal replay. We retain recent live
// segments until the published baked revision includes them. A replaced WebP
// tile is clipped and the newer live strokes are restored above it.
const gb3LiveTail=[];
// The server-owned baker can still differ from the live spray mask. Never
// replace pixels painted during THIS visit with a lower-fidelity checkpoint.
// Keep compact UV rectangles for recently painted and erased areas; tiles still
// stream and appear everywhere else. No old journal replay is required.
const gb3LivePaintProtected=new Map();
function gb3ProtectLiveStroke(seg){
 const sid=Number(seg?.sid),p=gb3PictureFindPanel(sid);
 if(!Number.isInteger(sid)||!p?.canvas)return;
 const u=Number(seg.x0)/3600,v=Number(seg.y0)/1235,r=Number(seg.w)/3600;
 if(![u,v,r].every(Number.isFinite))return;
 const aspect=p.canvas.width/Math.max(1,p.canvas.height);
 const elong=Math.max(1,Math.min(2.7,Number(seg.el)||1));
 const isDrip=seg.t==='drip',erase=seg.m==='eraser';
 const reach=erase?1.25:isDrip?1.7:Math.max(2.9,2.2+1.5*Math.max(0,Number(seg.d)||0)+Math.max(0,Number(seg.fl)||0));
 const padU=Math.min(.5,Math.max(.0025,r*reach*elong+.003));
 const padV=Math.min(.5,Math.max(.0025,r*reach*aspect+.003));
 const dripV=isDrip?Math.max(0,Number(seg.dlen)||0):0;
 let rect=[Math.max(0,u-padU),Math.max(0,v-padV),Math.min(1,u+padU),Math.min(1,v+padV+dripV)];
 if(rect[2]<=rect[0]||rect[3]<=rect[1])return;
 const list=gb3LivePaintProtected.get(sid)||[];
 // Overlapping protection rects must be merged for the even-odd clipping mask.
 for(let changed=true;changed;){
  changed=false;
  for(let i=0;i<list.length;i++){
   const b=list[i];if(rect[0]>b[2]||rect[2]<b[0]||rect[1]>b[3]||rect[3]<b[1])continue;
   rect=[Math.min(rect[0],b[0]),Math.min(rect[1],b[1]),Math.max(rect[2],b[2]),Math.max(rect[3],b[3])];
   list.splice(i,1);changed=true;break;
  }
 }
 list.push(rect);
 if(list.length>96){
  // Bound memory and clipping work on very busy walls. Prefer preserving the
  // entire painted region over allowing a late checkpoint to overwrite ink.
  const union=list.reduce((a,b)=>[Math.min(a[0],b[0]),Math.min(a[1],b[1]),Math.max(a[2],b[2]),Math.max(a[3],b[3])]);
  list.length=0;list.push(union);
 }
 gb3LivePaintProtected.set(sid,list);
}
function gb3PictureTileGeometry(f,p,canvas){
 const cw=Number(f.canvas_width)||canvas.width,ch=Number(f.canvas_height)||canvas.height;
 const fw=Number(f.width)||cw,fh=Number(f.height)||ch;
 const x=Number(f.x||0)*canvas.width/cw,y=Number(f.y||0)*canvas.height/ch;
 return {x,y,w:fw*canvas.width/cw,h:fh*canvas.height/ch};
}
function gb3PictureTileClip(ctx,p,canvas,f,paint){
 const {x,y,w,h}=gb3PictureTileGeometry(f,p,canvas);
 const protectedAreas=gb3LivePaintProtected.get(Number(f.sid))||[];
 ctx.save();ctx.beginPath();ctx.rect(x,y,w,h);
 for(const b of protectedAreas){
  const rx=Math.max(x,b[0]*canvas.width),ry=Math.max(y,b[1]*canvas.height);
  const ex=Math.min(x+w,b[2]*canvas.width),ey=Math.min(y+h,b[3]*canvas.height);
  if(ex>rx&&ey>ry)ctx.rect(rx,ry,ex-rx,ey-ry);
 }
 // All protected rectangles are non-overlapping. Their regions remain exactly
 // as the player rendered them, including transparent Eraser cuts and metal.
 ctx.clip('evenodd');
 ctx.clearRect(x,y,w,h);
 ctx.imageSmoothingEnabled=true;
 ctx.imageSmoothingQuality='high';
 if(paint)ctx.drawImage(paint,x,y,w,h);
 ctx.restore();
}
function gb3LiveTailAdd(seg,revision=0){
 if(!seg||!Number.isInteger(Number(seg.sid)))return;
 gb3LiveTail.push({seg,revision:Number(revision)||0});
 gb3ProtectLiveStroke(seg);
 if(gb3LiveTail.length>12000)gb3LiveTail.splice(0,gb3LiveTail.length-12000);
}
function gb3LiveTailMarkSaved(segments,revision){
 if(!Array.isArray(segments))return;
 const selected=new Set(segments);
 for(const item of gb3LiveTail)if(item.revision===0&&selected.has(item.seg))item.revision=Number(revision)||0;
}
function gb3LiveTailRestoreTile(f,checkpoint){
 const sid=Number(f.sid),p=gb3PictureFindPanel(sid);
 if(!p?.ctx)return;
 // The fresh pixels already exist in the live canvas. Redrawing a stroke
 // would compound alpha/metal coverage and make its footprint grow after bake.
 // gb3PictureTileClip now protects these pixels without any stroke replay.
 return;
 const newer=gb3LiveTail.filter(x=>Number(x.seg.sid)===sid&&(x.revision===0||x.revision>checkpoint));
 if(!newer.length)return;
 const cw=Number(f.canvas_width||p.canvas.width),ch=Number(f.canvas_height||p.canvas.height);
 const sx=p.canvas.width/cw,sy=p.canvas.height/ch;
 const x=Number(f.x||0)*sx,y=Number(f.y||0)*sy;
 const w=Number(f.width||cw)*sx,h=Number(f.height||ch)*sy;
 // Reapply only the layer overwritten by this file. The other layer's
 // geometry stays intact, preventing repeated alpha accumulation.
 const active=f.layer==='metal'?p.metalCtx:p.ctx;
 if(!active)return;
 active.save();active.beginPath();active.rect(x,y,w,h);active.clip();
 // The stroke renderer also touches the other layer; clip it to an empty rect.
 const other=f.layer==='metal'?p.ctx:p.metalCtx;
 if(other){other.save();other.beginPath();other.rect(0,0,0,0);other.clip();}
 try{for(const entry of newer)gb3BetaApplySegment(entry.seg,false);}
 finally{active.restore();if(other)other.restore();}
}
function gb3LiveTailPrune(revision){
 for(let i=gb3LiveTail.length-1;i>=0;i--)if(gb3LiveTail[i].revision>0&&gb3LiveTail[i].revision<=revision)gb3LiveTail.splice(i,1);
}

let gb3PictureIncoming=null;
let gb3PictureUploading=false;
let gb3PicturePendingRetry=null;
let gb3PictureStreaming=false,gb3PictureStreamTarget=0,gb3PictureStreamRevision=0;
let gb3PictureStreamBusy=false,gb3PictureStreamRoom='';
let gb3PictureStreamCount=0;
let gb3PictureHTTPFailed=false; // fallback only if HTTPS static pictures cannot be fetched
let gb3PictureHTTPAbort=null;
function gb3PictureStreamReset(){
 gb3PictureHTTPAbort?.abort();gb3PictureHTTPAbort=null;gb3PictureHTTPFailed=false;
 gb3PictureStreaming=false;gb3PictureStreamTarget=0;gb3PictureStreamRevision=0;
 gb3PictureStreamBusy=false;gb3PictureStreamRoom='';gb3PictureStreamCount=0;
 gb3PictureIncoming=null;
}
function gb3PictureStreamTick(){
 if(!gb3PictureStreaming||gb3PictureStreamBusy||gb3PictureIncoming)return;
 // Room artwork synchronization must not wait for train GLB decoding.
 // Room 1/2 have many more baked tiles than Room 3/4: request the manifest
 // immediately and let HTTPS fetch overlap the model load.
 if(!gb3PictureStreamRoom)return;
 if(gb3BetaSocket?.readyState!==WebSocket.OPEN)return;
 gb3PictureStreamBusy=true;
 if(!gb3BetaSend({type:'train_picture_sync',room:gb3PictureStreamRoom,picture_transport:gb3PictureHTTPFailed?'websocket':'http',picture_reset:gb3PictureHTTPFailed}))gb3PictureStreamBusy=false;
}
setInterval(gb3PictureStreamTick,4000);

function gb3PictureFindPanel(sid){
 if(!Number.isInteger(sid)||sid<0)return null;
 if(sid>=50&&sid<360)return gb3CityPanels[sid-50]||null;
 if(gb3TrainSelection==='c30'){
  if(sid<50)return panels[sid]||null;
  if(sid>=360&&sid<410)return gb3TwinPanels[sid-360]||null;
  if(sid>=410&&sid<460)return panels[50+sid-410]||null;
  if(sid>=460&&sid<510)return gb3TwinPanels[50+sid-460]||null;
  return null;
 }
 const base=GB3_MODEL_SURFACE_BASES[gb3TrainSelection];
 if(!base)return null;
 if(sid>=base.main&&sid<base.main+100)return panels[sid-base.main]||null;
 if(sid>=base.twin&&sid<base.twin+100)return gb3TwinPanels[sid-base.twin]||null;
 return null;
}
function gb3PictureDataLength(b64){return Math.floor(b64.length*3/4)-(b64.endsWith('==')?2:b64.endsWith('=')?1:0);}
function gb3PictureCaptureList(){
 const files=[];
 for(const sid of [...gb3PicturePainted].sort((a,b)=>a-b)){
  const p=gb3PictureFindPanel(sid);
  if(!p?.canvas)continue;
  for(const [layer,canvas] of [['color',p.canvas],['metal',p.metalCanvas]]){
   if(!canvas)continue;
   const mime=(layer==='metal'?'image/webp':'image/webp');const quality=(layer==='metal'?1:0.88);const url=canvas.toDataURL(mime,quality);const base64=url.split(',')[1];
   if(!base64)continue;
   files.push({sid,layer,width:canvas.width,height:canvas.height,bytes:gb3PictureDataLength(base64),base64});
  }
 }
 return files;
}
const gb3PictureSleep=ms=>new Promise(resolve=>setTimeout(resolve,ms));
async function gb3PictureUpload(m){
 if(gb3PictureUploading||!gb3BetaDrawingReady||gb3BetaChunkPending||m.room!==gb3BetaJoinedRoom||gb3BetaPendingSaves.size||gb3BetaQueue.length)return;
 gb3PictureUploading=true;
 try{
  // The existing renderer is the sole pigment/material raster authority.
  // The server publishes images only when its fsynced journal revision matches.
  const files=gb3PictureCaptureList();
  const totalBytes=files.reduce((n,f)=>n+f.bytes,0);
  if(!files.length||files.length>128||totalBytes>32*1024*1024||files.some(f=>f.bytes>8*1024*1024)){gb3BetaStatus('Picture export deferred: too many painted surfaces or image size');return;}
  if(!gb3BetaSend({type:'train_picture_begin',room:m.room,revision:m.revision,token:m.token,
    picture_files:files.map(({sid,layer,width,height,bytes})=>({sid,layer,width,height,bytes}))}))return;
  const PART=32768; // base64 characters: 24 KiB binary, below WebSocket limits
  for(const f of files){
   const parts=Math.ceil(f.base64.length/PART);
   for(let part=0;part<parts;part++){
    if(gb3BetaSocket?.readyState!==WebSocket.OPEN||gb3BetaJoinedRoom!==m.room)return;
    while(gb3BetaSocket.bufferedAmount>192*1024){await gb3PictureSleep(25);if(gb3BetaSocket?.readyState!==WebSocket.OPEN)return;}
    if(!gb3BetaSend({type:'train_picture_part',room:m.room,revision:m.revision,token:m.token,
      sid:f.sid,layer:f.layer,part,total:parts,data:f.base64.slice(part*PART,(part+1)*PART)}))return;
    if(part%8===0)await gb3PictureSleep(0);
   }
  }
  gb3BetaSend({type:'train_picture_finish',room:m.room,revision:m.revision,token:m.token});
 }catch(err){console.warn('GBattle picture consolidation was deferred:',err);}
 finally{gb3PictureUploading=false;}
}
function gb3PictureReceivePart(m){
 const st=gb3PictureIncoming;
 if(!st||m.room!==st.room||Number(m.revision)!==st.revision)return;
 const key=m.file?String(m.file):String(m.sid)+':'+m.layer;
 if(!st.allowed.has(key)||!Number.isInteger(m.part)||!Number.isInteger(m.total)||m.total<1||m.total>512||m.part<0||m.part>=m.total)return;
 let parts=st.parts.get(key);
 if(!parts){parts=new Array(m.total);st.parts.set(key,parts);}
 if(parts.length!==m.total||parts[m.part]!==undefined)return;
 parts[m.part]=String(m.data||'');
 st.bytes+=parts[m.part].length;
 if(st.bytes>44*1024*1024){gb3LiveMeters.lastError='Saved picture transfer exceeded safety limit';gb3BetaSocket?.close();}
 if(st.progressive&&!st.http)void gb3PictureStreamDrain();
}
async function gb3PictureApplyImages(){
 const st=gb3PictureIncoming;
 if(!st||!gb3BetaChunkPending||!gb3BetaModelLoaded||gb3BetaPendingState)return;
 if(st.applying)return;
 st.applying=true;
 try{
  for(const f of st.files){
   const key=f.file?String(f.file):String(f.sid)+':'+f.layer,parts=st.parts.get(key);
   if(!parts||parts.some(x=>typeof x!=='string'))throw Error('Missing picture chunk '+key);
   const decoded=atob(parts.join(''));
   const raw=new Uint8Array(decoded.length);
   for(let i=0;i<decoded.length;i++)raw[i]=decoded.charCodeAt(i);
   const blob=new Blob([raw],{type:'image/webp'});
   const image=await createImageBitmap(blob);
   const p=gb3PictureFindPanel(Number(f.sid));
   if(p){
    if(p.gb3City)gb3EnsureCityPaintResolution(p);
    if(f.layer==='color'){
     gb3PictureTileClip(p.ctx,p,p.canvas,f,image);
     gb3PicturePainted.add(Number(f.sid));
     if(p.gb3City)p.gb3HasPaint=true;
    }else{
     gb3R38EnsureMetal(p);
     gb3PictureTileClip(p.metalCtx,p,p.metalCanvas,f,image);
     p.metalDirty=true;
     // A baked metal tile must enable the same live reflection probe as a
     // freshly painted metal stroke. Otherwise the mask exists but the
     // reflective cube is never populated after a cold picture-only join.
     gb3R55MetalSeen=true;
    }
    dirty.add(p);
   }
   image.close?.();
   st.parts.delete(key);
  }
  gb3PictureIncoming=null;
  const c=gb3BetaChunkPending;
  if(c&&!c.started){c.started=true;gb3BetaSend({type:'train_history_ack',room:c.room,revision:c.revision,seq:0});}
 }catch(e){gb3LiveMeters.lastError='Picture load failed: '+String(e);gb3PictureIncoming=null;gb3BetaSocket?.close();}
}
// The streaming loader paints each finished WebP tile into the room as soon
// as its WebSocket pieces arrive. It never reconstructs historical strokes.
function gb3PictureClearTile(f){
 const p=gb3PictureFindPanel(Number(f.sid));if(!p)return;
 if(p.gb3City)gb3EnsureCityPaintResolution(p);
 const isMetal=f.layer==='metal';
 if(isMetal)gb3R38EnsureMetal(p);
 const canvas=isMetal?p.metalCanvas:p.canvas,ctx=isMetal?p.metalCtx:p.ctx;
 if(!canvas||!ctx)return;
 const sx=f.canvas_width>0?canvas.width/Number(f.canvas_width):canvas.width/Number(f.width);
 const sy=f.canvas_height>0?canvas.height/Number(f.canvas_height):canvas.height/Number(f.height);
 const x=Number(f.x||0)*sx,y=Number(f.y||0)*sy,w=Number(f.width)*sx,h=Number(f.height)*sy;
 gb3PictureTileClip(ctx,p,canvas,f,null);dirty.add(p);
 if(isMetal)p.metalDirty=true;
}
async function gb3PictureStreamDrain(){
 const st=gb3PictureIncoming;
 if(!st?.progressive||st.applying||!gb3BetaModelLoaded||gb3BetaPendingState)return;
 if(st.room!==gb3PictureStreamRoom)return;
 st.applying=true;
 try{
  while(st.nextIndex<st.files.length){
   const f=st.files[st.nextIndex],key=String(f.file||'');
   const parts=st.parts.get(key);
   if(!parts||parts.some(x=>typeof x!=='string'))break;
   const decoded=atob(parts.join(''));
   const bytes=new Uint8Array(decoded.length);
   for(let i=0;i<decoded.length;i++)bytes[i]=decoded.charCodeAt(i);
   const img=await createImageBitmap(new Blob([bytes],{type:'image/webp'}));
   if(gb3PictureIncoming!==st||!gb3PictureStreaming||st.room!==gb3BetaJoinedRoom){img.close?.();return;}
   const p=gb3PictureFindPanel(Number(f.sid));
   if(p){
    if(p.gb3City)gb3EnsureCityPaintResolution(p);
    const metal=f.layer==='metal';if(metal)gb3R38EnsureMetal(p);
    const canvas=metal?p.metalCanvas:p.canvas,ctx=metal?p.metalCtx:p.ctx;
    if(canvas&&ctx){
     const sx=f.canvas_width>0?canvas.width/Number(f.canvas_width):canvas.width/Number(f.width);
     const sy=f.canvas_height>0?canvas.height/Number(f.canvas_height):canvas.height/Number(f.height);
     const x=Number(f.x||0)*sx,y=Number(f.y||0)*sy,w=Number(f.width)*sx,h=Number(f.height)*sy;
     // Clear the replaced area first: transparent WebP pixels and Eraser
     // must REMOVE earlier ink, never blend on top of the prior picture.
     gb3PictureTileClip(ctx,p,canvas,f,img);
     if(metal){p.metalDirty=true;gb3R55MetalSeen=true;}
     else{gb3PicturePainted.add(Number(f.sid));if(p.gb3City)p.gb3HasPaint=true;}
     dirty.add(p);
    }
   }
   gb3LiveTailRestoreTile(f,st.revision);
   img.close?.();st.parts.delete(key);st.nextIndex++;gb3PictureStreamCount++;gb3ResourcePictures(st.nextIndex,st.files.length);
   st.bytes=Math.max(0,st.bytes-parts.reduce((n,v)=>n+v.length,0));
   // Yield between small batches; mobile rendering and walking stay responsive.
   if(st.nextIndex%4===0)await gb3PictureSleep(0);
   if(st.nextIndex%12===0)gb3JoinStatus(gb3ResourceLabel());
  }
  if(st.completed){
   if(st.nextIndex!==st.files.length)throw Error('Missing baked image chunk');
   const revision=st.revision;
   if(gb3PictureIncoming===st){
    gb3PictureIncoming=null;gb3PictureStreamBusy=false;
    gb3PictureStreamRevision=Math.max(gb3PictureStreamRevision,revision);gb3LiveTailPrune(revision);
    if(gb3BetaChunkPending){gb3BetaChunkPending.paintEvents=gb3BetaChunkPending.paintEvents.filter(
     event=>Number(event.revision||0)>gb3PictureStreamRevision);}
    if(gb3PictureStreamRevision>=gb3PictureStreamTarget){
     // Every old stroke is now represented by WebP pixels. Only paint
     // broadcast *after* this checkpoint is drawn as live strokes.
     const pending=gb3BetaChunkPending;
     gb3BetaChunkPending=null;gb3BetaDrawingReady=true; /* continue checking for later baked pictures */
     gb3BetaSend({type:'train_picture_ready',room:st.room});
     if(pending){for(const event of pending.paintEvents){
      if(Number(event.revision||0)>gb3PictureStreamRevision)gb3BetaOnMessage({data:JSON.stringify(event)});
     }}
     gb3ResourceUpdate(20);gb3JoinStatus('Artwork received · live painting active');
    }else{
     gb3JoinStatus(gb3ResourceLabel()+' · artwork streaming');
    }
   }
  }
 }catch(e){
  gb3LiveMeters.lastError='Progressive WebP loading failed: '+String(e);
  gb3PictureIncoming=null;gb3PictureStreamBusy=false;
  gb3BetaSocket?.close();
 }finally{st.applying=false;}
}
// Hold at most four already-downloaded image blobs until their GLB
// surfaces are available. This overlaps train loading and HTTP picture transfer
// without applying paint onto a wrong or missing surface. No historical strokes.
async function gb3PictureAwaitModel(st,signal){
 let announced=false;
 const began=Date.now();
 while(!gb3BetaModelLoaded||gb3BetaPendingState){
  if(gb3PictureIncoming!==st||!gb3PictureStreaming||signal.aborted||st.room!==gb3BetaJoinedRoom)return false;
  if(!announced&&Date.now()-began>12000){
   announced=true;
   gb3JoinStatus(gb3ResourceLabel());
   gb3LiveMeters.lastError='Room model loading delayed; WebP pictures remain queued safely';
  }
  await gb3PictureSleep(100);
 }
 return gb3PictureIncoming===st&&gb3PictureStreaming&&!signal.aborted&&st.room===gb3BetaJoinedRoom;
}
// Spatial picture streaming: request the nearest unrequested artwork next,
// reevaluating from the player's CURRENT location as they move through the yard.
// The old ordered manifest was NOT a distance priority. Color and metal tiles
// are independently streamed and both preserve their transparent pixels.
const gb3PictureTileSpatialCache=new WeakMap();
function gb3PictureTileLocalPoint(f){
 if(gb3PictureTileSpatialCache.has(f))return gb3PictureTileSpatialCache.get(f);
 const p=gb3PictureFindPanel(Number(f.sid));
 if(!p)return null; // model not decoded yet: don't cache the unknown position
 const cw=Number(f.canvas_width||0)||p.canvas?.width||1;
 const ch=Number(f.canvas_height||0)||p.canvas?.height||1;
 const u=Math.max(0,Math.min(1,(Number(f.x||0)+Number(f.width||cw)*.5)/cw));
 const v=Math.max(0,Math.min(1,(Number(f.y||0)+Number(f.height||ch)*.5)/ch));
 let at=null;
 if(p.gb3City&&p.gb3RayOrigin&&p.gb3RayU&&p.gb3RayV){
  at=[0,1,2].map(i=>p.gb3RayOrigin[i]+p.gb3RayU[i]*u+p.gb3RayV[i]*v);
 }else if(p.raw?.length){
  // Train panels contain the actual world-coordinate triangle and UV data.
  // Locate the tile midpoint in UV space so tiles on the SAME long carriage
  // are ordered by proximity, not just by the centre of the whole carriage.
  const a=p.raw;
  for(let i=0;i+23<a.length;i+=24){
   const u0=a[i+6],v0=a[i+7],u1=a[i+14],v1=a[i+15],u2=a[i+22],v2=a[i+23];
   const du1=u1-u0,dv1=v1-v0,du2=u2-u0,dv2=v2-v0;
   const det=du1*dv2-dv1*du2;
   if(Math.abs(det)<1e-9)continue;
   const b=((u-u0)*dv2-(v-v0)*du2)/det;
   const c=(du1*(v-v0)-dv1*(u-u0))/det;
   const x=1-b-c;
   if(x<-.001||b<-.001||c<-.001)continue;
   at=[0,1,2].map(k=>a[i+k]*x+a[i+8+k]*b+a[i+16+k]*c);
   break;
  }
 }
 if(!at&&p.bounds){
  at=[0,1,2].map(i=>(p.bounds[0][i]+p.bounds[1][i])*.5);
 }
 if(!at){
  const pos=p.pos||[0,0,0];at=[Number(pos[0])||0,Number(pos[1])||0,Number(pos[2])||0];
 }
 gb3PictureTileSpatialCache.set(f,at);
 return at;
}
function gb3PictureTileDistance(f){
 const point=gb3PictureTileLocalPoint(f);
 if(!point)return Number.POSITIVE_INFINITY;
 const p=gb3PictureFindPanel(Number(f.sid));
 // C30 on track B is mirrored around the second rail. Use the actual moving
 // train positions rather than static GLB coordinates for nearest ordering.
 const x=p?.gb3Twin?trainMotion2.x-point[0]:
  p?.surface?trainMotion.x+point[0]:point[0];
 const z=p?.gb3Twin?GB3_SECOND_LINE_Z-point[2]:point[2];
 const dx=x-cam.x,dz=z-cam.z,dy=point[1]-cam.y;
 return dx*dx+dz*dz+dy*dy*.16;
}
function gb3PictureNearestJob(pending){
 if(!pending.length)return null;
 let best=0,bestScore=Infinity;
 for(let i=0;i<pending.length;i++){
  const f=pending[i];
  let score=gb3PictureTileDistance(f);
  // When both layers cover the same area, show visible color before metal;
  // the distinct metallic mask follows immediately afterwards.
  if(Number.isFinite(score))score+=f.layer==='metal'?.001:0;
  if(score<bestScore){bestScore=score;best=i;}
 }
 return pending.splice(best,1)[0];
}
// HTTPS tile delivery is separate from the gameplay WebSocket. It avoids
// thousands of base64 frames for Room 1/2 and takes advantage of immutable
// WebP URLs and the browser HTTP cache. The old WS transfer is still supported.
function gb3PictureFinishHTTP(st){
 if(!st.completed||st.nextIndex!==st.files.length||gb3PictureIncoming!==st)return;
 gb3PictureIncoming=null;gb3PictureStreamBusy=false;
 gb3PictureStreamRevision=Math.max(gb3PictureStreamRevision,st.revision);gb3LiveTailPrune(st.revision);
 if(gb3BetaChunkPending)gb3BetaChunkPending.paintEvents=gb3BetaChunkPending.paintEvents.filter(
  event=>Number(event.revision||0)>gb3PictureStreamRevision);
 if(gb3PictureStreamRevision>=gb3PictureStreamTarget){
  const pending=gb3BetaChunkPending;
  gb3BetaChunkPending=null;gb3BetaDrawingReady=true; /* continue checking for later baked pictures */
  gb3BetaSend({type:'train_picture_ready',room:st.room});
  if(pending)for(const event of pending.paintEvents){
   if(Number(event.revision||0)>gb3PictureStreamRevision)gb3BetaOnMessage({data:JSON.stringify(event)});
  }
  gb3ResourceUpdate(20);gb3JoinStatus('Artwork received · live painting active');
 }else gb3JoinStatus(gb3ResourceLabel()+' · artwork streaming');
}
async function gb3PictureStreamHTTP(st){
 if(!st.http||st.applying)return;
 st.applying=true;
 const controller=new AbortController();gb3PictureHTTPAbort=controller;
 try{
  const match=/^train:gb3d-beta:(room-[1-4])$/.exec(st.room);
  if(!match)throw Error('Invalid picture room');
  // Same asset host already serves GLB models, cap textures and public pictures.
  let done=0;
  // Shared pending queue; each worker takes the NEAREST tile using the latest
  // avatar/camera position. Unlike a one-time sort, walking changes priority.
  const pending=st.files.slice();
  const concurrency=Math.min(4,pending.length);
  const task=async()=>{
   while(pending.length){
    if(gb3PictureIncoming!==st||controller.signal.aborted)return;
    const f=gb3PictureNearestJob(pending),filename=String(f?.file||'');
    if(!f)return;
    if(!/^p-[a-zA-Z0-9._-]+\.webp$/.test(filename))throw Error('Invalid WebP filename');
    const response=await fetch('https://gbattle.sweink.com/gbattle-ws?picture='+encodeURIComponent(match[1]+'/'+filename),{
     mode:'cors',credentials:'omit',cache:'force-cache',signal:controller.signal});
    if(!response.ok)throw Error('WebP '+response.status+' '+filename);
    const blob=await response.blob();
    if(blob.size<1||blob.size>8*1024*1024)throw Error('WebP size invalid '+filename);
    // Browser can finish downloading public art before model decoding.
    // Keep at most four fetched files in-flight until the correct GLB exists.
    if(!await gb3PictureAwaitModel(st,controller.signal))return;
    const img=await createImageBitmap(blob);
    if(gb3PictureIncoming!==st||controller.signal.aborted){img.close?.();return;}
    const p=gb3PictureFindPanel(Number(f.sid));
    if(p){
     if(p.gb3City)gb3EnsureCityPaintResolution(p);
     const metal=f.layer==='metal';if(metal)gb3R38EnsureMetal(p);
     const canvas=metal?p.metalCanvas:p.canvas,ctx=metal?p.metalCtx:p.ctx;
     if(canvas&&ctx){
      const sx=f.canvas_width>0?canvas.width/Number(f.canvas_width):canvas.width/Number(f.width);
      const sy=f.canvas_height>0?canvas.height/Number(f.canvas_height):canvas.height/Number(f.height);
      const x=Number(f.x||0)*sx,y=Number(f.y||0)*sy,w=Number(f.width)*sx,h=Number(f.height)*sy;
      gb3PictureTileClip(ctx,p,canvas,f,img);
      if(metal){p.metalDirty=true;gb3R55MetalSeen=true;}
      else{gb3PicturePainted.add(Number(f.sid));if(p.gb3City)p.gb3HasPaint=true;}
      dirty.add(p);
     }
    }
    gb3LiveTailRestoreTile(f,st.revision);
    img.close?.();done++;gb3PictureStreamCount++;gb3ResourcePictures(done,st.files.length);
    if(done%12===0)gb3JoinStatus(gb3ResourceLabel());
    // Keep rendering and touch controls responsive on the server.
    if(done%4===0)await gb3PictureSleep(0);
   }
  };
  await Promise.all(Array.from({length:concurrency},task));
  st.nextIndex=st.files.length;
  // The server completion frame may arrive before the HTTPS downloads.
  // It is a protocol marker, not proof the images are already drawn.
  if(!st.completed){st.readyForEnd=true;return;}
  gb3PictureFinishHTTP(st);
 }catch(err){
  if(controller.signal.aborted||gb3PictureIncoming!==st)return;
  controller.abort();
  gb3LiveMeters.lastError='Public WebP route failed; using WS fallback: '+String(err);
  console.warn('GBattle public WebP fetch failed; retrying over WebSocket',err);
  gb3PictureHTTPFailed=true;gb3PictureIncoming=null;gb3PictureStreamBusy=false;
  gb3JoinStatus('Public WebP fetch unavailable · retrying picture chunks on game connection');
  gb3PictureStreamTick();
 }finally{
  if(gb3PictureHTTPAbort===controller)gb3PictureHTTPAbort=null;
  st.applying=false;
 }
}
function gb3PictureStreamBegin(m){
 if(!gb3PictureStreaming||gb3BetaJoinedRoom!==m.room)return;
 if(!Array.isArray(m.files)||m.files.length>4096){gb3BetaSocket?.close();return;}
 const files=m.files;
 gb3ResourcesSync=false;gb3ResourcePictures(0,files.length);
 gb3PictureIncoming={progressive:true,room:m.room,revision:Number(m.revision),files,
  parts:new Map(),allowed:new Set(files.map(f=>String(f.file))),bytes:0,
  applying:false,completed:false,nextIndex:0,http:m.transport==='http',readyForEnd:false};
 if(gb3PictureIncoming.http&&files.length)void gb3PictureStreamHTTP(gb3PictureIncoming);
 for(const old of Array.isArray(m.removed)?m.removed:[])gb3PictureClearTile(old);
 if(!files.length)gb3JoinStatus('WebP checkpoint updated · checking remaining paint');
}
function gb3BetaResetPaint(){
 gb3LiveTail.length=0;gb3LivePaintProtected.clear();gb3PicturePainted.clear();
 gb3BetaQueue.length=0;wetPools.length=0;activeDrips.length=0;gb3BetaWetSpot=null;gb3BetaDripAnimations.length=0;
 for(const p of [...panels,...gb3TwinPanels,...gb3CityPanels]){p.ctx.clearRect(0,0,p.canvas.width,p.canvas.height);if(p.gb3City)p.gb3HasPaint=false;gb3R38ClearMetal(p);dirty.add(p);}
}
// Multiplayer strokes use the same UV surface IDs and V7.11 segment message fields.
// Deterministic seeded particles ensure receivers and snapshots replay identically.
function gb3BetaRand(seed){let n=(Number(seed)>>>0)||1;return ()=>{n=(Math.imul(n,1664525)+1013904223)>>>0;return n/4294967296;};}
function gb3BetaFinish(seg){
 if(seg.b==='gb3copper')return 'copper';
 return ['gold','chrome'].includes(seg.mat)?seg.mat:'solid';
}
const gb3BetaStampCache=new Map();
function gb3BetaMaskStamp(cap,finish,color){
 const key=cap+'|'+finish+'|'+color;
 if(gb3BetaStampCache.has(key))return gb3BetaStampCache.get(key);
 const isMetal=!!gb3MetalCoatColors[finish];
 const image=isMetal?null:gb3CapImages.get(cap);
 if(!image&&!isMetal)return null;
 const mask=document.createElement('canvas');mask.width=128;mask.height=128;
 const mc=mask.getContext('2d');
 mc.fillStyle=gb3MetalCoatColor(finish,color);
 mc.fillRect(0,0,128,128);mc.globalCompositeOperation='destination-in';
 if(isMetal){
  // Coverage has a flat inner coat and a feathered perimeter, without a
  // repeating sprayed-cap PNG inside the metallic finish.
  const fade=mc.createRadialGradient(64,64,0,64,64,64);
  fade.addColorStop(0,'rgba(255,255,255,1)');
  fade.addColorStop(.68,'rgba(255,255,255,1)');
  fade.addColorStop(.89,'rgba(255,255,255,.52)');
  fade.addColorStop(1,'rgba(255,255,255,0)');
  mc.fillStyle=fade;mc.fillRect(0,0,128,128);
 }else mc.drawImage(image,0,0,128,128);
 if(gb3BetaStampCache.size>=64)gb3BetaStampCache.clear();
 gb3BetaStampCache.set(key,mask);return mask;
}
// R44: the same server cap PNGs are used for local and remote deterministic strokes.
// New packets carry sv:44; the legacy renderer below keeps all historical paint unchanged.
// R47: multiplayer physics with perceptible, INDEPENDENT controls. The
// procedural effect is derived entirely from the saved segment and seed, so
// other players and snapshots reproduce the same pigment and mist.
function gb3BetaR47Profile(seg,op){
 const opacity=clamp(Number(op),0.02,1);
 const thickness=clamp(Number.isFinite(Number(seg.th))?Number(seg.th):.35,0,1);
 const dust=clamp(Number(seg.d)||0,0,1);
 const density=clamp(Number(seg.den)||.6,.12,1.2);
 const flare=clamp(Number(seg.fl)||0,0,1);
 const speed=clamp(Number(seg.spd)||0,0,1);
 const pigment=.10+.90*thickness;
 // Opacity affects ALL visible deposit, not just the outer pixels. The curve
 // avoids saturating pale strokes after a handful of consecutive dabs.
 const alphaCore=clamp(Math.pow(opacity,1.55)*(.06+.90*thickness)*(.28+.72*density),.0005,.98);
 const alphaMist=clamp(Math.pow(opacity,1.4)*dust*(.065+.13*(1-thickness))*(.55+.45*density),0,.28);
 const alphaFlare=clamp(Math.pow(opacity,1.4)*flare*(.035+.12*speed)*(.60+.4*density),0,.22);
 const flareSpread=1+flare*(.24+.85*speed);
 const oversprayReach=1.10+dust*2.40+flare*(.3+speed*.7);
 return {opacity,thickness,dust,density,flare,speed,pigment,
  alphaCore,alphaMist,alphaFlare,flareSpread,oversprayReach};
}
function gb3BetaDrawR44Spray(p,seg,x,y,r,op,color,finish){
 const c=p.ctx,rand=gb3BetaRand(seg.seed),fx=gb3BetaR47Profile(seg,op);
 const {dust,density,thickness,flare,speed,alphaCore,alphaMist,alphaFlare}=fx;
 // Keep building marks in WORLD metres, not the facade JPG's stretched UVs.
 const elong=p.gb3City?clamp(Number(seg.el)||1,1,1.30):clamp(Number(seg.el)||1,1,2.7);
 const angle=p.gb3City?0:(Number(seg.ang)||0);
 const pixelAspect=gb3CityPixelAspect(p);
 const cap=gb3CapNames.includes(seg.cap)?seg.cap:'ny-fat';
 const mask=gb3BetaMaskStamp(cap,finish,color);
 const isMetal=!!gb3MetalCoatColors[finish];
 const ink=gb3MetalCoatColor(finish,color);
 const coatCore=isMetal?gb3MetalCoatAlpha(seg,op):alphaCore;
 c.save();c.translate(x,y);c.scale(1,pixelAspect);
 c.rotate(angle);c.scale(elong*(1-speed*.17*flare),1+speed*.10*flare);
 if(mask){
  // FLARE creates a wider, lighter cloud even on slow strokes; faster sweeps
  // stretch it further. This is separate from DUST's speckled overspray.
  if(flare>.001){const a=r*1.78*fx.flareSpread;
   c.globalAlpha=alphaFlare;c.drawImage(mask,-a,-a,a*2,a*2);}
  if(dust>.001){const a=r*(2.15+1.2*dust);
   c.globalAlpha=alphaMist;c.drawImage(mask,-a,-a,a*2,a*2);}
  c.globalAlpha=coatCore;
  c.drawImage(mask,-r*1.78,-r*1.78,r*3.56,r*3.56);
 }else{
  // Fallback still obeys opacity and thickness when server cap masks are missing.
  const g=c.createRadialGradient(0,0,0,0,0,r*1.78);
  g.addColorStop(0,color);g.addColorStop(.55,color);g.addColorStop(1,'rgba(0,0,0,0)');
  c.fillStyle=g;c.globalAlpha=coatCore;c.beginPath();c.arc(0,0,r*1.78,0,TAU);c.fill();
  if(dust>.001||flare>.001){c.globalAlpha=Math.max(alphaMist,alphaFlare);c.beginPath();c.arc(0,0,r*(2.1+dust+flare),0,TAU);c.fill();}
 }
 c.restore();
 // Dust = visible small flecks *outside* the core. Thickness = how much wet
 // pigment settles in the core, plus the diameter of wet paint droplets.
 c.save();c.fillStyle=ink;
 const fine=1-thickness;
 // Metal is a continuous film: avoid random pigment holes and large speckles
 // across its core. Dust outside the perimeter remains subtle and deterministic.
 const innerCount=isMetal?0:Math.round(7+fine*16+thickness*13);
 const outerCount=dust>0?(isMetal?Math.round(dust*8):Math.round(dust*(18+65*fine))):0;
 const count=Math.min(isTouchDevice?76:125,innerCount+outerCount);
 for(let i=0;i<count;i++){
  const outer=i>=innerCount;
  const a=rand()*TAU;
  const dist=r*Math.sqrt(rand())*(outer?fx.oversprayReach:(.70+.12*thickness));
  const dx=Math.cos(a)*dist*elong,dy=Math.sin(a)*dist*pixelAspect;
  const grain=outer?(.25+.5*rand())*(.7+thickness*.5):(.2+thickness*2.8)*(.55+rand());
  c.globalAlpha=outer?Math.pow(fx.opacity,1.4)*dust*(.09+.14*rand())*(.45+.55*density)
                      :alphaCore*(.22+.28*rand());
  c.fillRect(x+dx,y+dy,grain,grain);
 }
 if(thickness>.30&&speed<.70){
  const extra=Math.round((thickness-.30)*15);
  for(let i=0;i<extra;i++){
   const a=rand()*TAU,d=r*(.2+rand()*1.2),sz=clamp((.6+rand()*2.1)*thickness,.4,5);
   c.globalAlpha=alphaCore*(.42+.27*rand());c.beginPath();c.arc(x+Math.cos(a)*d,y+Math.sin(a)*d,sz,0,TAU);c.fill();
  }
 }
 c.restore();
 if(typeof gb3R47LastRender!=='undefined')gb3R47LastRender={alphaCore:+alphaCore.toFixed(4),mistAlpha:+alphaMist.toFixed(4),flareAlpha:+alphaFlare.toFixed(4),thickness,dust,flare,speed,stampPx:+r.toFixed(2),surface:p.gb3City?'building':'train'};
}
// Every drip is a real server-persisted stroke event. On a fresh join or WAL
// recovery it renders fully; during live play it grows down the wall in ~1 s.
// Coordinates, branches and curve are derived from a saved seed (no random drift).
const gb3BetaDripAnimations=[];
function gb3BetaDripGeometry(p,seg){
 const seed=(Number(seg.seed)>>>0)||1,rand=gb3BetaRand(seed);
 const x=clamp(Number(seg.x0)/3600*p.canvas.width,1,p.canvas.width-1);
 const y=clamp(Number(seg.y0)/1235*p.canvas.height,0,p.canvas.height-1);
 const length=clamp((Number(seg.dlen)||.12)*p.canvas.height,8,Math.max(8,p.canvas.height-y-2));
 const width=clamp((Number(seg.dw)||.004)*p.canvas.width,.5,6.5);
 const sway=(rand()-.5)*Math.min(26,length*.25);
 const bend=(rand()-.5)*Math.min(18,length*.15);
 const fork=Number(seg.fork)>.5;
 return {x,y,length,width,sway,bend,fork,seed};
}
function gb3BetaDripPoint(g,t){return [g.x+g.sway*t*t+g.bend*Math.sin(t*Math.PI*1.5)*Math.sin(t*Math.PI),g.y+g.length*t];}
function gb3BetaDrawDripPart(p,seg,from,to){
 const g=gb3BetaDripGeometry(p,seg),c=p.ctx;
 const op=clamp(Number(seg.o)||.6,.02,1),color=String(seg.c||'#fa3040');
 const a=clamp(from,0,1),b=clamp(to,0,1);
 if(b<=a)return;
 c.save();c.strokeStyle=color;c.fillStyle=color;c.lineJoin='round';c.lineCap='round';c.globalAlpha=op*.91;
 function trail(lo,hi,offset=0,factor=1){
  const steps=Math.max(2,Math.ceil((hi-lo)*32));
  for(let i=0;i<steps;i++){
   const t0=lo+(hi-lo)*i/steps,t1=lo+(hi-lo)*(i+1)/steps;
   const p0=gb3BetaDripPoint(g,t0),p1=gb3BetaDripPoint(g,t1);
   const branchDelta=offset?(t0-.44)*offset:0;
   c.lineWidth=Math.max(.32,g.width*factor*Math.pow(Math.max(.045,1-t0),.65));
   c.beginPath();c.moveTo(p0[0]+branchDelta,p0[1]);c.lineTo(p1[0]+(offset?(t1-.44)*offset:0),p1[1]);c.stroke();
  }
 }
 trail(a,b);
 // One deterministic Y-shaped split, beginning 44% down the drip.
 if(g.fork&&b>.44){trail(Math.max(a,.44),b,(g.seed%2?1:-1)*Math.min(17,g.length*.12),.44);}
 if(b===1){const end=gb3BetaDripPoint(g,1);c.beginPath();c.ellipse(end[0],end[1],Math.max(.4,g.width*.25),Math.max(.6,g.width*.38),0,0,TAU);c.fill();}
 c.restore();
 // Trace metallic drip response along the same deterministic trajectory.
 const finish=gb3BetaFinish(seg);
 if((finish!=='solid'||p.metalCanvas)&&b>a){
  const steps=Math.max(2,Math.ceil((b-a)*20));
  for(let i=0;i<steps;i++){
   const t=a+(i+.5)*(b-a)/steps,pt=gb3BetaDripPoint(g,t);
   gb3R38MarkMetal(p,pt[0],pt[1],Math.max(.5,g.width*.45),finish,op*.66,false,1,0,false);
  }
 }
 dirty.add(p);
}
function gb3BetaAnimateDrip(p,seg){
 // Initial preview is fast; the final, stored path is identical on all clients.
 gb3BetaDripAnimations.push({p,seg,started:performance.now(),progress:0,duration:750+((Number(seg.seed)>>>4)%550)});
}
setInterval(()=>{
 if(!gb3BetaDripAnimations.length)return;
 const now=performance.now();
 for(let i=gb3BetaDripAnimations.length-1;i>=0;i--){
  const item=gb3BetaDripAnimations[i];const next=clamp((now-item.started)/item.duration,0,1);
  gb3BetaDrawDripPart(item.p,item.seg,item.progress,next);item.progress=next;
  if(next>=1)gb3BetaDripAnimations.splice(i,1);
 }
},55);
function gb3BetaDrawStroke(p,seg){
 // Upgrade an EMPTY wall canvas before rendering a new or historical stroke.
 // Replaying old normalized coordinates now produces the same physical paint
 // placement at the sharper resolution; existing Go/WAL records are untouched.
 gb3EnsureCityPaintResolution(p);
 const x=Number(seg.x0)/3600*p.canvas.width,y=Number(seg.y0)/1235*p.canvas.height;
 if(!Number.isFinite(x)||!Number.isFinite(y))return;
 const r=Math.max(.5,Number(seg.w)/3600*p.canvas.width);
 const op=Math.max(.02,Math.min(1,Number(seg.o)||.7));
 const erase=seg.m==='eraser';const color=String(seg.c||'#fa3040');
 const finish=gb3BetaFinish(seg),c=p.ctx;
 // The server stores these segment types without changing V7.11 or paint IDs.
 if(seg.t==='drip'&&!erase){
  if(Number(seg.sv)===44&&seg._live)gb3BetaAnimateDrip(p,seg);
  else gb3BetaDrawDripPart(p,seg,0,1);
  return;
 }
 const isSpray=seg.t==='spray'&&!erase; // Old saved plain-dot segments replay unchanged.
 const dust=Math.max(0,Math.min(1,Number(seg.d)||0));
 const density=Math.max(.12,Math.min(1.2,Number(seg.den)||.5));
 const elong=Math.max(1,Math.min(2.7,Number(seg.el)||1));
 const angle=Number(seg.ang)||0;
 const cap=typeof seg.cap==='string'&&gb3CapNames.includes(seg.cap)?seg.cap:'ny-fat';
 const rnd=gb3BetaRand(seg.seed);
 if(isSpray&&Number(seg.sv)===44){
  gb3BetaDrawR44Spray(p,seg,x,y,r,op,color,finish);
  // R48 metal coverage is derived from the existing segment data, including replays.
  gb3R38MarkMetal(p,x,y,r,finish,gb3MetalCoatColors[finish]?gb3MetalCoatAlpha(seg,op)*1.9:op*gb3BetaR47Profile(seg,op).alphaCore*3.0,false,
    p.gb3City?clamp(Number(seg.el)||1,1,1.30):clamp(Number(seg.el)||1,1,2.7),p.gb3City?0:angle,true);
  dirty.add(p);return;
 }
 c.save();c.globalCompositeOperation=erase?'destination-out':'source-over';c.globalAlpha=op;
 if(erase){c.fillStyle='#000';c.beginPath();c.arc(x,y,r*1.15,0,Math.PI*2);c.fill();c.restore();gb3R38MarkMetal(p,x,y,r,'solid',op,true,1,0,false);dirty.add(p);return;}
 let ink=color;
 if(gb3MetalCoatColors[finish])ink=gb3MetalCoatColor(finish,color);
 if(isSpray){
  c.save();c.translate(x,y);c.rotate(angle);c.scale(elong,1);
  // Consistent diffuse stamp and source cap mask, closely matching the single-player footprint.
  const capMask=gb3CapImages.get(cap);
  c.globalAlpha=op*(.25+.43*density);
  if(capMask){
   const mask=gb3BetaMaskStamp(cap,finish,color);
   if(dust>.05){c.globalAlpha=op*dust*.12;c.drawImage(mask,-r*2.2,-r*2.2,r*4.4,r*4.4);}
   c.globalAlpha=op*(.25+.43*density);
   c.drawImage(mask,-r*1.78,-r*1.78,r*3.56,r*3.56);
  }else{
   const g=c.createRadialGradient(0,0,0,0,0,r*1.78);
   g.addColorStop(0,color);g.addColorStop(.6,color);g.addColorStop(1,'rgba(0,0,0,0)');
   c.fillStyle=g;c.beginPath();c.arc(0,0,r*1.78,0,Math.PI*2);c.fill();
  }
  c.restore();
  // Deterministic overspray, replayed identically after reload across participants.
  const n=Math.min(64,Math.round((8+dust*46)*density));
  c.fillStyle=ink;
  for(let i=0;i<n;i++){
   const ang=rnd()*Math.PI*2,dist=r*(.5+rnd()*(1.1+dust*1.55));
   c.globalAlpha=Math.min(1,op*(.04+.12*rnd()));
   c.fillRect(x+Math.cos(ang)*dist*elong,y+Math.sin(ang)*dist,.45+.8*rnd(),.45+.8*rnd());
  }
 }else{
  c.fillStyle=ink;c.beginPath();c.arc(x,y,r,0,Math.PI*2);c.fill();
 }
 c.restore();
 gb3R38MarkMetal(p,x,y,r,finish,op,false,elong,angle,isSpray);
 dirty.add(p);
}
function gb3BetaApplySegment(seg,live=false){
 const sid=Number(seg.sid);if(!Number.isInteger(sid)||sid<0)return;
 const p=gb3PictureFindPanel(sid);if(!p?.ctx)return;
 gb3BetaDrawStroke(p,live?{...seg,_live:true}:seg);gb3PicturePainted.add(sid);if(p.gb3City)p.gb3HasPaint=true;
}
// R44: local per-gesture wetness only determines WHEN a shared drip event is sent.
// The actual drip geometry is stored in train_stroke segments and replayed identically.
let gb3BetaPaintCounter=1;
let gb3BetaWetSpot=null;
const GB3_SPRAY_BUILD='R47-responsive-multiplayer-spray';
let gb3R47LastPaint=null,gb3R47LastRender=null;
root.dataset.gb3SprayBuild=GB3_SPRAY_BUILD;
window.GB3_SPRAY_STATUS={build:GB3_SPRAY_BUILD,sharedDrips:true,physics:'network-deterministic',get controls(){return {cap:state.cap,size:state.size,flare:state.flare,dust:state.dust,opacity:state.opacity,thickness:state.sprayThickness,drips:state.drips}},get lastStroke(){return gb3R47LastPaint},get lastRender(){return gb3R47LastRender}};
function gb3BetaPaint(hit,dynamics=null){
 if(!gb3BetaDrawingReady)return;
 const p=hit.p,sid=p.gb3BetaSID;
 // Before deriving a physical cap radius, use the actual wall's texel density.
 gb3EnsureCityPaintResolution(p);
 if(!Number.isInteger(sid)||!gb3PictureFindPanel(sid))return;
 const u=Math.max(0,Math.min(1,hit.u)),v=Math.max(0,Math.min(1,hit.v));
 const spray=state.tool==='spray',erase=state.tool==='wash';
 const phys=spray?gb3SprayPhysics(hit,dynamics?.speed||0):null;
 const r=spray?phys.radius:Math.max(1,(state.size/100)*(p.canvas.width/(p.gb3City?p.gb3WorldU:10)));
 const color=/^#[0-9a-f]{6}$/i.test(state.color)?state.color:'#ff3040';
 const opacity=Math.max(.05,Math.min(1,state.opacity));
 const finish=!erase&&['chrome','gold','copper'].includes(state.mat)?state.mat:'solid';
 const seg={sid,x0:u*3600,y0:v*1235,x1:u*3600,y1:v*1235,
  w:Math.max(.4,Math.min(512,r/p.canvas.width*3600)),c:color,o:opacity,
  m:erase?'eraser':'brush',b:finish==='copper'?'gb3copper':'round',
  t:state.tool==='marker'?'marker':'spray',cap:state.cap,
  d:Math.round(state.dust*100)/100,den:Math.round((phys?.density||1)*100)/100,
  el:Math.round((phys?.elongate||1)*100)/100,ang:Math.round((phys?.viewAngle||0)*100)/100,
  // Physics is sampled at stroke time; clients reproduce identical results.
  sv:44,th:Math.round(state.sprayThickness*100)/100,fl:Math.round(state.flare*100)/100,
  spd:Math.round((phys?.fast||0)*100)/100,
  seed:((++gb3BetaPaintCounter*2654435761)>>>0)};
 if(finish==='chrome'||finish==='gold')seg.mat=finish;
 gb3R47LastPaint={sid,cap:seg.cap,opacity:seg.o,flare:seg.fl,overspray:seg.d,thickness:seg.th,fast:seg.spd,stampWorldWidth:seg.w};
 gb3BetaApplySegment(seg);gb3LiveTailAdd(seg);
 gb3BetaQueue.push(seg);
 // Spray drips are persisted as their own deterministic paint events, not
 // client-only wet textures. Old room art and the original Go protocol remain valid.
 if(spray&&state.drips&&p.region!=='roof'&&p.gb3CityFace!=='roof'){
  const x=u*p.canvas.width,y=v*p.canvas.height,now=performance.now();
  const held=!!dynamics?.held,th=clamp(state.sprayThickness,0,1);
  const wetAmount=opacity*(held?.24:.085)*(.45+.75*th)*(phys?.surface?.adhesion||1);
  const near=Math.max(5,r*2.4);
  if(!gb3BetaWetSpot||gb3BetaWetSpot.p!==p||Math.hypot(gb3BetaWetSpot.x-x,gb3BetaWetSpot.y-y)>near||now-gb3BetaWetSpot.time>2500){
   gb3BetaWetSpot={p,x,y,charge:0,time:now};
  }
  const spot=gb3BetaWetSpot;
  spot.x=spot.x*.72+x*.28;spot.y=spot.y*.72+y*.28;spot.charge+=wetAmount;spot.time=now;
  const threshold=.58+(1-th)*.42;
  if(spot.charge>=threshold){
   spot.charge-=threshold;
   const seed=((++gb3BetaPaintCounter*2654435761)>>>0);
   const rand=gb3BetaRand(seed);
   // Train runoff keeps its established R44 look. Facades use a measured
   // metre-length drip so a four-storey wall doesn't stretch a short drop
   // over multiple storeys; always stop at the lower edge of the actual wall.
   const freeHeight=Math.max(0,p.canvas.height-spot.y-2);
   const requested=p.gb3City?gb3CityDripLengthPixels(p,rand(),th):20+rand()*105+th*75;
   const dripLength=Math.min(freeHeight,p.gb3City?requested:Math.max(12,requested));
   if(dripLength>Math.max(3,p.gb3City?3:8)){
    const drip={sid,x0:clamp(spot.x,0,p.canvas.width)/p.canvas.width*3600,
     y0:clamp(spot.y,0,p.canvas.height)/p.canvas.height*1235,
     x1:clamp(spot.x,0,p.canvas.width)/p.canvas.width*3600,
     y1:clamp(spot.y,0,p.canvas.height)/p.canvas.height*1235,
     w:Math.max(.4,Math.min(512,r/p.canvas.width*3600)),
     c:color,o:opacity,m:'brush',b:'round',t:'drip',sv:44,
     dlen:dripLength/p.canvas.height,dw:clamp(.65+th*2.1+r*.09,.6,5.2)/p.canvas.width,
     fork:rand()>.51?1:0,seed};
    gb3BetaApplySegment(drip,true);gb3LiveTailAdd(drip);gb3BetaQueue.push(drip);
   }
  }
 }
 if(gb3BetaQueue.length>=50)gb3BetaFlush();
}
function gb3BetaFlush(){
 if(!gb3BetaDrawingReady||!gb3BetaJoinedRoom||!gb3BetaQueue.length)return;
 const segments=gb3BetaQueue.splice(0,Math.min(60,gb3BetaQueue.length));
 gb3LiveMeters.paintOut+=segments.length;
 const id=gb3BetaClientID+'-'+(++gb3BetaSeq);
 // A network send is NOT a save: only the server's fsynced train_saved is.
 const job={id,room:gb3BetaJoinedRoom,segments,at:Date.now()};
 gb3BetaPendingSaves.set(id,job);
 $('saveState').textContent='ROOM SAVING…';
 if(!gb3BetaSend({type:'train_stroke',room:gb3BetaJoinedRoom,event_id:id,action_id:id,segments})){
  gb3BetaDrawingReady=false;gb3BetaStatus('Connection interrupted. Unconfirmed paint will be retried after reconnect.');
 }
}
setInterval(gb3BetaFlush,115);
let gb3RoomModelRetryCount=0;
function gb3RetryRoomModel(model){
 const room=gb3BetaAwaitingRoom||gb3BetaJoinedRoom;
 void gb3LoadTrain(model,true).then(ok=>{
  if(ok){gb3RoomModelRetryCount=0;return;}
  if(gb3RoomModelRetryCount>=2){
   gb3LiveMeters.lastError='Train model '+model+' failed after retries';
   gb3BetaStatus('A required 3D resource failed to load');return;
  }
  gb3RoomModelRetryCount++;
  gb3JoinStatus(gb3ResourceLabel()+' · model retry '+gb3RoomModelRetryCount+'/2');
  setTimeout(()=>{
   if(!root.isConnected||!gb3BetaPendingState||gb3BetaPendingState.model!==model)return;
   if(room!==(gb3BetaAwaitingRoom||gb3BetaJoinedRoom))return;
   gb3RetryRoomModel(model);
  },2000*gb3RoomModelRetryCount);
 }).catch(e=>{
  gb3LiveMeters.lastError=String(e);gb3BetaStatus('Required resource load error: '+String(e.message||e));
 });
}
function gb3BetaApplySnapshot(state){
 if(state.model&&state.model!==gb3KeyToPublic[gb3TrainSelection]){
   gb3BetaDrawingReady=false;gb3BetaPendingState=state;
   if(!gb3BetaTargetModel||gb3BetaTargetModel!==state.model){
     gb3BetaTargetModel=state.model;gb3RoomModelRetryCount=0;
     gb3RetryRoomModel(state.model);
   }
   return;
 }
 if(!gb3BetaModelLoaded){gb3BetaPendingState=state;return;}
 gb3BetaPendingState=null;gb3BetaResetPaint();
 if(Array.isArray(state.segments))for(const s of state.segments)gb3BetaApplySegment(s);
 gb3BetaDrawingReady=!state.chunked||!!state.streaming_pictures;
 // A fresh picture-only room is immediately paintable after its model is ready.
 // Incoming baker tiles are applied underneath newer live strokes.
 if(state.streaming_pictures){gb3BetaChunkPending=null;gb3JoinStatus('Live painting enabled · WebP pictures load in background');}
 if(gb3BetaDrawingReady)gb3BetaSend({type:'train_picture_ready',room:state.room});
 if(state.chunked&&gb3BetaChunkPending&&!gb3BetaChunkPending.started){
  if(state.streaming_pictures){gb3PictureStreamTick();}
  else if(!state.picture){gb3BetaChunkPending.started=true;gb3BetaSend({type:'train_history_ack',room:state.room,revision:state.revision,seq:0});}
  else if(gb3PictureIncoming?.completed)void gb3PictureApplyImages();
 }
 // Server history is authoritative. Do not duplicate strokes that were saved
 // but whose acknowledgement was lost during a disconnect.
 const seen=new Set((state.segments||[]).map(x=>String(x._a||'')));
 for(const [id,job] of gb3BetaPendingSaves){
  if(state.chunked)break;
  if(job.room!==gb3BetaJoinedRoom)continue;
  if(seen.has(id)){gb3BetaPendingSaves.delete(id);continue;}
  gb3BetaSend({type:'train_stroke',room:job.room,event_id:id,action_id:id,segments:job.segments});
 }
 if(gb3BetaRoomStatus)gb3BetaRoomStatus.textContent='GLOBAL CHAT';
 $('saveState').textContent=gb3BetaPendingSaves.size?'ROOM SAVING…':'ROOM SYNC';
 if(gb3BetaUI)gb3BetaUI.hidden=true;
 gb3ResourceUpdate(2);gb3RouletteRoomReady=true;gb3RouletteUpdate();
 gb3SetChatVisible(gb3ChatVisible);
 if(gb3BetaPeople)gb3BetaPeople.textContent='Paint room '+gb3BetaJoinedRoom.slice(-1)+' · '+(state.online||1)+' connected · global messages';
 gb3JoinStatus((state.streaming_pictures?'Room '+gb3BetaJoinedRoom.slice(-1)+' · live paint available · pictures continue streaming':gb3ResourceLabel()));
}
function gb3BetaModelReady(){gb3ResourceUpdate(3);gb3BetaModelLoaded=true;gb3BetaTargetModel='';if(gb3BetaPendingState)gb3BetaApplySnapshot(gb3BetaPendingState);if(gb3PictureStreaming){if(gb3PictureIncoming?.progressive)void gb3PictureStreamDrain();else gb3PictureStreamTick();}}
function gb3BetaAddChat(name,message,{pending=false,failed=false}={}){
 if(!gb3BetaMessages)return null;
 const row=document.createElement('p'),strong=document.createElement('b');strong.textContent=String(name||'Guest').slice(0,25)+': ';
 const body=document.createTextNode(String(message||'').slice(0,240)),status=document.createElement('small');
 status.className='gb3-chat-status';status.textContent=failed?' NOT DELIVERED':pending?' SENDING…':'';
 row.className=failed?'gb3-chat-failed':pending?'gb3-chat-pending':'';
 row.append(strong,body,status);
 gb3BetaMessages.appendChild(row);while(gb3BetaMessages.children.length>80)gb3BetaMessages.removeChild(gb3BetaMessages.firstChild);
 gb3BetaMessages.scrollTop=gb3BetaMessages.scrollHeight;
 return row;
}
function gb3GlobalChatRow(tempID,name,message){
 const key=String(tempID||'');
 if(key&&gb3GlobalChatRows.has(key))return gb3GlobalChatRows.get(key);
 const row=gb3BetaAddChat(name,message,{pending:true});
 if(key&&row){gb3GlobalChatRows.set(key,row);if(gb3GlobalChatRows.size>100)gb3GlobalChatRows.delete(gb3GlobalChatRows.keys().next().value);}
 if(!gb3ChatVisible){
  gb3ChatUnread=Math.min(99,gb3ChatUnread+1);const unread=gb3BetaChatButton.querySelector('.gb3-chat-unread');
  unread.hidden=false;unread.textContent=gb3ChatUnread>9?'9+':String(gb3ChatUnread);
 }
 return row;
}
function gb3GlobalChatReceive(m){
 // Only a committed chat event confirms database saving. chat_received merely
 // confirms the server has the message and PHP save is still in progress.
 if(m.type==='chat_received'){
  const id=String(m.temp_id||'');const pending=gb3PendingChat.find(p=>p.id===id);
  if(pending){pending.received=true;const st=pending.node?.querySelector('.gb3-chat-status');if(st)st.textContent=' SERVER RECEIVED · SAVING…';}
  return;
 }
 // V7.11 broadcasts chat_preview, then chat:{message:{id,client,name,message,...}}.
 if(m.type==='chat_preview'){
  const id=String(m.temp_id||'');
  if(!id)return;
  const self=gb3PendingChat.find(p=>p.id===id);
  if(self){self.preview=true;return;}
  gb3GlobalChatRow(id,m.name,m.message);return;
 }
 if(m.type==='chat_reject'){
  const id=String(m.temp_id||'');const p=gb3PendingChat.find(p=>p.id===id);
  const row=p?.node||gb3GlobalChatRows.get(id);
  if(row){row.classList.remove('gb3-chat-pending');row.classList.add('gb3-chat-failed');const st=row.querySelector('.gb3-chat-status');if(st)st.textContent=' NOT SAVED (PREVIEW ONLY)';}
  if(p)gb3PendingChat.splice(gb3PendingChat.indexOf(p),1);
  return;
 }
 if(m.type!=='chat'||!m.message||typeof m.message!=='object')return;
 const data=m.message;
 const id=String(m.temp_id||'');
 const savedId=String(data.id??'');
 if(savedId&&gb3GlobalSeenIds.has(savedId))return;
 if(savedId){gb3GlobalSeenIds.add(savedId);if(gb3GlobalSeenIds.size>250)gb3GlobalSeenIds.delete(gb3GlobalSeenIds.values().next().value);}
 let self=gb3PendingChat.find(p=>p.id===id);
 // Older chat transports sometimes omit temp_id on committed events. Match only
 // one outstanding local message with the same authenticated display name and text.
 if(!self&&!id&&String(data.name||'')===String(gb3BetaNick||'')){
  const matching=gb3PendingChat.filter(p=>p.text===String(data.message||''));
  if(matching.length===1)self=matching[0];
 }
 let row=self?.node||gb3GlobalChatRows.get(id);
 if(!row){row=gb3BetaAddChat(data.name,data.message);}
 if(row){row.classList.remove('gb3-chat-pending','gb3-chat-failed');const st=row.querySelector('.gb3-chat-status');if(st)st.textContent=' ✓';}
 if(self)gb3PendingChat.splice(gb3PendingChat.indexOf(self),1);
}
// A separate, room-independent WebSocket handles GLOBAL CHAT only.  It is bound
// by Go to the existing multiplayer identity, cannot join train rooms, and never
// receives picture chunks.  Images and scene loading can no longer block chat.
function gb3ChatStop(){
 clearTimeout(gb3ChatReconnect);gb3ChatReconnect=null;
 const socket=gb3ChatSocket;gb3ChatSocket=null;gb3ChatReady=false;gb3ChatProbeConfirmed=false;
 try{socket?.close(1000,'Leaving multiplayer chat');}catch(_){ }
}
function gb3ChatOpen(){
 if(!gb3ChatTransportSupported||!gb3BetaSocketOpen)return;
 if(gb3ChatSocket&&(gb3ChatSocket.readyState===WebSocket.OPEN||gb3ChatSocket.readyState===WebSocket.CONNECTING))return;
 clearTimeout(gb3ChatReconnect);gb3ChatReconnect=null;
 const url=root.getAttribute('data-gb3-beta-ws')||'wss://gbattle.sweink.com/gbattle-ws';
 if(!/^wss:\/\//i.test(url)){gb3ChatStatus('CHAT: SECURE CONNECTION REQUIRED');return;}
 gb3ChatStatus('CHAT: CONNECTING INDEPENDENT CHANNEL…');
 let socket;
 try{socket=new WebSocket(url)}catch(err){gb3ChatStatus('CHAT: CONNECTION FAILED');return;}
 gb3ChatSocket=socket;gb3ChatReady=false;
 socket.onopen=()=>{
  if(socket!==gb3ChatSocket)return;
  try{socket.send(JSON.stringify({type:'hello',client_id:gb3BetaClientID+':chat',name:gb3BetaNick,
   chat_only:true,chat_link_token:gb3ChatLinkToken,paint_protocol:2,picture_protocol:0,binary_paint:false,skip_catchup:true}));}
  catch(err){gb3ChatStatus('CHAT: HANDSHAKE FAILED');socket.close();}
 };
 socket.onmessage=event=>{
  if(socket!==gb3ChatSocket)return;
  let m;try{m=JSON.parse(event.data)}catch(_){return;}
  if(m.type==='hello'){
   if(m.chat_only!==true||m.chat_transport!=='isolated'){
    gb3ChatStatus('CHAT: INCOMPATIBLE SERVER');socket.close();return;
   }
   gb3ChatReady=true;gb3ChatRetry=0;gb3ChatStatus('CHAT: CONNECTED · VERIFYING…');
   try{socket.send(JSON.stringify({type:'chat_probe',temp_id:'chat-probe-'+Date.now().toString(36)}));}
   catch(_){socket.close();}
   return;
  }
  if(m.type==='chat_probe_ack'){gb3ChatProbeConfirmed=true;gb3ChatStatus('CHAT: ONLINE · INDEPENDENT');return;}
  if(['chat','chat_preview','chat_received','chat_reject'].includes(m.type)){gb3GlobalChatReceive(m);return;}
  if(m.type==='error'){
   gb3ChatStatus('CHAT: '+String(m.code||'SERVER ERROR').toUpperCase());
   if(['chat_failed','rate_chat','chat_banned','chat_name_required','chat_link_required','chat_blocked'].includes(m.code)){
    const last=gb3PendingChat[gb3PendingChat.length-1];
    if(last?.node){const el=last.node.querySelector('.gb3-chat-status');if(el)el.textContent=' NOT SAVED: '+String(m.message||m.code).slice(0,90);}
    if(m.code==='chat_link_required')socket.close();
   }
  }
 };
 socket.onerror=()=>{if(socket===gb3ChatSocket)gb3ChatStatus('CHAT: CONNECTION ERROR');};
 socket.onclose=()=>{
  if(socket!==gb3ChatSocket)return;
  gb3ChatSocket=null;gb3ChatReady=false;gb3ChatProbeConfirmed=false;
  gb3ChatStatus('CHAT: DISCONNECTED · RECONNECTING…');
  if(gb3BetaSocketOpen&&gb3ChatTransportSupported){
   const delay=Math.min(10000,750*Math.pow(2,Math.min(4,gb3ChatRetry++)));
   gb3ChatReconnect=setTimeout(gb3ChatOpen,delay);
  }
 };
}
function gb3ChatSend(m){
 const socket=gb3ChatSocket;
 if(!gb3ChatReady||!gb3ChatProbeConfirmed||socket?.readyState!==WebSocket.OPEN)return false;
 try{socket.send(JSON.stringify(m));return true}catch(err){gb3ChatStatus('CHAT: SEND FAILED');return false;}
}
function gb3BetaOnMessage(event){
 let m;try{m=JSON.parse(event.data)}catch(_){return}
 if(m.type==='hello'){
  gb3StaffRole=String(m.role||'user');gb3ModRefreshPermissions();
  gb3BetaSocketOpen=true; // V7.11 does not support beta_rooms; train presence follows join.
  gb3ChatTransportSupported=m.chat_transport==='isolated'&&typeof m.chat_link_token==='string'&&m.chat_link_token.length===32;
  gb3ChatLinkToken=gb3ChatTransportSupported?m.chat_link_token:'';
  gb3ChatStatus(gb3ChatTransportSupported?'CHAT: CONNECTING · ROOM MAY STILL BE LOADING…':'CHAT: LEGACY GAME CONNECTION');
  // Never make room entry depend on password verification or background baking.
  // The server itself reserves ADMIN until it confirms admin_auth.
  const provisionalAdmin=gb3AdminAwaitingAuth&&gb3AdminAuthMode==='join';
  if(gb3ChatTransportSupported&&!provisionalAdmin)gb3ChatOpen();
  gb3BetaSend({type:'presence',name:provisionalAdmin?gb3SessionGuest:gb3BetaNick});
  if(gb3BetaAwaitingRoom)gb3BetaSend({type:'train_join',room:gb3BetaAwaitingRoom});
  if(provisionalAdmin){
   const password=gb3AdminPasswordPending;gb3AdminPasswordPending='';
   if(!password){gb3AdminAwaitingAuth=false;gb3BetaStatus('ADMIN password required · room available as Guest');}
   else if(!gb3BetaSend({type:'admin_auth',password})){
    gb3AdminAwaitingAuth=false;gb3BetaStatus('ADMIN verification unavailable · room joining as Guest');
   }
  }
  return;
 }
 if(m.type==='admin_auth'){
  if(!gb3AdminAwaitingAuth)return;
  const mode=gb3AdminAuthMode;
  gb3AdminAwaitingAuth=false;gb3AdminAuthMode='';gb3AdminPasswordPending='';
  if(m.ok===true && m.name==='ADMIN' && m.role==='owner'){
   gb3AdminAuthenticated=true;gb3StaffRole='owner';gb3BetaNick='ADMIN';gb3ModRefreshPermissions();
   gb3ModOpenButton.hidden=false;
   if(gb3GuestField)gb3GuestField.value='ADMIN';
   gb3AdminModal.hidden=true;
   gb3BetaStatus('ADMIN authenticated by GBattle realtime server');
   gb3BetaSend({type:'presence',name:'ADMIN'});
   if(mode==='join'&&gb3BetaAwaitingRoom)gb3BetaSend({type:'train_join',room:gb3BetaAwaitingRoom});
   if(gb3ChatTransportSupported)gb3ChatOpen();
  }else{
   gb3AdminAuthenticated=false;gb3ModOpenButton.hidden=true;
   gb3AdminStatus.textContent='ADMIN password rejected by the realtime server. No admin access granted.';
   if(mode==='join'){
    // The room stays open as an ordinary guest; failed ADMIN auth cannot freeze a map.
    gb3BetaNick=gb3SessionGuest;
    gb3BetaSend({type:'presence',name:gb3SessionGuest});
    if(gb3ChatTransportSupported)gb3ChatOpen();
    gb3BetaStatus('ADMIN verification declined · room remains available as Guest');
   }
   gb3AdminModal.hidden=false;gb3AdminPasswordInput.focus({preventScroll:true});
  }
  return;
 }
 if(m.type==='moderation_staff'||m.type==='moderation_rooms'||m.type==='moderation_backups'||m.type==='moderation_room_preview'||m.type==='moderation_room_result'||m.type==='moderation_roster'||m.type==='moderation_audit'||m.type==='moderation_mode'||m.type==='moderation_action_result'||m.type==='moderation_block_result'||m.type==='moderation_blocks'||m.type==='admin_log'){
  gb3ModPanelReceive(m);return;
 }
 if(m.type==='staff_credentials'){
  if(m.role==='moderator'&&/^[0-9a-f]{64}$/.test(String(m.token||''))){
   try{localStorage.setItem(gb3StaffTokenKey(),m.token);}catch(_){gb3BetaStatus('Moderator granted for this session; browser storage unavailable for reconnect.');}
   gb3StaffRole='moderator';gb3ModRefreshPermissions();
  }return;
 }
 if(m.type==='admin_event'&&m.target===gb3BetaClientID&&m.new_role){gb3StaffRole=String(m.new_role);gb3ModRefreshPermissions();return;}
 if(m.type==='train_loading'){if(m.room===gb3BetaAwaitingRoom)gb3JoinStatus(gb3ResourceLabel());return;}
 if(m.type==='beta_rooms'){gb3BetaRenderCounts(m.counts);return;}
 if(m.type==='error'){
  if(gb3HasStaffAccess()&&!gb3ModPanel.hidden)gb3ModStatus.textContent=String(m.code||'ERROR')+': '+String(m.message||'Command failed');
  if(gb3AdminAwaitingAuth){gb3AdminAwaitingAuth=false;gb3AdminPasswordPending='';gb3AdminStatus.textContent='ADMIN authorization error: '+String(m.code||'unknown');gb3AdminModal.hidden=false;return;}
  if(m.code==='train_save_failed'||m.code==='bad_surface'||m.code==='bad_segment'||m.code==='room_art_full'){
   gb3LiveMeters.errors++;gb3LiveMeters.lastError=String(m.code)+': '+String(m.message||'');
   $('saveState').textContent='SAVE FAILED';
   gb3BetaStatus('PAINT NOT SAVED: '+(m.message||m.code)+' · Do not leave the room before this is resolved.');
   console.error('[GBATTLE R62] SERVER REJECTED PAINT',m.code,m.message||'', 'room',gb3BetaJoinedRoom,'pending',gb3BetaPendingSaves.size);
   return;
  }
  if(m.code==='bad_type'){gb3BetaStatus('Server rejected an unsupported command. Painting will remain available.');return;}
  gb3BetaStatus((m.code||'ERROR')+': '+(m.message||'Unable to join'));
  if(m.code==='room_data_unavailable'||m.code==='beta_room_full')gb3ChatStatus('ROOM ERROR: '+String(m.code||'UNKNOWN').toUpperCase());
  if(m.code==='room_has_art')toast('This room already has artwork; train cannot be changed.');
  if(['rate_chat','chat_banned','chat_failed','chat_name_required','chat_blocked','wrong_room','not_ready'].includes(m.code)){
   const last=gb3PendingChat.pop();if(last?.node){last.node.classList.remove('gb3-chat-pending');last.node.classList.add('gb3-chat-failed');last.node.querySelector('.gb3-chat-status').textContent=' NOT SENT';}
   gb3SetChatVisible(true);
  }
  if(gb3Roulette&&!gb3Roulette.hidden){gb3RouletteError=(m.message||m.code||'Could not join room');gb3RouletteUpdate();}
  if(m.code==='beta_room_full'||m.code==='wrong_room'){gb3BetaAwaitingRoom='';gb3BetaDrawingReady=false;gb3RouletteHide();if(gb3BetaUI)gb3BetaUI.hidden=false;}
  return;
 }
 if(m.type==='chat_preview'||m.type==='chat'||m.type==='chat_reject'||m.type==='chat_received'){gb3GlobalChatReceive(m);return;}
 if(m.type==='train_state'){
  clearTimeout(gb3PicturePendingRetry);gb3PicturePendingRetry=null;
  if(m.room!==gb3BetaAwaitingRoom)return;
  gb3PictureStreamReset();
  gb3PictureStreaming=!!m.streaming_pictures;
  gb3PictureStreamRoom=gb3PictureStreaming?m.room:'';
  gb3PictureStreamTarget=gb3PictureStreaming?Number(m.revision||0):0;
  // R64 paints history onto the actual surface canvases as small disk chunks arrive.
  // Never concatenate complete history into a giant JS array.
  gb3PictureIncoming=m.picture&&Array.isArray(m.picture.files)?{room:m.room,revision:Number(m.picture.revision),files:m.picture.files,parts:new Map(),allowed:new Set(m.picture.files.map(f=>f.file?String(f.file):String(f.sid)+':'+f.layer)),bytes:0,completed:false,applying:false}:null;
  gb3BetaChunkPending=m.chunked?{room:m.room,revision:m.revision,state:m,paintEvents:[],nextSeq:1,count:0,started:false}:null;
  if(Number(m.segment_count)>=100000000){
   gb3LiveMeters.lastError='ROOM REACHED 100 MILLION DISK-STORED SEGMENTS';
   gb3BetaStatus('This room reached its 100-million-segment limit.');
  }
  // V7.11 servers without R23+ train-clock fields formerly left BOTH trains
  // permanently parked in beta mode. Use the authoritative room clock when
  // present, or run the proven singleplayer phase machine from a local,
  // monotonic join clock. This fallback is NOT cross-player synchronization.
  const hasClock=m.train_cycle_epoch_ms!=null&&m.train_server_time_ms!=null&&
   Number.isFinite(Number(m.train_cycle_epoch_ms))&&Number.isFinite(Number(m.train_server_time_ms))&&
   Number(m.train_server_time_ms)>=Number(m.train_cycle_epoch_ms);
  gb3BetaTrainClock={ageSeconds:hasClock?
     (Number(m.train_server_time_ms)-Number(m.train_cycle_epoch_ms))/1000:0,
    receivedAt:performance.now(),initialized:false,
    source:hasClock?'server-synchronized':'local-fallback'};
  if(!hasClock)console.warn('GBattle R43: train_state lacks server train epoch; trains will move on local fallback clock. Update existing Go beta to synchronize all players.');
  gb3BetaJoinedRoom=m.room;
  if(gb3ChatTransportSupported)gb3ChatOpen();
  gb3BetaApplySnapshot(m);
  gb3AvatarSyncUsers(m.users);
  return;
 }
 if(m.type==='train_picture_sync_wait'){
  if(m.room===gb3PictureStreamRoom){gb3PictureStreamBusy=false;gb3JoinStatus('Room open · painting available · baking pictures in background');}
  return;
 }
 if(m.type==='train_picture_sync_begin'){gb3PictureStreamBegin(m);return;}
 if(m.type==='train_picture_pending'){
  if(m.room!==gb3BetaAwaitingRoom&&m.room!==gb3BetaJoinedRoom)return;
  gb3JoinStatus(gb3ResourceLabel()+' · baker processing in background; paint available once model loads');
  clearTimeout(gb3PicturePendingRetry);
  gb3PicturePendingRetry=setTimeout(()=>{
   if(gb3BetaSocket?.readyState===WebSocket.OPEN&&(gb3BetaAwaitingRoom===m.room||gb3BetaJoinedRoom===m.room))gb3BetaSend({type:'train_join',room:m.room});
  },6000);
  return;
 }
 if(m.type==='train_picture_request'){return;}
 if(m.type==='train_picture_chunk'){gb3PictureReceivePart(m);return;}
 if(m.type==='train_picture_complete'){
  if(gb3PictureIncoming?.progressive&&gb3PictureIncoming.room===m.room&&gb3PictureIncoming.revision===Number(m.revision)){
   const stream=gb3PictureIncoming;stream.completed=true;
   if(stream.http){if(stream.nextIndex===stream.files.length||!stream.files.length){stream.nextIndex=stream.files.length;gb3PictureFinishHTTP(stream);}return;}
   void gb3PictureStreamDrain();return;
  }
  if(gb3PictureIncoming&&gb3PictureIncoming.room===m.room&&gb3PictureIncoming.revision===Number(m.revision)){
   gb3PictureIncoming.completed=true;void gb3PictureApplyImages();
  }
  return;
 }
 if(m.type==='train_picture_saved'){gb3JoinStatus('Completed WebP picture saved on GBattle server');return;}
 if(m.type==='train_state_chunk'){
  const c=gb3BetaChunkPending;
  if(!c||m.room!==c.room||Number(m.revision)!==Number(c.revision))return;
  if(Number(m.seq)!==c.nextSeq)return;
  if(!gb3BetaModelLoaded||gb3BetaPendingState)return; // server waits for paint-batch ACK
  if(Array.isArray(m.segments)){
    for(const seg of m.segments)gb3BetaApplySegment(seg);
    c.count+=m.segments.length;
  }
  c.nextSeq++;
  if(m.last){
   gb3BetaChunkPending=null;gb3PictureIncoming=null;
   for(const evt of c.paintEvents)gb3BetaOnMessage({data:JSON.stringify(evt)});
   gb3BetaDrawingReady=true;
   gb3BetaSend({type:'train_picture_ready',room:c.room});
   if(gb3BetaUI)gb3BetaUI.hidden=true;
   gb3ResourceUpdate(20);gb3JoinStatus('Resources loaded · ready');
   return;
  }
  gb3BetaSend({type:'train_history_ack',room:c.room,revision:c.revision,seq:m.seq});
  return;
 }
 if(m.type==='train_saved'&&m.room===gb3BetaJoinedRoom){
  gb3LiveMeters.saved++;
  gb3LiveTailMarkSaved(gb3BetaPendingSaves.get(String(m.event_id||''))?.segments,Number(m.revision)||0);
  gb3BetaPendingSaves.delete(String(m.event_id||''));
  if(!gb3BetaPendingSaves.size)$('saveState').textContent='ROOM SAVED';
  gb3LiveMeters.lastError='';
  return;
 }
 if(m.type==='train_paint'&&!gb3BetaDrawingReady&&gb3BetaChunkPending&&m.room===gb3BetaChunkPending.room){
  if(m.event?.client!==gb3BetaClientID)gb3LiveMeters.paintBuffered++; // Count only after snapshot replay to avoid duplicate RX metrics
  if(gb3BetaChunkPending.paintEvents.length>2000){
    gb3LiveMeters.lastError='Live queue overflow: reconnecting to avoid losing paint';
    gb3BetaSocket?.close();return;
  }
  gb3BetaChunkPending.paintEvents.push(m);return;
 }
 if(m.type==='train_paint'&&m.room===gb3BetaJoinedRoom){
  if(m.event?.client===gb3BetaClientID)return;
  gb3LiveMeters.paintIn++;gb3LiveMeters.paintSegmentsIn+=m.event?.segments?.length||0;gb3LiveMeters.lastPaintAt=Date.now();
  if(Array.isArray(m.event?.segments))for(const s of m.event.segments){gb3BetaApplySegment(s,true);gb3LiveTailAdd(s,Number(m.revision)||0);}
  return;
 }
 if(m.type==='train_rebuild'&&m.room===gb3BetaJoinedRoom){gb3BetaApplySnapshot(m);return;}
 if(m.type==='train_clear'&&m.room===gb3BetaJoinedRoom){gb3BetaResetPaint();return;}
 if(m.type==='train_presence'&&m.room===gb3BetaJoinedRoom){
  const self=Array.isArray(m.users)?m.users.find(u=>u.id===gb3BetaClientID):null;if(self){gb3StaffRole=String(self.role||'user');gb3ModRefreshPermissions();}
  if(gb3BetaPeople)gb3BetaPeople.textContent='Paint room '+m.room.slice(-1)+' · '+m.online+' connected · global messages';
  if(gb3BetaPeople){gb3BetaPeople.textContent=Array.isArray(m.users)?m.users.map(x=>x.name||'Guest').join('  •  '):'';}
  gb3AvatarSyncUsers(m.users);
  return;
 }
 if(m.type==='beta_avatar'&&m.room===gb3BetaJoinedRoom){gb3LiveMeters.avatarsIn++;gb3LiveMeters.lastAvatarAt=Date.now();gb3AvatarRemoteUpdate(m);return;}
 if(m.type==='beta_train_model'&&m.room===gb3BetaJoinedRoom){
  gb3BetaResetPaint();gb3BetaDrawingReady=false;
  const state={room:m.room,model:m.model,segments:[],online:gb3Avatars.size+1};
  gb3BetaApplySnapshot(state);
  return;
 }
 // Existing V7.11 global chat is handled above; no train_chat is sent.
}
function gb3BetaConnect(){
 if(gb3BetaSocket&&(gb3BetaSocket.readyState===WebSocket.OPEN||gb3BetaSocket.readyState===WebSocket.CONNECTING))return;
 clearTimeout(gb3BetaReconnect);gb3BetaStatus('Connecting to multiplayer…');
 const url=root.getAttribute('data-gb3-beta-ws')||'wss://gbattle.sweink.com/gbattle-ws';
 if(!/^wss:\/\//i.test(url)){gb3BetaStatus('Secure WebSocket URL required');return;}
 try{const ws=new WebSocket(url);gb3BetaSocket=ws;
  ws.onopen=()=>{gb3BetaRetry=0;gb3BetaSend({type:'hello',client_id:gb3BetaClientID,name:gb3BetaNick,staff_token:gb3ReadStaffToken(),paint_protocol:2,picture_protocol:3,binary_paint:false,skip_catchup:true});};
  ws.onmessage=gb3BetaOnMessage;
  ws.onclose=()=>{if(ws!==gb3BetaSocket)return;gb3ChatStop();gb3Avatars.clear();gb3BetaDrawingReady=false;gb3BetaSocketOpen=false;gb3BetaTrainClock=null;gb3BetaChunkPending=null;gb3PictureStreamReset();
   if(!gb3BetaAwaitingRoom&&!gb3BetaJoinedRoom){gb3BetaStatus('Disconnected');return;}
   if(gb3BetaNick==='ADMIN'){
    const slot=gb3BetaAwaitingRoom?Number(gb3BetaAwaitingRoom.slice(-1)):Number(gb3BetaJoinedRoom.slice(-1));
    gb3AdminAuthenticated=false;gb3AdminFlyEnabled=false;gb3AdminGodEnabled=false;gb3ModOpenButton.hidden=true;gb3AdminAwaitingAuth=false;gb3AdminPasswordPending='';
    gb3BetaAwaitingRoom='';gb3BetaJoinedRoom='';gb3RouletteHide();if(gb3BetaUI)gb3BetaUI.hidden=false;
    gb3BetaStatus('ADMIN disconnected. Password required to reconnect.');
    gb3AdminPrompt(slot>=1&&slot<=4?slot:1);return;
   }
   gb3BetaStatus('Connection lost. Reconnecting…');gb3BetaReconnect=setTimeout(gb3BetaConnect,Math.min(12000,1200*(2**Math.min(4,gb3BetaRetry++))));};
  ws.onerror=()=>gb3BetaStatus('Multiplayer connection failed. Please reconnect.');
 }catch(err){gb3BetaStatus('Cannot open WebSocket: '+err.message);}
}
// All FOUR rooms use exactly the same train/WebP paths and join handler.
// Södermalm is NOT a room and its runtime is not active in this yard script.
function gb3EnterPaintRoom(slot,chosenName,admin=false){
 if(!Number.isInteger(slot)||slot<1||slot>4)return;
 gb3BetaNick=chosenName;
 console.info('GBattle room route',slot,gb3BetaRooms[slot-1],'runtime:yard','picture transport:progressive-WebP');
 gb3AdminAuthenticated=false;
 if(!admin){gb3AdminAwaitingAuth=false;gb3AdminAuthMode='';gb3AdminPasswordPending='';}
 else{gb3AdminAwaitingAuth=true;gb3AdminAuthMode='join';gb3AdminRequestedRoom=slot;}
 // Any leftover city-selection URL must not alter a normal paint room.
 if(gb3ActiveMap==='sodermalm'){gb3MapSelect.value='yard';gb3MapSelect.dispatchEvent(new Event('change'));}
 try{const url=new URL(location.href);if(url.searchParams.get('gb3map')==='sodermalm'){
  url.searchParams.set('gb3map','yard');history.replaceState(history.state,'',url.toString());
 }}catch(_){}
 if(gb3BetaSocket&&(gb3BetaSocket.readyState===WebSocket.OPEN||gb3BetaSocket.readyState===WebSocket.CONNECTING)){
  const old=gb3BetaSocket;gb3BetaSocket=null;try{old.close();}catch(_){}
 }
 gb3ChatStop();
 gb3Avatars.clear();gb3BetaTrainClock=null;gb3AvatarLastTX=0;gb3BetaChunkPending=null;
 gb3PictureStreamReset();gb3BetaPendingSaves.clear();gb3PendingChat.length=0;gb3SetChatVisible(false);
 gb3BetaAwaitingRoom=gb3BetaRooms[slot-1];gb3BetaJoinedRoom='';gb3BetaDrawingReady=false;gb3BetaPendingState=null;
 if(gb3BetaUI)gb3BetaUI.hidden=true;gb3RouletteShow();gb3BetaConnect();
 gb3BetaStatus(admin?'Verifying ADMIN before Room '+slot+'…':'Joining room '+slot+'…');
}

const gb3AdminModal=document.createElement('div');
gb3AdminModal.className='gb3-admin-join-modal';gb3AdminModal.hidden=true;
// Server-authenticated owner moderation console. No password or IP is saved in Shopify.
const gb3ModPanel=document.createElement('div');gb3ModPanel.className='gb3-moderation-panel';gb3ModPanel.hidden=true;
gb3ModPanel.setAttribute('role','dialog');gb3ModPanel.setAttribute('aria-modal','true');gb3ModPanel.setAttribute('aria-label','Owner moderation console');
gb3ModPanel.innerHTML=`<section class="gb3-mod-window"><header><b>GBATTLE · ADMIN</b><button type="button" data-mod-close>✕ CLOSE</button></header>
<p data-mod-status>Owner authentication required.</p>
<nav><button type="button" data-mod-refresh>PLAYERS</button><button type="button" data-mod-audit data-owner-only>SEARCH IP / NAMES</button><button type="button" data-mod-chatlog data-owner-only>CHAT LOG</button><button type="button" data-mod-staff data-owner-only>MODERATORS</button><label data-owner-only>Search<input data-mod-history-query placeholder="Name, IP or player ID" maxlength="96" autocomplete="off"></label></nav>
<div class="gb3-mod-row"><label>Player <select data-mod-target><option value="">Choose online player</option></select></label><label>Action<select data-mod-action><option value="mute">Mute chat</option><option value="unmute">Unmute chat</option><option value="kick">Kick</option><option value="ban_chat">Ban chat</option><option value="ban_paint">Ban painting</option><option value="ban_both">Block chat & paint / IP ban</option><option value="unban_chat">Unban chat</option><option value="unban_paint">Unban painting</option><option value="unban_both">Unblock</option><option value="block_ip">BLOCK IP / deny joins</option><option value="promote_mod">Promote moderator</option><option value="demote_mod">Demote moderator</option><option value="delete">Delete chat message</option><option value="clear">Clear retained chat</option></select></label></div>
<div class="gb3-mod-row"><label>Ban duration <select data-mod-minutes><option value="5">5 minutes</option><option value="30" selected>30 minutes</option><option value="60">1 hour</option><option value="1440">1 day</option><option value="10080">7 days</option><option value="0">Permanent (owner)</option></select></label><label>Reason<input data-mod-reason maxlength="180" placeholder="Moderation reason"></label></div>
<label>Chat message ID (for delete)<input data-mod-message-id type="number" min="1" step="1"></label><button type="button" data-mod-apply>APPLY ACTION</button><div class="gb3-mod-row"><button type="button" data-mod-listblocks data-owner-only>BLOCKED IPs</button><label>Unblock IP<input data-mod-unblock-ip data-owner-only placeholder="IP already blocked"></label><button type="button" data-mod-unblock data-owner-only>UNBLOCK IP</button></div><div class="gb3-mod-row"><button type="button" data-mod-fly data-owner-only>FLY: OFF</button><button type="button" data-mod-god data-owner-only>GOD: OFF</button></div>
<small>Fly: Space / Ctrl to ascend / descend (mobile: jump / crouch). God: pass through walls and ignore guard detection. Both require owner approval from Go.</small>
<section data-owner-only><h3>ARTWORK CLEANUP</h3>
<p>Choose a multiplayer room. Players must leave it first. Each cleanup creates a restorable backup.</p>
<div class="gb3-mod-row"><label>Room<select data-mod-room><option value="train:gb3d-beta:room-1">Room 1</option><option value="train:gb3d-beta:room-2">Room 2</option><option value="train:gb3d-beta:room-3">Room 3</option><option value="train:gb3d-beta:room-4">Room 4</option></select></label>
<label>What to erase<select data-mod-room-action><option value="clean_train">Entire train artwork · keep city art</option><option value="clean_room">All player artwork in this room</option><option value="restore">Restore a room backup</option></select></label></div>
<div class="gb3-mod-row"><button type="button" data-mod-rooms>ROOM STATUS</button><button type="button" data-mod-backups>LIST BACKUPS</button><label>Backup<select data-mod-backup><option value="">Select backup for restore</option></select></label><button type="button" data-mod-room-preview>PREVIEW OPERATION</button></div>
<p data-mod-room-preview-text>No operation selected.</p><div class="gb3-mod-row"><label>Exact confirmation<input data-mod-room-confirm autocomplete="off" placeholder="Preview first"></label><button type="button" data-mod-room-apply disabled>CONFIRM & APPLY</button></div>
</section><pre data-mod-result aria-live="polite">Choose an action. Detailed records appear only when requested.</pre></section>`;
root.appendChild(gb3ModPanel);
const gb3ModTarget=gb3ModPanel.querySelector('[data-mod-target]');
const gb3ModOutput=gb3ModPanel.querySelector('[data-mod-result]');
const gb3ModStatus=gb3ModPanel.querySelector('[data-mod-status]');
let gb3ModUsers=[];
let gb3RoomAdminPreview=null;
function gb3ModRefreshPermissions(){
 const owner=gb3AdminAuthenticated;
 gb3ModOpenButton.hidden=!gb3HasStaffAccess();
 gb3ModOpenButton.title=owner?'Superior Admin tools':'Moderator tools';
 if(!gb3HasStaffAccess())gb3ModPanel.hidden=true;
 for(const node of gb3ModPanel.querySelectorAll('[data-owner-only]'))node.hidden=!owner;
 for(const option of gb3ModPanel.querySelectorAll('[data-mod-action] option')){
  option.disabled=!owner&&['block_ip','promote_mod','demote_mod','clear'].includes(option.value);
 }
}
const gb3ModSend=(message)=>{
 if(!gb3HasStaffAccess()||!gb3BetaSocketOpen){gb3ModStatus.textContent='Staff login required on the active game connection.';return false;}
 return gb3BetaSend(message);
};
function gb3ModPanelReceive(m){
 gb3ModPanel.querySelector('[data-mod-audit-details]')?.remove();
 if(m.type==='moderation_staff'){
  const online=new Set(gb3ModUsers.map(u=>u.id));
  for(const u of m.staff||[]){if(!online.has(u.id)){gb3ModUsers.push({...u,room:'offline'});const o=document.createElement('option');o.value=String(u.id);o.textContent=String(u.name||u.id)+' · offline · '+String(u.role);gb3ModTarget.appendChild(o);}}
  gb3ModOutput.textContent=(m.staff||[]).map(u=>[u.name||u.id||'Moderator',u.role||'moderator',u.created||''].filter(Boolean).join(' · ')).join('\n')||'No stored moderators.';
 }else if(m.type==='moderation_rooms'){
  gb3ModOutput.textContent=(m.rooms||[]).map(r=>[r.room||r.id||'Room','players: '+Number(r.players||0),'artwork: '+Number(r.artwork||0)+' marks',r.status||'ready'].join(' · ')).join('\n')||'No room status available.';
 }else if(m.type==='moderation_backups'){
  if(m.room!==gb3ModPanel.querySelector('[data-mod-room]').value)return;
  const select=gb3ModPanel.querySelector('[data-mod-backup]');select.replaceChildren();
  for(const b of m.backups||[]){const o=document.createElement('option');o.value=String(b.id);o.textContent=String(b.created)+' · '+String(b.action)+' · '+String(b.segments)+' segments';select.appendChild(o);}
  gb3ModOutput.textContent=(m.backups||[]).length?'Backups for '+m.room+' loaded.':'No backups for this room.';
 }else if(m.type==='moderation_room_preview'){
  if(m.room!==gb3ModPanel.querySelector('[data-mod-room]').value)return;
  gb3RoomAdminPreview=m;
  gb3ModPanel.querySelector('[data-mod-room-preview-text]').textContent=m.scope+' Room must be empty. Type: '+m.confirmation;
  gb3ModPanel.querySelector('[data-mod-room-confirm]').value='';
  gb3ModPanel.querySelector('[data-mod-room-apply]').disabled=false;
 }else if(m.type==='moderation_room_result'){
  gb3ModStatus.textContent=m.pending?'Room operation running…':m.ok?'Room operation completed; backup: '+m.backup:'Room unchanged or operation failed: '+String(m.message||'not confirmed');
  if(!m.pending){gb3RoomAdminPreview=null;gb3ModPanel.querySelector('[data-mod-room-apply]').disabled=true;}
 }else if(m.type==='moderation_roster'){
  gb3ModUsers=Array.isArray(m.users)?m.users:[];
  const previous=gb3ModTarget.value;gb3ModTarget.replaceChildren();
  const opt=document.createElement('option');opt.value='';opt.textContent='Choose online player';gb3ModTarget.appendChild(opt);
  for(const u of gb3ModUsers){const o=document.createElement('option');o.value=String(u.id||'');o.textContent=String(u.name||'Guest')+' · '+String(u.room||'lobby')+' · '+String(u.role||'user');gb3ModTarget.appendChild(o);}
  if(gb3ModUsers.some(u=>u.id===previous))gb3ModTarget.value=previous;
  gb3ModOutput.textContent=gb3ModUsers.map(u=>[u.name||'Guest',u.room||'lobby',u.role||'user'].join(' · ')).join('\n')||'No online players.';
  gb3ModStatus.textContent='Connected players. Select one for moderation actions.';
 }else if(m.type==='moderation_audit'){
  gb3ModStatus.textContent=m.history_available?'IP search results. A shared IP does not confirm the same person.':'Current sessions only; saved login history is unavailable.';
  const ties=(m.ip_ties||[]).map(x=>String(x.ip)+' : '+(x.names||[]).join(', '));
  const events=(m.events||[]).slice(-40).reverse().map(x=>[x.time,x.event,x.name,x.action||''].filter(Boolean).join(' · '));
  gb3ModOutput.textContent=(ties.length?'Names seen on matching IPs\n'+ties.join('\n'):'No matching IP/name ties.');
  if(events.length){const details=document.createElement('details');details.dataset.modAuditDetails='';const summary=document.createElement('summary');summary.textContent='Show recent login and staff events';const pre=document.createElement('pre');pre.textContent=events.join('\n');details.append(summary,pre);gb3ModOutput.after(details);}
 }else if(m.type==='admin_log'){
  const rows=m.messages||m.chat||m.logs||m.rows||m.items||[];
  gb3ModStatus.textContent='Chat log'+(m.query?' · search: '+m.query:'')+'.';
  gb3ModOutput.textContent=Array.isArray(rows)?(rows.slice(-80).reverse().map(x=>[x.ts||x.time||'',x.name||x.player||'Guest',x.message||x.text||''].filter(Boolean).join(' · ')).join('\n')||'No chat messages matched the search.'):'Chat log response received. Use a name or IP to narrow the search.';
 }else if(m.type==='moderation_mode'){
  gb3AdminFlyEnabled=m.fly===true;gb3AdminGodEnabled=m.god===true;
  gb3ModPanel.querySelector('[data-mod-fly]').textContent='FLY: '+(gb3AdminFlyEnabled?'ON':'OFF');
  gb3ModPanel.querySelector('[data-mod-god]').textContent='GOD: '+(gb3AdminGodEnabled?'ON':'OFF');
  gb3ModStatus.textContent='Owner movement mode authorized by server.';
 }else if(m.type==='moderation_blocks'){
  gb3ModOutput.textContent=Object.entries(m.blocks||{}).map(([ip,x])=>ip+' | '+(x.until===-1?'permanent':new Date(x.until*1000).toLocaleString())+' | '+String(x.reason||'')).join('\n')||'No IP entry bans.';
 }else if(m.type==='moderation_block_result'){
  gb3ModStatus.textContent=m.ok?'Entry ban updated: '+m.action+' '+m.ip:'Entry ban not confirmed';
  gb3ModSend({type:'moderation_block',action:'list'});
 }else if(m.type==='moderation_action_result'){
  gb3ModStatus.textContent=m.ok?'Action saved: '+m.action+' · '+m.target:'Action not confirmed';
  gb3ModSend({type:'moderation_roster'});
 }
}
gb3ModOpenButton.onclick=()=>{
 if(!gb3HasStaffAccess())return;
 gb3ModPanel.hidden=false;
 gb3ModSend({type:'moderation_roster'});
};
gb3ModPanel.querySelector('[data-mod-close]').onclick=()=>gb3ModPanel.hidden=true;
gb3ModPanel.querySelector('[data-mod-refresh]').onclick=()=>gb3ModSend({type:'moderation_roster'});
gb3ModPanel.querySelector('[data-mod-audit]').onclick=()=>gb3ModSend({type:'moderation_audit',query:gb3ModPanel.querySelector('[data-mod-history-query]').value.trim()});
gb3ModPanel.querySelector('[data-mod-listblocks]').onclick=()=>gb3ModSend({type:'moderation_block',action:'list'});
gb3ModPanel.querySelector('[data-mod-unblock]').onclick=()=>{
 const ip=gb3ModPanel.querySelector('[data-mod-unblock-ip]').value.trim();
 if(!ip||!window.confirm('Remove connection ban for '+ip+'?'))return;
 gb3ModSend({type:'moderation_block',action:'unblock_ip',target:ip});
};
gb3ModPanel.querySelector('[data-mod-chatlog]').onclick=()=>gb3ModSend({type:'admin_log',query:gb3ModPanel.querySelector('[data-mod-history-query]').value.trim()});
gb3ModPanel.querySelector('[data-mod-staff]').onclick=()=>gb3ModSend({type:'moderation_staff'});
gb3ModPanel.querySelector('[data-mod-fly]').onclick=()=>gb3ModSend({type:'moderation_mode',action:gb3AdminFlyEnabled?'fly_off':'fly_on'});
gb3ModPanel.querySelector('[data-mod-god]').onclick=()=>gb3ModSend({type:'moderation_mode',action:gb3AdminGodEnabled?'god_off':'god_on'});
gb3ModPanel.querySelector('[data-mod-apply]').onclick=()=>{
 const target=gb3ModTarget.value,action=gb3ModPanel.querySelector('[data-mod-action]').value;
 if(!target&&!['clear','delete'].includes(action)){gb3ModStatus.textContent='Select a player';return;}
 const u=gb3ModUsers.find(u=>u.id===target);
 if(!['clear','delete'].includes(action)&&(u?.role==='owner'||u?.role==='admin')){gb3ModStatus.textContent='Owner/admin accounts cannot be targeted';return;}
 const minutes=Number(gb3ModPanel.querySelector('[data-mod-minutes]').value);
 const reason=gb3ModPanel.querySelector('[data-mod-reason]').value.trim();
 const message_id=Number(gb3ModPanel.querySelector('[data-mod-message-id]').value)||0;
 if(action==='delete'&&(!Number.isInteger(message_id)||message_id<1)){gb3ModStatus.textContent='Enter a valid chat message ID.';return;}
 const confirmation=action==='clear'?'Clear the retained global chat history?':action==='delete'?'Delete chat message #'+message_id+'?':'Apply '+action+' to '+String(u?.name||target)+' for '+minutes+' minute(s)?';
 if(!window.confirm(confirmation))return;
 gb3ModStatus.textContent='Submitting action to server…';
 gb3ModSend({type:action==='block_ip'?'moderation_block':'admin_action',action,target,minutes,reason,message_id});
};
root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!gb3ModPanel.hidden){e.stopPropagation();gb3ModPanel.hidden=true;}});


const gb3RoomControl=()=>gb3ModPanel.querySelector('[data-mod-room]').value;
const gb3RoomPreviewReset=()=>{gb3RoomAdminPreview=null;gb3ModPanel.querySelector('[data-mod-room-apply]').disabled=true;gb3ModPanel.querySelector('[data-mod-room-preview-text]').textContent='Preview required for the selected operation.';};
for(const sel of ['[data-mod-room]','[data-mod-room-action]','[data-mod-backup]'])gb3ModPanel.querySelector(sel).onchange=gb3RoomPreviewReset;
gb3ModPanel.querySelector('[data-mod-rooms]').onclick=()=>gb3ModSend({type:'moderation_rooms',action:'status'});
gb3ModPanel.querySelector('[data-mod-backups]').onclick=()=>gb3ModSend({type:'moderation_rooms',action:'backups',room:gb3RoomControl()});
gb3ModPanel.querySelector('[data-mod-room-preview]').onclick=()=>{gb3RoomPreviewReset();gb3ModSend({type:'moderation_rooms',action:gb3ModPanel.querySelector('[data-mod-room-action]').value,room:gb3RoomControl(),target:gb3ModPanel.querySelector('[data-mod-backup]').value});};
gb3ModPanel.querySelector('[data-mod-room-apply]').onclick=()=>{
 const plan=gb3RoomAdminPreview,confirmation=gb3ModPanel.querySelector('[data-mod-room-confirm]').value;
 if(!plan||plan.room!==gb3RoomControl()||confirmation!==plan.confirmation){gb3ModStatus.textContent='Type the exact confirmation from the current preview.';return;}
 gb3ModPanel.querySelector('[data-mod-room-apply]').disabled=true;
 gb3ModSend({type:'moderation_rooms',action:'apply',room:plan.room,query:plan.token,reason:confirmation});
};

gb3AdminModal.setAttribute('role','dialog');gb3AdminModal.setAttribute('aria-modal','true');
gb3AdminModal.setAttribute('aria-label','GBattle admin password');
gb3AdminModal.innerHTML=`<div class="gb3-admin-join-dialog">
 <button type="button" data-admin-close aria-label="Close admin login">✕</button>
 <h2>ADMIN LOGIN</h2><p>Use the established GBattle admin password. Södermalm map access is separate.</p>
 <form data-admin-form><label>Room
  <select data-admin-room><option value="1">ROOM 01</option><option value="2">ROOM 02</option>
  <option value="3">ROOM 03</option><option value="4">ROOM 04</option></select></label>
  <label>Admin password <input data-admin-password type="password" autocomplete="current-password" maxlength="200" required></label>
  <button type="submit">VERIFY WITH SERVER</button>
 </form><p data-admin-status role="status" aria-live="polite"></p></div>`;
const gb3AdminCSS=document.createElement('style');gb3AdminCSS.textContent=`
.gb3-game .gb3-admin-join-modal[hidden]{display:none!important}
.gb3-game .gb3-admin-join-modal{position:absolute;inset:0;z-index:30001;background:#02060be0;display:grid;place-items:center;padding:16px;overflow-y:auto}
.gb3-game .gb3-admin-join-dialog{width:min(390px,96%);background:#13212c;color:#f3f5f8;border:1px solid #e8d339;border-radius:12px;padding:21px;font:13px/1.4 system-ui,sans-serif;box-shadow:0 10px 35px #0009}
.gb3-game .gb3-admin-join-dialog h2{color:#ebd32b;font-size:19px;margin:0 0 8px}
.gb3-game .gb3-admin-join-dialog p{color:#dfebef;font-size:12px}
.gb3-game .gb3-admin-join-dialog label{display:block;font-weight:700;margin:10px 0}
.gb3-game .gb3-admin-join-dialog input,.gb3-game .gb3-admin-join-dialog select{display:block;width:100%;box-sizing:border-box;background:#09151f;color:#fff;border:1px solid #8293a0;border-radius:6px;padding:10px;margin-top:4px}
.gb3-game .gb3-admin-join-dialog button{border:1px solid #d2c94a;background:#dfcf2d;color:#0c161a;border-radius:6px;padding:9px;font-weight:900;cursor:pointer}
.gb3-game .gb3-admin-join-dialog button[data-admin-close]{float:right;background:#23323e;color:#fff}
.gb3-game .gb3-admin-entry{padding:8px;border-radius:7px;background:#222f39;color:#ffeb58;border:1px solid #c1b245;font-weight:800;cursor:pointer;margin:8px 0}
`;
root.appendChild(gb3AdminCSS);root.appendChild(gb3AdminModal);
const gb3AdminRoomSelect=gb3AdminModal.querySelector('[data-admin-room]');
const gb3AdminPasswordInput=gb3AdminModal.querySelector('[data-admin-password]');
const gb3AdminStatus=gb3AdminModal.querySelector('[data-admin-status]');
function gb3AdminPrompt(slot=0){
 if(slot)gb3AdminRoomSelect.value=String(slot);
 gb3AdminModal.hidden=false;gb3AdminStatus.textContent='Only the server can grant the ADMIN role.';
 gb3AdminPasswordInput.value='';gb3AdminPasswordInput.focus({preventScroll:true});
}
gb3AdminModal.querySelector('[data-admin-close]').addEventListener('click',()=>{
 gb3AdminModal.hidden=true;gb3AdminPasswordInput.value='';
});
gb3AdminModal.querySelector('[data-admin-form]').addEventListener('submit',e=>{
 e.preventDefault();const pwd=gb3AdminPasswordInput.value;gb3AdminPasswordInput.value='';
 const slot=Number(gb3AdminRoomSelect.value);
 if(pwd.length<1||pwd.length>200)return;
 gb3AdminPasswordPending=pwd;gb3AdminRequestedRoom=slot;
 gb3AdminModal.hidden=true;
 if(gb3BetaSocketOpen&&gb3BetaJoinedRoom){
  gb3AdminAwaitingAuth=true;gb3AdminAuthMode='inroom';
  const password=gb3AdminPasswordPending;gb3AdminPasswordPending='';
  if(!gb3BetaSend({type:'admin_auth',password})){
   gb3AdminAwaitingAuth=false;gb3AdminStatus.textContent='Game WebSocket is disconnected. Rejoin the room.';gb3AdminModal.hidden=false;
  }
 }else gb3EnterPaintRoom(slot,'ADMIN',true);
});
// Owner login remains available through the existing ADMIN room-join flow.
root.querySelectorAll('[data-gb3-beta-join]').forEach(btn=>btn.addEventListener('click',()=>{
 const slot=Number(btn.dataset.gb3BetaJoin);if(!Number.isInteger(slot)||slot<1||slot>4)return;
 const input=gb3NormalizeChosenName(gb3GuestField?.value);
 if(input.toUpperCase()==='ADMIN'){gb3AdminPrompt(slot);return;}
 const name=gb3ChosenPlayerName();if(!name)return;
 gb3EnterPaintRoom(slot,name,false);
}));
root.querySelector('[data-gb3-beta-leave]')?.addEventListener('click',()=>{
 gb3BetaSend({type:'train_leave'});
 // Close the socket too: leaving the room must remove global presence, not leave a ghost user.
 clearTimeout(gb3BetaReconnect); const departing=gb3BetaSocket;gb3BetaSocket=null;
 gb3BetaSocketOpen=false;gb3PictureStreamReset();gb3ChatStop();try{departing?.close(1000,'Left multiplayer');}catch(_){}
 gb3BetaTrainClock=null;gb3Avatars.clear();gb3SetChatVisible(false);gb3PendingChat.length=0;gb3BetaJoinedRoom='';gb3BetaAwaitingRoom='';gb3BetaDrawingReady=false;gb3BetaPendingState=null;
 gb3BetaResetPaint();gb3Avatars.clear();gb3RouletteHide();if(gb3BetaUI)gb3BetaUI.hidden=false;gb3SetChatVisible(false);
 // V7.11 has no room-list query; the join buttons remain available.
});
root.querySelector('[data-gb3-beta-chat-form]')?.addEventListener('submit',e=>{
 e.preventDefault();const input=root.querySelector('[data-gb3-beta-message]');if(!input||(!gb3BetaJoinedRoom&&!gb3BetaAwaitingRoom))return;
 const msg=input.value.trim().slice(0,200);if(!msg)return;
 if(!gb3BetaSocketOpen){gb3ChatStatus('CHAT: GAME DISCONNECTED');return;}
 if(gb3ChatTransportSupported&&(!gb3ChatReady||!gb3ChatProbeConfirmed)){
  gb3ChatStatus('CHAT: NOT CONNECTED · RETRYING…');gb3ChatOpen();return;
 }
 const id='gb3chat-'+Date.now().toString(36)+'-'+(++gb3GlobalChatCounter).toString(36);
 const delivered=gb3ChatTransportSupported?gb3ChatSend({type:'chat',message:msg,temp_id:id}):gb3BetaSend({type:'chat',message:msg,temp_id:id});
 if(delivered){
  input.value='';const node=gb3GlobalChatRow(id,gb3BetaNick,msg);
  const pending={id,text:msg,node};gb3PendingChat.push(pending);
  setTimeout(()=>{if(!gb3PendingChat.includes(pending))return;
   const status=node?.querySelector('.gb3-chat-status');
   if(status)status.textContent=pending.received?' SERVER RECEIVED · SAVE DELAYED…':' UNCONFIRMED · CHECK CHAT CONNECTION';
   // Keep the pending ID so a delayed saved event can still confirm this row.
   if(gb3PendingChat.length>80)gb3PendingChat.splice(0,gb3PendingChat.length-80);
  },25000);
 }else gb3ChatStatus('CHAT: SEND FAILED · NO MESSAGE SENT');
});
root.querySelector('[data-gb3-beta-refresh]')?.addEventListener('click',()=>gb3BetaStatus('Choose a room to see live occupancy.')); 
// Room shortcut after switching away from Södermalm. Does not start a global WS in the lobby.
const gb3RouteParams=new URLSearchParams(location.search);
const gb3ReturnName=(()=>{try{const n=sessionStorage.getItem('gb3-return-name');sessionStorage.removeItem('gb3-return-name');return n;}catch(_){return null}})();
if(gb3ReturnName&&root.querySelector('[data-gb3-beta-name]'))root.querySelector('[data-gb3-beta-name]').value=gb3ReturnName;
const gb3RouteRoom=Number(gb3RouteParams.get('gb3room'));
if(['1','2','3','4'].includes(gb3RouteParams.get('gb3room'))){
 setTimeout(()=>{
  if(!root.isConnected)return;
  const btn=root.querySelector('[data-gb3-beta-join="'+gb3RouteRoom+'"]');if(btn)btn.click();
 },100);
}
if(['depot','tunnel'].includes(gb3RouteParams.get('gb3map'))){
 setTimeout(()=>{
  if(!root.isConnected)return;
  gb3MapSelect.value=gb3RouteParams.get('gb3map');gb3MapSelect.dispatchEvent(new Event('change'));
 },0);
}
// R62: Do not open a global socket just by visiting the lobby. Connect only after JOIN ROOM.
 const gb3StopSocket=()=>{gb3ChatStop();clearTimeout(gb3BetaReconnect);const ws=gb3BetaSocket;gb3BetaSocket=null;gb3BetaSocketOpen=false;try{ws?.close(1000,'Page closed');}catch(_){}};
 window.addEventListener('pagehide',gb3StopSocket,{once:true});
 root.addEventListener('shopify:section:unload',gb3StopSocket,{once:true});

}
// Native Shopify section lifecycle: support initial load and theme-editor reload.
function gb3BetaBoot(){document.querySelectorAll('[data-gb3-beta-root]').forEach(root=>{
 try{gbattle3DBetaInit(root)}catch(err){
  const detail=String(err?.message||err||'unknown startup error').slice(0,180);
  console.error('GBattle multiplayer lobby startup failed:',err);
  root.dataset.gb3StartupError=detail;
  root.querySelectorAll('[data-gb3-beta-count]').forEach(el=>el.textContent='STARTUP ERROR');
  const notice=root.querySelector('[data-gb3-beta-notice]');
  if(notice)notice.textContent='Multiplayer lobby failed to start: '+detail;
 }
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',gb3BetaBoot,{once:true});
else gb3BetaBoot();
document.addEventListener('shopify:section:load',gb3BetaBoot);
